import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  AccountNumber: { input: any; output: any };
  BigInt: { input: any; output: any };
  Byte: { input: any; output: any };
  CountryCode: { input: any; output: any };
  Cuid: { input: any; output: any };
  Currency: { input: any; output: any };
  DID: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  DateTimeISO: { input: any; output: any };
  DeweyDecimal: { input: any; output: any };
  Duration: { input: any; output: any };
  EmailAddress: { input: any; output: any };
  GUID: { input: any; output: any };
  HSL: { input: any; output: any };
  HSLA: { input: any; output: any };
  HexColorCode: { input: any; output: any };
  Hexadecimal: { input: any; output: any };
  IBAN: { input: any; output: any };
  IP: { input: any; output: any };
  IPCPatent: { input: any; output: any };
  IPv4: { input: any; output: any };
  IPv6: { input: any; output: any };
  ISBN: { input: any; output: any };
  ISO8601Duration: { input: any; output: any };
  JSON: { input: any; output: any };
  JSONObject: { input: any; output: any };
  JWT: { input: any; output: any };
  LCCSubclass: { input: any; output: any };
  Latitude: { input: any; output: any };
  LocalDate: { input: any; output: any };
  LocalDateTime: { input: any; output: any };
  LocalEndTime: { input: any; output: any };
  LocalTime: { input: any; output: any };
  Locale: { input: any; output: any };
  Long: { input: any; output: any };
  Longitude: { input: any; output: any };
  MAC: { input: any; output: any };
  NegativeFloat: { input: any; output: any };
  NegativeInt: { input: any; output: any };
  NonEmptyString: { input: any; output: any };
  NonNegativeFloat: { input: any; output: any };
  NonNegativeInt: { input: any; output: any };
  NonPositiveFloat: { input: any; output: any };
  NonPositiveInt: { input: any; output: any };
  ObjectID: { input: any; output: any };
  PhoneNumber: { input: any; output: any };
  Port: { input: any; output: any };
  PositiveFloat: { input: any; output: any };
  PositiveInt: { input: any; output: any };
  PostalCode: { input: any; output: any };
  RGB: { input: any; output: any };
  RGBA: { input: any; output: any };
  RoutingNumber: { input: any; output: any };
  SESSN: { input: any; output: any };
  SafeInt: { input: any; output: any };
  SemVer: { input: any; output: any };
  Time: { input: any; output: any };
  TimeZone: { input: any; output: any };
  Timestamp: { input: any; output: any };
  URL: { input: any; output: any };
  USCurrency: { input: any; output: any };
  UUID: { input: any; output: any };
  UnsignedFloat: { input: any; output: any };
  UnsignedInt: { input: any; output: any };
  UtcOffset: { input: any; output: any };
  Void: { input: any; output: any };
};

export type AddPaymentInstrumentInput = {
  billingAddressLine1: Scalars['String']['input'];
  billingAddressLine2?: InputMaybe<Scalars['String']['input']>;
  billingCity: Scalars['String']['input'];
  billingCountry: Scalars['String']['input'];
  billingEmail: Scalars['String']['input'];
  billingFirstName: Scalars['String']['input'];
  billingLastName: Scalars['String']['input'];
  billingPhone?: InputMaybe<Scalars['String']['input']>;
  billingPostalCode: Scalars['String']['input'];
  billingState: Scalars['String']['input'];
  paymentToken: Scalars['String']['input'];
};

export type ApplicantUser = MongoBase & {
  __typename?: 'ApplicantUser';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  hasVerifiedCredential?: Maybe<Scalars['Boolean']['output']>;
  hasVerifiedIdentity?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ObjectID']['output'];
  isProfileSubmitted?: Maybe<Scalars['Boolean']['output']>;
  payment?: Maybe<ApplicantUserPayment>;
  personalInformation?: Maybe<ApplicantUserPersonalInformation>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<ApplicantUserSearch>;
  systemFlags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  termsAndConditions?: Maybe<Array<Maybe<ApplicantUserTermsAndCondition>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserFileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type ApplicantUserAddress = {
  __typename?: 'ApplicantUserAddress';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  streetAddressLine1?: Maybe<Scalars['String']['output']>;
  streetAddressLine2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine1?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine2?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserBlobContentAuthHeaderResult = {
  __typename?: 'ApplicantUserBlobContentAuthHeaderResult';
  applicant?: Maybe<ApplicantUser>;
  authHeader?: Maybe<BlobAuthHeader>;
  status: MutationStatus;
};

export type ApplicantUserBlobFileInput = {
  applicantId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type ApplicantUserCitizenship = {
  __typename?: 'ApplicantUserCitizenship';
  currentCitizenOf?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApplicantUserCitizenshipInput = {
  currentCitizenOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ApplicantUserContactInformation = {
  __typename?: 'ApplicantUserContactInformation';
  address?: Maybe<ApplicantUserAddress>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Array<Maybe<ApplicantUserPhone>>>;
  primaryPhone?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserContactInformationInput = {
  address?: InputMaybe<ApplicantUserAddressInput>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Array<InputMaybe<ApplicantUserPhoneInput>>>;
};

export type ApplicantUserDetailsInput = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  isProfileSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  payment?: InputMaybe<ApplicantUserPaymentInput>;
  personalInformation?: InputMaybe<ApplicantUserPersonalInformationInput>;
  schemaVersion?: InputMaybe<Scalars['String']['input']>;
  systemFlags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsAndConditions?: InputMaybe<Array<InputMaybe<ApplicantUserTermsAndConditionInput>>>;
  userType?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserIdentityDetails = {
  __typename?: 'ApplicantUserIdentityDetails';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  generationalSuffix?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  legalNameConsistsOfOneName?: Maybe<Scalars['Boolean']['output']>;
  restOfName?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserIdentityDetailsInput = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  generationalSuffix?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  legalNameConsistsOfOneName?: InputMaybe<Scalars['Boolean']['input']>;
  restOfName?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserIdentityDetailsResult = {
  __typename?: 'ApplicantUserIdentityDetailsResult';
  dateOfBirth?: Maybe<Scalars['Date']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  generationalSuffix?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  restOfName?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserMutationResult = MutationResult & {
  __typename?: 'ApplicantUserMutationResult';
  applicantUser?: Maybe<ApplicantUser>;
  status: MutationStatus;
};

export type ApplicantUserNameOnDocumentAsset = MongoSubdocument & {
  __typename?: 'ApplicantUserNameOnDocumentAsset';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  documentName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  isDeleteRequested?: Maybe<Scalars['Boolean']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  uploadedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserNameOnDocumentAssetInput = {
  documentName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isDeleteRequested?: InputMaybe<Scalars['Boolean']['input']>;
  uploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ApplicantUserOtherIssuingInstitution = {
  __typename?: 'ApplicantUserOtherIssuingInstitution';
  addressLine1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserOtherIssuingInstitutionInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserPayment = {
  __typename?: 'ApplicantUserPayment';
  cybersourceCustomerId?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserPaymentInput = {
  cybersourceCustomerId: Scalars['String']['input'];
};

export type ApplicantUserPersonalInformation = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Maybe<Array<Maybe<Entity>>>;
  citizenship?: Maybe<ApplicantUserCitizenship>;
  contactInformation?: Maybe<ApplicantUserContactInformation>;
  identityDetails?: Maybe<ApplicantUserIdentityDetails>;
  nameOnDocumentAssets?: Maybe<Array<Maybe<ApplicantUserNameOnDocumentAsset>>>;
  professional?: Maybe<ApplicantUserProfessional>;
};

export type ApplicantUserPersonalInformationInput = {
  applyingTo?: InputMaybe<Array<InputMaybe<Scalars['ObjectID']['input']>>>;
  citizenship?: InputMaybe<ApplicantUserCitizenshipInput>;
  contactInformation?: InputMaybe<ApplicantUserContactInformationInput>;
  identityDetails?: InputMaybe<ApplicantUserIdentityDetailsInput>;
  nameOnDocumentAssets?: InputMaybe<Array<InputMaybe<ApplicantUserNameOnDocumentAssetInput>>>;
  professional?: InputMaybe<ApplicantUserProfessionalInput>;
};

export type ApplicantUserPhone = MongoSubdocument & {
  __typename?: 'ApplicantUserPhone';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneType?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserPhoneInput = {
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneType?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserPrimaryEducationalInformation = MongoSubdocument & {
  __typename?: 'ApplicantUserPrimaryEducationalInformation';
  attendanceEndedAt?: Maybe<Scalars['Date']['output']>;
  attendanceStartedAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  degreeIssuedAt?: Maybe<Scalars['Date']['output']>;
  degreeTitle?: Maybe<Scalars['String']['output']>;
  graduationYear?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ObjectID']['output'];
  issuingInstitution?: Maybe<Entity>;
  otherIssuingInstitution?: Maybe<ApplicantUserOtherIssuingInstitution>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserPrimaryEducationalInformationInput = {
  attendanceEndedAt?: InputMaybe<Scalars['Date']['input']>;
  attendanceStartedAt?: InputMaybe<Scalars['Date']['input']>;
  degreeIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  degreeTitle?: InputMaybe<Scalars['String']['input']>;
  graduationYear?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  issuingInstitutionId?: InputMaybe<Scalars['ObjectID']['input']>;
  otherIssuingInstitution?: InputMaybe<ApplicantUserOtherIssuingInstitutionInput>;
};

export type ApplicantUserProfessional = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: Maybe<Scalars['String']['output']>;
  healthProfession?: Maybe<Scalars['String']['output']>;
  primaryEducationalInformation?: Maybe<Array<Maybe<ApplicantUserPrimaryEducationalInformation>>>;
};

export type ApplicantUserProfessionalInput = {
  citizenshipAtTimeEnteredMedicalInstitution?: InputMaybe<Scalars['String']['input']>;
  healthProfession?: InputMaybe<Scalars['String']['input']>;
  primaryEducationalInformation?: InputMaybe<Array<InputMaybe<ApplicantUserPrimaryEducationalInformationInput>>>;
};

export type ApplicantUserPublicFileRemoveInput = {
  applicantId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type ApplicantUserResult = {
  __typename?: 'ApplicantUserResult';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  applyingTo?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  identityDetails?: Maybe<ApplicantUserIdentityDetailsResult>;
  role?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type ApplicantUserSearch = {
  __typename?: 'ApplicantUserSearch';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ApplicantUserSearchFacets = {
  __typename?: 'ApplicantUserSearchFacets';
  accessBlocked?: Maybe<Array<Maybe<FacetDetail>>>;
  applyingTo?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  dateOfBirth?: Maybe<Array<Maybe<FacetDetail>>>;
  gender?: Maybe<Array<Maybe<FacetDetail>>>;
  generationalSuffix?: Maybe<Array<Maybe<FacetDetail>>>;
  role?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  tags?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type ApplicantUserSearchFilterDetail = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  applyingTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateOfBirth?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  gender?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generationalSuffix?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ApplicantUserSearchInput = {
  options?: InputMaybe<ApplicantUserSearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type ApplicantUserSearchOptions = {
  filter?: InputMaybe<ApplicantUserSearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type ApplicantUserSearchResult = {
  __typename?: 'ApplicantUserSearchResult';
  applicantUserResults?: Maybe<Array<Maybe<ApplicantUserResult>>>;
  count?: Maybe<Scalars['Int']['output']>;
  facets?: Maybe<ApplicantUserSearchFacets>;
};

export type ApplicantUserTermsAndCondition = MongoSubdocument & {
  __typename?: 'ApplicantUserTermsAndCondition';
  acceptanceOf?: Maybe<Scalars['String']['output']>;
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type ApplicantUserTermsAndConditionInput = {
  acceptanceOf?: InputMaybe<Scalars['String']['input']>;
  attestedAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  version?: InputMaybe<Scalars['Float']['input']>;
};

export type ApplicantUserUpdateInput = {
  applicantUserDetails?: InputMaybe<ApplicantUserDetailsInput>;
  id: Scalars['ObjectID']['input'];
};

export type ApplicantUserUpdatePaymentInstrumentInput = {
  paymentInstrument: AddPaymentInstrumentInput;
  paymentInstrumentId: Scalars['String']['input'];
};

export type ArchivedCaseSummary = {
  __typename?: 'ArchivedCaseSummary';
  archivedAt: Scalars['DateTime']['output'];
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  state: Scalars['String']['output'];
};

export type ArchivedCaseSummaryActivityLog = {
  __typename?: 'ArchivedCaseSummaryActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ArchivedCaseSummaryAffirmations = {
  __typename?: 'ArchivedCaseSummaryAffirmations';
  audit?: Maybe<ArchivedCaseSummaryAffirmationsAudit>;
};

export type ArchivedCaseSummaryAffirmationsAudit = {
  __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCaseSummaryDecision = {
  __typename?: 'ArchivedCaseSummaryDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCaseSummaryFinanceDetails = {
  __typename?: 'ArchivedCaseSummaryFinanceDetails';
  transactions?: Maybe<ArchivedCaseSummaryFinanceDetailsTransactions>;
};

export type ArchivedCaseSummaryFinanceDetailsAdhocTransaction = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval>;
  reason?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<ArchivedCaseSummaryTransactionReference>;
};

export type ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type ArchivedCaseSummaryFinanceDetailsTransactionSubmission = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<ArchivedCaseSummaryTransactionReference>;
};

export type ArchivedCaseSummaryFinanceDetailsTransactions = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<ArchivedCaseSummaryFinanceDetailsAdhocTransaction>>>;
  submission?: Maybe<ArchivedCaseSummaryFinanceDetailsTransactionSubmission>;
};

export type ArchivedCaseSummaryTransactionReference = {
  __typename?: 'ArchivedCaseSummaryTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCredentialVerificationCaseSummary = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  activityLog: Array<Maybe<ArchivedCaseSummaryActivityLog>>;
  applicant: ApplicantUser;
  archiveEligibleAt: Scalars['DateTime']['output'];
  archivedAt: Scalars['DateTime']['output'];
  caseDetails: ArchivedCredentialVerificationCaseSummaryCaseDetails;
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails: ArchivedCaseSummaryFinanceDetails;
  id: Scalars['ObjectID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  state: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetails = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
  application: ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication;
  applicationReview: ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
  credentialTitle: Scalars['String']['output'];
  credentialType: Scalars['String']['output'];
  dateCredentialIssuedAt: Scalars['DateTime']['output'];
  issuingInstitution?: Maybe<Entity>;
  issuingInstitutionName?: Maybe<Scalars['String']['output']>;
  nameOnCredential: Scalars['String']['output'];
  otherIssuingInstitution?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution>;
  program?: Maybe<Scalars['String']['output']>;
  sendDestination?: Maybe<Entity>;
  sendDestinationName: Scalars['String']['output'];
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
  institutionName?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
  decision: ArchivedCaseSummaryDecision;
  privateCaseDetails: ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails;
  verificationAffirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
  alternativeVerifyingEntity?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity>;
  institutionContactDetails?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails>;
  verificationStatus?: Maybe<ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
  isVerifiedWithOther?: Maybe<Scalars['Boolean']['output']>;
  otherDetails?: Maybe<Scalars['String']['output']>;
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail: Scalars['String']['output'];
  institutionPhone: Scalars['String']['output'];
};

export type ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
  verificationResponse?: Maybe<Scalars['String']['output']>;
};

export type ArchivedIdentityVerificationCaseSummary = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  activityLog: Array<Maybe<ArchivedCaseSummaryActivityLog>>;
  applicant: ApplicantUser;
  archiveEligibleAt: Scalars['DateTime']['output'];
  archivedAt: Scalars['DateTime']['output'];
  caseDetails: ArchivedIdentityVerificationCaseSummaryCaseDetails;
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails: ArchivedCaseSummaryFinanceDetails;
  id: Scalars['ObjectID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  state: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetails = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
  application: ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication;
  applicationReview: ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview;
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
  passportDetails: ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails;
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: Maybe<Scalars['Boolean']['output']>;
  isPassportInLatinCharacters?: Maybe<Scalars['Boolean']['output']>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  passportIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
};

export type ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
  decision: ArchivedCaseSummaryDecision;
  notaryAffirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
};

export type ArchivedSendReportCaseSummary = {
  __typename?: 'ArchivedSendReportCaseSummary';
  activityLog: Array<Maybe<ArchivedCaseSummaryActivityLog>>;
  applicant: ApplicantUser;
  archiveEligibleAt: Scalars['DateTime']['output'];
  archivedAt: Scalars['DateTime']['output'];
  caseDetails: ArchivedSendReportCaseSummaryCaseDetails;
  caseName: Scalars['String']['output'];
  caseType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails: ArchivedCaseSummaryFinanceDetails;
  id: Scalars['ObjectID']['output'];
  lastActivityAt: Scalars['DateTime']['output'];
  state: Scalars['String']['output'];
  submittedAt: Scalars['DateTime']['output'];
};

export type ArchivedSendReportCaseSummaryCaseDetails = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
  application: ArchivedSendReportCaseSummaryCaseDetailsApplication;
  applicationReview: ArchivedSendReportCaseSummaryCaseDetailsApplicationReview;
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplication = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication';
  credential: CredentialVerificationCaseV1;
  credentialTitle: Scalars['String']['output'];
  destination: Entity;
  destinationEmail: Scalars['String']['output'];
  destinationName: Scalars['String']['output'];
  destinationPhone: Scalars['String']['output'];
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplicationReview = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
  affirmations?: Maybe<ArchivedCaseSummaryAffirmations>;
  decision: ArchivedCaseSummaryDecision;
  privateCaseDetails: ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails;
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
  institutionContactDetails: ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails;
};

export type ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail: Scalars['String']['output'];
  institutionPhone: Scalars['String']['output'];
};

export type BlobActivityLog = {
  __typename?: 'BlobActivityLog';
  data?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  logType?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['String']['output']>;
  user?: Maybe<UserData>;
};

export type BlobAuthHeader = {
  __typename?: 'BlobAuthHeader';
  authHeader?: Maybe<Scalars['String']['output']>;
  blobName?: Maybe<Scalars['String']['output']>;
  blobPath?: Maybe<Scalars['String']['output']>;
  indexTags?: Maybe<Array<Maybe<BlobIndexTag>>>;
  metadataFields?: Maybe<Array<Maybe<BlobMetadataField>>>;
  requestDate?: Maybe<Scalars['String']['output']>;
};

export type BlobCountriesInput = {
  blobData: CountriesInput;
};

export type BlobCountriesMutationResult = MutationResult & {
  __typename?: 'BlobCountriesMutationResult';
  countries: BlobCountryEvent;
  status: MutationStatus;
};

export type BlobCountry = {
  __typename?: 'BlobCountry';
  countryCode?: Maybe<Scalars['String']['output']>;
  countryName?: Maybe<Scalars['String']['output']>;
  states?: Maybe<Array<Maybe<BlobState>>>;
};

export type BlobCountryEvent = {
  __typename?: 'BlobCountryEvent';
  apiName: Scalars['String']['output'];
  eventPayload?: Maybe<BlobCountryEventPayload>;
  eventTimestamp: Scalars['DateTime']['output'];
  eventUuid: Scalars['String']['output'];
  replayId: Scalars['String']['output'];
};

export type BlobCountryEventPayload = {
  __typename?: 'BlobCountryEventPayload';
  countries: Array<BlobCountry>;
  externalId?: Maybe<Scalars['String']['output']>;
};

export type BlobCountryEventPayloadInput = {
  countries: Array<BlobCountryInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
};

export type BlobCountryInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countryName?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<InputMaybe<BlobStateInputData>>>;
};

export type BlobFeatureFlag = {
  __typename?: 'BlobFeatureFlag';
  allowedValues: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  retirementDate: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type BlobFeatureFlagInput = {
  blobData: FeatureFlagsInput;
};

export type BlobFeatureFlagInputData = {
  allowedValues: Array<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  name: Scalars['String']['input'];
  retirementDate: Scalars['DateTime']['input'];
  value: Scalars['String']['input'];
};

export type BlobFeatureFlagMutationResult = MutationResult & {
  __typename?: 'BlobFeatureFlagMutationResult';
  featureFlags?: Maybe<Array<BlobFeatureFlag>>;
  status: MutationStatus;
};

export type BlobFinanceAdditionalCharge = {
  __typename?: 'BlobFinanceAdditionalCharge';
  creditGLAccount?: Maybe<Scalars['String']['output']>;
  debitGLAccount?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceAdditionalChargeInput = {
  creditGLAccount?: InputMaybe<Scalars['String']['input']>;
  debitGLAccount?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceCharge = {
  __typename?: 'BlobFinanceCharge';
  amount?: Maybe<Scalars['Float']['output']>;
  chargeType?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
};

export type BlobFinanceConfig = {
  __typename?: 'BlobFinanceConfig';
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<BlobFinanceGlConfig>;
  id?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceConfigInput = {
  blobData: FinanceConfigInput;
  caseType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceConfigMutationResult = MutationResult & {
  __typename?: 'BlobFinanceConfigMutationResult';
  financeGlConfig: BlobFinanceConfig;
  status: MutationStatus;
};

export type BlobFinanceConfigNameInput = {
  configBlobName: Scalars['String']['input'];
};

export type BlobFinanceGlAccount = {
  __typename?: 'BlobFinanceGlAccount';
  accountId?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
};

export type BlobFinanceGlConfig = {
  __typename?: 'BlobFinanceGlConfig';
  additionalCharges?: Maybe<Array<Maybe<BlobFinanceAdditionalCharge>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  recognition?: Maybe<BlobFinanceRefund>;
  refunds?: Maybe<BlobFinanceRefund>;
  submission?: Maybe<BlobFinanceSubmission>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceGlConfigInput = {
  additionalCharges?: InputMaybe<Array<InputMaybe<BlobFinanceAdditionalChargeInput>>>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  recognition?: InputMaybe<BlobFinanceRefundInput>;
  refunds?: InputMaybe<BlobFinanceRefundInput>;
  submission?: InputMaybe<BlobFinanceSubmissionInput>;
  version?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceGlEvent = {
  __typename?: 'BlobFinanceGlEvent';
  eventCode?: Maybe<Scalars['String']['output']>;
  eventDesc?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  records?: Maybe<Array<BlobFinanceGlRecord>>;
};

export type BlobFinanceGlRecord = {
  __typename?: 'BlobFinanceGlRecord';
  amount?: Maybe<Scalars['Float']['output']>;
  glCreditAccountId?: Maybe<Scalars['String']['output']>;
  glDebitAccountId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  inclPNReferenceNumber?: Maybe<Scalars['Boolean']['output']>;
};

export type BlobFinanceGlTemplate = {
  __typename?: 'BlobFinanceGlTemplate';
  events?: Maybe<Array<BlobFinanceGlEvent>>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  isExceptionCase?: Maybe<Scalars['Boolean']['output']>;
};

export type BlobFinanceInput = {
  caseType: Scalars['String']['input'];
};

export type BlobFinanceRefund = {
  __typename?: 'BlobFinanceRefund';
  creditGLAccount?: Maybe<Scalars['String']['output']>;
  debitGLAccount?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceRefundInput = {
  creditGLAccount?: InputMaybe<Scalars['String']['input']>;
  debitGLAccount?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinanceSubmission = {
  __typename?: 'BlobFinanceSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGLAccount?: Maybe<Scalars['String']['output']>;
  debitGLAccount?: Maybe<Scalars['String']['output']>;
};

export type BlobFinanceSubmissionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  creditGLAccount?: InputMaybe<Scalars['String']['input']>;
  debitGLAccount?: InputMaybe<Scalars['String']['input']>;
};

export type BlobFinancialConfig = {
  __typename?: 'BlobFinancialConfig';
  caseType?: Maybe<Scalars['String']['output']>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  ruleName?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type BlobHealthProfession = {
  __typename?: 'BlobHealthProfession';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  healthProfessions?: Maybe<Array<Maybe<HealthProfessionsData>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BlobHealthProfessionsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  healthProfessions?: InputMaybe<Array<InputMaybe<HealthProfessionsDataInput>>>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  updatedBy?: InputMaybe<Scalars['String']['input']>;
};

export type BlobHealthProfessionsMutationResult = MutationResult & {
  __typename?: 'BlobHealthProfessionsMutationResult';
  healthProfessions: BlobHealthProfession;
  status: MutationStatus;
};

export type BlobIndexTag = {
  __typename?: 'BlobIndexTag';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BlobMetadataField = {
  __typename?: 'BlobMetadataField';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type BlobState = {
  __typename?: 'BlobState';
  stateCode?: Maybe<Scalars['String']['output']>;
  stateName?: Maybe<Scalars['String']['output']>;
};

export type BlobStateInputData = {
  stateCode?: InputMaybe<Scalars['String']['input']>;
  stateName?: InputMaybe<Scalars['String']['input']>;
};

/**  Required to enable Apollo Cache Control  */
export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CaseDecisionResult = {
  __typename?: 'CaseDecisionResult';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<CaseSearchStaffUserResult>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CaseLastActivityResult = {
  __typename?: 'CaseLastActivityResult';
  activity?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseReIndexResult = {
  __typename?: 'CaseReIndexResult';
  credentialCaseReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  identityCaseReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sendReportCaseReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type CaseResult = {
  __typename?: 'CaseResult';
  applicantId?: Maybe<Scalars['String']['output']>;
  applicantName?: Maybe<Scalars['String']['output']>;
  caseName?: Maybe<Scalars['String']['output']>;
  caseType?: Maybe<Scalars['String']['output']>;
  caseWorkerAssigned?: Maybe<CaseSearchStaffUserResult>;
  clientId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  credentialType?: Maybe<Scalars['String']['output']>;
  decision?: Maybe<CaseDecisionResult>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  lastActivity?: Maybe<CaseLastActivityResult>;
  revisionRequest?: Maybe<CaseRevisionRequestResult>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseRevisionRequestResult = {
  __typename?: 'CaseRevisionRequestResult';
  commentsToApplicant?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<CaseSearchStaffUserResult>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CaseSearchFacets = {
  __typename?: 'CaseSearchFacets';
  caseType?: Maybe<Array<Maybe<FacetDetail>>>;
  caseWorkerAssigned?: Maybe<Array<Maybe<FacetDetail>>>;
  clientId?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  credentialType?: Maybe<Array<Maybe<FacetDetail>>>;
  decisionCompletedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  decisionCompletedBy?: Maybe<Array<Maybe<FacetDetail>>>;
  decisionResult?: Maybe<Array<Maybe<FacetDetail>>>;
  expirationEligibleAt?: Maybe<Array<Maybe<FacetDetail>>>;
  lastActivityCreatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  revisionRequestRequestedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  revisionRequestRequestedBy?: Maybe<Array<Maybe<FacetDetail>>>;
  revisionRequestSubmittedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  state?: Maybe<Array<Maybe<FacetDetail>>>;
  submittedAt?: Maybe<Array<Maybe<FacetDetail>>>;
  systemTags?: Maybe<Array<Maybe<FacetDetail>>>;
  tags?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type CaseSearchFilterDetail = {
  applicantId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caseWorkerAssigned?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  credentialType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decisionCompletedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decisionCompletedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  decisionResult?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expirationEligibleAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastActivityCreatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revisionRequestRequestedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revisionRequestRequestedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  revisionRequestSubmittedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  state?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CaseSearchInput = {
  options?: InputMaybe<CaseSearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type CaseSearchOptions = {
  filter?: InputMaybe<CaseSearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type CaseSearchResult = {
  __typename?: 'CaseSearchResult';
  caseResults?: Maybe<Array<Maybe<CaseResult>>>;
  count?: Maybe<Scalars['Int']['output']>;
  facets?: Maybe<CaseSearchFacets>;
};

export type CaseSearchStaffUserResult = {
  __typename?: 'CaseSearchStaffUserResult';
  displayName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
};

export type CountriesInput = {
  apiName: Scalars['String']['input'];
  eventPayload?: InputMaybe<BlobCountryEventPayloadInput>;
  eventTimestamp: Scalars['DateTime']['input'];
  eventUuid: Scalars['String']['input'];
  replayId: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1 = MongoBase & {
  __typename?: 'CredentialVerificationCaseV1';
  activityLog?: Maybe<Array<Maybe<CredentialVerificationCaseV1ActivityLog>>>;
  applicant?: Maybe<ApplicantUser>;
  archiveEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  assets?: Maybe<CredentialVerificationCaseV1Assets>;
  caseDetails?: Maybe<CredentialVerificationCaseV1CaseDetails>;
  caseFlagged?: Maybe<Array<Maybe<CredentialVerificationCaseV1CaseFlagged>>>;
  caseHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1CaseHistory>>>;
  caseName?: Maybe<Scalars['String']['output']>;
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails?: Maybe<CredentialVerificationCaseV1FinanceDetails>;
  id: Scalars['ObjectID']['output'];
  isCurrentUserAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Maybe<CredentialVerificationCaseV1Message>>>;
  purgeEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  revisionRequest?: Maybe<CredentialVerificationCaseV1RevisionRequest>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<CredentialVerificationCaseV1Search>;
  state: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1ActivityLog = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1ActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1ActivityLogInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CredentialVerificationCaseV1AdhocPaymentRequestInput = {
  adhocPaymentType?: InputMaybe<Scalars['String']['input']>;
  adhocTransactionId?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1Affirmations = {
  __typename?: 'CredentialVerificationCaseV1Affirmations';
  audit?: Maybe<CredentialVerificationCaseV1Audit>;
  isCredentialAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialSentForVerification?: Maybe<Scalars['String']['output']>;
  isDateOfBirthAcceptable?: Maybe<Scalars['String']['output']>;
  isEntityAcceptable?: Maybe<Scalars['String']['output']>;
  isNameAcceptable?: Maybe<Scalars['String']['output']>;
  isTranslationAcceptable?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1AffirmationsInput = {
  audit?: InputMaybe<CredentialVerificationCaseV1AuditInput>;
  isCredentialAcceptable?: InputMaybe<Scalars['String']['input']>;
  isCredentialDetailsAcceptable?: InputMaybe<Scalars['String']['input']>;
  isCredentialSentForVerification?: InputMaybe<Scalars['String']['input']>;
  isDateOfBirthAcceptable?: InputMaybe<Scalars['String']['input']>;
  isEntityAcceptable?: InputMaybe<Scalars['String']['input']>;
  isNameAcceptable?: InputMaybe<Scalars['String']['input']>;
  isTranslationAcceptable?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1AlternateVerifyingEntity = {
  __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
  isVerifiedWithOther?: Maybe<Scalars['Boolean']['output']>;
  otherDetails?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1AlternateVerifyingEntityInput = {
  isVerifiedWithOther?: InputMaybe<Scalars['Boolean']['input']>;
  otherDetails?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1Application = {
  __typename?: 'CredentialVerificationCaseV1Application';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialAssets?: Maybe<CredentialVerificationCaseV1CredentialAssets>;
  credentialTitle?: Maybe<Scalars['String']['output']>;
  credentialType?: Maybe<Scalars['String']['output']>;
  dateCredentialIssuedAt?: Maybe<Scalars['Date']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  isCredentialInEnglish?: Maybe<Scalars['Boolean']['output']>;
  isNameOnCredentialMatchPassport?: Maybe<Scalars['Boolean']['output']>;
  issuingInstitution?: Maybe<Entity>;
  nameOnCredential?: Maybe<Scalars['String']['output']>;
  otherIssuingInstitution?: Maybe<CredentialVerificationCaseV1OtherIssuingInstitution>;
  program?: Maybe<Scalars['String']['output']>;
  sendDestination?: Maybe<Entity>;
};

export type CredentialVerificationCaseV1ApplicationInput = {
  credentialAssets?: InputMaybe<CredentialVerificationCaseV1CredentialAssetsInput>;
  credentialTitle?: InputMaybe<Scalars['String']['input']>;
  credentialType?: InputMaybe<Scalars['String']['input']>;
  dateCredentialIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  isAttestationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  isCredentialInEnglish?: InputMaybe<Scalars['Boolean']['input']>;
  isNameOnCredentialMatchPassport?: InputMaybe<Scalars['Boolean']['input']>;
  issuingInstitution?: InputMaybe<Scalars['ObjectID']['input']>;
  nameOnCredential?: InputMaybe<Scalars['String']['input']>;
  otherIssuingInstitution?: InputMaybe<CredentialVerificationCaseV1OtherIssuingInstitutionInput>;
  program?: InputMaybe<Scalars['String']['input']>;
  sendDestination?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CredentialVerificationCaseV1ApplicationReview = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReview';
  affirmations?: Maybe<CredentialVerificationCaseV1Affirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  decision?: Maybe<CredentialVerificationCaseV1ApplicationReviewDecision>;
  privateCaseDetails?: Maybe<CredentialVerificationCaseV1PrivateCaseDetails>;
  verificationAffirmations?: Maybe<CredentialVerificationCaseV1VerificationAffirmations>;
};

export type CredentialVerificationCaseV1ApplicationReviewDecision = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1ApplicationReviewDecisionInput = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1ApplicationReviewInput = {
  affirmations?: InputMaybe<CredentialVerificationCaseV1AffirmationsInput>;
  caseWorkerAssigned?: InputMaybe<Scalars['ObjectID']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  decision?: InputMaybe<CredentialVerificationCaseV1ApplicationReviewDecisionInput>;
  privateCaseDetails?: InputMaybe<CredentialVerificationCaseV1PrivateCaseDetailsInput>;
  verificationAffirmations?: InputMaybe<CredentialVerificationCaseV1VerificationAffirmationsInput>;
};

export type CredentialVerificationCaseV1AssetHistory = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1AssetHistory';
  assetUploadedBy?: Maybe<StaffUser>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1AssetHistoryInput = {
  assetUploadedBy?: InputMaybe<Scalars['ObjectID']['input']>;
  assetVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
};

export type CredentialVerificationCaseV1Assets = {
  __typename?: 'CredentialVerificationCaseV1Assets';
  private?: Maybe<CredentialVerificationCaseV1AssetsPrivate>;
};

export type CredentialVerificationCaseV1AssetsInput = {
  private?: InputMaybe<CredentialVerificationCaseV1AssetsPrivateInput>;
};

export type CredentialVerificationCaseV1AssetsPrivate = {
  __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
  verificationComponentPacket?: Maybe<Scalars['String']['output']>;
  verificationComponentPacketHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
  verificationForm?: Maybe<Scalars['String']['output']>;
  verificationFormHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
  verificationPacket?: Maybe<Scalars['String']['output']>;
  verificationPacketHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
  verificationPacketResponse?: Maybe<Scalars['String']['output']>;
  verificationPacketResponseHistory?: Maybe<Array<Maybe<CredentialVerificationCaseV1AssetHistory>>>;
};

export type CredentialVerificationCaseV1AssetsPrivateInput = {
  verificationComponentPacket?: InputMaybe<Scalars['String']['input']>;
  verificationComponentPacketVersion?: InputMaybe<Scalars['String']['input']>;
  verificationForm?: InputMaybe<Scalars['String']['input']>;
  verificationFormVersion?: InputMaybe<Scalars['String']['input']>;
  verificationPacket?: InputMaybe<Scalars['String']['input']>;
  verificationPacketResponse?: InputMaybe<Scalars['String']['input']>;
  verificationPacketResponseVersion?: InputMaybe<Scalars['String']['input']>;
  verificationPacketVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1Audit = {
  __typename?: 'CredentialVerificationCaseV1Audit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1AuditInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type CredentialVerificationCaseV1BlobContentAuthHeaderResult = MutationResult & {
  __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: Maybe<BlobAuthHeader>;
  case?: Maybe<CredentialVerificationCaseV1>;
  status: MutationStatus;
};

export type CredentialVerificationCaseV1BlobFileInput = {
  caseId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1CaseDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  application?: Maybe<CredentialVerificationCaseV1Application>;
  applicationReview?: Maybe<CredentialVerificationCaseV1ApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseDetailsInput = {
  application?: InputMaybe<CredentialVerificationCaseV1ApplicationInput>;
  applicationReview?: InputMaybe<CredentialVerificationCaseV1ApplicationReviewInput>;
};

export type CredentialVerificationCaseV1CaseFlagged = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1CaseFlagged';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseFlaggedInput = {
  flagType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1CaseHistory = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1CaseHistory';
  caseDetails?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetails>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  revisionRequest?: Maybe<CredentialVerificationCaseV1CaseHistoryRevisionRequest>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetails';
  application?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication>;
  applicationReview?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialAssets?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets>;
  credentialTitle?: Maybe<Scalars['String']['output']>;
  credentialType?: Maybe<Scalars['String']['output']>;
  dateCredentialIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  isCredentialInEnglish?: Maybe<Scalars['Boolean']['output']>;
  isNameOnCredentialMatchPassport?: Maybe<Scalars['Boolean']['output']>;
  issuingInstitution?: Maybe<Entity>;
  nameOnCredential?: Maybe<Scalars['String']['output']>;
  otherIssuingInstitution?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution>;
  program?: Maybe<Scalars['String']['output']>;
  sendDestination?: Maybe<Entity>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
  affirmations?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision>;
  privateCaseDetails?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails>;
  verificationAffirmations?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
  audit?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit>;
  isCredentialAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isCredentialSentForVerification?: Maybe<Scalars['String']['output']>;
  isDateOfBirthAcceptable?: Maybe<Scalars['String']['output']>;
  isEntityAcceptable?: Maybe<Scalars['String']['output']>;
  isNameAcceptable?: Maybe<Scalars['String']['output']>;
  isTranslationAcceptable?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails';
  alternateVerifyingEntity?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity>;
  entitySuppliedCredential?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential>;
  institutionContactDetails?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails>;
  verificationStatus?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity';
  isVerifiedWithOther?: Maybe<Scalars['Boolean']['output']>;
  otherDetails?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail?: Maybe<Scalars['String']['output']>;
  institutionPhone?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
  verificationResponse?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations';
  audit?: Maybe<CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit>;
  isCredentialReturnedFromEntity?: Maybe<Scalars['String']['output']>;
  isEntityDetailCorrect?: Maybe<Scalars['String']['output']>;
  isReturnedFromCorrectEntity?: Maybe<Scalars['String']['output']>;
  isVerificationComplete?: Maybe<Scalars['String']['output']>;
  isVerificationComponentPacketCompiled?: Maybe<Scalars['String']['output']>;
  isVerificationInEnglishOrWithTranslation?: Maybe<Scalars['String']['output']>;
  isVerificationMethodAcceptable?: Maybe<Scalars['String']['output']>;
  isVerificationStatusComplete?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryRevisionRequest = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges = {
  __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
  requestUpdatedCredentialDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  requestUploadCredential?: Maybe<Scalars['Boolean']['output']>;
  requestUploadTranslation?: Maybe<Scalars['Boolean']['output']>;
};

export type CredentialVerificationCaseV1CredentialAssets = {
  __typename?: 'CredentialVerificationCaseV1CredentialAssets';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1CredentialAssetsInput = {
  credential?: InputMaybe<Scalars['String']['input']>;
  credentialUploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  credentialVersion?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
  translationUploadedAt?: InputMaybe<Scalars['DateTime']['input']>;
  translationVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1DeleteInput = {
  caseId: Scalars['ObjectID']['input'];
};

export type CredentialVerificationCaseV1EntitySuppliedCredential = {
  __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential';
  credential?: Maybe<Scalars['String']['output']>;
  credentialUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  credentialVersion?: Maybe<Scalars['String']['output']>;
  translation?: Maybe<Scalars['String']['output']>;
  translationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  translationVersion?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1EntitySuppliedCredentialInput = {
  credential?: InputMaybe<Scalars['String']['input']>;
  credentialVersion?: InputMaybe<Scalars['String']['input']>;
  translation?: InputMaybe<Scalars['String']['input']>;
  translationVersion?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1FileRemoveInput = {
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1FinanceDetails = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetails';
  financeConfig?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfig>;
  revenueRecognition?: Maybe<CredentialVerificationCaseV1RevenueRecognition>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactions>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfig = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfig>;
  note?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfig = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
  additionalCharges?: Maybe<Array<Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge>>>;
  recognition?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition>;
  refunds?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds>;
  submission?: Maybe<CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRecognition';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRefunds';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsInput = {
  transactions?: InputMaybe<CredentialVerificationCaseV1FinanceDetailsTransactionsInput>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  financeReference?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  status?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
  applicantRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApprovalInput = {
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicantApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFinanceReference';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  approval?: InputMaybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApprovalInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactions = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions>>>;
  submission?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsInput = {
  adhocTransactions?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsInput>>>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference>;
};

export type CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1InstitutionContactDetails = {
  __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
  institutionEmail?: Maybe<Scalars['String']['output']>;
  institutionPhone?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1InstitutionContactDetailsInput = {
  institutionEmail?: InputMaybe<Scalars['String']['input']>;
  institutionPhone?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1MergePdfFilesInput = {
  blobPaths: Array<InputMaybe<FileInfoInput>>;
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type CredentialVerificationCaseV1Message = MongoSubdocument & {
  __typename?: 'CredentialVerificationCaseV1Message';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  embedding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  initiatedBy?: Maybe<StaffUser>;
  isHiddenFromApplicant?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1MessageInput = {
  embedding?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isHiddenFromApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1MutationResult = MutationResult & {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  credentialVerificationCaseV1?: Maybe<CredentialVerificationCaseV1>;
  status: MutationStatus;
};

export type CredentialVerificationCaseV1OtherIssuingInstitution = {
  __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  institutionName?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1OtherIssuingInstitutionInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  institutionName?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1PrivateCaseDetails = {
  __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
  alternateVerifyingEntity?: Maybe<CredentialVerificationCaseV1AlternateVerifyingEntity>;
  entitySuppliedCredential?: Maybe<CredentialVerificationCaseV1EntitySuppliedCredential>;
  institutionContactDetails?: Maybe<CredentialVerificationCaseV1InstitutionContactDetails>;
  verificationStatus?: Maybe<CredentialVerificationCaseV1VerificationStatus>;
};

export type CredentialVerificationCaseV1PrivateCaseDetailsInput = {
  alternateVerifyingEntity?: InputMaybe<CredentialVerificationCaseV1AlternateVerifyingEntityInput>;
  entitySuppliedCredential?: InputMaybe<CredentialVerificationCaseV1EntitySuppliedCredentialInput>;
  institutionContactDetails?: InputMaybe<CredentialVerificationCaseV1InstitutionContactDetailsInput>;
  verificationStatus?: InputMaybe<CredentialVerificationCaseV1VerificationStatusInput>;
};

export type CredentialVerificationCaseV1ProcessPaymentInput = {
  paymentAmount: Scalars['Float']['input'];
};

export type CredentialVerificationCaseV1RequestedChanges = {
  __typename?: 'CredentialVerificationCaseV1RequestedChanges';
  requestUpdatedCredentialDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  requestUploadCredential?: Maybe<Scalars['Boolean']['output']>;
  requestUploadTranslation?: Maybe<Scalars['Boolean']['output']>;
};

export type CredentialVerificationCaseV1RequestedChangesInput = {
  requestUpdatedCredentialDetails?: InputMaybe<Scalars['Boolean']['input']>;
  requestUpdatedIssuingInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadCredential?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadTranslation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CredentialVerificationCaseV1RevenueRecognition = {
  __typename?: 'CredentialVerificationCaseV1RevenueRecognition';
  recognition?: Maybe<CredentialVerificationCaseV1RevenueRecognitionRecognition>;
  submission?: Maybe<CredentialVerificationCaseV1RevenueRecognitionSubmission>;
};

export type CredentialVerificationCaseV1RevenueRecognitionRecognition = {
  __typename?: 'CredentialVerificationCaseV1RevenueRecognitionRecognition';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1RevenueRecognitionSubmission = {
  __typename?: 'CredentialVerificationCaseV1RevenueRecognitionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1RevisionRequest = {
  __typename?: 'CredentialVerificationCaseV1RevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<CredentialVerificationCaseV1RequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1RevisionRequestInput = {
  requestedChanges?: InputMaybe<CredentialVerificationCaseV1RequestedChangesInput>;
  revisionSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionSummary?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1Search = {
  __typename?: 'CredentialVerificationCaseV1Search';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CredentialVerificationCaseV1StateInput = {
  newState?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1UpdateInput = {
  activityLog?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1ActivityLogInput>>>;
  adhocPayment?: InputMaybe<CredentialVerificationCaseV1AdhocPaymentRequestInput>;
  archiveEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<CredentialVerificationCaseV1AssetsInput>;
  caseDetails?: InputMaybe<CredentialVerificationCaseV1CaseDetailsInput>;
  caseFlagged?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1CaseFlaggedInput>>>;
  caseName?: InputMaybe<Scalars['String']['input']>;
  caseType?: InputMaybe<Scalars['String']['input']>;
  expirationEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  financeDetails?: InputMaybe<CredentialVerificationCaseV1FinanceDetailsInput>;
  id: Scalars['ObjectID']['input'];
  messages?: InputMaybe<Array<InputMaybe<CredentialVerificationCaseV1MessageInput>>>;
  payment?: InputMaybe<CredentialVerificationCaseV1ProcessPaymentInput>;
  purgeEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionRequest?: InputMaybe<CredentialVerificationCaseV1RevisionRequestInput>;
  state?: InputMaybe<CredentialVerificationCaseV1StateInput>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CredentialVerificationCaseV1VerificationAffirmations = {
  __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
  audit?: Maybe<CredentialVerificationCaseV1Audit>;
  isCredentialReturnedFromEntity?: Maybe<Scalars['String']['output']>;
  isEntityDetailCorrect?: Maybe<Scalars['String']['output']>;
  isReturnedFromCorrectEntity?: Maybe<Scalars['String']['output']>;
  isVerificationComplete?: Maybe<Scalars['String']['output']>;
  isVerificationComponentPacketCompiled?: Maybe<Scalars['String']['output']>;
  isVerificationInEnglishOrWithTranslation?: Maybe<Scalars['String']['output']>;
  isVerificationMethodAcceptable?: Maybe<Scalars['String']['output']>;
  isVerificationStatusComplete?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1VerificationAffirmationsInput = {
  audit?: InputMaybe<CredentialVerificationCaseV1AuditInput>;
  isCredentialReturnedFromEntity?: InputMaybe<Scalars['String']['input']>;
  isEntityDetailCorrect?: InputMaybe<Scalars['String']['input']>;
  isReturnedFromCorrectEntity?: InputMaybe<Scalars['String']['input']>;
  isVerificationComplete?: InputMaybe<Scalars['String']['input']>;
  isVerificationComponentPacketCompiled?: InputMaybe<Scalars['String']['input']>;
  isVerificationInEnglishOrWithTranslation?: InputMaybe<Scalars['String']['input']>;
  isVerificationMethodAcceptable?: InputMaybe<Scalars['String']['input']>;
  isVerificationStatusComplete?: InputMaybe<Scalars['String']['input']>;
};

export type CredentialVerificationCaseV1VerificationStatus = {
  __typename?: 'CredentialVerificationCaseV1VerificationStatus';
  verificationResponse?: Maybe<Scalars['String']['output']>;
};

export type CredentialVerificationCaseV1VerificationStatusInput = {
  verificationResponse?: InputMaybe<Scalars['String']['input']>;
};

export type Entity = MongoBase & {
  __typename?: 'Entity';
  address?: Maybe<EntityAddressInfo>;
  client?: Maybe<EntityClient>;
  clientDisabledAt?: Maybe<Scalars['Date']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  disabledAt?: Maybe<Scalars['Date']['output']>;
  entityLanguage?: Maybe<Scalars['String']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  institutionDisabledAt?: Maybe<Scalars['Date']['output']>;
  isClient?: Maybe<Scalars['Boolean']['output']>;
  isIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  issuingInstitution?: Maybe<EntityIssuingInstitution>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntityAddressInfo = {
  __typename?: 'EntityAddressInfo';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  stateOrProvince?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type EntityAddressInfoInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  stateOrProvince?: InputMaybe<Scalars['String']['input']>;
  zipOrPostalCode?: InputMaybe<Scalars['String']['input']>;
};

export type EntityClient = {
  __typename?: 'EntityClient';
  address?: Maybe<EntityAddressInfo>;
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EntityClientInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EntityCreateInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  client?: InputMaybe<EntityClientInput>;
  entityLanguage?: InputMaybe<Scalars['String']['input']>;
  entityName: Scalars['String']['input'];
  isClient: Scalars['Boolean']['input'];
  isIssuingInstitution: Scalars['Boolean']['input'];
  issuingInstitution?: InputMaybe<EntityIssuingInstitutionInput>;
};

export type EntityIssuingInstitution = {
  __typename?: 'EntityIssuingInstitution';
  address?: Maybe<EntityAddressInfo>;
  email?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EntityIssuingInstitutionInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type EntityMutationResult = MutationResult & {
  __typename?: 'EntityMutationResult';
  entity?: Maybe<Entity>;
  status: MutationStatus;
};

export type EntityReIndexResult = {
  __typename?: 'EntityReIndexResult';
  entityReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type EntityResult = {
  __typename?: 'EntityResult';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  disabledAt?: Maybe<Scalars['Date']['output']>;
  entityName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isClient?: Maybe<Scalars['Boolean']['output']>;
  isIssuingInstitution?: Maybe<Scalars['Boolean']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type EntitySearchFacets = {
  __typename?: 'EntitySearchFacets';
  country?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  disabledAt?: Maybe<Array<Maybe<FacetDetail>>>;
  isClient?: Maybe<Array<Maybe<FacetDetail>>>;
  isIssuingInstitution?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type EntitySearchFilterDetail = {
  country?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disabledAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isIssuingInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EntitySearchInput = {
  options?: InputMaybe<EntitySearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type EntitySearchOptions = {
  filter?: InputMaybe<EntitySearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type EntitySearchResult = {
  __typename?: 'EntitySearchResult';
  count?: Maybe<Scalars['Int']['output']>;
  entityResults?: Maybe<Array<Maybe<EntityResult>>>;
  facets?: Maybe<EntitySearchFacets>;
};

export type EntityUpdateInput = {
  address?: InputMaybe<EntityAddressInfoInput>;
  client?: InputMaybe<EntityClientInput>;
  disabledAt?: InputMaybe<Scalars['Date']['input']>;
  entityLanguage?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ObjectID']['input'];
  isClient?: InputMaybe<Scalars['Boolean']['input']>;
  isClientDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isInstitutionDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  isIssuingInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  issuingInstitution?: InputMaybe<EntityIssuingInstitutionInput>;
};

export type FacetDetail = {
  __typename?: 'FacetDetail';
  count?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type FeatureFlagsInput = {
  featureFlags?: InputMaybe<Array<BlobFeatureFlagInputData>>;
};

export type FileInfo = {
  __typename?: 'FileInfo';
  name: Scalars['String']['output'];
  size?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type FileInfoInput = {
  fileName: Scalars['String']['input'];
  fileType: Scalars['String']['input'];
};

export type FinanceConfigInput = {
  effectiveAt?: InputMaybe<Scalars['DateTime']['input']>;
  glConfig?: InputMaybe<BlobFinanceGlConfigInput>;
};

export type GlPostingSummary = MongoBase & {
  __typename?: 'GlPostingSummary';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  glSummary: Array<Maybe<GlPostingSummaryGlSummary>>;
  glTransactionDate: Scalars['Date']['output'];
  id: Scalars['ObjectID']['output'];
  postingAttempt?: Maybe<Array<Maybe<GlPostingSummaryPostingAttempt>>>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlPostingSummaryCreateInput = {
  glSummary: Array<InputMaybe<GlPostingSummaryGlSummaryInput>>;
  glTransactionDate: Scalars['Date']['input'];
};

export type GlPostingSummaryDeleteInput = {
  id: Scalars['ObjectID']['input'];
};

export type GlPostingSummaryGlSummary = MongoSubdocument & {
  __typename?: 'GlPostingSummaryGlSummary';
  accountingType: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  glAccountId: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlPostingSummaryGlSummaryInput = {
  accountingType: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  glAccountId: Scalars['String']['input'];
};

export type GlPostingSummaryPostingAttempt = MongoSubdocument & {
  __typename?: 'GlPostingSummaryPostingAttempt';
  attemptData: GlPostingSummaryPostingAttemptAttemptData;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdUser: Scalars['String']['output'];
  id: Scalars['ObjectID']['output'];
  responseData?: Maybe<GlPostingSummaryPostingAttemptResponseData>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GlPostingSummaryPostingAttemptAttemptData = {
  __typename?: 'GlPostingSummaryPostingAttemptAttemptData';
  attemptedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
};

export type GlPostingSummaryPostingAttemptAttemptDataInput = {
  status: Scalars['String']['input'];
};

export type GlPostingSummaryPostingAttemptInput = {
  attemptData?: InputMaybe<GlPostingSummaryPostingAttemptAttemptDataInput>;
  createdUser?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  responseData?: InputMaybe<GlPostingSummaryPostingAttemptResponseDataInput>;
};

export type GlPostingSummaryPostingAttemptResponseData = {
  __typename?: 'GlPostingSummaryPostingAttemptResponseData';
  errorMessage?: Maybe<Scalars['String']['output']>;
  glBatchNumber?: Maybe<Scalars['String']['output']>;
  isSuccess: Scalars['Boolean']['output'];
  jEntryNumber?: Maybe<Scalars['Int']['output']>;
  respondedAt: Scalars['DateTime']['output'];
};

export type GlPostingSummaryPostingAttemptResponseDataInput = {
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  glBatchNumber?: InputMaybe<Scalars['String']['input']>;
  isSuccess: Scalars['Boolean']['input'];
  jEntryNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type GlPostingSummaryUpdateInput = {
  id: Scalars['ObjectID']['input'];
  postingAttempt?: InputMaybe<Array<InputMaybe<GlPostingSummaryPostingAttemptInput>>>;
};

export type GlTransactionSummary = {
  __typename?: 'GlTransactionSummary';
  amount: Scalars['Float']['output'];
  applicant: ApplicantUser;
  case: Scalars['ObjectID']['output'];
  caseType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  feeType?: Maybe<Scalars['String']['output']>;
  financeReference: GlTransactionSummaryFinanceReference;
  id: Scalars['ObjectID']['output'];
  institution?: Maybe<Entity>;
  reason?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<GlTransactionSummaryTransactionReference>;
  transactionType: Scalars['String']['output'];
};

export type GlTransactionSummaryCreateInput = {
  amount: Scalars['Float']['input'];
  applicant: Scalars['ObjectID']['input'];
  case: Scalars['ObjectID']['input'];
  caseType: Scalars['String']['input'];
  feeType?: InputMaybe<Scalars['String']['input']>;
  financeReference?: InputMaybe<GlTransactionSummaryFinanceReferenceInput>;
  institution?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  transactionReference?: InputMaybe<GlTransactionSummaryTransactionReferenceeInput>;
  transactionType: Scalars['String']['input'];
};

export type GlTransactionSummaryDeleteInput = {
  id: Scalars['ObjectID']['input'];
};

export type GlTransactionSummaryFinanceReference = {
  __typename?: 'GlTransactionSummaryFinanceReference';
  creditGlAccount: Scalars['String']['output'];
  debitGlAccount: Scalars['String']['output'];
};

export type GlTransactionSummaryFinanceReferenceInput = {
  creditGlAccount: Scalars['String']['input'];
  debitGlAccount: Scalars['String']['input'];
};

export type GlTransactionSummaryTransactionReference = {
  __typename?: 'GlTransactionSummaryTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type GlTransactionSummaryTransactionReferenceeInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type HealthProfessionsData = {
  __typename?: 'HealthProfessionsData';
  professionCode?: Maybe<Scalars['String']['output']>;
  professionName?: Maybe<Scalars['String']['output']>;
};

export type HealthProfessionsDataInput = {
  professionCode?: InputMaybe<Scalars['String']['input']>;
  professionName?: InputMaybe<Scalars['String']['input']>;
};

export type HealthProfessionsInput = {
  blobData: BlobHealthProfessionsInput;
};

export type IdentityVerificationCaseV1 = MongoBase & {
  __typename?: 'IdentityVerificationCaseV1';
  activityLog?: Maybe<Array<Maybe<IdentityVerificationCaseV1ActivityLog>>>;
  applicant?: Maybe<ApplicantUser>;
  archiveEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  assets?: Maybe<IdentityVerificationCaseV1Assets>;
  caseDetails?: Maybe<IdentityVerificationCaseV1CaseDetails>;
  caseFlagged?: Maybe<Array<Maybe<IdentityVerificationCaseV1CaseFlagged>>>;
  caseHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1CaseHistory>>>;
  caseName: Scalars['String']['output'];
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails?: Maybe<IdentityVerificationCaseV1FinanceDetails>;
  id: Scalars['ObjectID']['output'];
  isCurrentUserAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Maybe<IdentityVerificationCaseV1Message>>>;
  purgeEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  revisionRequest?: Maybe<IdentityVerificationCaseV1RevisionRequest>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<IdentityVerificationCaseV1Search>;
  state: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1ActivityLog = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1ActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1ActivityLogInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type IdentityVerificationCaseV1AdhocPaymentRequestInput = {
  adhocPaymentType?: InputMaybe<Scalars['String']['input']>;
  adhocTransactionId?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1Assets = {
  __typename?: 'IdentityVerificationCaseV1Assets';
  private?: Maybe<IdentityVerificationCaseV1AssetsPrivate>;
  shared?: Maybe<IdentityVerificationCaseV1AssetsShared>;
};

export type IdentityVerificationCaseV1AssetsInput = {
  private?: InputMaybe<IdentityVerificationCaseV1AssetsPrivateInput>;
  shared?: InputMaybe<IdentityVerificationCaseV1AssetsSharedInput>;
};

export type IdentityVerificationCaseV1AssetsPrivate = {
  __typename?: 'IdentityVerificationCaseV1AssetsPrivate';
  redactedNotarizedIdForm?: Maybe<Scalars['String']['output']>;
  redactedNotarizedIdFormHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1AssetsPrivateRedactedNotarizedIdFormHistory>>>;
};

export type IdentityVerificationCaseV1AssetsPrivateInput = {
  redactedNotarizedIdForm?: InputMaybe<Scalars['String']['input']>;
  redactedNotarizedIdFormVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1AssetsPrivateRedactedNotarizedIdFormHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1AssetsPrivateRedactedNotarizedIdFormHistory';
  assetUploadedBy?: Maybe<User>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1AssetsShared = {
  __typename?: 'IdentityVerificationCaseV1AssetsShared';
  idForm?: Maybe<Scalars['String']['output']>;
  idFormHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1AssetsSharedIdFormHistory>>>;
  notarizedIdForm?: Maybe<Scalars['String']['output']>;
  notarizedIdFormHistory?: Maybe<Array<Maybe<IdentityVerificationCaseV1AssetsSharedNotarizedIdFormHistory>>>;
};

export type IdentityVerificationCaseV1AssetsSharedIdFormHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1AssetsSharedIdFormHistory';
  assetUploadedBy?: Maybe<User>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1AssetsSharedInput = {
  idForm?: InputMaybe<Scalars['String']['input']>;
  idFormVersion?: InputMaybe<Scalars['String']['input']>;
  notarizedIdForm?: InputMaybe<Scalars['String']['input']>;
  notarizedIdFormVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1AssetsSharedNotarizedIdFormHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1AssetsSharedNotarizedIdFormHistory';
  assetUploadedBy?: Maybe<User>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1BlobContentAuthHeaderResult = MutationResult & {
  __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: Maybe<BlobAuthHeader>;
  case?: Maybe<IdentityVerificationCaseV1>;
  status: MutationStatus;
};

export type IdentityVerificationCaseV1BlobFileInput = {
  caseId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1CaseDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  application?: Maybe<IdentityVerificationCaseV1CaseDetailsApplication>;
  applicationReview?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplication = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  caseWorkerModifiedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  notarizationDetails?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails>;
  passportAssets?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets>;
  passportDetails?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails>;
  photoAssets?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationInput = {
  caseWorkerModifiedPassportDetails?: InputMaybe<Scalars['Boolean']['input']>;
  isAttestationComplete?: InputMaybe<Scalars['Boolean']['input']>;
  notarizationDetails?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetailsInput>;
  passportAssets?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsInput>;
  passportDetails?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsInput>;
  photoAssets?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsInput>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetails';
  isNotarizationComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationNotarizationDetailsInput = {
  isNotarizationComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
  passport?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['String']['output']>;
  passportExpirationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportExpirationVersion?: Maybe<Scalars['String']['output']>;
  passportTranslation?: Maybe<Scalars['String']['output']>;
  passportTranslationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportTranslationVersion?: Maybe<Scalars['String']['output']>;
  passportUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportAssetsInput = {
  passport?: InputMaybe<Scalars['String']['input']>;
  passportExpiration?: InputMaybe<Scalars['String']['input']>;
  passportExpirationVersion?: InputMaybe<Scalars['String']['input']>;
  passportTranslation?: InputMaybe<Scalars['String']['input']>;
  passportTranslationVersion?: InputMaybe<Scalars['String']['input']>;
  passportVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: Maybe<Scalars['Boolean']['output']>;
  isPassportInLatinCharacters?: Maybe<Scalars['Boolean']['output']>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiresAt?: Maybe<Scalars['Date']['output']>;
  passportIssuedAt?: Maybe<Scalars['Date']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPassportDetailsInput = {
  isPassportExpirationDateVisible?: InputMaybe<Scalars['Boolean']['input']>;
  isPassportInLatinCharacters?: InputMaybe<Scalars['Boolean']['input']>;
  passportCountry?: InputMaybe<Scalars['String']['input']>;
  passportExpiresAt?: InputMaybe<Scalars['Date']['input']>;
  passportIssuedAt?: InputMaybe<Scalars['Date']['input']>;
  passportNumber?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets';
  photo?: Maybe<Scalars['String']['output']>;
  photoUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  photoVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssetsInput = {
  photo?: InputMaybe<Scalars['String']['input']>;
  photoVersion?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReview = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
  affirmations?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision>;
  notaryAffirmations?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit>;
  isIdDocumentAcceptable?: Maybe<Scalars['String']['output']>;
  isIdDocumentDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isPhotoAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAuditInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsInput = {
  audit?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAuditInput>;
  isIdDocumentAcceptable?: InputMaybe<Scalars['String']['input']>;
  isIdDocumentDetailsAcceptable?: InputMaybe<Scalars['String']['input']>;
  isPhotoAcceptable?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionInput = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewInput = {
  affirmations?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsInput>;
  caseWorkerAssigned?: InputMaybe<Scalars['ObjectID']['input']>;
  decision?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewDecisionInput>;
  notaryAffirmations?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsInput>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit>;
  isNotarizedIdAcceptable?: Maybe<Scalars['String']['output']>;
  isNotaryAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAuditInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsInput = {
  audit?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAuditInput>;
  isNotarizedIdAcceptable?: InputMaybe<Scalars['String']['input']>;
  isNotaryAcceptable?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseDetailsInput = {
  application?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationInput>;
  applicationReview?: InputMaybe<IdentityVerificationCaseV1CaseDetailsApplicationReviewInput>;
};

export type IdentityVerificationCaseV1CaseFlagged = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1CaseFlagged';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseFlaggedInput = {
  flagType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1CaseHistory = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1CaseHistory';
  caseDetails?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetails>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  revisionRequest?: Maybe<IdentityVerificationCaseV1CaseHistoryRevisionRequest>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetails';
  application?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication>;
  applicationReview?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  caseWorkerModifiedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
  notarizationDetails?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails>;
  passportAssets?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets>;
  passportDetails?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails>;
  photoAssets?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails';
  isNotarizationComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets';
  passport?: Maybe<Scalars['String']['output']>;
  passportExpiration?: Maybe<Scalars['String']['output']>;
  passportExpirationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportExpirationVersion?: Maybe<Scalars['String']['output']>;
  passportTranslation?: Maybe<Scalars['String']['output']>;
  passportTranslationUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportTranslationVersion?: Maybe<Scalars['String']['output']>;
  passportUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  passportVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: Maybe<Scalars['Boolean']['output']>;
  isPassportInLatinCharacters?: Maybe<Scalars['Boolean']['output']>;
  passportCountry?: Maybe<Scalars['String']['output']>;
  passportExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  passportIssuedAt?: Maybe<Scalars['DateTime']['output']>;
  passportNumber?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets';
  photo?: Maybe<Scalars['String']['output']>;
  photoUploadedAt?: Maybe<Scalars['DateTime']['output']>;
  photoVersion?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
  affirmations?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision>;
  notaryAffirmations?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit>;
  isIdDocumentAcceptable?: Maybe<Scalars['String']['output']>;
  isIdDocumentDetailsAcceptable?: Maybe<Scalars['String']['output']>;
  isPhotoAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations';
  audit?: Maybe<IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit>;
  isNotarizedIdAcceptable?: Maybe<Scalars['String']['output']>;
  isNotaryAcceptable?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryRevisionRequest = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges = {
  __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
  requestScheduleNotaryCam?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUploadExpirationPage?: Maybe<Scalars['Boolean']['output']>;
  requestUploadNotarizedIdForm?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassport?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassportTranslation?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPhoto?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1DeleteInput = {
  caseId: Scalars['ObjectID']['input'];
};

export type IdentityVerificationCaseV1FileRemoveInput = {
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type IdentityVerificationCaseV1FinanceDetails = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  financeConfig?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfig>;
  revenueRecognition?: Maybe<IdentityVerificationCaseV1FinanceDetailsRevenueRecognition>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactions>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfig = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig>;
  note?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
  additionalCharges?: Maybe<Array<Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge>>>;
  recognition?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition>;
  refunds?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds>;
  submission?: Maybe<IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRecognition';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigRefunds';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsInput = {
  transactions?: InputMaybe<IdentityVerificationCaseV1FinanceDetailsTransactionsInput>;
};

export type IdentityVerificationCaseV1FinanceDetailsRevenueRecognition = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsRevenueRecognition';
  recognition?: Maybe<IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionRecognition>;
  submission?: Maybe<IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionSubmission>;
};

export type IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionRecognition = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionRecognition';
  amount?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionSubmission = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsRevenueRecognitionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactions = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction>>>;
  submission?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  financeReference?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  status?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval';
  applicantRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApprovalInput = {
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicantApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionInput = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  approval?: InputMaybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApprovalInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsInput = {
  adhocTransactions?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionInput>>>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference>;
};

export type IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1Message = MongoSubdocument & {
  __typename?: 'IdentityVerificationCaseV1Message';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  embedding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  initiatedBy?: Maybe<StaffUser>;
  isHiddenFromApplicant?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1MessageInput = {
  embedding?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isHiddenFromApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1MutationResult = MutationResult & {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: Maybe<IdentityVerificationCaseV1>;
  status: MutationStatus;
};

export type IdentityVerificationCaseV1ProcessPaymentInput = {
  paymentAmount: Scalars['Float']['input'];
  paymentInstrument?: InputMaybe<AddPaymentInstrumentInput>;
  paymentInstrumentId?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1RevisionRequest = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<IdentityVerificationCaseV1RevisionRequestRequestedChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type IdentityVerificationCaseV1RevisionRequestInput = {
  requestedChanges?: InputMaybe<IdentityVerificationCaseV1RevisionRequestRequestedChangesInput>;
  revisionSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionSummary?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1RevisionRequestRequestedChanges = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
  requestScheduleNotaryCam?: Maybe<Scalars['Boolean']['output']>;
  requestUpdatedPassportDetails?: Maybe<Scalars['Boolean']['output']>;
  requestUploadExpirationPage?: Maybe<Scalars['Boolean']['output']>;
  requestUploadNotarizedIdForm?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassport?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPassportTranslation?: Maybe<Scalars['Boolean']['output']>;
  requestUploadPhoto?: Maybe<Scalars['Boolean']['output']>;
};

export type IdentityVerificationCaseV1RevisionRequestRequestedChangesInput = {
  requestScheduleNotaryCam?: InputMaybe<Scalars['Boolean']['input']>;
  requestUpdatedPassportDetails?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadExpirationPage?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadNotarizedIdForm?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadPassport?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadPassportTranslation?: InputMaybe<Scalars['Boolean']['input']>;
  requestUploadPhoto?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentityVerificationCaseV1Search = {
  __typename?: 'IdentityVerificationCaseV1Search';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityVerificationCaseV1StateInput = {
  newState?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type IdentityVerificationCaseV1UpdateInput = {
  activityLog?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1ActivityLogInput>>>;
  adhocPayment?: InputMaybe<IdentityVerificationCaseV1AdhocPaymentRequestInput>;
  archiveEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<IdentityVerificationCaseV1AssetsInput>;
  caseDetails?: InputMaybe<IdentityVerificationCaseV1CaseDetailsInput>;
  caseFlagged?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1CaseFlaggedInput>>>;
  caseName?: InputMaybe<Scalars['String']['input']>;
  expirationEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  financeDetails?: InputMaybe<IdentityVerificationCaseV1FinanceDetailsInput>;
  id: Scalars['ObjectID']['input'];
  messages?: InputMaybe<Array<InputMaybe<IdentityVerificationCaseV1MessageInput>>>;
  payment?: InputMaybe<IdentityVerificationCaseV1ProcessPaymentInput>;
  purgeEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionRequest?: InputMaybe<IdentityVerificationCaseV1RevisionRequestInput>;
  state?: InputMaybe<IdentityVerificationCaseV1StateInput>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Base type for all models in mongo. */
export type MongoBase = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ObjectID']['output'];
  schemaVersion?: Maybe<Scalars['String']['output']>;
  /** Automatically generated timestamp, updated on every save. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Base type for all models in mongo. */
export type MongoSubdocument = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The ID of the object. */
  id: Scalars['ObjectID']['output'];
  /** Automatically generated timestamp, updated on every save. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type Mutation = {
  __typename?: 'Mutation';
  /** IGNORE: Dummy field necessary for the Mutation type to be valid */
  _empty?: Maybe<Scalars['String']['output']>;
  applicantUserDelete: ApplicantUserMutationResult;
  applicantUserFileCreateAuthHeader: ApplicantUserBlobContentAuthHeaderResult;
  applicantUserFileRemove: ApplicantUserMutationResult;
  applicantUserUpdate: ApplicantUserMutationResult;
  applicantUserUpdatePaymentInstrument: PaymentInstrumentResult;
  credentialVerificationCaseV1Delete?: Maybe<CredentialVerificationCaseV1MutationResult>;
  credentialVerificationCaseV1FileCreateAuthHeader: CredentialVerificationCaseV1BlobContentAuthHeaderResult;
  credentialVerificationCaseV1FileRemove: CredentialVerificationCaseV1MutationResult;
  credentialVerificationCaseV1ImageFileCreateAuthHeader: CredentialVerificationCaseV1BlobContentAuthHeaderResult;
  credentialVerificationCaseV1MergePdfFiles: CredentialVerificationCaseV1MutationResult;
  credentialVerificationCaseV1PdfFileCreateAuthHeader: CredentialVerificationCaseV1BlobContentAuthHeaderResult;
  credentialVerificationCaseV1Update?: Maybe<CredentialVerificationCaseV1MutationResult>;
  entityCreate: EntityMutationResult;
  entityDelete: EntityMutationResult;
  entityUpdate: EntityMutationResult;
  healthProfessionsUpdate?: Maybe<BlobHealthProfessionsMutationResult>;
  identityVerificationCaseV1Delete: IdentityVerificationCaseV1MutationResult;
  identityVerificationCaseV1FileCreateAuthHeader: IdentityVerificationCaseV1BlobContentAuthHeaderResult;
  identityVerificationCaseV1FileRemove: IdentityVerificationCaseV1MutationResult;
  identityVerificationCaseV1ImageFileCreateAuthHeader: IdentityVerificationCaseV1BlobContentAuthHeaderResult;
  identityVerificationCaseV1PdfFileCreateAuthHeader: IdentityVerificationCaseV1BlobContentAuthHeaderResult;
  identityVerificationCaseV1Update: IdentityVerificationCaseV1MutationResult;
  processMaliciousFileScan?: Maybe<ProcessMaliciousFileScanMutationResult>;
  sendReportCaseV1Delete: SendReportCaseV1MutationResult;
  sendReportCaseV1FileRemove: SendReportCaseV1MutationResult;
  sendReportCaseV1ImageFileCreateAuthHeader: SendReportCaseV1BlobContentAuthHeaderResult;
  sendReportCaseV1MergePdfFiles: SendReportCaseV1MutationResult;
  sendReportCaseV1PdfFileCreateAuthHeader: SendReportCaseV1BlobContentAuthHeaderResult;
  sendReportCaseV1Update: SendReportCaseV1MutationResult;
  staffRoleCreate: StaffRoleMutationResult;
  staffRoleDelete: StaffRoleMutationResult;
  staffRoleUpdate: StaffRoleMutationResult;
  staffUserDelete: StaffUserMutationResult;
  staffUserUpdate: StaffUserMutationResult;
  updateBlobCountries?: Maybe<BlobCountriesMutationResult>;
  updateBlobFeatureFlags?: Maybe<BlobFeatureFlagMutationResult>;
  updateBlobFinanceGlConfig?: Maybe<BlobFinanceConfigMutationResult>;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserDeleteArgs = {
  applicantUserId: Scalars['ObjectID']['input'];
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserFileCreateAuthHeaderArgs = {
  input: ApplicantUserBlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserFileRemoveArgs = {
  input: ApplicantUserPublicFileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserUpdateArgs = {
  input: ApplicantUserUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationApplicantUserUpdatePaymentInstrumentArgs = {
  input: ApplicantUserUpdatePaymentInstrumentInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1DeleteArgs = {
  input: CredentialVerificationCaseV1DeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1FileCreateAuthHeaderArgs = {
  input: CredentialVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1FileRemoveArgs = {
  input: CredentialVerificationCaseV1FileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1ImageFileCreateAuthHeaderArgs = {
  input: CredentialVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1MergePdfFilesArgs = {
  input: CredentialVerificationCaseV1MergePdfFilesInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1PdfFileCreateAuthHeaderArgs = {
  input: CredentialVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationCredentialVerificationCaseV1UpdateArgs = {
  input: CredentialVerificationCaseV1UpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationEntityCreateArgs = {
  input: EntityCreateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationEntityDeleteArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationEntityUpdateArgs = {
  input: EntityUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationHealthProfessionsUpdateArgs = {
  input: HealthProfessionsInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1DeleteArgs = {
  input: IdentityVerificationCaseV1DeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1FileCreateAuthHeaderArgs = {
  input: IdentityVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1FileRemoveArgs = {
  input: IdentityVerificationCaseV1FileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1ImageFileCreateAuthHeaderArgs = {
  input: IdentityVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1PdfFileCreateAuthHeaderArgs = {
  input: IdentityVerificationCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationIdentityVerificationCaseV1UpdateArgs = {
  input: IdentityVerificationCaseV1UpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationProcessMaliciousFileScanArgs = {
  input: ProcessMaliciousFileScanInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1DeleteArgs = {
  input: SendReportCaseV1DeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1FileRemoveArgs = {
  input: SendReportCaseV1FileRemoveInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1ImageFileCreateAuthHeaderArgs = {
  input: SendReportCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1MergePdfFilesArgs = {
  input: SendReportCaseV1MergePdfFilesInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1PdfFileCreateAuthHeaderArgs = {
  input: SendReportCaseV1BlobFileInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationSendReportCaseV1UpdateArgs = {
  input: SendReportCaseV1UpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffRoleCreateArgs = {
  input: StaffRoleCreateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffRoleDeleteArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffRoleUpdateArgs = {
  input: StaffRoleUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffUserDeleteArgs = {
  input: StaffUserDeleteInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationStaffUserUpdateArgs = {
  input: StaffUserUpdateInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationUpdateBlobCountriesArgs = {
  input: BlobCountriesInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationUpdateBlobFeatureFlagsArgs = {
  input: BlobFeatureFlagInput;
};

/**  Base Mutation Type definition - all mutations will be defined in separate files extending this type  */
export type MutationUpdateBlobFinanceGlConfigArgs = {
  input: BlobFinanceConfigInput;
};

export type MutationResult = {
  status: MutationStatus;
};

export type MutationStatus = {
  __typename?: 'MutationStatus';
  errorMessage?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type PaymentBillingInfo = {
  __typename?: 'PaymentBillingInfo';
  billingAddressLine1?: Maybe<Scalars['String']['output']>;
  billingAddressLine2?: Maybe<Scalars['String']['output']>;
  billingCity?: Maybe<Scalars['String']['output']>;
  billingCountry?: Maybe<Scalars['String']['output']>;
  billingEmail?: Maybe<Scalars['String']['output']>;
  billingFirstName?: Maybe<Scalars['String']['output']>;
  billingLastName?: Maybe<Scalars['String']['output']>;
  billingPhone?: Maybe<Scalars['String']['output']>;
  billingPostalCode?: Maybe<Scalars['String']['output']>;
  billingState?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrument = {
  __typename?: 'PaymentInstrument';
  billTo?: Maybe<PaymentBillingInfo>;
  cardNumber?: Maybe<Scalars['String']['output']>;
  cardType?: Maybe<Scalars['String']['output']>;
  expirationMonth?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  paymentInstrumentId?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type PaymentInstrumentResult = {
  __typename?: 'PaymentInstrumentResult';
  paymentInstrument?: Maybe<PaymentInstrument>;
  status: MutationStatus;
};

export type ProcessMaliciousFileScanInput = {
  blobUrl: Scalars['String']['input'];
  initialDelay?: InputMaybe<Scalars['Int']['input']>;
  maxTimeoutMs?: InputMaybe<Scalars['Int']['input']>;
  versionId: Scalars['String']['input'];
};

export type ProcessMaliciousFileScanMutationResult = MutationResult & {
  __typename?: 'ProcessMaliciousFileScanMutationResult';
  isMalicious?: Maybe<Scalars['Boolean']['output']>;
  isSafe?: Maybe<Scalars['Boolean']['output']>;
  scanResult?: Maybe<Scalars['String']['output']>;
  status: MutationStatus;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type Query = {
  __typename?: 'Query';
  /** IGNORE: Dummy field necessary for the Query type to be valid */
  _empty?: Maybe<Scalars['String']['output']>;
  applicantUser?: Maybe<ApplicantUser>;
  applicantUserCurrent?: Maybe<ApplicantUser>;
  applicantUserCybersourcePublicKeyId?: Maybe<Scalars['String']['output']>;
  applicantUserGetAllTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  applicantUserPaymentInstrument?: Maybe<PaymentInstrument>;
  applicantUserSearch?: Maybe<ApplicantUserSearchResult>;
  archivedCasesByApplicantId?: Maybe<Array<Maybe<ArchivedCaseSummary>>>;
  archivedCredentialVerificationCaseSummary?: Maybe<ArchivedCredentialVerificationCaseSummary>;
  archivedIdentityVerificationCaseSummary?: Maybe<ArchivedIdentityVerificationCaseSummary>;
  archivedSendReportCaseSummary?: Maybe<ArchivedSendReportCaseSummary>;
  blobCountries?: Maybe<BlobCountryEvent>;
  blobFeatureFlags?: Maybe<Array<BlobFeatureFlag>>;
  blobFinanceGlConfigs?: Maybe<BlobFinanceConfig>;
  blobFinancialConfigs?: Maybe<Array<Maybe<BlobFinancialConfig>>>;
  blobFinancialGlConfig?: Maybe<BlobFinanceConfig>;
  blobHealthProfessions?: Maybe<BlobHealthProfession>;
  caseGetAllTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  caseReIndex?: Maybe<CaseReIndexResult>;
  caseSearch?: Maybe<CaseSearchResult>;
  credentialCaseReIndex?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  credentialVerificationCaseV1?: Maybe<CredentialVerificationCaseV1>;
  credentialVerificationCaseV1Current?: Maybe<CredentialVerificationCaseV1>;
  credentialVerificationCasesV1ByApplicant?: Maybe<Array<Maybe<CredentialVerificationCaseV1>>>;
  entities?: Maybe<Array<Maybe<Entity>>>;
  entity?: Maybe<Entity>;
  entityByName?: Maybe<Entity>;
  entityReIndex?: Maybe<EntityReIndexResult>;
  entitySearch?: Maybe<EntitySearchResult>;
  glPostingSummariesByDateRange?: Maybe<Array<Maybe<GlPostingSummary>>>;
  glTransactionSummariesByDateRange?: Maybe<Array<Maybe<GlTransactionSummary>>>;
  identityCaseReIndex?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  identityVerificationCaseV1?: Maybe<IdentityVerificationCaseV1>;
  identityVerificationCaseV1Current?: Maybe<IdentityVerificationCaseV1>;
  identityVerificationCasesV1ByApplicant?: Maybe<Array<Maybe<IdentityVerificationCaseV1>>>;
  sendReportCaseReIndex?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sendReportCaseV1?: Maybe<SendReportCaseV1>;
  sendReportCaseV1Current?: Maybe<SendReportCaseV1>;
  sendReportCasesV1?: Maybe<Array<Maybe<SendReportCaseV1>>>;
  sendReportCasesV1ByApplicant?: Maybe<Array<Maybe<SendReportCaseV1>>>;
  serverDate?: Maybe<Scalars['String']['output']>;
  staffRole?: Maybe<StaffRole>;
  staffRoles?: Maybe<Array<Maybe<StaffRole>>>;
  staffUser?: Maybe<StaffUser>;
  staffUserCurrent?: Maybe<StaffUser>;
  staffUserGetAllTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  staffUserSearch?: Maybe<StaffUserSearchResult>;
  staffUsers?: Maybe<Array<Maybe<StaffUser>>>;
  userReIndex?: Maybe<UserReIndexResult>;
  verifiedCredentialVerificationCaseSummariesByApplicant?: Maybe<Array<Maybe<VerifiedCredentialVerificationCaseSummary>>>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryApplicantUserArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryApplicantUserPaymentInstrumentArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryApplicantUserSearchArgs = {
  input?: InputMaybe<ApplicantUserSearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedCasesByApplicantIdArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedCredentialVerificationCaseSummaryArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedIdentityVerificationCaseSummaryArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryArchivedSendReportCaseSummaryArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryBlobFinanceGlConfigsArgs = {
  input: BlobFinanceInput;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryBlobFinancialGlConfigArgs = {
  input: BlobFinanceConfigNameInput;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCaseSearchArgs = {
  input?: InputMaybe<CaseSearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCredentialVerificationCaseV1Args = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCredentialVerificationCaseV1CurrentArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryCredentialVerificationCasesV1ByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryEntityArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryEntityByNameArgs = {
  entityName: Scalars['String']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryEntitySearchArgs = {
  input?: InputMaybe<EntitySearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryGlPostingSummariesByDateRangeArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryGlTransactionSummariesByDateRangeArgs = {
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryIdentityVerificationCaseV1Args = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryIdentityVerificationCaseV1CurrentArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryIdentityVerificationCasesV1ByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QuerySendReportCaseV1Args = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QuerySendReportCaseV1CurrentArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QuerySendReportCasesV1ByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffRoleArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffUserArgs = {
  id: Scalars['ObjectID']['input'];
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffUserCurrentArgs = {
  oid?: InputMaybe<Scalars['String']['input']>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryStaffUserSearchArgs = {
  input?: InputMaybe<StaffUserSearchInput>;
};

/**  Base Query Type definition - , all mutations will be defined in separate files extending this type  */
export type QueryVerifiedCredentialVerificationCaseSummariesByApplicantArgs = {
  applicantId: Scalars['ObjectID']['input'];
};

export type SendReportCaseV1 = MongoBase & {
  __typename?: 'SendReportCaseV1';
  activityLog?: Maybe<Array<Maybe<SendReportCaseV1ActivityLog>>>;
  applicant?: Maybe<ApplicantUser>;
  archiveEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  assets?: Maybe<SendReportCaseV1Asset>;
  caseDetails?: Maybe<SendReportCaseV1CaseDetails>;
  caseFlagged?: Maybe<Array<Maybe<SendReportCaseV1CaseFlagged>>>;
  caseHistory?: Maybe<Array<Maybe<SendReportCaseV1CaseHistory>>>;
  caseName?: Maybe<Scalars['String']['output']>;
  caseType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  expirationEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  fileByFileName?: Maybe<FileInfo>;
  files?: Maybe<Array<Maybe<FileInfo>>>;
  financeDetails?: Maybe<SendReportCaseV1FinanceDetails>;
  id: Scalars['ObjectID']['output'];
  isCurrentUserAssigned?: Maybe<Scalars['Boolean']['output']>;
  lastActivityAt?: Maybe<Scalars['DateTime']['output']>;
  lastStatusChangeAt?: Maybe<Scalars['DateTime']['output']>;
  messages?: Maybe<Array<Maybe<SendReportCaseV1Message>>>;
  purgeEligibleAt?: Maybe<Scalars['DateTime']['output']>;
  revisionRequest?: Maybe<SendReportCaseV1RevisionRequest>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<SendReportCaseV1Search>;
  state: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  systemTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FileByFileNameArgs = {
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1ActivityLog = MongoSubdocument & {
  __typename?: 'SendReportCaseV1ActivityLog';
  activityBy?: Maybe<User>;
  activityType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  metaData?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1ActivityLogInput = {
  activityType?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  metaData?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SendReportCaseV1AdhocPaymentRequestInput = {
  adhocPaymentType?: InputMaybe<Scalars['String']['input']>;
  adhocTransactionId?: InputMaybe<Scalars['String']['input']>;
  amount: Scalars['Float']['input'];
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  reason: Scalars['String']['input'];
};

export type SendReportCaseV1Asset = {
  __typename?: 'SendReportCaseV1Asset';
  private?: Maybe<SendReportCaseV1AssetPrivate>;
};

export type SendReportCaseV1AssetPrivate = {
  __typename?: 'SendReportCaseV1AssetPrivate';
  statusReportCoverLetter?: Maybe<Scalars['String']['output']>;
  statusReportCoverLetterHistory?: Maybe<Array<Maybe<SendReportCaseV1AssetPrivateStatusReportCoverLetterHistory>>>;
  verificationStatusReport?: Maybe<Scalars['String']['output']>;
  verificationStatusReportHistory?: Maybe<Array<Maybe<SendReportCaseV1AssetPrivateVerificationStatusReportHistory>>>;
};

export type SendReportCaseV1AssetPrivateInput = {
  statusReportCoverLetter?: InputMaybe<Scalars['String']['input']>;
  statusReportCoverLetterVersion?: InputMaybe<Scalars['String']['input']>;
  verificationStatusReport?: InputMaybe<Scalars['String']['input']>;
  verificationStatusReportVersion?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1AssetPrivateStatusReportCoverLetterHistory = MongoSubdocument & {
  __typename?: 'SendReportCaseV1AssetPrivateStatusReportCoverLetterHistory';
  assetUploadedBy?: Maybe<StaffUser>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1AssetPrivateVerificationStatusReportHistory = MongoSubdocument & {
  __typename?: 'SendReportCaseV1AssetPrivateVerificationStatusReportHistory';
  assetUploadedBy?: Maybe<StaffUser>;
  assetVersion?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1AssetsInput = {
  private?: InputMaybe<SendReportCaseV1AssetPrivateInput>;
};

export type SendReportCaseV1AuditType = {
  __typename?: 'SendReportCaseV1AuditType';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  result?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1AuditTypeInput = {
  setAffirmationsComplete: Scalars['Boolean']['input'];
};

export type SendReportCaseV1BlobContentAuthHeaderResult = MutationResult & {
  __typename?: 'SendReportCaseV1BlobContentAuthHeaderResult';
  authHeader?: Maybe<BlobAuthHeader>;
  case?: Maybe<SendReportCaseV1>;
  status: MutationStatus;
};

export type SendReportCaseV1BlobFileInput = {
  caseId: Scalars['ObjectID']['input'];
  contentLength: Scalars['Int']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1CaseDetails = {
  __typename?: 'SendReportCaseV1CaseDetails';
  application?: Maybe<SendReportCaseV1CaseDetailsApplication>;
  applicationReview?: Maybe<SendReportCaseV1CaseDetailsApplicationReview>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  initiatedByApplicant?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1CaseDetailsApplication = {
  __typename?: 'SendReportCaseV1CaseDetailsApplication';
  attestedAt?: Maybe<Scalars['DateTime']['output']>;
  credential?: Maybe<CredentialVerificationCaseV1>;
  destination?: Maybe<Entity>;
  isAttestationComplete?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1CaseDetailsApplicationInput = {
  credential?: InputMaybe<Scalars['ObjectID']['input']>;
  destination?: InputMaybe<Scalars['ObjectID']['input']>;
  isAttestationComplete?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1CaseDetailsApplicationReview = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
  affirmations?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewAffirmation>;
  caseWorkerAssigned?: Maybe<StaffUser>;
  decision?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewDecision>;
  privateCaseDetails?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewAffirmation = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
  audit?: Maybe<SendReportCaseV1AuditType>;
  isDestinationAcceptable?: Maybe<Scalars['String']['output']>;
  isReportCompiled?: Maybe<Scalars['String']['output']>;
  isReportSent?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewAffirmationInput = {
  audit?: InputMaybe<SendReportCaseV1AuditTypeInput>;
  isDestinationAcceptable?: InputMaybe<Scalars['String']['input']>;
  isReportCompiled?: InputMaybe<Scalars['String']['input']>;
  isReportSent?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewDecision = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  completedBy?: Maybe<StaffUser>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewDecisionInput = {
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  result?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewInput = {
  affirmations?: InputMaybe<SendReportCaseV1CaseDetailsApplicationReviewAffirmationInput>;
  caseWorkerAssigned?: InputMaybe<Scalars['ObjectID']['input']>;
  decision?: InputMaybe<SendReportCaseV1CaseDetailsApplicationReviewDecisionInput>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails';
  institutionContactDetails?: Maybe<SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails>;
};

export type SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
  institutionEmail?: Maybe<Scalars['String']['output']>;
  institutionPhone?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1CaseDetailsInput = {
  application?: InputMaybe<SendReportCaseV1CaseDetailsApplicationInput>;
  applicationReview?: InputMaybe<SendReportCaseV1CaseDetailsApplicationReviewInput>;
  initiatedByApplicant?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1CaseFlagged = MongoSubdocument & {
  __typename?: 'SendReportCaseV1CaseFlagged';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  flagType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1CaseFlaggedInput = {
  flagType?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1CaseHistory = MongoSubdocument & {
  __typename?: 'SendReportCaseV1CaseHistory';
  caseDetails?: Maybe<SendReportCaseV1CaseDetails>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  revisionRequest?: Maybe<SendReportCaseV1RevisionRequest>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1DeleteInput = {
  caseId: Scalars['ObjectID']['input'];
};

export type SendReportCaseV1FileRemoveInput = {
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1FinanceDetails = {
  __typename?: 'SendReportCaseV1FinanceDetails';
  financeConfig?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfig>;
  revenueRecognition?: Maybe<SendReportCaseV1FinanceDetailsRevenueRecognition>;
  serviceFee?: Maybe<Scalars['Float']['output']>;
  transactions?: Maybe<SendReportCaseV1FinanceDetailsTransactions>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfig = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<StaffUser>;
  effectiveAt?: Maybe<Scalars['DateTime']['output']>;
  glConfig?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfig>;
  note?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfig = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
  additionalCharges?: Maybe<Array<Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge>>>;
  recognition?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRecognition>;
  refunds?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRefunds>;
  submission?: Maybe<SendReportCaseV1FinanceDetailsFinanceConfigGlConfigSubmission>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge = MongoSubdocument & {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRecognition = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigRecognition';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigRefunds = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigRefunds';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsFinanceConfigGlConfigSubmission = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsInput = {
  transactions?: InputMaybe<SendReportCaseV1FinanceDetailsTransactionsInput>;
};

export type SendReportCaseV1FinanceDetailsRevenueRecognition = {
  __typename?: 'SendReportCaseV1FinanceDetailsRevenueRecognition';
  recognition?: Maybe<SendReportCaseV1FinanceDetailsRevenueRecognitionRecognition>;
  submission?: Maybe<SendReportCaseV1FinanceDetailsRevenueRecognitionSubmission>;
};

export type SendReportCaseV1FinanceDetailsRevenueRecognitionRecognition = {
  __typename?: 'SendReportCaseV1FinanceDetailsRevenueRecognitionRecognition';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsRevenueRecognitionSubmission = {
  __typename?: 'SendReportCaseV1FinanceDetailsRevenueRecognitionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransaction = MongoSubdocument & {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
  amount?: Maybe<Scalars['Float']['output']>;
  approval?: Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  financeReference?: Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference>;
  id: Scalars['ObjectID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  status?: Maybe<Scalars['String']['output']>;
  transactionReference?: Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval';
  applicantRespondedAt?: Maybe<Scalars['DateTime']['output']>;
  isApplicantApprovalRequired?: Maybe<Scalars['Boolean']['output']>;
  isApplicantApproved?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApprovalInput = {
  isApplicantApprovalRequired?: InputMaybe<Scalars['Boolean']['input']>;
  isApplicantApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference';
  creditGlAccount?: Maybe<Scalars['String']['output']>;
  debitGlAccount?: Maybe<Scalars['String']['output']>;
  recognizedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  approval?: InputMaybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApprovalInput>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactionSubmission = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
  amount?: Maybe<Scalars['Float']['output']>;
  transactionReference?: Maybe<SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference>;
};

export type SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
  lastRequestedAt?: Maybe<Scalars['DateTime']['output']>;
  reconciliationId?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  transactionId?: Maybe<Scalars['String']['output']>;
  vendor?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1FinanceDetailsTransactions = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
  adhocTransactions?: Maybe<Array<Maybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransaction>>>;
  submission?: Maybe<SendReportCaseV1FinanceDetailsTransactionSubmission>;
};

export type SendReportCaseV1FinanceDetailsTransactionsInput = {
  adhocTransactions?: InputMaybe<Array<InputMaybe<SendReportCaseV1FinanceDetailsTransactionAdhocTransactionInput>>>;
};

export type SendReportCaseV1MergePdfFilesInput = {
  blobPaths: Array<InputMaybe<FileInfoInput>>;
  caseId: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
};

export type SendReportCaseV1Message = MongoSubdocument & {
  __typename?: 'SendReportCaseV1Message';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  embedding?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  initiatedBy?: Maybe<StaffUser>;
  isHiddenFromApplicant?: Maybe<Scalars['Boolean']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1MessageInput = {
  embedding?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ObjectID']['input']>;
  isHiddenFromApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1MutationResult = MutationResult & {
  __typename?: 'SendReportCaseV1MutationResult';
  sendReportCaseV1?: Maybe<SendReportCaseV1>;
  status: MutationStatus;
};

export type SendReportCaseV1ProcessPaymentInput = {
  paymentAmount: Scalars['Float']['input'];
};

export type SendReportCaseV1RevisionRequest = {
  __typename?: 'SendReportCaseV1RevisionRequest';
  requestedAt?: Maybe<Scalars['DateTime']['output']>;
  requestedBy?: Maybe<StaffUser>;
  requestedChanges?: Maybe<SendReportCaseV1RevisionRequestRequestChanges>;
  revisionSubmittedAt?: Maybe<Scalars['DateTime']['output']>;
  revisionSummary?: Maybe<Scalars['String']['output']>;
};

export type SendReportCaseV1RevisionRequestInput = {
  requestedChanges?: InputMaybe<SendReportCaseV1RevisionRequestRequestChangesInput>;
  revisionSubmittedAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionSummary?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1RevisionRequestRequestChanges = {
  __typename?: 'SendReportCaseV1RevisionRequestRequestChanges';
  requestUpdatedDestination?: Maybe<Scalars['Boolean']['output']>;
};

export type SendReportCaseV1RevisionRequestRequestChangesInput = {
  requestUpdatedDestination?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SendReportCaseV1Search = {
  __typename?: 'SendReportCaseV1Search';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['DateTime']['output']>;
  indexingFailedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type SendReportCaseV1StateInput = {
  newState?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export type SendReportCaseV1UpdateInput = {
  activityLog?: InputMaybe<Array<InputMaybe<SendReportCaseV1ActivityLogInput>>>;
  adhocPayment?: InputMaybe<SendReportCaseV1AdhocPaymentRequestInput>;
  archiveEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  assets?: InputMaybe<SendReportCaseV1AssetsInput>;
  caseDetails?: InputMaybe<SendReportCaseV1CaseDetailsInput>;
  caseFlagged?: InputMaybe<Array<InputMaybe<SendReportCaseV1CaseFlaggedInput>>>;
  caseName?: InputMaybe<Scalars['String']['input']>;
  caseType?: InputMaybe<Scalars['String']['input']>;
  expirationEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  financeDetails?: InputMaybe<SendReportCaseV1FinanceDetailsInput>;
  id: Scalars['ObjectID']['input'];
  messages?: InputMaybe<Array<InputMaybe<SendReportCaseV1MessageInput>>>;
  payment?: InputMaybe<SendReportCaseV1ProcessPaymentInput>;
  purgeEligibleAt?: InputMaybe<Scalars['DateTime']['input']>;
  revisionRequest?: InputMaybe<SendReportCaseV1RevisionRequestInput>;
  state?: InputMaybe<SendReportCaseV1StateInput>;
  systemTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StaffRole = MongoBase & {
  __typename?: 'StaffRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ObjectID']['output'];
  isDefault: Scalars['Boolean']['output'];
  permissions: StaffRolePermissions;
  roleName: Scalars['String']['output'];
  roleSubtype: Scalars['String']['output'];
  roleType?: Maybe<Scalars['String']['output']>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type StaffRoleApplicantUserPermissions = {
  __typename?: 'StaffRoleApplicantUserPermissions';
  canAddOrRemoveTags: Scalars['Boolean']['output'];
  canBlockAccess: Scalars['Boolean']['output'];
  canSearchApplicants: Scalars['Boolean']['output'];
  canUpdatePersonalInformation: Scalars['Boolean']['output'];
};

export type StaffRoleApplicantUserPermissionsInput = {
  canAddOrRemoveTags?: InputMaybe<Scalars['Boolean']['input']>;
  canBlockAccess?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchApplicants?: InputMaybe<Scalars['Boolean']['input']>;
  canUpdatePersonalInformation?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleCreateInput = {
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<StaffRolePermissionsInput>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  roleSubtype?: InputMaybe<Scalars['String']['input']>;
};

export type StaffRoleCredCasePermissions = {
  __typename?: 'StaffRoleCredCasePermissions';
  canAssignCaseWorker: Scalars['Boolean']['output'];
  canAssignSelf: Scalars['Boolean']['output'];
  canBeAssignedCases: Scalars['Boolean']['output'];
  canIssueRefunds: Scalars['Boolean']['output'];
  canOverrideCaseState: Scalars['Boolean']['output'];
  canReopenCases: Scalars['Boolean']['output'];
  canSearchCases: Scalars['Boolean']['output'];
  canUnassignCaseWorker: Scalars['Boolean']['output'];
  canUnassignSelf: Scalars['Boolean']['output'];
  canViewCaseHistory: Scalars['Boolean']['output'];
  canViewCasesAssignedToOthers: Scalars['Boolean']['output'];
  canViewUnassignedCases: Scalars['Boolean']['output'];
};

export type StaffRoleCredCasePermissionsInput = {
  canAssignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canBeAssignedCases?: InputMaybe<Scalars['Boolean']['input']>;
  canIssueRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canOverrideCaseState?: InputMaybe<Scalars['Boolean']['input']>;
  canReopenCases?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchCases?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCaseHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCasesAssignedToOthers?: InputMaybe<Scalars['Boolean']['input']>;
  canViewUnassignedCases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleEntityPermissions = {
  __typename?: 'StaffRoleEntityPermissions';
  canAddEntities: Scalars['Boolean']['output'];
  canDeleteEntities: Scalars['Boolean']['output'];
  canEditEntities: Scalars['Boolean']['output'];
  canSearchEntities: Scalars['Boolean']['output'];
};

export type StaffRoleEntityPermissionsInput = {
  canAddEntities?: InputMaybe<Scalars['Boolean']['input']>;
  canDeleteEntities?: InputMaybe<Scalars['Boolean']['input']>;
  canEditEntities?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchEntities?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleIdCasePermissions = {
  __typename?: 'StaffRoleIdCasePermissions';
  canAssignCaseWorker: Scalars['Boolean']['output'];
  canAssignSelf: Scalars['Boolean']['output'];
  canBeAssignedCases: Scalars['Boolean']['output'];
  canIssueRefunds: Scalars['Boolean']['output'];
  canOverrideCaseState: Scalars['Boolean']['output'];
  canReopenCases: Scalars['Boolean']['output'];
  canSearchCases: Scalars['Boolean']['output'];
  canUnassignCaseWorker: Scalars['Boolean']['output'];
  canUnassignSelf: Scalars['Boolean']['output'];
  canViewCaseHistory: Scalars['Boolean']['output'];
  canViewCasesAssignedToOthers: Scalars['Boolean']['output'];
  canViewUnassignedCases: Scalars['Boolean']['output'];
};

export type StaffRoleIdCasePermissionsInput = {
  canAssignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canBeAssignedCases?: InputMaybe<Scalars['Boolean']['input']>;
  canIssueRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canOverrideCaseState?: InputMaybe<Scalars['Boolean']['input']>;
  canReopenCases?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchCases?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCaseHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCasesAssignedToOthers?: InputMaybe<Scalars['Boolean']['input']>;
  canViewUnassignedCases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleMutationResult = MutationResult & {
  __typename?: 'StaffRoleMutationResult';
  staffRole?: Maybe<StaffRole>;
  status: MutationStatus;
};

export type StaffRolePermissions = {
  __typename?: 'StaffRolePermissions';
  applicantUserPermissions: StaffRoleApplicantUserPermissions;
  credCasePermissions: StaffRoleCredCasePermissions;
  entityPermissions: StaffRoleEntityPermissions;
  idCasePermissions: StaffRoleIdCasePermissions;
  rolePermissions: StaffRoleRolePermissions;
  sendCasePermissions: StaffRoleSendCasePermissions;
  staffUserPermissions: StaffRoleStaffUserPermissions;
};

export type StaffRolePermissionsInput = {
  applicantUserPermissions?: InputMaybe<StaffRoleApplicantUserPermissionsInput>;
  credCasePermissions?: InputMaybe<StaffRoleCredCasePermissionsInput>;
  entityPermissions?: InputMaybe<StaffRoleEntityPermissionsInput>;
  idCasePermissions?: InputMaybe<StaffRoleIdCasePermissionsInput>;
  rolePermissions?: InputMaybe<StaffRoleRolePermissionsInput>;
  sendCasePermissions?: InputMaybe<StaffRoleSendCasePermissionsInput>;
  staffUserPermissions?: InputMaybe<StaffRoleStaffUserPermissionsInput>;
};

export type StaffRoleRolePermissions = {
  __typename?: 'StaffRoleRolePermissions';
  canAddRoles: Scalars['Boolean']['output'];
  canEditRoles: Scalars['Boolean']['output'];
  canSearchRoles: Scalars['Boolean']['output'];
};

export type StaffRoleRolePermissionsInput = {
  canAddRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canEditRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchRoles?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleSendCasePermissions = {
  __typename?: 'StaffRoleSendCasePermissions';
  canAssignCaseWorker: Scalars['Boolean']['output'];
  canAssignSelf: Scalars['Boolean']['output'];
  canBeAssignedCases: Scalars['Boolean']['output'];
  canIssueRefunds: Scalars['Boolean']['output'];
  canOverrideCaseState: Scalars['Boolean']['output'];
  canReopenCases: Scalars['Boolean']['output'];
  canSearchCases: Scalars['Boolean']['output'];
  canUnassignCaseWorker: Scalars['Boolean']['output'];
  canUnassignSelf: Scalars['Boolean']['output'];
  canViewCaseHistory: Scalars['Boolean']['output'];
  canViewCasesAssignedToOthers: Scalars['Boolean']['output'];
  canViewUnassignedCases: Scalars['Boolean']['output'];
};

export type StaffRoleSendCasePermissionsInput = {
  canAssignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canBeAssignedCases?: InputMaybe<Scalars['Boolean']['input']>;
  canIssueRefunds?: InputMaybe<Scalars['Boolean']['input']>;
  canOverrideCaseState?: InputMaybe<Scalars['Boolean']['input']>;
  canReopenCases?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchCases?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignCaseWorker?: InputMaybe<Scalars['Boolean']['input']>;
  canUnassignSelf?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCaseHistory?: InputMaybe<Scalars['Boolean']['input']>;
  canViewCasesAssignedToOthers?: InputMaybe<Scalars['Boolean']['input']>;
  canViewUnassignedCases?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleStaffUserPermissions = {
  __typename?: 'StaffRoleStaffUserPermissions';
  canAddOrRemoveTags: Scalars['Boolean']['output'];
  canAssignRoles: Scalars['Boolean']['output'];
  canBlockAccess: Scalars['Boolean']['output'];
  canSearchStaff: Scalars['Boolean']['output'];
};

export type StaffRoleStaffUserPermissionsInput = {
  canAddOrRemoveTags?: InputMaybe<Scalars['Boolean']['input']>;
  canAssignRoles?: InputMaybe<Scalars['Boolean']['input']>;
  canBlockAccess?: InputMaybe<Scalars['Boolean']['input']>;
  canSearchStaff?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StaffRoleUpdateInput = {
  id: Scalars['ObjectID']['input'];
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  permissions?: InputMaybe<StaffRolePermissionsInput>;
  roleName?: InputMaybe<Scalars['String']['input']>;
  roleSubtype?: InputMaybe<Scalars['String']['input']>;
};

export type StaffUser = MongoBase & {
  __typename?: 'StaffUser';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  role?: Maybe<StaffRole>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  search?: Maybe<StaffUserSearch>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type StaffUserDeleteInput = {
  id: Scalars['ObjectID']['input'];
};

export type StaffUserIdentityDetailsResult = {
  __typename?: 'StaffUserIdentityDetailsResult';
  firstName?: Maybe<Scalars['String']['output']>;
  restOfName?: Maybe<Scalars['String']['output']>;
};

export type StaffUserMutationResult = MutationResult & {
  __typename?: 'StaffUserMutationResult';
  staffUser?: Maybe<StaffUser>;
  status: MutationStatus;
};

export type StaffUserResult = {
  __typename?: 'StaffUserResult';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ObjectID']['output']>;
  identityDetails?: Maybe<StaffUserIdentityDetailsResult>;
  role?: Maybe<StaffUserSearchRoleResult>;
  schemaVersion?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type StaffUserSearch = {
  __typename?: 'StaffUserSearch';
  hash?: Maybe<Scalars['String']['output']>;
  indexedAt?: Maybe<Scalars['Date']['output']>;
  indexingFailedAt?: Maybe<Scalars['Date']['output']>;
};

export type StaffUserSearchFacets = {
  __typename?: 'StaffUserSearchFacets';
  accessBlocked?: Maybe<Array<Maybe<FacetDetail>>>;
  createdAt?: Maybe<Array<Maybe<FacetDetail>>>;
  role?: Maybe<Array<Maybe<FacetDetail>>>;
  schemaVersion?: Maybe<Array<Maybe<FacetDetail>>>;
  tags?: Maybe<Array<Maybe<FacetDetail>>>;
  updatedAt?: Maybe<Array<Maybe<FacetDetail>>>;
};

export type StaffUserSearchFilterDetail = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  role?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schemaVersion?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type StaffUserSearchInput = {
  options?: InputMaybe<StaffUserSearchOptions>;
  searchString?: InputMaybe<Scalars['String']['input']>;
};

export type StaffUserSearchOptions = {
  filter?: InputMaybe<StaffUserSearchFilterDetail>;
  orderBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type StaffUserSearchResult = {
  __typename?: 'StaffUserSearchResult';
  count?: Maybe<Scalars['Int']['output']>;
  facets?: Maybe<StaffUserSearchFacets>;
  staffUserResults?: Maybe<Array<Maybe<StaffUserResult>>>;
};

export type StaffUserSearchRoleResult = {
  __typename?: 'StaffUserSearchRoleResult';
  id?: Maybe<Scalars['ObjectID']['output']>;
  roleName?: Maybe<Scalars['String']['output']>;
};

export type StaffUserUpdateInput = {
  accessBlocked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ObjectID']['input'];
  role?: InputMaybe<Scalars['ObjectID']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User = MongoBase & {
  __typename?: 'User';
  accessBlocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ObjectID']['output'];
  schemaVersion?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  userType?: Maybe<Scalars['String']['output']>;
};

export type UserData = {
  __typename?: 'UserData';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type UserReIndexResult = {
  __typename?: 'UserReIndexResult';
  applicantUserReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  staffUserReIndexErrors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VerifiedCredentialVerificationCaseSummary = {
  __typename?: 'VerifiedCredentialVerificationCaseSummary';
  caseDetails: VerifiedCredentialVerificationCaseSummaryCaseDetails;
  id: Scalars['ObjectID']['output'];
};

export type VerifiedCredentialVerificationCaseSummaryCaseDetails = {
  __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetails';
  application: VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication;
};

export type VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication = {
  __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication';
  credentialTitle: Scalars['String']['output'];
  issuingInstitutionName: Scalars['String']['output'];
};

export type CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    id: any;
    applicant: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
        } | null;
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            degreeTitle?: string | null;
            attendanceStartedAt?: any | null;
            attendanceEndedAt?: any | null;
            degreeIssuedAt?: any | null;
            graduationYear?: number | null;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              zipOrPostalCode?: string | null;
              stateOrProvince?: string | null;
              name?: string | null;
              country?: string | null;
              city?: string | null;
              addressLine1?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    };
  } | null;
};

export type CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  id: any;
  applicant: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
      } | null;
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          attendanceStartedAt?: any | null;
          attendanceEndedAt?: any | null;
          degreeIssuedAt?: any | null;
          graduationYear?: number | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            zipOrPostalCode?: string | null;
            stateOrProvince?: string | null;
            name?: string | null;
            country?: string | null;
            city?: string | null;
            addressLine1?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  };
};

export type CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    contactInformation?: {
      __typename?: 'ApplicantUserContactInformation';
      emailAddress?: string | null;
      primaryPhone?: string | null;
      address?: {
        __typename?: 'ApplicantUserAddress';
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        streetAddressLine1?: string | null;
        streetAddressLine2?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
    } | null;
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      generationalSuffix?: string | null;
      lastName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      restOfName?: string | null;
    } | null;
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      citizenshipAtTimeEnteredMedicalInstitution?: string | null;
      healthProfession?: string | null;
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        degreeTitle?: string | null;
        attendanceStartedAt?: any | null;
        attendanceEndedAt?: any | null;
        degreeIssuedAt?: any | null;
        graduationYear?: number | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
        otherIssuingInstitution?: {
          __typename?: 'ApplicantUserOtherIssuingInstitution';
          zipOrPostalCode?: string | null;
          stateOrProvince?: string | null;
          name?: string | null;
          country?: string | null;
          city?: string | null;
          addressLine1?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformationFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
  } | null;
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      degreeTitle?: string | null;
      attendanceStartedAt?: any | null;
      attendanceEndedAt?: any | null;
      degreeIssuedAt?: any | null;
      graduationYear?: number | null;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null;
      } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        zipOrPostalCode?: string | null;
        stateOrProvince?: string | null;
        name?: string | null;
        country?: string | null;
        city?: string | null;
        addressLine1?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        decision?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReview';
    decision?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    archiveEligibleAt: any;
    archivedAt: any;
    caseName: string;
    caseType: string;
    createdAt: any;
    id: any;
    lastActivityAt: any;
    state: string;
    submittedAt: any;
    activityLog: Array<{
      __typename?: 'ArchivedCaseSummaryActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      activityBy?: {
        __typename?: 'User';
        accessBlocked?: boolean | null;
        createdAt?: any | null;
        displayName?: string | null;
        externalId?: string | null;
        id: any;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        userType?: string | null;
      } | null;
    } | null>;
    applicant: {
      __typename?: 'ApplicantUser';
      accessBlocked?: boolean | null;
      displayName?: string | null;
      externalId?: string | null;
      isProfileSubmitted?: boolean | null;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      userType?: string | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        applyingTo?: Array<{
          __typename?: 'Entity';
          createdAt?: any | null;
          disabledAt?: any | null;
          entityLanguage?: string | null;
          entityName?: string | null;
          id: any;
          isClient?: boolean | null;
          isIssuingInstitution?: boolean | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
          createdBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
        } | null> | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{
            __typename?: 'ApplicantUserPhone';
            createdAt?: any | null;
            id: any;
            phoneNumber?: string | null;
            phoneType?: string | null;
            updatedAt?: any | null;
          } | null> | null;
        } | null;
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        nameOnDocumentAssets?: Array<{
          __typename?: 'ApplicantUserNameOnDocumentAsset';
          createdAt?: any | null;
          documentName?: string | null;
          id: any;
          isDeleteRequested?: boolean | null;
          updatedAt?: any | null;
          uploadedAt?: any | null;
        } | null> | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            attendanceEndedAt?: any | null;
            attendanceStartedAt?: any | null;
            createdAt?: any | null;
            degreeIssuedAt?: any | null;
            degreeTitle?: string | null;
            graduationYear?: number | null;
            id: any;
            updatedAt?: any | null;
            issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              addressLine1?: string | null;
              city?: string | null;
              country?: string | null;
              name?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      termsAndConditions?: Array<{
        __typename?: 'ApplicantUserTermsAndCondition';
        acceptanceOf?: string | null;
        attestedAt?: any | null;
        createdAt?: any | null;
        id: any;
        updatedAt?: any | null;
        version?: number | null;
      } | null> | null;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    };
    caseDetails: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
      application: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
        credentialTitle: string;
        credentialType: string;
        dateCredentialIssuedAt: any;
        issuingInstitutionName?: string | null;
        nameOnCredential: string;
        program?: string | null;
        sendDestinationName: string;
        issuingInstitution?: {
          __typename?: 'Entity';
          createdAt?: any | null;
          disabledAt?: any | null;
          entityLanguage?: string | null;
          entityName?: string | null;
          id: any;
          isClient?: boolean | null;
          isIssuingInstitution?: boolean | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
        } | null;
        otherIssuingInstitution?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
          institutionName?: string | null;
        } | null;
        sendDestination?: {
          __typename?: 'Entity';
          createdAt?: any | null;
          disabledAt?: any | null;
          entityLanguage?: string | null;
          entityName?: string | null;
          id: any;
          isClient?: boolean | null;
          isIssuingInstitution?: boolean | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
        } | null;
      };
      applicationReview: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          result?: string | null;
          rejectionReason?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        };
        privateCaseDetails: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
          verificationStatus?: {
            __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
            verificationResponse?: string | null;
          } | null;
          institutionContactDetails?: {
            __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
            institutionEmail: string;
            institutionPhone: string;
          } | null;
          alternativeVerifyingEntity?: {
            __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
            otherDetails?: string | null;
            isVerifiedWithOther?: boolean | null;
          } | null;
        };
        verificationAffirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      };
    };
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          approval?: {
            __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
            isApplicantApproved?: boolean | null;
            isApplicantApprovalRequired?: boolean | null;
          } | null;
          transactionReference?: {
            __typename?: 'ArchivedCaseSummaryTransactionReference';
            referenceId?: string | null;
            completedAt?: any | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  archiveEligibleAt: any;
  archivedAt: any;
  caseName: string;
  caseType: string;
  createdAt: any;
  id: any;
  lastActivityAt: any;
  state: string;
  submittedAt: any;
  activityLog: Array<{
    __typename?: 'ArchivedCaseSummaryActivityLog';
    activityType?: string | null;
    createdAt?: any | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    activityBy?: {
      __typename?: 'User';
      accessBlocked?: boolean | null;
      createdAt?: any | null;
      displayName?: string | null;
      externalId?: string | null;
      id: any;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      userType?: string | null;
    } | null;
  } | null>;
  applicant: {
    __typename?: 'ApplicantUser';
    accessBlocked?: boolean | null;
    displayName?: string | null;
    externalId?: string | null;
    isProfileSubmitted?: boolean | null;
    schemaVersion?: string | null;
    tags?: Array<string | null> | null;
    userType?: string | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{
        __typename?: 'Entity';
        createdAt?: any | null;
        disabledAt?: any | null;
        entityLanguage?: string | null;
        entityName?: string | null;
        id: any;
        isClient?: boolean | null;
        isIssuingInstitution?: boolean | null;
        schemaVersion?: string | null;
        updatedAt?: any | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
        createdBy?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          id: any;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            id: any;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
      } | null> | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{
          __typename?: 'ApplicantUserPhone';
          createdAt?: any | null;
          id: any;
          phoneNumber?: string | null;
          phoneType?: string | null;
          updatedAt?: any | null;
        } | null> | null;
      } | null;
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        createdAt?: any | null;
        documentName?: string | null;
        id: any;
        isDeleteRequested?: boolean | null;
        updatedAt?: any | null;
        uploadedAt?: any | null;
      } | null> | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          createdAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          updatedAt?: any | null;
          issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      createdAt?: any | null;
      id: any;
      updatedAt?: any | null;
      version?: number | null;
    } | null> | null;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  };
  caseDetails: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
    application: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
      credentialTitle: string;
      credentialType: string;
      dateCredentialIssuedAt: any;
      issuingInstitutionName?: string | null;
      nameOnCredential: string;
      program?: string | null;
      sendDestinationName: string;
      issuingInstitution?: {
        __typename?: 'Entity';
        createdAt?: any | null;
        disabledAt?: any | null;
        entityLanguage?: string | null;
        entityName?: string | null;
        id: any;
        isClient?: boolean | null;
        isIssuingInstitution?: boolean | null;
        schemaVersion?: string | null;
        updatedAt?: any | null;
      } | null;
      otherIssuingInstitution?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
        institutionName?: string | null;
      } | null;
      sendDestination?: {
        __typename?: 'Entity';
        createdAt?: any | null;
        disabledAt?: any | null;
        entityLanguage?: string | null;
        entityName?: string | null;
        id: any;
        isClient?: boolean | null;
        isIssuingInstitution?: boolean | null;
        schemaVersion?: string | null;
        updatedAt?: any | null;
      } | null;
    };
    applicationReview: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      decision: {
        __typename?: 'ArchivedCaseSummaryDecision';
        completedAt?: any | null;
        result?: string | null;
        rejectionReason?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      };
      privateCaseDetails: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
        verificationStatus?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
          verificationResponse?: string | null;
        } | null;
        institutionContactDetails?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
          institutionEmail: string;
          institutionPhone: string;
        } | null;
        alternativeVerifyingEntity?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
          otherDetails?: string | null;
          isVerifiedWithOther?: boolean | null;
        } | null;
      };
      verificationAffirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    };
  };
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        approval?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
          isApplicantApproved?: boolean | null;
          isApplicantApprovalRequired?: boolean | null;
        } | null;
        transactionReference?: {
          __typename?: 'ArchivedCaseSummaryTransactionReference';
          referenceId?: string | null;
          completedAt?: any | null;
          isSuccess?: boolean | null;
        } | null;
      } | null> | null;
      submission?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null;
    } | null;
  };
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetails';
  transactions?: {
    __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      approval?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
        isApplicantApproved?: boolean | null;
        isApplicantApprovalRequired?: boolean | null;
      } | null;
      transactionReference?: {
        __typename?: 'ArchivedCaseSummaryTransactionReference';
        referenceId?: string | null;
        completedAt?: any | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
    submission?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
      amount?: number | null;
      transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryActivityLog';
  activityType?: string | null;
  createdAt?: any | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  updatedAt?: any | null;
  activityBy?: {
    __typename?: 'User';
    accessBlocked?: boolean | null;
    createdAt?: any | null;
    displayName?: string | null;
    externalId?: string | null;
    id: any;
    schemaVersion?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    userType?: string | null;
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  accessBlocked?: boolean | null;
  displayName?: string | null;
  externalId?: string | null;
  isProfileSubmitted?: boolean | null;
  schemaVersion?: string | null;
  tags?: Array<string | null> | null;
  userType?: string | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{
      __typename?: 'Entity';
      createdAt?: any | null;
      disabledAt?: any | null;
      entityLanguage?: string | null;
      entityName?: string | null;
      id: any;
      isClient?: boolean | null;
      isIssuingInstitution?: boolean | null;
      schemaVersion?: string | null;
      updatedAt?: any | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
      createdBy?: {
        __typename?: 'StaffUser';
        accessBlocked?: boolean | null;
        createdAt?: any | null;
        displayName?: string | null;
        emailAddress?: string | null;
        externalId?: string | null;
        firstName?: string | null;
        id: any;
        lastName?: string | null;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        userType?: string | null;
        role?: {
          __typename?: 'StaffRole';
          createdAt?: any | null;
          id: any;
          isDefault: boolean;
          roleName: string;
          roleSubtype: string;
          roleType?: string | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          permissions: {
            __typename?: 'StaffRolePermissions';
            applicantUserPermissions: {
              __typename?: 'StaffRoleApplicantUserPermissions';
              canAddOrRemoveTags: boolean;
              canBlockAccess: boolean;
              canSearchApplicants: boolean;
              canUpdatePersonalInformation: boolean;
            };
            credCasePermissions: {
              __typename?: 'StaffRoleCredCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            entityPermissions: {
              __typename?: 'StaffRoleEntityPermissions';
              canAddEntities: boolean;
              canDeleteEntities: boolean;
              canEditEntities: boolean;
              canSearchEntities: boolean;
            };
            idCasePermissions: {
              __typename?: 'StaffRoleIdCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
            sendCasePermissions: {
              __typename?: 'StaffRoleSendCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            staffUserPermissions: {
              __typename?: 'StaffRoleStaffUserPermissions';
              canAddOrRemoveTags: boolean;
              canAssignRoles: boolean;
              canBlockAccess: boolean;
              canSearchStaff: boolean;
            };
          };
        } | null;
        search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      } | null;
      issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
    } | null> | null;
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    contactInformation?: {
      __typename?: 'ApplicantUserContactInformation';
      emailAddress?: string | null;
      primaryPhone?: string | null;
      address?: {
        __typename?: 'ApplicantUserAddress';
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        streetAddressLine1?: string | null;
        streetAddressLine2?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      phone?: Array<{
        __typename?: 'ApplicantUserPhone';
        createdAt?: any | null;
        id: any;
        phoneNumber?: string | null;
        phoneType?: string | null;
        updatedAt?: any | null;
      } | null> | null;
    } | null;
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      generationalSuffix?: string | null;
      lastName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      restOfName?: string | null;
    } | null;
    nameOnDocumentAssets?: Array<{
      __typename?: 'ApplicantUserNameOnDocumentAsset';
      createdAt?: any | null;
      documentName?: string | null;
      id: any;
      isDeleteRequested?: boolean | null;
      updatedAt?: any | null;
      uploadedAt?: any | null;
    } | null> | null;
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      citizenshipAtTimeEnteredMedicalInstitution?: string | null;
      healthProfession?: string | null;
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        attendanceEndedAt?: any | null;
        attendanceStartedAt?: any | null;
        createdAt?: any | null;
        degreeIssuedAt?: any | null;
        degreeTitle?: string | null;
        graduationYear?: number | null;
        id: any;
        updatedAt?: any | null;
        issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
        otherIssuingInstitution?: {
          __typename?: 'ApplicantUserOtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          name?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    createdAt?: any | null;
    id: any;
    updatedAt?: any | null;
    version?: number | null;
  } | null> | null;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformationFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Array<{
    __typename?: 'Entity';
    createdAt?: any | null;
    disabledAt?: any | null;
    entityLanguage?: string | null;
    entityName?: string | null;
    id: any;
    isClient?: boolean | null;
    isIssuingInstitution?: boolean | null;
    schemaVersion?: string | null;
    updatedAt?: any | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
    createdBy?: {
      __typename?: 'StaffUser';
      accessBlocked?: boolean | null;
      createdAt?: any | null;
      displayName?: string | null;
      emailAddress?: string | null;
      externalId?: string | null;
      firstName?: string | null;
      id: any;
      lastName?: string | null;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      userType?: string | null;
      role?: {
        __typename?: 'StaffRole';
        createdAt?: any | null;
        id: any;
        isDefault: boolean;
        roleName: string;
        roleSubtype: string;
        roleType?: string | null;
        schemaVersion?: string | null;
        updatedAt?: any | null;
        permissions: {
          __typename?: 'StaffRolePermissions';
          applicantUserPermissions: {
            __typename?: 'StaffRoleApplicantUserPermissions';
            canAddOrRemoveTags: boolean;
            canBlockAccess: boolean;
            canSearchApplicants: boolean;
            canUpdatePersonalInformation: boolean;
          };
          credCasePermissions: {
            __typename?: 'StaffRoleCredCasePermissions';
            canAssignCaseWorker: boolean;
            canAssignSelf: boolean;
            canBeAssignedCases: boolean;
            canIssueRefunds: boolean;
            canOverrideCaseState: boolean;
            canReopenCases: boolean;
            canSearchCases: boolean;
            canUnassignCaseWorker: boolean;
            canUnassignSelf: boolean;
            canViewCasesAssignedToOthers: boolean;
            canViewUnassignedCases: boolean;
          };
          entityPermissions: {
            __typename?: 'StaffRoleEntityPermissions';
            canAddEntities: boolean;
            canDeleteEntities: boolean;
            canEditEntities: boolean;
            canSearchEntities: boolean;
          };
          idCasePermissions: {
            __typename?: 'StaffRoleIdCasePermissions';
            canAssignCaseWorker: boolean;
            canAssignSelf: boolean;
            canBeAssignedCases: boolean;
            canIssueRefunds: boolean;
            canOverrideCaseState: boolean;
            canReopenCases: boolean;
            canSearchCases: boolean;
            canUnassignCaseWorker: boolean;
            canUnassignSelf: boolean;
            canViewCasesAssignedToOthers: boolean;
            canViewUnassignedCases: boolean;
          };
          rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
          sendCasePermissions: {
            __typename?: 'StaffRoleSendCasePermissions';
            canAssignCaseWorker: boolean;
            canAssignSelf: boolean;
            canBeAssignedCases: boolean;
            canIssueRefunds: boolean;
            canOverrideCaseState: boolean;
            canReopenCases: boolean;
            canSearchCases: boolean;
            canUnassignCaseWorker: boolean;
            canUnassignSelf: boolean;
            canViewCasesAssignedToOthers: boolean;
            canViewUnassignedCases: boolean;
          };
          staffUserPermissions: {
            __typename?: 'StaffRoleStaffUserPermissions';
            canAddOrRemoveTags: boolean;
            canAssignRoles: boolean;
            canBlockAccess: boolean;
            canSearchStaff: boolean;
          };
        };
      } | null;
      search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
    } | null;
    issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
  } | null> | null;
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{
      __typename?: 'ApplicantUserPhone';
      createdAt?: any | null;
      id: any;
      phoneNumber?: string | null;
      phoneType?: string | null;
      updatedAt?: any | null;
    } | null> | null;
  } | null;
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
  nameOnDocumentAssets?: Array<{
    __typename?: 'ApplicantUserNameOnDocumentAsset';
    createdAt?: any | null;
    documentName?: string | null;
    id: any;
    isDeleteRequested?: boolean | null;
    updatedAt?: any | null;
    uploadedAt?: any | null;
  } | null> | null;
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      attendanceEndedAt?: any | null;
      attendanceStartedAt?: any | null;
      createdAt?: any | null;
      degreeIssuedAt?: any | null;
      degreeTitle?: string | null;
      graduationYear?: number | null;
      id: any;
      updatedAt?: any | null;
      issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        name?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
  application: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
    credentialTitle: string;
    credentialType: string;
    dateCredentialIssuedAt: any;
    issuingInstitutionName?: string | null;
    nameOnCredential: string;
    program?: string | null;
    sendDestinationName: string;
    issuingInstitution?: {
      __typename?: 'Entity';
      createdAt?: any | null;
      disabledAt?: any | null;
      entityLanguage?: string | null;
      entityName?: string | null;
      id: any;
      isClient?: boolean | null;
      isIssuingInstitution?: boolean | null;
      schemaVersion?: string | null;
      updatedAt?: any | null;
    } | null;
    otherIssuingInstitution?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
      institutionName?: string | null;
    } | null;
    sendDestination?: {
      __typename?: 'Entity';
      createdAt?: any | null;
      disabledAt?: any | null;
      entityLanguage?: string | null;
      entityName?: string | null;
      id: any;
      isClient?: boolean | null;
      isIssuingInstitution?: boolean | null;
      schemaVersion?: string | null;
      updatedAt?: any | null;
    } | null;
  };
  applicationReview: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    decision: {
      __typename?: 'ArchivedCaseSummaryDecision';
      completedAt?: any | null;
      result?: string | null;
      rejectionReason?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    };
    privateCaseDetails: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
      verificationStatus?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
        verificationResponse?: string | null;
      } | null;
      institutionContactDetails?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
        institutionEmail: string;
        institutionPhone: string;
      } | null;
      alternativeVerifyingEntity?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
        otherDetails?: string | null;
        isVerifiedWithOther?: boolean | null;
      } | null;
    };
    verificationAffirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  };
};

export type CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
  credentialTitle: string;
  credentialType: string;
  dateCredentialIssuedAt: any;
  issuingInstitutionName?: string | null;
  nameOnCredential: string;
  program?: string | null;
  sendDestinationName: string;
  issuingInstitution?: {
    __typename?: 'Entity';
    createdAt?: any | null;
    disabledAt?: any | null;
    entityLanguage?: string | null;
    entityName?: string | null;
    id: any;
    isClient?: boolean | null;
    isIssuingInstitution?: boolean | null;
    schemaVersion?: string | null;
    updatedAt?: any | null;
  } | null;
  otherIssuingInstitution?: { __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution'; institutionName?: string | null } | null;
  sendDestination?: {
    __typename?: 'Entity';
    createdAt?: any | null;
    disabledAt?: any | null;
    entityLanguage?: string | null;
    entityName?: string | null;
    id: any;
    isClient?: boolean | null;
    isIssuingInstitution?: boolean | null;
    schemaVersion?: string | null;
    updatedAt?: any | null;
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  decision: {
    __typename?: 'ArchivedCaseSummaryDecision';
    completedAt?: any | null;
    result?: string | null;
    rejectionReason?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  };
  privateCaseDetails: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
    verificationStatus?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
      verificationResponse?: string | null;
    } | null;
    institutionContactDetails?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
      institutionEmail: string;
      institutionPhone: string;
    } | null;
    alternativeVerifyingEntity?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
      otherDetails?: string | null;
      isVerifiedWithOther?: boolean | null;
    } | null;
  };
  verificationAffirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryDecision';
  completedAt?: any | null;
  result?: string | null;
  rejectionReason?: string | null;
  completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
  verificationStatus?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
    verificationResponse?: string | null;
  } | null;
  institutionContactDetails?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
    institutionEmail: string;
    institutionPhone: string;
  } | null;
  alternativeVerifyingEntity?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
    otherDetails?: string | null;
    isVerifiedWithOther?: boolean | null;
  } | null;
};

export type CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryAffirmations';
  audit?: {
    __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
    completedAt?: any | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    submittedAt: any;
    lastActivityAt: any;
    id: any;
    applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
  } | null;
};

export type CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  submittedAt: any;
  lastActivityAt: any;
  id: any;
  applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    id: any;
    caseDetails: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
      application: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
        nameOnCredential: string;
        credentialType: string;
        credentialTitle: string;
        dateCredentialIssuedAt: any;
        program?: string | null;
        otherIssuingInstitution?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
          institutionName?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          id: any;
          entityName?: string | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            email?: string | null;
            phoneNumber?: string | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
      };
      applicationReview: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          result?: string | null;
          rejectionReason?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        };
        privateCaseDetails: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
          verificationStatus?: {
            __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
            verificationResponse?: string | null;
          } | null;
          institutionContactDetails?: {
            __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
            institutionEmail: string;
            institutionPhone: string;
          } | null;
          alternativeVerifyingEntity?: {
            __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
            otherDetails?: string | null;
            isVerifiedWithOther?: boolean | null;
          } | null;
        };
        verificationAffirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      };
    };
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          approval?: {
            __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
            isApplicantApproved?: boolean | null;
            isApplicantApprovalRequired?: boolean | null;
          } | null;
          transactionReference?: {
            __typename?: 'ArchivedCaseSummaryTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
    activityLog: Array<{
      __typename?: 'ArchivedCaseSummaryActivityLog';
      tags?: Array<string | null> | null;
      description?: string | null;
      activityType?: string | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null>;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  id: any;
  caseDetails: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
    application: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
      nameOnCredential: string;
      credentialType: string;
      credentialTitle: string;
      dateCredentialIssuedAt: any;
      program?: string | null;
      otherIssuingInstitution?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
        institutionName?: string | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'Entity';
        id: any;
        entityName?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          email?: string | null;
          phoneNumber?: string | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null;
      } | null;
    };
    applicationReview: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      decision: {
        __typename?: 'ArchivedCaseSummaryDecision';
        completedAt?: any | null;
        result?: string | null;
        rejectionReason?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      };
      privateCaseDetails: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
        verificationStatus?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
          verificationResponse?: string | null;
        } | null;
        institutionContactDetails?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
          institutionEmail: string;
          institutionPhone: string;
        } | null;
        alternativeVerifyingEntity?: {
          __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
          otherDetails?: string | null;
          isVerifiedWithOther?: boolean | null;
        } | null;
      };
      verificationAffirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    };
  };
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        approval?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
          isApplicantApproved?: boolean | null;
          isApplicantApprovalRequired?: boolean | null;
        } | null;
        transactionReference?: {
          __typename?: 'ArchivedCaseSummaryTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          isSuccess?: boolean | null;
        } | null;
      } | null> | null;
      submission?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null;
    } | null;
  };
  activityLog: Array<{
    __typename?: 'ArchivedCaseSummaryActivityLog';
    tags?: Array<string | null> | null;
    description?: string | null;
    activityType?: string | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null>;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetails';
  application: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
    nameOnCredential: string;
    credentialType: string;
    credentialTitle: string;
    dateCredentialIssuedAt: any;
    program?: string | null;
    otherIssuingInstitution?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution';
      institutionName?: string | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'Entity';
      id: any;
      entityName?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
  };
  applicationReview: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    decision: {
      __typename?: 'ArchivedCaseSummaryDecision';
      completedAt?: any | null;
      result?: string | null;
      rejectionReason?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    };
    privateCaseDetails: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
      verificationStatus?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
        verificationResponse?: string | null;
      } | null;
      institutionContactDetails?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
        institutionEmail: string;
        institutionPhone: string;
      } | null;
      alternativeVerifyingEntity?: {
        __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
        otherDetails?: string | null;
        isVerifiedWithOther?: boolean | null;
      } | null;
    };
    verificationAffirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  };
};

export type CasesCredentialVerificationCaseSummaryContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  id: any;
  entityName?: string | null;
  address?: {
    __typename?: 'EntityAddressInfo';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  issuingInstitution?: {
    __typename?: 'EntityIssuingInstitution';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication';
  nameOnCredential: string;
  credentialType: string;
  credentialTitle: string;
  dateCredentialIssuedAt: any;
  program?: string | null;
  otherIssuingInstitution?: { __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationOtherIssuingInstitution'; institutionName?: string | null } | null;
  issuingInstitution?: {
    __typename?: 'Entity';
    id: any;
    entityName?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  decision: {
    __typename?: 'ArchivedCaseSummaryDecision';
    completedAt?: any | null;
    result?: string | null;
    rejectionReason?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  };
  privateCaseDetails: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
    verificationStatus?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
      verificationResponse?: string | null;
    } | null;
    institutionContactDetails?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
      institutionEmail: string;
      institutionPhone: string;
    } | null;
    alternativeVerifyingEntity?: {
      __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
      otherDetails?: string | null;
      isVerifiedWithOther?: boolean | null;
    } | null;
  };
  verificationAffirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryDecision';
  completedAt?: any | null;
  result?: string | null;
  rejectionReason?: string | null;
  completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
  verificationStatus?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
    verificationResponse?: string | null;
  } | null;
  institutionContactDetails?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
    institutionEmail: string;
    institutionPhone: string;
  } | null;
  alternativeVerifyingEntity?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsAlternativeVerifyingEntity';
    otherDetails?: string | null;
    isVerifiedWithOther?: boolean | null;
  } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetails';
  transactions?: {
    __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      approval?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
        isApplicantApproved?: boolean | null;
        isApplicantApprovalRequired?: boolean | null;
      } | null;
      transactionReference?: {
        __typename?: 'ArchivedCaseSummaryTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
    submission?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
      amount?: number | null;
      transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryActivityLog';
  tags?: Array<string | null> | null;
  description?: string | null;
  activityType?: string | null;
  updatedAt?: any | null;
  activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationCaseSummaryContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryAffirmations';
  audit?: {
    __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
    completedAt?: any | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
  amount?: number | null;
  reason?: string | null;
  transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null; isSuccess?: boolean | null } | null;
};

export type CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
  amount?: number | null;
  transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
};

export type CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        credentialTitle?: string | null;
        credentialType?: string | null;
        dateCredentialIssuedAt?: any | null;
        isAttestationComplete?: boolean | null;
        nameOnCredential?: string | null;
        isNameOnCredentialMatchPassport?: boolean | null;
        program?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1CurrentQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1CurrentQuery = {
  __typename?: 'Query';
  credentialVerificationCaseV1Current?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        credentialTitle?: string | null;
        credentialType?: string | null;
        dateCredentialIssuedAt?: any | null;
        isAttestationComplete?: boolean | null;
        nameOnCredential?: string | null;
        isNameOnCredentialMatchPassport?: boolean | null;
        program?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'CredentialVerificationCaseV1Application';
      credentialTitle?: string | null;
      credentialType?: string | null;
      dateCredentialIssuedAt?: any | null;
      isAttestationComplete?: boolean | null;
      nameOnCredential?: string | null;
      isNameOnCredentialMatchPassport?: boolean | null;
      program?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1QueryQueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1QueryQuery = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    isCurrentUserAssigned?: boolean | null;
    state: string;
    id: any;
    activityLog?: Array<{
      __typename?: 'CredentialVerificationCaseV1ActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      id: any;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutationMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutationMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      isCurrentUserAssigned?: boolean | null;
      state: string;
      id: any;
      activityLog?: Array<{
        __typename?: 'CredentialVerificationCaseV1ActivityLog';
        activityType?: string | null;
        createdAt?: any | null;
        description?: string | null;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        id: any;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  isCurrentUserAssigned?: boolean | null;
  state: string;
  id: any;
  activityLog?: Array<{
    __typename?: 'CredentialVerificationCaseV1ActivityLog';
    activityType?: string | null;
    createdAt?: any | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    id: any;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
};

export type StaffActivityLogContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    isCurrentUserAssigned?: boolean | null;
    state: string;
    id: any;
    activityLog?: Array<{
      __typename?: 'CredentialVerificationCaseV1ActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      id: any;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationAdditionalFilesContainerQueryQueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationAdditionalFilesContainerQueryQuery = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesCredentialVerificationAdditionalFilesContainerCreateAuthHeaderMutationMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredentialVerificationAdditionalFilesContainerCreateAuthHeaderMutationMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1FileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobName?: string | null;
      blobPath?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationAdditionalFilesContainerFileRemoveMutationVariables = Exact<{
  input: CredentialVerificationCaseV1FileRemoveInput;
}>;

export type CasesCredentialVerificationAdditionalFilesContainerFileRemoveMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1FileRemove: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffCasesApplicationContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    caseName?: string | null;
    state: string;
    isCurrentUserAssigned?: boolean | null;
    purgeEligibleAt?: any | null;
    archiveEligibleAt?: any | null;
    expirationEligibleAt?: any | null;
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        nameOnCredential?: string | null;
        credentialType?: string | null;
        credentialTitle?: string | null;
        isCredentialInEnglish?: boolean | null;
        dateCredentialIssuedAt?: any | null;
        program?: string | null;
        otherIssuingInstitution?: {
          __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          institutionName?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          isIssuingInstitution?: boolean | null;
          isClient?: boolean | null;
          id: any;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            email?: string | null;
            phoneNumber?: string | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
        sendDestination?: {
          __typename?: 'Entity';
          entityName?: string | null;
          isIssuingInstitution?: boolean | null;
          isClient?: boolean | null;
          id: any;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            email?: string | null;
            phoneNumber?: string | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        decision?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
          completedAt?: any | null;
          result?: string | null;
          rejectionReason?: string | null;
        } | null;
        privateCaseDetails?: {
          __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
          verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
          alternateVerifyingEntity?: {
            __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
            otherDetails?: string | null;
            isVerifiedWithOther?: boolean | null;
          } | null;
          institutionContactDetails?: {
            __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
            institutionEmail?: string | null;
            institutionPhone?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{
    __typename?: 'Entity';
    entityName?: string | null;
    isIssuingInstitution?: boolean | null;
    isClient?: boolean | null;
    id: any;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null> | null;
};

export type StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      purgeEligibleAt?: any | null;
      archiveEligibleAt?: any | null;
      expirationEligibleAt?: any | null;
      caseName?: string | null;
      state: string;
      isCurrentUserAssigned?: boolean | null;
      id: any;
      applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'CredentialVerificationCaseV1Application';
          nameOnCredential?: string | null;
          credentialType?: string | null;
          credentialTitle?: string | null;
          isCredentialInEnglish?: boolean | null;
          dateCredentialIssuedAt?: any | null;
          program?: string | null;
          otherIssuingInstitution?: {
            __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            institutionName?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            isIssuingInstitution?: boolean | null;
            isClient?: boolean | null;
            id: any;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              email?: string | null;
              phoneNumber?: string | null;
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          sendDestination?: {
            __typename?: 'Entity';
            entityName?: string | null;
            isIssuingInstitution?: boolean | null;
            isClient?: boolean | null;
            id: any;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              email?: string | null;
              phoneNumber?: string | null;
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
        } | null;
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReview';
          decision?: {
            __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
            completedAt?: any | null;
            result?: string | null;
            rejectionReason?: string | null;
          } | null;
          privateCaseDetails?: {
            __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
            verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
            alternateVerifyingEntity?: {
              __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
              otherDetails?: string | null;
              isVerifiedWithOther?: boolean | null;
            } | null;
            institutionContactDetails?: {
              __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
              institutionEmail?: string | null;
              institutionPhone?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      revisionRequest?: {
        __typename?: 'CredentialVerificationCaseV1RevisionRequest';
        requestedChanges?: {
          __typename?: 'CredentialVerificationCaseV1RequestedChanges';
          requestUpdatedCredentialDetails?: boolean | null;
          requestUpdatedIssuingInstitution?: boolean | null;
          requestUploadCredential?: boolean | null;
          requestUploadTranslation?: boolean | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    purgeEligibleAt?: any | null;
    archiveEligibleAt?: any | null;
    expirationEligibleAt?: any | null;
    caseName?: string | null;
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        nameOnCredential?: string | null;
        credentialType?: string | null;
        credentialTitle?: string | null;
        isCredentialInEnglish?: boolean | null;
        dateCredentialIssuedAt?: any | null;
        program?: string | null;
        otherIssuingInstitution?: {
          __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          institutionName?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          isIssuingInstitution?: boolean | null;
          isClient?: boolean | null;
          id: any;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            email?: string | null;
            phoneNumber?: string | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
        sendDestination?: {
          __typename?: 'Entity';
          entityName?: string | null;
          isIssuingInstitution?: boolean | null;
          isClient?: boolean | null;
          id: any;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            email?: string | null;
            phoneNumber?: string | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        decision?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
          completedAt?: any | null;
          result?: string | null;
          rejectionReason?: string | null;
        } | null;
        privateCaseDetails?: {
          __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
          verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
          alternateVerifyingEntity?: {
            __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
            otherDetails?: string | null;
            isVerifiedWithOther?: boolean | null;
          } | null;
          institutionContactDetails?: {
            __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
            institutionEmail?: string | null;
            institutionPhone?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  caseName?: string | null;
  state: string;
  isCurrentUserAssigned?: boolean | null;
  purgeEligibleAt?: any | null;
  archiveEligibleAt?: any | null;
  expirationEligibleAt?: any | null;
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'CredentialVerificationCaseV1Application';
      nameOnCredential?: string | null;
      credentialType?: string | null;
      credentialTitle?: string | null;
      isCredentialInEnglish?: boolean | null;
      dateCredentialIssuedAt?: any | null;
      program?: string | null;
      otherIssuingInstitution?: {
        __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        institutionName?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        isIssuingInstitution?: boolean | null;
        isClient?: boolean | null;
        id: any;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          email?: string | null;
          phoneNumber?: string | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null;
      } | null;
      sendDestination?: {
        __typename?: 'Entity';
        entityName?: string | null;
        isIssuingInstitution?: boolean | null;
        isClient?: boolean | null;
        id: any;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          email?: string | null;
          phoneNumber?: string | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      decision?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
        completedAt?: any | null;
        result?: string | null;
        rejectionReason?: string | null;
      } | null;
      privateCaseDetails?: {
        __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
        verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
        alternateVerifyingEntity?: {
          __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
          otherDetails?: string | null;
          isVerifiedWithOther?: boolean | null;
        } | null;
        institutionContactDetails?: {
          __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
          institutionEmail?: string | null;
          institutionPhone?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  revisionRequest?: {
    __typename?: 'CredentialVerificationCaseV1RevisionRequest';
    requestedChanges?: {
      __typename?: 'CredentialVerificationCaseV1RequestedChanges';
      requestUpdatedCredentialDetails?: boolean | null;
      requestUpdatedIssuingInstitution?: boolean | null;
      requestUploadCredential?: boolean | null;
      requestUploadTranslation?: boolean | null;
    } | null;
  } | null;
};

export type StaffCasesApplicationContainerApplicantUserFieldsFragment = { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };

export type StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  application?: {
    __typename?: 'CredentialVerificationCaseV1Application';
    nameOnCredential?: string | null;
    credentialType?: string | null;
    credentialTitle?: string | null;
    isCredentialInEnglish?: boolean | null;
    dateCredentialIssuedAt?: any | null;
    program?: string | null;
    otherIssuingInstitution?: {
      __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      institutionName?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'Entity';
      entityName?: string | null;
      isIssuingInstitution?: boolean | null;
      isClient?: boolean | null;
      id: any;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
    sendDestination?: {
      __typename?: 'Entity';
      entityName?: string | null;
      isIssuingInstitution?: boolean | null;
      isClient?: boolean | null;
      id: any;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
  applicationReview?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReview';
    decision?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
      completedAt?: any | null;
      result?: string | null;
      rejectionReason?: string | null;
    } | null;
    privateCaseDetails?: {
      __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
      verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
      alternateVerifyingEntity?: {
        __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
        otherDetails?: string | null;
        isVerifiedWithOther?: boolean | null;
      } | null;
      institutionContactDetails?: {
        __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
        institutionEmail?: string | null;
        institutionPhone?: string | null;
      } | null;
    } | null;
  } | null;
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1RevisionRequest';
  requestedChanges?: {
    __typename?: 'CredentialVerificationCaseV1RequestedChanges';
    requestUpdatedCredentialDetails?: boolean | null;
    requestUpdatedIssuingInstitution?: boolean | null;
    requestUploadCredential?: boolean | null;
    requestUploadTranslation?: boolean | null;
  } | null;
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  institutionName?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type StaffCasesApplicationContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
  address?: {
    __typename?: 'EntityAddressInfo';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  issuingInstitution?: {
    __typename?: 'EntityIssuingInstitution';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1Application';
  nameOnCredential?: string | null;
  credentialType?: string | null;
  credentialTitle?: string | null;
  isCredentialInEnglish?: boolean | null;
  dateCredentialIssuedAt?: any | null;
  program?: string | null;
  otherIssuingInstitution?: {
    __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    institutionName?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  issuingInstitution?: {
    __typename?: 'Entity';
    entityName?: string | null;
    isIssuingInstitution?: boolean | null;
    isClient?: boolean | null;
    id: any;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
  sendDestination?: {
    __typename?: 'Entity';
    entityName?: string | null;
    isIssuingInstitution?: boolean | null;
    isClient?: boolean | null;
    id: any;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReview';
  decision?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
    completedAt?: any | null;
    result?: string | null;
    rejectionReason?: string | null;
  } | null;
  privateCaseDetails?: {
    __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
    verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
    alternateVerifyingEntity?: {
      __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
      otherDetails?: string | null;
      isVerifiedWithOther?: boolean | null;
    } | null;
    institutionContactDetails?: {
      __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
      institutionEmail?: string | null;
      institutionPhone?: string | null;
    } | null;
  } | null;
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReviewDecision';
  completedAt?: any | null;
  result?: string | null;
  rejectionReason?: string | null;
};

export type StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
  verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
  alternateVerifyingEntity?: {
    __typename?: 'CredentialVerificationCaseV1AlternateVerifyingEntity';
    otherDetails?: string | null;
    isVerifiedWithOther?: boolean | null;
  } | null;
  institutionContactDetails?: {
    __typename?: 'CredentialVerificationCaseV1InstitutionContactDetails';
    institutionEmail?: string | null;
    institutionPhone?: string | null;
  } | null;
};

export type CasesCredentialVerificationV1ApplicationContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesCredentialVerificationV1ApplicationContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: { __typename?: 'StaffUser'; id: any; role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null } | null;
};

export type CasesCredentialVerificationV1ApplicationContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null;
};

export type CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerStaffUsersQueryVariables = Exact<{ [key: string]: never }>;

export type CasesCredentialVerificationCaseDetailsContainerStaffUsersQuery = {
  __typename?: 'Query';
  staffUsers?: Array<{
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canBeAssignedCases: boolean } };
    } | null;
  } | null> | null;
};

export type CasesCredentialVerificationV1CaseDetailsContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesCredentialVerificationV1CaseDetailsContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        credCasePermissions: {
          __typename?: 'StaffRoleCredCasePermissions';
          canAssignSelf: boolean;
          canAssignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canUnassignCaseWorker: boolean;
        };
      };
    } | null;
  } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    tags?: Array<string | null> | null;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        affirmations?: {
          __typename?: 'CredentialVerificationCaseV1Affirmations';
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        verificationAffirmations?: {
          __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: { __typename?: 'CredentialVerificationCaseV1RevisionRequest'; requestedAt?: any | null; revisionSubmittedAt?: any | null } | null;
  } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerQueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerQuery = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'CredentialVerificationCaseV1ActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      id: any;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      tags?: Array<string | null> | null;
      id: any;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReview';
          caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      activityLog?: Array<{
        __typename?: 'CredentialVerificationCaseV1ActivityLog';
        activityType?: string | null;
        createdAt?: any | null;
        description?: string | null;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        id: any;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerStaffUsersFieldsFragment = {
  __typename?: 'StaffUser';
  displayName?: string | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canBeAssignedCases: boolean } };
  } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  displayName?: string | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      credCasePermissions: {
        __typename?: 'StaffRoleCredCasePermissions';
        canAssignSelf: boolean;
        canAssignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canUnassignCaseWorker: boolean;
      };
    };
  } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'CredentialVerificationCaseV1ActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      id: any;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  tags?: Array<string | null> | null;
  id: any;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  activityLog?: Array<{
    __typename?: 'CredentialVerificationCaseV1ActivityLog';
    activityType?: string | null;
    createdAt?: any | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    id: any;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  tags?: Array<string | null> | null;
  isCurrentUserAssigned?: boolean | null;
  id: any;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      affirmations?: {
        __typename?: 'CredentialVerificationCaseV1Affirmations';
        audit?: {
          __typename?: 'CredentialVerificationCaseV1Audit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      verificationAffirmations?: {
        __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
        audit?: {
          __typename?: 'CredentialVerificationCaseV1Audit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  revisionRequest?: { __typename?: 'CredentialVerificationCaseV1RevisionRequest'; requestedAt?: any | null; revisionSubmittedAt?: any | null } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1ActivityLog';
  activityType?: string | null;
  createdAt?: any | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  updatedAt?: any | null;
  id: any;
  activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1RevisionRequest';
  requestedAt?: any | null;
  revisionSubmittedAt?: any | null;
};

export type CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReview';
    affirmations?: {
      __typename?: 'CredentialVerificationCaseV1Affirmations';
      audit?: {
        __typename?: 'CredentialVerificationCaseV1Audit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    verificationAffirmations?: {
      __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
      audit?: {
        __typename?: 'CredentialVerificationCaseV1Audit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    caseHistory?: Array<{
      __typename?: 'CredentialVerificationCaseV1CaseHistory';
      createdAt?: any | null;
      id: any;
      updatedAt?: any | null;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetails';
        createdAt?: any | null;
        application?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication';
          attestedAt?: any | null;
          credentialTitle?: string | null;
          credentialType?: string | null;
          dateCredentialIssuedAt?: any | null;
          isAttestationComplete?: boolean | null;
          isCredentialInEnglish?: boolean | null;
          isNameOnCredentialMatchPassport?: boolean | null;
          nameOnCredential?: string | null;
          program?: string | null;
          credentialAssets?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets';
            credential?: string | null;
            credentialUploadedAt?: any | null;
            credentialVersion?: string | null;
            translation?: string | null;
            translationUploadedAt?: any | null;
            translationVersion?: string | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            clientDisabledAt?: any | null;
            createdAt?: any | null;
            disabledAt?: any | null;
            entityLanguage?: string | null;
            entityName?: string | null;
            institutionDisabledAt?: any | null;
            isClient?: boolean | null;
            isIssuingInstitution?: boolean | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
            client?: {
              __typename?: 'EntityClient';
              email?: string | null;
              phoneNumber?: string | null;
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
            createdBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              email?: string | null;
              phoneNumber?: string | null;
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            institutionName?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          sendDestination?: {
            __typename?: 'Entity';
            clientDisabledAt?: any | null;
            createdAt?: any | null;
            disabledAt?: any | null;
            entityLanguage?: string | null;
            entityName?: string | null;
            institutionDisabledAt?: any | null;
            isClient?: boolean | null;
            isIssuingInstitution?: boolean | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
            client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
            createdBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
            issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
          } | null;
        } | null;
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
          affirmations?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
            isCredentialAcceptable?: string | null;
            isCredentialDetailsAcceptable?: string | null;
            isCredentialSentForVerification?: string | null;
            isDateOfBirthAcceptable?: string | null;
            isEntityAcceptable?: string | null;
            isNameAcceptable?: string | null;
            isTranslationAcceptable?: string | null;
            audit?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                emailAddress?: string | null;
                externalId?: string | null;
                firstName?: string | null;
                id: any;
                lastName?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
                updatedAt?: any | null;
                userType?: string | null;
                role?: {
                  __typename?: 'StaffRole';
                  createdAt?: any | null;
                  id: any;
                  isDefault: boolean;
                  roleName: string;
                  roleSubtype: string;
                  roleType?: string | null;
                  schemaVersion?: string | null;
                  updatedAt?: any | null;
                  permissions: {
                    __typename?: 'StaffRolePermissions';
                    applicantUserPermissions: {
                      __typename?: 'StaffRoleApplicantUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canBlockAccess: boolean;
                      canSearchApplicants: boolean;
                      canUpdatePersonalInformation: boolean;
                    };
                    credCasePermissions: {
                      __typename?: 'StaffRoleCredCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    entityPermissions: {
                      __typename?: 'StaffRoleEntityPermissions';
                      canAddEntities: boolean;
                      canDeleteEntities: boolean;
                      canEditEntities: boolean;
                      canSearchEntities: boolean;
                    };
                    idCasePermissions: {
                      __typename?: 'StaffRoleIdCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                    sendCasePermissions: {
                      __typename?: 'StaffRoleSendCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    staffUserPermissions: {
                      __typename?: 'StaffRoleStaffUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canAssignRoles: boolean;
                      canBlockAccess: boolean;
                      canSearchStaff: boolean;
                    };
                  };
                } | null;
                search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
              } | null;
            } | null;
          } | null;
          caseWorkerAssigned?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          decision?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
            completedAt?: any | null;
            rejectionReason?: string | null;
            result?: string | null;
          } | null;
          privateCaseDetails?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails';
            alternateVerifyingEntity?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity';
              isVerifiedWithOther?: boolean | null;
              otherDetails?: string | null;
            } | null;
            entitySuppliedCredential?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential';
              credential?: string | null;
              credentialUploadedAt?: any | null;
              credentialVersion?: string | null;
              translation?: string | null;
              translationUploadedAt?: any | null;
              translationVersion?: string | null;
            } | null;
            institutionContactDetails?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
              institutionEmail?: string | null;
              institutionPhone?: string | null;
            } | null;
            verificationStatus?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
              verificationResponse?: string | null;
            } | null;
          } | null;
          verificationAffirmations?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations';
            isCredentialReturnedFromEntity?: string | null;
            isEntityDetailCorrect?: string | null;
            isReturnedFromCorrectEntity?: string | null;
            isVerificationComplete?: string | null;
            isVerificationComponentPacketCompiled?: string | null;
            isVerificationInEnglishOrWithTranslation?: string | null;
            isVerificationMethodAcceptable?: string | null;
            isVerificationStatusComplete?: string | null;
            audit?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                emailAddress?: string | null;
                externalId?: string | null;
                firstName?: string | null;
                id: any;
                lastName?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
                updatedAt?: any | null;
                userType?: string | null;
                role?: {
                  __typename?: 'StaffRole';
                  createdAt?: any | null;
                  id: any;
                  isDefault: boolean;
                  roleName: string;
                  roleSubtype: string;
                  roleType?: string | null;
                  schemaVersion?: string | null;
                  updatedAt?: any | null;
                  permissions: {
                    __typename?: 'StaffRolePermissions';
                    applicantUserPermissions: {
                      __typename?: 'StaffRoleApplicantUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canBlockAccess: boolean;
                      canSearchApplicants: boolean;
                      canUpdatePersonalInformation: boolean;
                    };
                    credCasePermissions: {
                      __typename?: 'StaffRoleCredCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    entityPermissions: {
                      __typename?: 'StaffRoleEntityPermissions';
                      canAddEntities: boolean;
                      canDeleteEntities: boolean;
                      canEditEntities: boolean;
                      canSearchEntities: boolean;
                    };
                    idCasePermissions: {
                      __typename?: 'StaffRoleIdCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                    sendCasePermissions: {
                      __typename?: 'StaffRoleSendCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    staffUserPermissions: {
                      __typename?: 'StaffRoleStaffUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canAssignRoles: boolean;
                      canBlockAccess: boolean;
                      canSearchStaff: boolean;
                    };
                  };
                } | null;
                search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
              } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      revisionRequest?: {
        __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequest';
        requestedAt?: any | null;
        revisionSubmittedAt?: any | null;
        revisionSummary?: string | null;
        requestedBy?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            id: any;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        requestedChanges?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
          requestUpdatedCredentialDetails?: boolean | null;
          requestUpdatedIssuingInstitution?: boolean | null;
          requestUploadCredential?: boolean | null;
          requestUploadTranslation?: boolean | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  caseHistory?: Array<{
    __typename?: 'CredentialVerificationCaseV1CaseHistory';
    createdAt?: any | null;
    id: any;
    updatedAt?: any | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetails';
      createdAt?: any | null;
      application?: {
        __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication';
        attestedAt?: any | null;
        credentialTitle?: string | null;
        credentialType?: string | null;
        dateCredentialIssuedAt?: any | null;
        isAttestationComplete?: boolean | null;
        isCredentialInEnglish?: boolean | null;
        isNameOnCredentialMatchPassport?: boolean | null;
        nameOnCredential?: string | null;
        program?: string | null;
        credentialAssets?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets';
          credential?: string | null;
          credentialUploadedAt?: any | null;
          credentialVersion?: string | null;
          translation?: string | null;
          translationUploadedAt?: any | null;
          translationVersion?: string | null;
        } | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          clientDisabledAt?: any | null;
          createdAt?: any | null;
          disabledAt?: any | null;
          entityLanguage?: string | null;
          entityName?: string | null;
          institutionDisabledAt?: any | null;
          isClient?: boolean | null;
          isIssuingInstitution?: boolean | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          client?: {
            __typename?: 'EntityClient';
            email?: string | null;
            phoneNumber?: string | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
          createdBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            email?: string | null;
            phoneNumber?: string | null;
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
        otherIssuingInstitution?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          institutionName?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        sendDestination?: {
          __typename?: 'Entity';
          clientDisabledAt?: any | null;
          createdAt?: any | null;
          disabledAt?: any | null;
          entityLanguage?: string | null;
          entityName?: string | null;
          institutionDisabledAt?: any | null;
          isClient?: boolean | null;
          isIssuingInstitution?: boolean | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
          createdBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
        } | null;
      } | null;
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
          isCredentialAcceptable?: string | null;
          isCredentialDetailsAcceptable?: string | null;
          isCredentialSentForVerification?: string | null;
          isDateOfBirthAcceptable?: string | null;
          isEntityAcceptable?: string | null;
          isNameAcceptable?: string | null;
          isTranslationAcceptable?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
          } | null;
        } | null;
        caseWorkerAssigned?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        decision?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
        } | null;
        privateCaseDetails?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails';
          alternateVerifyingEntity?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity';
            isVerifiedWithOther?: boolean | null;
            otherDetails?: string | null;
          } | null;
          entitySuppliedCredential?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential';
            credential?: string | null;
            credentialUploadedAt?: any | null;
            credentialVersion?: string | null;
            translation?: string | null;
            translationUploadedAt?: any | null;
            translationVersion?: string | null;
          } | null;
          institutionContactDetails?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
            institutionEmail?: string | null;
            institutionPhone?: string | null;
          } | null;
          verificationStatus?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
            verificationResponse?: string | null;
          } | null;
        } | null;
        verificationAffirmations?: {
          __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations';
          isCredentialReturnedFromEntity?: string | null;
          isEntityDetailCorrect?: string | null;
          isReturnedFromCorrectEntity?: string | null;
          isVerificationComplete?: string | null;
          isVerificationComponentPacketCompiled?: string | null;
          isVerificationInEnglishOrWithTranslation?: string | null;
          isVerificationMethodAcceptable?: string | null;
          isVerificationStatusComplete?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      revisionSummary?: string | null;
      requestedBy?: {
        __typename?: 'StaffUser';
        accessBlocked?: boolean | null;
        createdAt?: any | null;
        displayName?: string | null;
        emailAddress?: string | null;
        externalId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        userType?: string | null;
        role?: {
          __typename?: 'StaffRole';
          createdAt?: any | null;
          id: any;
          isDefault: boolean;
          roleName: string;
          roleSubtype: string;
          roleType?: string | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          permissions: {
            __typename?: 'StaffRolePermissions';
            applicantUserPermissions: {
              __typename?: 'StaffRoleApplicantUserPermissions';
              canAddOrRemoveTags: boolean;
              canBlockAccess: boolean;
              canSearchApplicants: boolean;
              canUpdatePersonalInformation: boolean;
            };
            credCasePermissions: {
              __typename?: 'StaffRoleCredCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            entityPermissions: {
              __typename?: 'StaffRoleEntityPermissions';
              canAddEntities: boolean;
              canDeleteEntities: boolean;
              canEditEntities: boolean;
              canSearchEntities: boolean;
            };
            idCasePermissions: {
              __typename?: 'StaffRoleIdCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
            sendCasePermissions: {
              __typename?: 'StaffRoleSendCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            staffUserPermissions: {
              __typename?: 'StaffRoleStaffUserPermissions';
              canAddOrRemoveTags: boolean;
              canAssignRoles: boolean;
              canBlockAccess: boolean;
              canSearchStaff: boolean;
            };
          };
        } | null;
        search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      } | null;
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
  } | null> | null;
};

export type CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    submittedAt?: any | null;
    expirationEligibleAt?: any | null;
    lastActivityAt?: any | null;
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  submittedAt?: any | null;
  expirationEligibleAt?: any | null;
  lastActivityAt?: any | null;
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    expirationEligibleAt?: any | null;
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        affirmations?: {
          __typename?: 'CredentialVerificationCaseV1Affirmations';
          isCredentialAcceptable?: string | null;
          isCredentialDetailsAcceptable?: string | null;
          isCredentialSentForVerification?: string | null;
          isDateOfBirthAcceptable?: string | null;
          isEntityAcceptable?: string | null;
          isNameAcceptable?: string | null;
          isTranslationAcceptable?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        verificationAffirmations?: {
          __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
          isCredentialReturnedFromEntity?: string | null;
          isEntityDetailCorrect?: string | null;
          isReturnedFromCorrectEntity?: string | null;
          isVerificationComplete?: string | null;
          isVerificationComponentPacketCompiled?: string | null;
          isVerificationInEnglishOrWithTranslation?: string | null;
          isVerificationMethodAcceptable?: string | null;
          isVerificationStatusComplete?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'CredentialVerificationCaseV1ActivityLog';
      tags?: Array<string | null> | null;
      description?: string | null;
      activityType?: string | null;
      updatedAt?: any | null;
      id: any;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesCredentialVerificationChangeStatusContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      roleName: string;
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canReopenCases: boolean } };
    } | null;
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      expirationEligibleAt?: any | null;
      id: any;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReview';
          affirmations?: {
            __typename?: 'CredentialVerificationCaseV1Affirmations';
            isCredentialAcceptable?: string | null;
            isCredentialDetailsAcceptable?: string | null;
            isCredentialSentForVerification?: string | null;
            isDateOfBirthAcceptable?: string | null;
            isEntityAcceptable?: string | null;
            isNameAcceptable?: string | null;
            isTranslationAcceptable?: string | null;
            audit?: {
              __typename?: 'CredentialVerificationCaseV1Audit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
          verificationAffirmations?: {
            __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
            isCredentialReturnedFromEntity?: string | null;
            isEntityDetailCorrect?: string | null;
            isReturnedFromCorrectEntity?: string | null;
            isVerificationComplete?: string | null;
            isVerificationComponentPacketCompiled?: string | null;
            isVerificationInEnglishOrWithTranslation?: string | null;
            isVerificationMethodAcceptable?: string | null;
            isVerificationStatusComplete?: string | null;
            audit?: {
              __typename?: 'CredentialVerificationCaseV1Audit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      activityLog?: Array<{
        __typename?: 'CredentialVerificationCaseV1ActivityLog';
        tags?: Array<string | null> | null;
        description?: string | null;
        activityType?: string | null;
        updatedAt?: any | null;
        id: any;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesCredentialVerificationChangeStatusContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    roleName: string;
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canReopenCases: boolean } };
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  expirationEligibleAt?: any | null;
  id: any;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      affirmations?: {
        __typename?: 'CredentialVerificationCaseV1Affirmations';
        isCredentialAcceptable?: string | null;
        isCredentialDetailsAcceptable?: string | null;
        isCredentialSentForVerification?: string | null;
        isDateOfBirthAcceptable?: string | null;
        isEntityAcceptable?: string | null;
        isNameAcceptable?: string | null;
        isTranslationAcceptable?: string | null;
        audit?: {
          __typename?: 'CredentialVerificationCaseV1Audit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      verificationAffirmations?: {
        __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
        isCredentialReturnedFromEntity?: string | null;
        isEntityDetailCorrect?: string | null;
        isReturnedFromCorrectEntity?: string | null;
        isVerificationComplete?: string | null;
        isVerificationComponentPacketCompiled?: string | null;
        isVerificationInEnglishOrWithTranslation?: string | null;
        isVerificationMethodAcceptable?: string | null;
        isVerificationStatusComplete?: string | null;
        audit?: {
          __typename?: 'CredentialVerificationCaseV1Audit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  activityLog?: Array<{
    __typename?: 'CredentialVerificationCaseV1ActivityLog';
    tags?: Array<string | null> | null;
    description?: string | null;
    activityType?: string | null;
    updatedAt?: any | null;
    id: any;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    expirationEligibleAt?: any | null;
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        affirmations?: {
          __typename?: 'CredentialVerificationCaseV1Affirmations';
          isCredentialAcceptable?: string | null;
          isCredentialDetailsAcceptable?: string | null;
          isCredentialSentForVerification?: string | null;
          isDateOfBirthAcceptable?: string | null;
          isEntityAcceptable?: string | null;
          isNameAcceptable?: string | null;
          isTranslationAcceptable?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        verificationAffirmations?: {
          __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
          isCredentialReturnedFromEntity?: string | null;
          isEntityDetailCorrect?: string | null;
          isReturnedFromCorrectEntity?: string | null;
          isVerificationComplete?: string | null;
          isVerificationComponentPacketCompiled?: string | null;
          isVerificationInEnglishOrWithTranslation?: string | null;
          isVerificationMethodAcceptable?: string | null;
          isVerificationStatusComplete?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'CredentialVerificationCaseV1ActivityLog';
      tags?: Array<string | null> | null;
      description?: string | null;
      activityType?: string | null;
      updatedAt?: any | null;
      id: any;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1ActivityLog';
  tags?: Array<string | null> | null;
  description?: string | null;
  activityType?: string | null;
  updatedAt?: any | null;
  id: any;
  activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReview';
    affirmations?: {
      __typename?: 'CredentialVerificationCaseV1Affirmations';
      isCredentialAcceptable?: string | null;
      isCredentialDetailsAcceptable?: string | null;
      isCredentialSentForVerification?: string | null;
      isDateOfBirthAcceptable?: string | null;
      isEntityAcceptable?: string | null;
      isNameAcceptable?: string | null;
      isTranslationAcceptable?: string | null;
      audit?: {
        __typename?: 'CredentialVerificationCaseV1Audit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    verificationAffirmations?: {
      __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
      isCredentialReturnedFromEntity?: string | null;
      isEntityDetailCorrect?: string | null;
      isReturnedFromCorrectEntity?: string | null;
      isVerificationComplete?: string | null;
      isVerificationComponentPacketCompiled?: string | null;
      isVerificationInEnglishOrWithTranslation?: string | null;
      isVerificationMethodAcceptable?: string | null;
      isVerificationStatusComplete?: string | null;
      audit?: {
        __typename?: 'CredentialVerificationCaseV1Audit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1ApplicationReview';
  affirmations?: {
    __typename?: 'CredentialVerificationCaseV1Affirmations';
    isCredentialAcceptable?: string | null;
    isCredentialDetailsAcceptable?: string | null;
    isCredentialSentForVerification?: string | null;
    isDateOfBirthAcceptable?: string | null;
    isEntityAcceptable?: string | null;
    isNameAcceptable?: string | null;
    isTranslationAcceptable?: string | null;
    audit?: {
      __typename?: 'CredentialVerificationCaseV1Audit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  verificationAffirmations?: {
    __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
    isCredentialReturnedFromEntity?: string | null;
    isEntityDetailCorrect?: string | null;
    isReturnedFromCorrectEntity?: string | null;
    isVerificationComplete?: string | null;
    isVerificationComponentPacketCompiled?: string | null;
    isVerificationInEnglishOrWithTranslation?: string | null;
    isVerificationMethodAcceptable?: string | null;
    isVerificationStatusComplete?: string | null;
    audit?: {
      __typename?: 'CredentialVerificationCaseV1Audit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1Affirmations';
  isCredentialAcceptable?: string | null;
  isCredentialDetailsAcceptable?: string | null;
  isCredentialSentForVerification?: string | null;
  isDateOfBirthAcceptable?: string | null;
  isEntityAcceptable?: string | null;
  isNameAcceptable?: string | null;
  isTranslationAcceptable?: string | null;
  audit?: {
    __typename?: 'CredentialVerificationCaseV1Audit';
    completedAt?: any | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
  isCredentialReturnedFromEntity?: string | null;
  isEntityDetailCorrect?: string | null;
  isReturnedFromCorrectEntity?: string | null;
  isVerificationComplete?: string | null;
  isVerificationComponentPacketCompiled?: string | null;
  isVerificationInEnglishOrWithTranslation?: string | null;
  isVerificationMethodAcceptable?: string | null;
  isVerificationStatusComplete?: string | null;
  audit?: {
    __typename?: 'CredentialVerificationCaseV1Audit';
    completedAt?: any | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
    messages?: Array<{
      __typename?: 'CredentialVerificationCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      createdAt?: any | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
    } | null> | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      financeConfig?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
        glConfig?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
          additionalCharges?: Array<{ __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
        } | null;
      } | null;
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        submission?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
        adhocTransactions?: Array<{
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
          reason?: string | null;
          amount?: number | null;
          createdAt?: any | null;
          id: any;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
          approval?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval'; isApplicantApproved?: boolean | null } | null;
        } | null> | null;
      } | null;
    } | null;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesCredentialVerificationV1ChatPageContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canIssueRefunds: boolean } };
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canIssueRefunds: boolean } };
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      id: any;
      revisionRequest?: {
        __typename?: 'CredentialVerificationCaseV1RevisionRequest';
        requestedAt?: any | null;
        requestedChanges?: {
          __typename?: 'CredentialVerificationCaseV1RequestedChanges';
          requestUpdatedCredentialDetails?: boolean | null;
          requestUpdatedIssuingInstitution?: boolean | null;
          requestUploadCredential?: boolean | null;
          requestUploadTranslation?: boolean | null;
        } | null;
      } | null;
      messages?: Array<{
        __typename?: 'CredentialVerificationCaseV1Message';
        isHiddenFromApplicant?: boolean | null;
        sentBy?: string | null;
        createdAt?: any | null;
        embedding?: string | null;
        message?: string | null;
        id: any;
      } | null> | null;
      financeDetails?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetails';
        financeConfig?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
          glConfig?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
            additionalCharges?: Array<{ __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
          } | null;
        } | null;
        transactions?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
          submission?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
          adhocTransactions?: Array<{
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
            reason?: string | null;
            amount?: number | null;
            createdAt?: any | null;
            id: any;
            transactionReference?: {
              __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
              referenceId?: string | null;
            } | null;
            approval?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval'; isApplicantApproved?: boolean | null } | null;
          } | null> | null;
        } | null;
      } | null;
      applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    revisionRequest?: {
      __typename?: 'CredentialVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      requestedChanges?: {
        __typename?: 'CredentialVerificationCaseV1RequestedChanges';
        requestUpdatedCredentialDetails?: boolean | null;
        requestUpdatedIssuingInstitution?: boolean | null;
        requestUploadCredential?: boolean | null;
        requestUploadTranslation?: boolean | null;
      } | null;
    } | null;
    messages?: Array<{
      __typename?: 'CredentialVerificationCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      createdAt?: any | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
    } | null> | null;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      financeConfig?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
        glConfig?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
          additionalCharges?: Array<{ __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
        } | null;
      } | null;
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        submission?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
        adhocTransactions?: Array<{
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
          reason?: string | null;
          amount?: number | null;
          createdAt?: any | null;
          id: any;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
          approval?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval'; isApplicantApproved?: boolean | null } | null;
        } | null> | null;
      } | null;
    } | null;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  id: any;
  revisionRequest?: {
    __typename?: 'CredentialVerificationCaseV1RevisionRequest';
    requestedAt?: any | null;
    requestedChanges?: {
      __typename?: 'CredentialVerificationCaseV1RequestedChanges';
      requestUpdatedCredentialDetails?: boolean | null;
      requestUpdatedIssuingInstitution?: boolean | null;
      requestUploadCredential?: boolean | null;
      requestUploadTranslation?: boolean | null;
    } | null;
  } | null;
  messages?: Array<{
    __typename?: 'CredentialVerificationCaseV1Message';
    isHiddenFromApplicant?: boolean | null;
    sentBy?: string | null;
    createdAt?: any | null;
    embedding?: string | null;
    message?: string | null;
    id: any;
  } | null> | null;
  financeDetails?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetails';
    financeConfig?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
      glConfig?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
        additionalCharges?: Array<{ __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
      } | null;
    } | null;
    transactions?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
      submission?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
      adhocTransactions?: Array<{
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
        reason?: string | null;
        amount?: number | null;
        createdAt?: any | null;
        id: any;
        transactionReference?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
          referenceId?: string | null;
        } | null;
        approval?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval'; isApplicantApproved?: boolean | null } | null;
      } | null> | null;
    } | null;
  } | null;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1RevisionRequest';
  requestedAt?: any | null;
  requestedChanges?: {
    __typename?: 'CredentialVerificationCaseV1RequestedChanges';
    requestUpdatedCredentialDetails?: boolean | null;
    requestUpdatedIssuingInstitution?: boolean | null;
    requestUploadCredential?: boolean | null;
    requestUploadTranslation?: boolean | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetails';
  financeConfig?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
    glConfig?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
      additionalCharges?: Array<{ __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
    } | null;
  } | null;
  transactions?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
    submission?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
    adhocTransactions?: Array<{
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
      reason?: string | null;
      amount?: number | null;
      createdAt?: any | null;
      id: any;
      transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
      approval?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval'; isApplicantApproved?: boolean | null } | null;
    } | null> | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
  glConfig?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
    additionalCharges?: Array<{ __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
  } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
  submission?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
  adhocTransactions?: Array<{
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
    reason?: string | null;
    amount?: number | null;
    createdAt?: any | null;
    id: any;
    transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
    approval?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval'; isApplicantApproved?: boolean | null } | null;
  } | null> | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
  reason?: string | null;
  amount?: number | null;
  createdAt?: any | null;
  id: any;
  transactionReference?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
  approval?: { __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval'; isApplicantApproved?: boolean | null } | null;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1Message';
  isHiddenFromApplicant?: boolean | null;
  sentBy?: string | null;
  createdAt?: any | null;
  embedding?: string | null;
  message?: string | null;
  id: any;
};

export type CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1RequestedChanges';
  requestUpdatedCredentialDetails?: boolean | null;
  requestUpdatedIssuingInstitution?: boolean | null;
  requestUploadCredential?: boolean | null;
  requestUploadTranslation?: boolean | null;
};

export type CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        affirmations?: {
          __typename?: 'CredentialVerificationCaseV1Affirmations';
          isNameAcceptable?: string | null;
          isTranslationAcceptable?: string | null;
          isCredentialAcceptable?: string | null;
          isCredentialDetailsAcceptable?: string | null;
          isDateOfBirthAcceptable?: string | null;
          isEntityAcceptable?: string | null;
          isCredentialSentForVerification?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
          } | null;
        } | null;
        verificationAffirmations?: {
          __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
          isReturnedFromCorrectEntity?: string | null;
          isVerificationMethodAcceptable?: string | null;
          isVerificationComplete?: string | null;
          isVerificationInEnglishOrWithTranslation?: string | null;
          isEntityDetailCorrect?: string | null;
          isCredentialReturnedFromEntity?: string | null;
          isVerificationStatusComplete?: string | null;
          isVerificationComponentPacketCompiled?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      id: any;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReview';
          affirmations?: {
            __typename?: 'CredentialVerificationCaseV1Affirmations';
            isNameAcceptable?: string | null;
            isTranslationAcceptable?: string | null;
            isCredentialAcceptable?: string | null;
            isCredentialDetailsAcceptable?: string | null;
            isDateOfBirthAcceptable?: string | null;
            isEntityAcceptable?: string | null;
            isCredentialSentForVerification?: string | null;
            audit?: {
              __typename?: 'CredentialVerificationCaseV1Audit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
            } | null;
          } | null;
          verificationAffirmations?: {
            __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
            isReturnedFromCorrectEntity?: string | null;
            isVerificationMethodAcceptable?: string | null;
            isVerificationComplete?: string | null;
            isVerificationInEnglishOrWithTranslation?: string | null;
            isEntityDetailCorrect?: string | null;
            isCredentialReturnedFromEntity?: string | null;
            isVerificationStatusComplete?: string | null;
            isVerificationComponentPacketCompiled?: string | null;
            audit?: {
              __typename?: 'CredentialVerificationCaseV1Audit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        affirmations?: {
          __typename?: 'CredentialVerificationCaseV1Affirmations';
          isNameAcceptable?: string | null;
          isTranslationAcceptable?: string | null;
          isCredentialAcceptable?: string | null;
          isCredentialDetailsAcceptable?: string | null;
          isDateOfBirthAcceptable?: string | null;
          isEntityAcceptable?: string | null;
          isCredentialSentForVerification?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
          } | null;
        } | null;
        verificationAffirmations?: {
          __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
          isReturnedFromCorrectEntity?: string | null;
          isVerificationMethodAcceptable?: string | null;
          isVerificationComplete?: string | null;
          isVerificationInEnglishOrWithTranslation?: string | null;
          isEntityDetailCorrect?: string | null;
          isCredentialReturnedFromEntity?: string | null;
          isVerificationStatusComplete?: string | null;
          isVerificationComponentPacketCompiled?: string | null;
          audit?: {
            __typename?: 'CredentialVerificationCaseV1Audit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  id: any;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      affirmations?: {
        __typename?: 'CredentialVerificationCaseV1Affirmations';
        isNameAcceptable?: string | null;
        isTranslationAcceptable?: string | null;
        isCredentialAcceptable?: string | null;
        isCredentialDetailsAcceptable?: string | null;
        isDateOfBirthAcceptable?: string | null;
        isEntityAcceptable?: string | null;
        isCredentialSentForVerification?: string | null;
        audit?: {
          __typename?: 'CredentialVerificationCaseV1Audit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
        } | null;
      } | null;
      verificationAffirmations?: {
        __typename?: 'CredentialVerificationCaseV1VerificationAffirmations';
        isReturnedFromCorrectEntity?: string | null;
        isVerificationMethodAcceptable?: string | null;
        isVerificationComplete?: string | null;
        isVerificationInEnglishOrWithTranslation?: string | null;
        isEntityDetailCorrect?: string | null;
        isCredentialReturnedFromEntity?: string | null;
        isVerificationStatusComplete?: string | null;
        isVerificationComponentPacketCompiled?: string | null;
        audit?: {
          __typename?: 'CredentialVerificationCaseV1Audit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          primaryPhone?: string | null;
          emailAddress?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
        } | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            degreeTitle?: string | null;
            attendanceStartedAt?: any | null;
            attendanceEndedAt?: any | null;
            degreeIssuedAt?: any | null;
            graduationYear?: number | null;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              zipOrPostalCode?: string | null;
              stateOrProvince?: string | null;
              name?: string | null;
              country?: string | null;
              city?: string | null;
              addressLine1?: string | null;
            } | null;
          } | null> | null;
        } | null;
        applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  applicant?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        primaryPhone?: string | null;
        emailAddress?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
      } | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          attendanceStartedAt?: any | null;
          attendanceEndedAt?: any | null;
          degreeIssuedAt?: any | null;
          graduationYear?: number | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            zipOrPostalCode?: string | null;
            stateOrProvince?: string | null;
            name?: string | null;
            country?: string | null;
            city?: string | null;
            addressLine1?: string | null;
          } | null;
        } | null> | null;
      } | null;
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
  } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'CredentialVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'CredentialVerificationCaseV1Application';
          credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
        } | null;
        applicationReview?: {
          __typename?: 'CredentialVerificationCaseV1ApplicationReview';
          privateCaseDetails?: {
            __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
            entitySuppliedCredential?: { __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential'; credential?: string | null; translation?: string | null } | null;
          } | null;
        } | null;
      } | null;
      assets?: {
        __typename?: 'CredentialVerificationCaseV1Assets';
        private?: {
          __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
          verificationForm?: string | null;
          verificationPacket?: string | null;
          verificationPacketResponse?: string | null;
          verificationComponentPacket?: string | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type StaffCasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1FileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1PdfFileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1ImageFileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
      } | null;
      applicationReview?: {
        __typename?: 'CredentialVerificationCaseV1ApplicationReview';
        privateCaseDetails?: {
          __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
          entitySuppliedCredential?: { __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential'; credential?: string | null; translation?: string | null } | null;
        } | null;
      } | null;
    } | null;
    assets?: {
      __typename?: 'CredentialVerificationCaseV1Assets';
      private?: {
        __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
        verificationForm?: string | null;
        verificationPacket?: string | null;
        verificationPacketResponse?: string | null;
        verificationComponentPacket?: string | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobPath?: string | null;
    blobName?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobPath?: string | null;
  blobName?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'CredentialVerificationCaseV1Application';
      credentialAssets?: { __typename?: 'CredentialVerificationCaseV1CredentialAssets'; credential?: string | null; translation?: string | null } | null;
    } | null;
    applicationReview?: {
      __typename?: 'CredentialVerificationCaseV1ApplicationReview';
      privateCaseDetails?: {
        __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
        entitySuppliedCredential?: { __typename?: 'CredentialVerificationCaseV1EntitySuppliedCredential'; credential?: string | null; translation?: string | null } | null;
      } | null;
    } | null;
  } | null;
  assets?: {
    __typename?: 'CredentialVerificationCaseV1Assets';
    private?: {
      __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
      verificationForm?: string | null;
      verificationPacket?: string | null;
      verificationPacketResponse?: string | null;
      verificationComponentPacket?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQuery = {
  __typename?: 'Query';
  identityVerificationCasesV1ByApplicant?: Array<{
    __typename?: 'IdentityVerificationCaseV1';
    caseName: string;
    caseType?: string | null;
    state: string;
    lastActivityAt?: any | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        decision?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null } | null;
      } | null;
    } | null;
  } | null> | null;
};

export type StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQuery = {
  __typename?: 'Query';
  credentialVerificationCasesV1ByApplicant?: Array<{
    __typename?: 'CredentialVerificationCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    state: string;
    lastActivityAt?: any | null;
    id: any;
  } | null> | null;
};

export type StaffActiveCaseListContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffActiveCaseListContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type StaffActiveCaseListContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  caseName?: string | null;
  caseType?: string | null;
  state: string;
  lastActivityAt?: any | null;
  id: any;
};

export type StaffActiveCaseListContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  caseName: string;
  caseType?: string | null;
  state: string;
  lastActivityAt?: any | null;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
      decision?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null } | null;
    } | null;
  } | null;
};

export type StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
    decision?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null } | null;
  } | null;
};

export type StaffActiveListContainerCredentialVerificationCaseV1IdFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQuery = {
  __typename?: 'Query';
  archivedCasesByApplicantId?: Array<{ __typename?: 'ArchivedCaseSummary'; archivedAt: any; caseName: string; caseType: string; id: any; state: string } | null> | null;
};

export type CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCaseSummary';
  archivedAt: any;
  caseName: string;
  caseType: string;
  id: any;
  state: string;
};

export type StaffFilePickerCaseListContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffFilePickerCaseListContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type StaffFilePickerCaseListContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type StaffDocumentListContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffDocumentListContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type StaffDocumentListContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffDocumentListContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesDocumentListContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesDocumentListContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  archivedIdentityVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesDocumentListContainerArchivedSendReportCaseSummaryQueryVariables = Exact<{
  archivedSendReportCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesDocumentListContainerArchivedSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type StaffDocumentListContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type StaffDocumentListContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesDocumentListContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesDocumentListContainerArchivedSendReportCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummary';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type StaffDocumentListContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; name: string; url: string; type?: string | null };

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    } | null;
  } | null;
};

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1FileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobName?: string | null;
      blobPath?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobName?: string | null;
    blobPath?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobName?: string | null;
  blobPath?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    } | null;
  } | null;
};

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables = Exact<{
  input: CredentialVerificationCaseV1BlobFileInput;
}>;

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1FileCreateAuthHeader: {
    __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobName?: string | null;
      blobPath?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobName?: string | null;
    blobPath?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobName?: string | null;
  blobPath?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationVariables = Exact<{
  input: CredentialVerificationCaseV1UpdateInput;
}>;

export type StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1Update?: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    credentialVerificationCaseV1?: {
      __typename?: 'CredentialVerificationCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    } | null;
  } | null;
};

export type StaffCasesFilesContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffCasesFilesContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: { __typename?: 'CredentialVerificationCaseV1'; id: any; isCurrentUserAssigned?: boolean | null; state: string } | null;
};

export type StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type StaffCasesFilesContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type StaffCasesFilesContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string };

export type StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdQueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdQuery = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    applicant?: {
      __typename?: 'ApplicantUser';
      displayName?: string | null;
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          lastName?: string | null;
          restOfName?: string | null;
        } | null;
      } | null;
    } | null;
    caseDetails?: {
      __typename?: 'CredentialVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'CredentialVerificationCaseV1Application';
        nameOnCredential?: string | null;
        issuingInstitution?: { __typename?: 'Entity'; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdCredentialVerificationCaseV1Fragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  applicant?: {
    __typename?: 'ApplicantUser';
    displayName?: string | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        lastName?: string | null;
        restOfName?: string | null;
      } | null;
    } | null;
  } | null;
  caseDetails?: {
    __typename?: 'CredentialVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'CredentialVerificationCaseV1Application';
      nameOnCredential?: string | null;
      issuingInstitution?: { __typename?: 'Entity'; id: any } | null;
    } | null;
  } | null;
};

export type StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFieldsFragment = {
  __typename?: 'ApplicantUser';
  displayName?: string | null;
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      lastName?: string | null;
      restOfName?: string | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: { __typename?: 'CredentialVerificationCaseV1'; isCurrentUserAssigned?: boolean | null; id: any } | null;
};

export type CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    id: any;
    applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
  } | null;
};

export type CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  isCurrentUserAssigned?: boolean | null;
  id: any;
};

export type CasesCredentialVerificationV1RelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  id: any;
  applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
};

export type CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    financeDetails?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
          amount?: number | null;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
          } | null;
        } | null;
        adhocTransactions?: Array<{
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
          amount?: number | null;
          reason?: string | null;
          status?: string | null;
          updatedAt?: any | null;
          id: any;
          approval?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
            isApplicantApproved?: boolean | null;
            isApplicantApprovalRequired?: boolean | null;
            applicantRespondedAt?: any | null;
          } | null;
          transactionReference?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  financeDetails?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
      submission?: {
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmission';
        amount?: number | null;
        transactionReference?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
        } | null;
      } | null;
      adhocTransactions?: Array<{
        __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
        amount?: number | null;
        reason?: string | null;
        status?: string | null;
        updatedAt?: any | null;
        id: any;
        approval?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
          isApplicantApproved?: boolean | null;
          isApplicantApprovalRequired?: boolean | null;
          applicantRespondedAt?: any | null;
        } | null;
        transactionReference?: {
          __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          vendor?: string | null;
          isSuccess?: boolean | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
  amount?: number | null;
  reason?: string | null;
  status?: string | null;
  updatedAt?: any | null;
  id: any;
  approval?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsApproval';
    isApplicantApproved?: boolean | null;
    isApplicantApprovalRequired?: boolean | null;
    applicantRespondedAt?: any | null;
  } | null;
  transactionReference?: {
    __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
    completedAt?: any | null;
    referenceId?: string | null;
    vendor?: string | null;
    isSuccess?: boolean | null;
  } | null;
};

export type CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutationVariables = Exact<{
  input: CredentialVerificationCaseV1MergePdfFilesInput;
}>;

export type CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1MergePdfFiles: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutationVariables = Exact<{
  input: CredentialVerificationCaseV1MergePdfFilesInput;
}>;

export type CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutation = {
  __typename?: 'Mutation';
  credentialVerificationCaseV1MergePdfFiles: {
    __typename?: 'CredentialVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesCredentialVerificationV1IndexContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesCredentialVerificationV1IndexContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canViewCaseHistory: boolean } };
    } | null;
  } | null;
};

export type CasesCredentialVerificationV1IndexContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canViewCaseHistory: boolean } };
  } | null;
};

export type CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: { __typename?: 'CredentialVerificationCaseV1'; state: string; caseName?: string | null; id: any } | null;
};

export type CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  state: string;
  caseName?: string | null;
  id: any;
};

export type CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  archivedIdentityVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    id: any;
    applicant: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
        } | null;
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            degreeTitle?: string | null;
            attendanceStartedAt?: any | null;
            attendanceEndedAt?: any | null;
            degreeIssuedAt?: any | null;
            graduationYear?: number | null;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              zipOrPostalCode?: string | null;
              stateOrProvince?: string | null;
              name?: string | null;
              country?: string | null;
              city?: string | null;
              addressLine1?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    };
  } | null;
};

export type CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  id: any;
  applicant: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
      } | null;
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          attendanceStartedAt?: any | null;
          attendanceEndedAt?: any | null;
          degreeIssuedAt?: any | null;
          graduationYear?: number | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            zipOrPostalCode?: string | null;
            stateOrProvince?: string | null;
            name?: string | null;
            country?: string | null;
            city?: string | null;
            addressLine1?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  };
};

export type CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    contactInformation?: {
      __typename?: 'ApplicantUserContactInformation';
      emailAddress?: string | null;
      primaryPhone?: string | null;
      address?: {
        __typename?: 'ApplicantUserAddress';
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        streetAddressLine1?: string | null;
        streetAddressLine2?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
    } | null;
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      generationalSuffix?: string | null;
      lastName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      restOfName?: string | null;
    } | null;
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      citizenshipAtTimeEnteredMedicalInstitution?: string | null;
      healthProfession?: string | null;
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        degreeTitle?: string | null;
        attendanceStartedAt?: any | null;
        attendanceEndedAt?: any | null;
        degreeIssuedAt?: any | null;
        graduationYear?: number | null;
        issuingInstitution?: {
          __typename?: 'Entity';
          entityName?: string | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'EntityIssuingInstitution';
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null;
        } | null;
        otherIssuingInstitution?: {
          __typename?: 'ApplicantUserOtherIssuingInstitution';
          zipOrPostalCode?: string | null;
          stateOrProvince?: string | null;
          name?: string | null;
          country?: string | null;
          city?: string | null;
          addressLine1?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformationFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
  } | null;
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      degreeTitle?: string | null;
      attendanceStartedAt?: any | null;
      attendanceEndedAt?: any | null;
      degreeIssuedAt?: any | null;
      graduationYear?: number | null;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null;
      } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        zipOrPostalCode?: string | null;
        stateOrProvince?: string | null;
        name?: string | null;
        country?: string | null;
        city?: string | null;
        addressLine1?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        decision?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
    decision?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  archivedIdentityVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    archiveEligibleAt: any;
    archivedAt: any;
    caseName: string;
    caseType: string;
    lastActivityAt: any;
    state: string;
    submittedAt: any;
    id: any;
    createdAt: any;
    activityLog: Array<{
      __typename?: 'ArchivedCaseSummaryActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      activityBy?: {
        __typename?: 'User';
        accessBlocked?: boolean | null;
        displayName?: string | null;
        externalId?: string | null;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        userType?: string | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
      } | null;
    } | null>;
    applicant: {
      __typename?: 'ApplicantUser';
      accessBlocked?: boolean | null;
      displayName?: string | null;
      externalId?: string | null;
      isProfileSubmitted?: boolean | null;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      userType?: string | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        applyingTo?: Array<{
          __typename?: 'Entity';
          disabledAt?: any | null;
          entityLanguage?: string | null;
          entityName?: string | null;
          isClient?: boolean | null;
          isIssuingInstitution?: boolean | null;
          schemaVersion?: string | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
          createdBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            userType?: string | null;
            id: any;
            updatedAt?: any | null;
            role?: {
              __typename?: 'StaffRole';
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              id: any;
              updatedAt?: any | null;
              createdAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
        } | null> | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{
            __typename?: 'ApplicantUserPhone';
            createdAt?: any | null;
            id: any;
            phoneNumber?: string | null;
            phoneType?: string | null;
            updatedAt?: any | null;
          } | null> | null;
        } | null;
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        nameOnDocumentAssets?: Array<{
          __typename?: 'ApplicantUserNameOnDocumentAsset';
          isDeleteRequested?: boolean | null;
          documentName?: string | null;
          updatedAt?: any | null;
          uploadedAt?: any | null;
          createdAt?: any | null;
          id: any;
        } | null> | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            attendanceEndedAt?: any | null;
            attendanceStartedAt?: any | null;
            degreeIssuedAt?: any | null;
            degreeTitle?: string | null;
            graduationYear?: number | null;
            id: any;
            createdAt?: any | null;
            updatedAt?: any | null;
            issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              addressLine1?: string | null;
              city?: string | null;
              country?: string | null;
              name?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      termsAndConditions?: Array<{
        __typename?: 'ApplicantUserTermsAndCondition';
        acceptanceOf?: string | null;
        attestedAt?: any | null;
        version?: number | null;
        updatedAt?: any | null;
        createdAt?: any | null;
        id: any;
      } | null> | null;
      files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    };
    caseDetails: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
      application: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
        passportDetails: {
          __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        };
      };
      applicationReview: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        };
        notaryAffirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      };
    };
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; referenceId?: string | null; completedAt?: any | null } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
  } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  archiveEligibleAt: any;
  archivedAt: any;
  caseName: string;
  caseType: string;
  lastActivityAt: any;
  state: string;
  submittedAt: any;
  id: any;
  createdAt: any;
  activityLog: Array<{
    __typename?: 'ArchivedCaseSummaryActivityLog';
    activityType?: string | null;
    createdAt?: any | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    activityBy?: {
      __typename?: 'User';
      accessBlocked?: boolean | null;
      displayName?: string | null;
      externalId?: string | null;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      userType?: string | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null;
  } | null>;
  applicant: {
    __typename?: 'ApplicantUser';
    accessBlocked?: boolean | null;
    displayName?: string | null;
    externalId?: string | null;
    isProfileSubmitted?: boolean | null;
    schemaVersion?: string | null;
    tags?: Array<string | null> | null;
    userType?: string | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{
        __typename?: 'Entity';
        disabledAt?: any | null;
        entityLanguage?: string | null;
        entityName?: string | null;
        isClient?: boolean | null;
        isIssuingInstitution?: boolean | null;
        schemaVersion?: string | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
        createdBy?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          userType?: string | null;
          id: any;
          updatedAt?: any | null;
          role?: {
            __typename?: 'StaffRole';
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            id: any;
            updatedAt?: any | null;
            createdAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
      } | null> | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{
          __typename?: 'ApplicantUserPhone';
          createdAt?: any | null;
          id: any;
          phoneNumber?: string | null;
          phoneType?: string | null;
          updatedAt?: any | null;
        } | null> | null;
      } | null;
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        isDeleteRequested?: boolean | null;
        documentName?: string | null;
        updatedAt?: any | null;
        uploadedAt?: any | null;
        createdAt?: any | null;
        id: any;
      } | null> | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
          issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      version?: number | null;
      updatedAt?: any | null;
      createdAt?: any | null;
      id: any;
    } | null> | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  };
  caseDetails: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
    application: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
      passportDetails: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
      };
    };
    applicationReview: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      decision: {
        __typename?: 'ArchivedCaseSummaryDecision';
        completedAt?: any | null;
        rejectionReason?: string | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      };
      notaryAffirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    };
  };
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; referenceId?: string | null; completedAt?: any | null } | null;
      } | null> | null;
      submission?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null;
    } | null;
  };
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryActivityLog';
  activityType?: string | null;
  createdAt?: any | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  updatedAt?: any | null;
  activityBy?: {
    __typename?: 'User';
    accessBlocked?: boolean | null;
    displayName?: string | null;
    externalId?: string | null;
    schemaVersion?: string | null;
    tags?: Array<string | null> | null;
    userType?: string | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  accessBlocked?: boolean | null;
  displayName?: string | null;
  externalId?: string | null;
  isProfileSubmitted?: boolean | null;
  schemaVersion?: string | null;
  tags?: Array<string | null> | null;
  userType?: string | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{
      __typename?: 'Entity';
      disabledAt?: any | null;
      entityLanguage?: string | null;
      entityName?: string | null;
      isClient?: boolean | null;
      isIssuingInstitution?: boolean | null;
      schemaVersion?: string | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
      createdBy?: {
        __typename?: 'StaffUser';
        accessBlocked?: boolean | null;
        createdAt?: any | null;
        displayName?: string | null;
        emailAddress?: string | null;
        externalId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        userType?: string | null;
        id: any;
        updatedAt?: any | null;
        role?: {
          __typename?: 'StaffRole';
          isDefault: boolean;
          roleName: string;
          roleSubtype: string;
          roleType?: string | null;
          schemaVersion?: string | null;
          id: any;
          updatedAt?: any | null;
          createdAt?: any | null;
          permissions: {
            __typename?: 'StaffRolePermissions';
            applicantUserPermissions: {
              __typename?: 'StaffRoleApplicantUserPermissions';
              canAddOrRemoveTags: boolean;
              canBlockAccess: boolean;
              canSearchApplicants: boolean;
              canUpdatePersonalInformation: boolean;
            };
            credCasePermissions: {
              __typename?: 'StaffRoleCredCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            entityPermissions: {
              __typename?: 'StaffRoleEntityPermissions';
              canAddEntities: boolean;
              canDeleteEntities: boolean;
              canEditEntities: boolean;
              canSearchEntities: boolean;
            };
            idCasePermissions: {
              __typename?: 'StaffRoleIdCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
            sendCasePermissions: {
              __typename?: 'StaffRoleSendCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            staffUserPermissions: {
              __typename?: 'StaffRoleStaffUserPermissions';
              canAddOrRemoveTags: boolean;
              canAssignRoles: boolean;
              canBlockAccess: boolean;
              canSearchStaff: boolean;
            };
          };
        } | null;
        search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      } | null;
      issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
    } | null> | null;
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    contactInformation?: {
      __typename?: 'ApplicantUserContactInformation';
      emailAddress?: string | null;
      primaryPhone?: string | null;
      address?: {
        __typename?: 'ApplicantUserAddress';
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        streetAddressLine1?: string | null;
        streetAddressLine2?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      phone?: Array<{
        __typename?: 'ApplicantUserPhone';
        createdAt?: any | null;
        id: any;
        phoneNumber?: string | null;
        phoneType?: string | null;
        updatedAt?: any | null;
      } | null> | null;
    } | null;
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      generationalSuffix?: string | null;
      lastName?: string | null;
      legalNameConsistsOfOneName?: boolean | null;
      restOfName?: string | null;
    } | null;
    nameOnDocumentAssets?: Array<{
      __typename?: 'ApplicantUserNameOnDocumentAsset';
      isDeleteRequested?: boolean | null;
      documentName?: string | null;
      updatedAt?: any | null;
      uploadedAt?: any | null;
      createdAt?: any | null;
      id: any;
    } | null> | null;
    professional?: {
      __typename?: 'ApplicantUserProfessional';
      citizenshipAtTimeEnteredMedicalInstitution?: string | null;
      healthProfession?: string | null;
      primaryEducationalInformation?: Array<{
        __typename?: 'ApplicantUserPrimaryEducationalInformation';
        attendanceEndedAt?: any | null;
        attendanceStartedAt?: any | null;
        degreeIssuedAt?: any | null;
        degreeTitle?: string | null;
        graduationYear?: number | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
        otherIssuingInstitution?: {
          __typename?: 'ApplicantUserOtherIssuingInstitution';
          addressLine1?: string | null;
          city?: string | null;
          country?: string | null;
          name?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
  search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
  termsAndConditions?: Array<{
    __typename?: 'ApplicantUserTermsAndCondition';
    acceptanceOf?: string | null;
    attestedAt?: any | null;
    version?: number | null;
    updatedAt?: any | null;
    createdAt?: any | null;
    id: any;
  } | null> | null;
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
};

export type CasesIdentityVerificationHeaderDetailContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  name: string;
  size?: number | null;
  type?: string | null;
  url: string;
};

export type CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFieldsFragment = {
  __typename?: 'ApplicantUserTermsAndCondition';
  acceptanceOf?: string | null;
  attestedAt?: any | null;
  version?: number | null;
  updatedAt?: any | null;
  createdAt?: any | null;
  id: any;
};

export type CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  applyingTo?: Array<{
    __typename?: 'Entity';
    disabledAt?: any | null;
    entityLanguage?: string | null;
    entityName?: string | null;
    isClient?: boolean | null;
    isIssuingInstitution?: boolean | null;
    schemaVersion?: string | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
    createdBy?: {
      __typename?: 'StaffUser';
      accessBlocked?: boolean | null;
      createdAt?: any | null;
      displayName?: string | null;
      emailAddress?: string | null;
      externalId?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      userType?: string | null;
      id: any;
      updatedAt?: any | null;
      role?: {
        __typename?: 'StaffRole';
        isDefault: boolean;
        roleName: string;
        roleSubtype: string;
        roleType?: string | null;
        schemaVersion?: string | null;
        id: any;
        updatedAt?: any | null;
        createdAt?: any | null;
        permissions: {
          __typename?: 'StaffRolePermissions';
          applicantUserPermissions: {
            __typename?: 'StaffRoleApplicantUserPermissions';
            canAddOrRemoveTags: boolean;
            canBlockAccess: boolean;
            canSearchApplicants: boolean;
            canUpdatePersonalInformation: boolean;
          };
          credCasePermissions: {
            __typename?: 'StaffRoleCredCasePermissions';
            canAssignCaseWorker: boolean;
            canAssignSelf: boolean;
            canBeAssignedCases: boolean;
            canIssueRefunds: boolean;
            canOverrideCaseState: boolean;
            canReopenCases: boolean;
            canSearchCases: boolean;
            canUnassignCaseWorker: boolean;
            canUnassignSelf: boolean;
            canViewCasesAssignedToOthers: boolean;
            canViewUnassignedCases: boolean;
          };
          entityPermissions: {
            __typename?: 'StaffRoleEntityPermissions';
            canAddEntities: boolean;
            canDeleteEntities: boolean;
            canEditEntities: boolean;
            canSearchEntities: boolean;
          };
          idCasePermissions: {
            __typename?: 'StaffRoleIdCasePermissions';
            canAssignCaseWorker: boolean;
            canAssignSelf: boolean;
            canBeAssignedCases: boolean;
            canIssueRefunds: boolean;
            canOverrideCaseState: boolean;
            canReopenCases: boolean;
            canSearchCases: boolean;
            canUnassignCaseWorker: boolean;
            canUnassignSelf: boolean;
            canViewCasesAssignedToOthers: boolean;
            canViewUnassignedCases: boolean;
          };
          rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
          sendCasePermissions: {
            __typename?: 'StaffRoleSendCasePermissions';
            canAssignCaseWorker: boolean;
            canAssignSelf: boolean;
            canBeAssignedCases: boolean;
            canIssueRefunds: boolean;
            canOverrideCaseState: boolean;
            canReopenCases: boolean;
            canSearchCases: boolean;
            canUnassignCaseWorker: boolean;
            canUnassignSelf: boolean;
            canViewCasesAssignedToOthers: boolean;
            canViewUnassignedCases: boolean;
          };
          staffUserPermissions: {
            __typename?: 'StaffRoleStaffUserPermissions';
            canAddOrRemoveTags: boolean;
            canAssignRoles: boolean;
            canBlockAccess: boolean;
            canSearchStaff: boolean;
          };
        };
      } | null;
      search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
    } | null;
    issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
  } | null> | null;
  citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{
      __typename?: 'ApplicantUserPhone';
      createdAt?: any | null;
      id: any;
      phoneNumber?: string | null;
      phoneType?: string | null;
      updatedAt?: any | null;
    } | null> | null;
  } | null;
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
  nameOnDocumentAssets?: Array<{
    __typename?: 'ApplicantUserNameOnDocumentAsset';
    isDeleteRequested?: boolean | null;
    documentName?: string | null;
    updatedAt?: any | null;
    uploadedAt?: any | null;
    createdAt?: any | null;
    id: any;
  } | null> | null;
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      attendanceEndedAt?: any | null;
      attendanceStartedAt?: any | null;
      degreeIssuedAt?: any | null;
      degreeTitle?: string | null;
      graduationYear?: number | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        name?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  disabledAt?: any | null;
  entityLanguage?: string | null;
  entityName?: string | null;
  isClient?: boolean | null;
  isIssuingInstitution?: boolean | null;
  schemaVersion?: string | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  address?: {
    __typename?: 'EntityAddressInfo';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
  createdBy?: {
    __typename?: 'StaffUser';
    accessBlocked?: boolean | null;
    createdAt?: any | null;
    displayName?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    schemaVersion?: string | null;
    tags?: Array<string | null> | null;
    userType?: string | null;
    id: any;
    updatedAt?: any | null;
    role?: {
      __typename?: 'StaffRole';
      isDefault: boolean;
      roleName: string;
      roleSubtype: string;
      roleType?: string | null;
      schemaVersion?: string | null;
      id: any;
      updatedAt?: any | null;
      createdAt?: any | null;
      permissions: {
        __typename?: 'StaffRolePermissions';
        applicantUserPermissions: {
          __typename?: 'StaffRoleApplicantUserPermissions';
          canAddOrRemoveTags: boolean;
          canBlockAccess: boolean;
          canSearchApplicants: boolean;
          canUpdatePersonalInformation: boolean;
        };
        credCasePermissions: {
          __typename?: 'StaffRoleCredCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        entityPermissions: {
          __typename?: 'StaffRoleEntityPermissions';
          canAddEntities: boolean;
          canDeleteEntities: boolean;
          canEditEntities: boolean;
          canSearchEntities: boolean;
        };
        idCasePermissions: {
          __typename?: 'StaffRoleIdCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
        sendCasePermissions: {
          __typename?: 'StaffRoleSendCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        staffUserPermissions: {
          __typename?: 'StaffRoleStaffUserPermissions';
          canAddOrRemoveTags: boolean;
          canAssignRoles: boolean;
          canBlockAccess: boolean;
          canSearchStaff: boolean;
        };
      };
    } | null;
    search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
  } | null;
  issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  accessBlocked?: boolean | null;
  createdAt?: any | null;
  displayName?: string | null;
  emailAddress?: string | null;
  externalId?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  schemaVersion?: string | null;
  tags?: Array<string | null> | null;
  userType?: string | null;
  id: any;
  updatedAt?: any | null;
  role?: {
    __typename?: 'StaffRole';
    isDefault: boolean;
    roleName: string;
    roleSubtype: string;
    roleType?: string | null;
    schemaVersion?: string | null;
    id: any;
    updatedAt?: any | null;
    createdAt?: any | null;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: {
        __typename?: 'StaffRoleApplicantUserPermissions';
        canAddOrRemoveTags: boolean;
        canBlockAccess: boolean;
        canSearchApplicants: boolean;
        canUpdatePersonalInformation: boolean;
      };
      credCasePermissions: {
        __typename?: 'StaffRoleCredCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      entityPermissions: {
        __typename?: 'StaffRoleEntityPermissions';
        canAddEntities: boolean;
        canDeleteEntities: boolean;
        canEditEntities: boolean;
        canSearchEntities: boolean;
      };
      idCasePermissions: {
        __typename?: 'StaffRoleIdCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
      sendCasePermissions: {
        __typename?: 'StaffRoleSendCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      staffUserPermissions: {
        __typename?: 'StaffRoleStaffUserPermissions';
        canAddOrRemoveTags: boolean;
        canAssignRoles: boolean;
        canBlockAccess: boolean;
        canSearchStaff: boolean;
      };
    };
  } | null;
  search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleFieldsFragment = {
  __typename?: 'StaffRole';
  isDefault: boolean;
  roleName: string;
  roleSubtype: string;
  roleType?: string | null;
  schemaVersion?: string | null;
  id: any;
  updatedAt?: any | null;
  createdAt?: any | null;
  permissions: {
    __typename?: 'StaffRolePermissions';
    applicantUserPermissions: {
      __typename?: 'StaffRoleApplicantUserPermissions';
      canAddOrRemoveTags: boolean;
      canBlockAccess: boolean;
      canSearchApplicants: boolean;
      canUpdatePersonalInformation: boolean;
    };
    credCasePermissions: {
      __typename?: 'StaffRoleCredCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    entityPermissions: {
      __typename?: 'StaffRoleEntityPermissions';
      canAddEntities: boolean;
      canDeleteEntities: boolean;
      canEditEntities: boolean;
      canSearchEntities: boolean;
    };
    idCasePermissions: {
      __typename?: 'StaffRoleIdCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
    sendCasePermissions: {
      __typename?: 'StaffRoleSendCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    staffUserPermissions: {
      __typename?: 'StaffRoleStaffUserPermissions';
      canAddOrRemoveTags: boolean;
      canAssignRoles: boolean;
      canBlockAccess: boolean;
      canSearchStaff: boolean;
    };
  };
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFieldsFragment = {
  __typename?: 'StaffRolePermissions';
  applicantUserPermissions: {
    __typename?: 'StaffRoleApplicantUserPermissions';
    canAddOrRemoveTags: boolean;
    canBlockAccess: boolean;
    canSearchApplicants: boolean;
    canUpdatePersonalInformation: boolean;
  };
  credCasePermissions: {
    __typename?: 'StaffRoleCredCasePermissions';
    canAssignCaseWorker: boolean;
    canAssignSelf: boolean;
    canBeAssignedCases: boolean;
    canIssueRefunds: boolean;
    canOverrideCaseState: boolean;
    canReopenCases: boolean;
    canSearchCases: boolean;
    canUnassignCaseWorker: boolean;
    canUnassignSelf: boolean;
    canViewCasesAssignedToOthers: boolean;
    canViewUnassignedCases: boolean;
  };
  entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canAddEntities: boolean; canDeleteEntities: boolean; canEditEntities: boolean; canSearchEntities: boolean };
  idCasePermissions: {
    __typename?: 'StaffRoleIdCasePermissions';
    canAssignCaseWorker: boolean;
    canAssignSelf: boolean;
    canBeAssignedCases: boolean;
    canIssueRefunds: boolean;
    canOverrideCaseState: boolean;
    canReopenCases: boolean;
    canSearchCases: boolean;
    canUnassignCaseWorker: boolean;
    canUnassignSelf: boolean;
    canViewCasesAssignedToOthers: boolean;
    canViewUnassignedCases: boolean;
  };
  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
  sendCasePermissions: {
    __typename?: 'StaffRoleSendCasePermissions';
    canAssignCaseWorker: boolean;
    canAssignSelf: boolean;
    canBeAssignedCases: boolean;
    canIssueRefunds: boolean;
    canOverrideCaseState: boolean;
    canReopenCases: boolean;
    canSearchCases: boolean;
    canUnassignCaseWorker: boolean;
    canUnassignSelf: boolean;
    canViewCasesAssignedToOthers: boolean;
    canViewUnassignedCases: boolean;
  };
  staffUserPermissions: {
    __typename?: 'StaffRoleStaffUserPermissions';
    canAddOrRemoveTags: boolean;
    canAssignRoles: boolean;
    canBlockAccess: boolean;
    canSearchStaff: boolean;
  };
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFieldsFragment = {
  __typename?: 'StaffRoleApplicantUserPermissions';
  canAddOrRemoveTags: boolean;
  canBlockAccess: boolean;
  canSearchApplicants: boolean;
  canUpdatePersonalInformation: boolean;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFieldsFragment = {
  __typename?: 'StaffRoleCredCasePermissions';
  canAssignCaseWorker: boolean;
  canAssignSelf: boolean;
  canBeAssignedCases: boolean;
  canIssueRefunds: boolean;
  canOverrideCaseState: boolean;
  canReopenCases: boolean;
  canSearchCases: boolean;
  canUnassignCaseWorker: boolean;
  canUnassignSelf: boolean;
  canViewCasesAssignedToOthers: boolean;
  canViewUnassignedCases: boolean;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFieldsFragment = {
  __typename?: 'StaffRoleEntityPermissions';
  canAddEntities: boolean;
  canDeleteEntities: boolean;
  canEditEntities: boolean;
  canSearchEntities: boolean;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFieldsFragment = {
  __typename?: 'StaffRoleIdCasePermissions';
  canAssignCaseWorker: boolean;
  canAssignSelf: boolean;
  canBeAssignedCases: boolean;
  canIssueRefunds: boolean;
  canOverrideCaseState: boolean;
  canReopenCases: boolean;
  canSearchCases: boolean;
  canUnassignCaseWorker: boolean;
  canUnassignSelf: boolean;
  canViewCasesAssignedToOthers: boolean;
  canViewUnassignedCases: boolean;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFieldsFragment = {
  __typename?: 'StaffRoleRolePermissions';
  canAddRoles: boolean;
  canEditRoles: boolean;
  canSearchRoles: boolean;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFieldsFragment = {
  __typename?: 'StaffRoleSendCasePermissions';
  canAssignCaseWorker: boolean;
  canAssignSelf: boolean;
  canBeAssignedCases: boolean;
  canIssueRefunds: boolean;
  canOverrideCaseState: boolean;
  canReopenCases: boolean;
  canSearchCases: boolean;
  canUnassignCaseWorker: boolean;
  canUnassignSelf: boolean;
  canViewCasesAssignedToOthers: boolean;
  canViewUnassignedCases: boolean;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFieldsFragment = {
  __typename?: 'StaffRoleStaffUserPermissions';
  canAddOrRemoveTags: boolean;
  canAssignRoles: boolean;
  canBlockAccess: boolean;
  canSearchStaff: boolean;
};

export type CasesIdentityVerificationHeaderDetailContainerApplicantUserSearchFieldsFragment = {
  __typename?: 'ApplicantUserSearch';
  hash?: string | null;
  indexedAt?: any | null;
  indexingFailedAt?: any | null;
};

export type CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFieldsFragment = {
  __typename?: 'ApplicantUserIdentityDetails';
  dateOfBirth?: any | null;
  gender?: string | null;
  generationalSuffix?: string | null;
  lastName?: string | null;
  legalNameConsistsOfOneName?: boolean | null;
  restOfName?: string | null;
};

export type CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFieldsFragment = {
  __typename?: 'ApplicantUserNameOnDocumentAsset';
  isDeleteRequested?: boolean | null;
  documentName?: string | null;
  updatedAt?: any | null;
  uploadedAt?: any | null;
  createdAt?: any | null;
  id: any;
};

export type CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFieldsFragment = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: string | null;
  healthProfession?: string | null;
  primaryEducationalInformation?: Array<{
    __typename?: 'ApplicantUserPrimaryEducationalInformation';
    attendanceEndedAt?: any | null;
    attendanceStartedAt?: any | null;
    degreeIssuedAt?: any | null;
    degreeTitle?: string | null;
    graduationYear?: number | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
    otherIssuingInstitution?: {
      __typename?: 'ApplicantUserOtherIssuingInstitution';
      addressLine1?: string | null;
      city?: string | null;
      country?: string | null;
      name?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null> | null;
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetails';
  transactions?: {
    __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; referenceId?: string | null; completedAt?: any | null } | null;
    } | null> | null;
    submission?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
      amount?: number | null;
      transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
  application: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
    passportDetails: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
      isPassportExpirationDateVisible?: boolean | null;
      isPassportInLatinCharacters?: boolean | null;
      passportCountry?: string | null;
      passportExpiresAt?: any | null;
      passportIssuedAt?: any | null;
      passportNumber?: string | null;
    };
  };
  applicationReview: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    decision: {
      __typename?: 'ArchivedCaseSummaryDecision';
      completedAt?: any | null;
      rejectionReason?: string | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    };
    notaryAffirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  };
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
  passportDetails: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
    isPassportExpirationDateVisible?: boolean | null;
    isPassportInLatinCharacters?: boolean | null;
    passportCountry?: string | null;
    passportExpiresAt?: any | null;
    passportIssuedAt?: any | null;
    passportNumber?: string | null;
  };
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: boolean | null;
  isPassportInLatinCharacters?: boolean | null;
  passportCountry?: string | null;
  passportExpiresAt?: any | null;
  passportIssuedAt?: any | null;
  passportNumber?: string | null;
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  decision: {
    __typename?: 'ArchivedCaseSummaryDecision';
    completedAt?: any | null;
    rejectionReason?: string | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  };
  notaryAffirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryAffirmations';
  audit?: {
    __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
    completedAt?: any | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryDecision';
  completedAt?: any | null;
  rejectionReason?: string | null;
  result?: string | null;
  completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFieldsFragment = {
  __typename?: 'StaffUserSearch';
  hash?: string | null;
  indexedAt?: any | null;
  indexingFailedAt?: any | null;
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRolesFieldsFragment = {
  __typename?: 'StaffRole';
  isDefault: boolean;
  roleName: string;
  roleSubtype: string;
  roleType?: string | null;
  schemaVersion?: string | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  permissions: {
    __typename?: 'StaffRolePermissions';
    applicantUserPermissions: {
      __typename?: 'StaffRoleApplicantUserPermissions';
      canAddOrRemoveTags: boolean;
      canBlockAccess: boolean;
      canSearchApplicants: boolean;
      canUpdatePersonalInformation: boolean;
    };
    credCasePermissions: {
      __typename?: 'StaffRoleCredCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    entityPermissions: {
      __typename?: 'StaffRoleEntityPermissions';
      canAddEntities: boolean;
      canDeleteEntities: boolean;
      canEditEntities: boolean;
      canSearchEntities: boolean;
    };
    idCasePermissions: {
      __typename?: 'StaffRoleIdCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
    sendCasePermissions: {
      __typename?: 'StaffRoleSendCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    staffUserPermissions: {
      __typename?: 'StaffRoleStaffUserPermissions';
      canAddOrRemoveTags: boolean;
      canAssignRoles: boolean;
      canBlockAccess: boolean;
      canSearchStaff: boolean;
    };
  };
};

export type CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionFieldsFragment = {
  __typename?: 'StaffRolePermissions';
  applicantUserPermissions: {
    __typename?: 'StaffRoleApplicantUserPermissions';
    canAddOrRemoveTags: boolean;
    canBlockAccess: boolean;
    canSearchApplicants: boolean;
    canUpdatePersonalInformation: boolean;
  };
  credCasePermissions: {
    __typename?: 'StaffRoleCredCasePermissions';
    canAssignCaseWorker: boolean;
    canAssignSelf: boolean;
    canBeAssignedCases: boolean;
    canIssueRefunds: boolean;
    canOverrideCaseState: boolean;
    canReopenCases: boolean;
    canSearchCases: boolean;
    canUnassignCaseWorker: boolean;
    canUnassignSelf: boolean;
    canViewCasesAssignedToOthers: boolean;
    canViewUnassignedCases: boolean;
  };
  entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canAddEntities: boolean; canDeleteEntities: boolean; canEditEntities: boolean; canSearchEntities: boolean };
  idCasePermissions: {
    __typename?: 'StaffRoleIdCasePermissions';
    canAssignCaseWorker: boolean;
    canAssignSelf: boolean;
    canBeAssignedCases: boolean;
    canIssueRefunds: boolean;
    canOverrideCaseState: boolean;
    canReopenCases: boolean;
    canSearchCases: boolean;
    canUnassignCaseWorker: boolean;
    canUnassignSelf: boolean;
    canViewCasesAssignedToOthers: boolean;
    canViewUnassignedCases: boolean;
  };
  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
  sendCasePermissions: {
    __typename?: 'StaffRoleSendCasePermissions';
    canAssignCaseWorker: boolean;
    canAssignSelf: boolean;
    canBeAssignedCases: boolean;
    canIssueRefunds: boolean;
    canOverrideCaseState: boolean;
    canReopenCases: boolean;
    canSearchCases: boolean;
    canUnassignCaseWorker: boolean;
    canUnassignSelf: boolean;
    canViewCasesAssignedToOthers: boolean;
    canViewUnassignedCases: boolean;
  };
  staffUserPermissions: {
    __typename?: 'StaffRoleStaffUserPermissions';
    canAddOrRemoveTags: boolean;
    canAssignRoles: boolean;
    canBlockAccess: boolean;
    canSearchStaff: boolean;
  };
};

export type CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  archivedIdentityVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    id: any;
    submittedAt: any;
    lastActivityAt: any;
    applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
  } | null;
};

export type CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  id: any;
  submittedAt: any;
  lastActivityAt: any;
  applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
};

export type CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  archivedIdentityVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null; size?: number | null } | null> | null;
    caseDetails: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
      applicationReview: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        };
        notaryAffirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      };
      application: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
        passportDetails: {
          __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        };
      };
    };
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          approval?: {
            __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
            isApplicantApproved?: boolean | null;
            isApplicantApprovalRequired?: boolean | null;
          } | null;
          transactionReference?: {
            __typename?: 'ArchivedCaseSummaryTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
    activityLog: Array<{
      __typename?: 'ArchivedCaseSummaryActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; id: any; displayName?: string | null } | null;
    } | null>;
  } | null;
};

export type CasesIdentityVerificationCaseSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null; size?: number | null } | null> | null;
  caseDetails: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
    applicationReview: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      decision: {
        __typename?: 'ArchivedCaseSummaryDecision';
        completedAt?: any | null;
        rejectionReason?: string | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      };
      notaryAffirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: {
          __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    };
    application: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
      passportDetails: {
        __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
      };
    };
  };
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        approval?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
          isApplicantApproved?: boolean | null;
          isApplicantApprovalRequired?: boolean | null;
        } | null;
        transactionReference?: {
          __typename?: 'ArchivedCaseSummaryTransactionReference';
          completedAt?: any | null;
          referenceId?: string | null;
          isSuccess?: boolean | null;
        } | null;
      } | null> | null;
      submission?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
        amount?: number | null;
        transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
      } | null;
    } | null;
  };
  activityLog: Array<{
    __typename?: 'ArchivedCaseSummaryActivityLog';
    activityType?: string | null;
    createdAt?: any | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; id: any; displayName?: string | null } | null;
  } | null>;
};

export type CasesIdentityVerificationSummaryContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  name: string;
  url: string;
  type?: string | null;
  size?: number | null;
};

export type CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetails';
  transactions?: {
    __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      approval?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
        isApplicantApproved?: boolean | null;
        isApplicantApprovalRequired?: boolean | null;
      } | null;
      transactionReference?: {
        __typename?: 'ArchivedCaseSummaryTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
    submission?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
      amount?: number | null;
      transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
  amount?: number | null;
  reason?: string | null;
  transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null; isSuccess?: boolean | null } | null;
};

export type CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
  amount?: number | null;
  transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
};

export type CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetails';
  applicationReview: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    decision: {
      __typename?: 'ArchivedCaseSummaryDecision';
      completedAt?: any | null;
      rejectionReason?: string | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    };
    notaryAffirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  };
  application: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
    passportDetails: {
      __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
      isPassportExpirationDateVisible?: boolean | null;
      isPassportInLatinCharacters?: boolean | null;
      passportCountry?: string | null;
      passportExpiresAt?: any | null;
      passportIssuedAt?: any | null;
      passportNumber?: string | null;
    };
  };
};

export type CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryActivityLog';
  activityType?: string | null;
  createdAt?: any | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  updatedAt?: any | null;
  activityBy?: { __typename?: 'User'; id: any; displayName?: string | null } | null;
};

export type CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication';
  passportDetails: {
    __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
    isPassportExpirationDateVisible?: boolean | null;
    isPassportInLatinCharacters?: boolean | null;
    passportCountry?: string | null;
    passportExpiresAt?: any | null;
    passportIssuedAt?: any | null;
    passportNumber?: string | null;
  };
};

export type CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails';
  isPassportExpirationDateVisible?: boolean | null;
  isPassportInLatinCharacters?: boolean | null;
  passportCountry?: string | null;
  passportExpiresAt?: any | null;
  passportIssuedAt?: any | null;
  passportNumber?: string | null;
};

export type CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  decision: {
    __typename?: 'ArchivedCaseSummaryDecision';
    completedAt?: any | null;
    rejectionReason?: string | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  };
  notaryAffirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryAffirmations';
  audit?: {
    __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
    completedAt?: any | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryDecision';
  completedAt?: any | null;
  rejectionReason?: string | null;
  result?: string | null;
  completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
};

export type StaffActiveCaseListContainerSendReportCasesV1ByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type StaffActiveCaseListContainerSendReportCasesV1ByApplicantQuery = {
  __typename?: 'Query';
  sendReportCasesV1ByApplicant?: Array<{
    __typename?: 'SendReportCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    state: string;
    id: any;
    lastActivityAt?: any | null;
  } | null> | null;
};

export type StaffActiveCaseListContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffActiveCaseListContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type StaffActiveCaseListIdentityVerificationCaseV1CurrentQueryQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type StaffActiveCaseListIdentityVerificationCaseV1CurrentQueryQuery = {
  __typename?: 'Query';
  identityVerificationCaseV1Current?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    caseName: string;
    lastActivityAt?: any | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ActiveCaseListContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  caseName: string;
  lastActivityAt?: any | null;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      passportDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
        isPassportExpirationDateVisible?: boolean | null;
        isPassportInLatinCharacters?: boolean | null;
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
      } | null;
    } | null;
  } | null;
};

export type StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1QueryQueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1QueryQuery = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    isCurrentUserAssigned?: boolean | null;
    state: string;
    activityLog?: Array<{
      __typename?: 'IdentityVerificationCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutationMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutationMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      isCurrentUserAssigned?: boolean | null;
      state: string;
      activityLog?: Array<{
        __typename?: 'IdentityVerificationCaseV1ActivityLog';
        activityType?: string | null;
        description?: string | null;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  };
};

export type StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    isCurrentUserAssigned?: boolean | null;
    state: string;
    activityLog?: Array<{
      __typename?: 'IdentityVerificationCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  isCurrentUserAssigned?: boolean | null;
  state: string;
  activityLog?: Array<{
    __typename?: 'IdentityVerificationCaseV1ActivityLog';
    activityType?: string | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    caseName: string;
    state: string;
    isCurrentUserAssigned?: boolean | null;
    purgeEligibleAt?: any | null;
    archiveEligibleAt?: any | null;
    expirationEligibleAt?: any | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
      } | null;
    } | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      caseName: string;
      state: string;
      isCurrentUserAssigned?: boolean | null;
      purgeEligibleAt?: any | null;
      archiveEligibleAt?: any | null;
      expirationEligibleAt?: any | null;
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
          } | null;
        } | null;
      } | null;
      files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
    } | null;
  };
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: { __typename?: 'StaffUser'; id: any; role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null } | null;
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null;
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    caseName: string;
    state: string;
    isCurrentUserAssigned?: boolean | null;
    purgeEligibleAt?: any | null;
    archiveEligibleAt?: any | null;
    expirationEligibleAt?: any | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
      } | null;
    } | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  caseName: string;
  state: string;
  isCurrentUserAssigned?: boolean | null;
  purgeEligibleAt?: any | null;
  archiveEligibleAt?: any | null;
  expirationEligibleAt?: any | null;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      passportDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
        passportCountry?: string | null;
        passportExpiresAt?: any | null;
        passportIssuedAt?: any | null;
        passportNumber?: string | null;
      } | null;
    } | null;
  } | null;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string } | null> | null;
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
  passportDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
    passportCountry?: string | null;
    passportExpiresAt?: any | null;
    passportIssuedAt?: any | null;
    passportNumber?: string | null;
  } | null;
};

export type CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  application?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
    passportDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportDetails';
      passportCountry?: string | null;
      passportExpiresAt?: any | null;
      passportIssuedAt?: any | null;
      passportNumber?: string | null;
    } | null;
  } | null;
};

export type StaffArchivedCaseListContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type StaffArchivedCaseListContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerStaffUsersQueryVariables = Exact<{ [key: string]: never }>;

export type CasesIdentityVerificationV1CaseDetailsContainerStaffUsersQuery = {
  __typename?: 'Query';
  staffUsers?: Array<{
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canBeAssignedCases: boolean } };
    } | null;
  } | null> | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        idCasePermissions: {
          __typename?: 'StaffRoleIdCasePermissions';
          canAssignSelf: boolean;
          canAssignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canUnassignCaseWorker: boolean;
        };
      };
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        affirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        notaryAffirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'IdentityVerificationCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      requestedChanges?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
        requestUpdatedPassportDetails?: boolean | null;
        requestUploadExpirationPage?: boolean | null;
        requestUploadPassport?: boolean | null;
        requestUploadPassportTranslation?: boolean | null;
        requestUploadPhoto?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      tags?: Array<string | null> | null;
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
          caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          affirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
          notaryAffirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      activityLog?: Array<{
        __typename?: 'IdentityVerificationCaseV1ActivityLog';
        activityType?: string | null;
        description?: string | null;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
      revisionRequest?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequest';
        requestedAt?: any | null;
        revisionSubmittedAt?: any | null;
        requestedChanges?: {
          __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
          requestUpdatedPassportDetails?: boolean | null;
          requestUploadExpirationPage?: boolean | null;
          requestUploadPassport?: boolean | null;
          requestUploadPassportTranslation?: boolean | null;
          requestUploadPhoto?: boolean | null;
        } | null;
      } | null;
    } | null;
  };
};

export type CasesIdentityVerificationV1CaseDetailsContainerStaffUsersFieldsFragment = {
  __typename?: 'StaffUser';
  displayName?: string | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canBeAssignedCases: boolean } };
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  displayName?: string | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      idCasePermissions: {
        __typename?: 'StaffRoleIdCasePermissions';
        canAssignSelf: boolean;
        canAssignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canUnassignCaseWorker: boolean;
      };
    };
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        affirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        notaryAffirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'IdentityVerificationCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      requestedChanges?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
        requestUpdatedPassportDetails?: boolean | null;
        requestUploadExpirationPage?: boolean | null;
        requestUploadPassport?: boolean | null;
        requestUploadPassportTranslation?: boolean | null;
        requestUploadPhoto?: boolean | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  tags?: Array<string | null> | null;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
      caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      affirmations?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
        audit?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      notaryAffirmations?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
        audit?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  activityLog?: Array<{
    __typename?: 'IdentityVerificationCaseV1ActivityLog';
    activityType?: string | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
  revisionRequest?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequest';
    requestedAt?: any | null;
    revisionSubmittedAt?: any | null;
    requestedChanges?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
      requestUpdatedPassportDetails?: boolean | null;
      requestUploadExpirationPage?: boolean | null;
      requestUploadPassport?: boolean | null;
      requestUploadPassportTranslation?: boolean | null;
      requestUploadPhoto?: boolean | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
    caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    affirmations?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
      audit?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    notaryAffirmations?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
      audit?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
  caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  affirmations?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
    audit?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  notaryAffirmations?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
    audit?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1ActivityLog';
  activityType?: string | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequest';
  requestedAt?: any | null;
  revisionSubmittedAt?: any | null;
  requestedChanges?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
    requestUpdatedPassportDetails?: boolean | null;
    requestUploadExpirationPage?: boolean | null;
    requestUploadPassport?: boolean | null;
    requestUploadPassportTranslation?: boolean | null;
    requestUploadPhoto?: boolean | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
  requestUpdatedPassportDetails?: boolean | null;
  requestUploadExpirationPage?: boolean | null;
  requestUploadPassport?: boolean | null;
  requestUploadPassportTranslation?: boolean | null;
  requestUploadPhoto?: boolean | null;
};

export type CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseHistory?: Array<{
      __typename?: 'IdentityVerificationCaseV1CaseHistory';
      createdAt?: any | null;
      id: any;
      updatedAt?: any | null;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetails';
        createdAt?: any | null;
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication';
          attestedAt?: any | null;
          caseWorkerModifiedPassportDetails?: boolean | null;
          isAttestationComplete?: boolean | null;
          notarizationDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails';
            isNotarizationComplete?: boolean | null;
          } | null;
          passportAssets?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets';
            passport?: string | null;
            passportExpiration?: string | null;
            passportExpirationUploadedAt?: any | null;
            passportExpirationVersion?: string | null;
            passportTranslation?: string | null;
            passportTranslationUploadedAt?: any | null;
            passportTranslationVersion?: string | null;
            passportUploadedAt?: any | null;
            passportVersion?: string | null;
          } | null;
          passportDetails?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails';
            isPassportExpirationDateVisible?: boolean | null;
            isPassportInLatinCharacters?: boolean | null;
            passportCountry?: string | null;
            passportExpiresAt?: any | null;
            passportIssuedAt?: any | null;
            passportNumber?: string | null;
          } | null;
          photoAssets?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets';
            photo?: string | null;
            photoUploadedAt?: any | null;
            photoVersion?: string | null;
          } | null;
        } | null;
        applicationReview?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
          affirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
            isIdDocumentAcceptable?: string | null;
            isIdDocumentDetailsAcceptable?: string | null;
            isPhotoAcceptable?: string | null;
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                emailAddress?: string | null;
                externalId?: string | null;
                firstName?: string | null;
                id: any;
                lastName?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
                updatedAt?: any | null;
                userType?: string | null;
                role?: {
                  __typename?: 'StaffRole';
                  createdAt?: any | null;
                  id: any;
                  isDefault: boolean;
                  roleName: string;
                  roleSubtype: string;
                  roleType?: string | null;
                  schemaVersion?: string | null;
                  updatedAt?: any | null;
                  permissions: {
                    __typename?: 'StaffRolePermissions';
                    applicantUserPermissions: {
                      __typename?: 'StaffRoleApplicantUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canBlockAccess: boolean;
                      canSearchApplicants: boolean;
                      canUpdatePersonalInformation: boolean;
                    };
                    credCasePermissions: {
                      __typename?: 'StaffRoleCredCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    entityPermissions: {
                      __typename?: 'StaffRoleEntityPermissions';
                      canAddEntities: boolean;
                      canDeleteEntities: boolean;
                      canEditEntities: boolean;
                      canSearchEntities: boolean;
                    };
                    idCasePermissions: {
                      __typename?: 'StaffRoleIdCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                    sendCasePermissions: {
                      __typename?: 'StaffRoleSendCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    staffUserPermissions: {
                      __typename?: 'StaffRoleStaffUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canAssignRoles: boolean;
                      canBlockAccess: boolean;
                      canSearchStaff: boolean;
                    };
                  };
                } | null;
                search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
              } | null;
            } | null;
          } | null;
          caseWorkerAssigned?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          decision?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
            completedAt?: any | null;
            rejectionReason?: string | null;
            result?: string | null;
            completedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
          } | null;
          notaryAffirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations';
            isNotarizedIdAcceptable?: string | null;
            isNotaryAcceptable?: string | null;
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                emailAddress?: string | null;
                externalId?: string | null;
                firstName?: string | null;
                id: any;
                lastName?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
                updatedAt?: any | null;
                userType?: string | null;
                role?: {
                  __typename?: 'StaffRole';
                  createdAt?: any | null;
                  id: any;
                  isDefault: boolean;
                  roleName: string;
                  roleSubtype: string;
                  roleType?: string | null;
                  schemaVersion?: string | null;
                  updatedAt?: any | null;
                  permissions: {
                    __typename?: 'StaffRolePermissions';
                    applicantUserPermissions: {
                      __typename?: 'StaffRoleApplicantUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canBlockAccess: boolean;
                      canSearchApplicants: boolean;
                      canUpdatePersonalInformation: boolean;
                    };
                    credCasePermissions: {
                      __typename?: 'StaffRoleCredCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    entityPermissions: {
                      __typename?: 'StaffRoleEntityPermissions';
                      canAddEntities: boolean;
                      canDeleteEntities: boolean;
                      canEditEntities: boolean;
                      canSearchEntities: boolean;
                    };
                    idCasePermissions: {
                      __typename?: 'StaffRoleIdCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                    sendCasePermissions: {
                      __typename?: 'StaffRoleSendCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    staffUserPermissions: {
                      __typename?: 'StaffRoleStaffUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canAssignRoles: boolean;
                      canBlockAccess: boolean;
                      canSearchStaff: boolean;
                    };
                  };
                } | null;
                search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
              } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      revisionRequest?: {
        __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequest';
        requestedAt?: any | null;
        revisionSubmittedAt?: any | null;
        revisionSummary?: string | null;
        requestedBy?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            id: any;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        requestedChanges?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
          requestScheduleNotaryCam?: boolean | null;
          requestUpdatedPassportDetails?: boolean | null;
          requestUploadExpirationPage?: boolean | null;
          requestUploadNotarizedIdForm?: boolean | null;
          requestUploadPassport?: boolean | null;
          requestUploadPassportTranslation?: boolean | null;
          requestUploadPhoto?: boolean | null;
        } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  caseHistory?: Array<{
    __typename?: 'IdentityVerificationCaseV1CaseHistory';
    createdAt?: any | null;
    id: any;
    updatedAt?: any | null;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetails';
      createdAt?: any | null;
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplication';
        attestedAt?: any | null;
        caseWorkerModifiedPassportDetails?: boolean | null;
        isAttestationComplete?: boolean | null;
        notarizationDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationNotarizationDetails';
          isNotarizationComplete?: boolean | null;
        } | null;
        passportAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportAssets';
          passport?: string | null;
          passportExpiration?: string | null;
          passportExpirationUploadedAt?: any | null;
          passportExpirationVersion?: string | null;
          passportTranslation?: string | null;
          passportTranslationUploadedAt?: any | null;
          passportTranslationVersion?: string | null;
          passportUploadedAt?: any | null;
          passportVersion?: string | null;
        } | null;
        passportDetails?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPassportDetails';
          isPassportExpirationDateVisible?: boolean | null;
          isPassportInLatinCharacters?: boolean | null;
          passportCountry?: string | null;
          passportExpiresAt?: any | null;
          passportIssuedAt?: any | null;
          passportNumber?: string | null;
        } | null;
        photoAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationPhotoAssets';
          photo?: string | null;
          photoUploadedAt?: any | null;
          photoVersion?: string | null;
        } | null;
      } | null;
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
          isIdDocumentAcceptable?: string | null;
          isIdDocumentDetailsAcceptable?: string | null;
          isPhotoAcceptable?: string | null;
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
          } | null;
        } | null;
        caseWorkerAssigned?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            id: any;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        decision?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
          completedBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
        } | null;
        notaryAffirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmations';
          isNotarizedIdAcceptable?: string | null;
          isNotaryAcceptable?: string | null;
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewNotaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      revisionSummary?: string | null;
      requestedBy?: {
        __typename?: 'StaffUser';
        accessBlocked?: boolean | null;
        createdAt?: any | null;
        displayName?: string | null;
        emailAddress?: string | null;
        externalId?: string | null;
        firstName?: string | null;
        lastName?: string | null;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        userType?: string | null;
        role?: {
          __typename?: 'StaffRole';
          createdAt?: any | null;
          id: any;
          isDefault: boolean;
          roleName: string;
          roleSubtype: string;
          roleType?: string | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          permissions: {
            __typename?: 'StaffRolePermissions';
            applicantUserPermissions: {
              __typename?: 'StaffRoleApplicantUserPermissions';
              canAddOrRemoveTags: boolean;
              canBlockAccess: boolean;
              canSearchApplicants: boolean;
              canUpdatePersonalInformation: boolean;
            };
            credCasePermissions: {
              __typename?: 'StaffRoleCredCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            entityPermissions: {
              __typename?: 'StaffRoleEntityPermissions';
              canAddEntities: boolean;
              canDeleteEntities: boolean;
              canEditEntities: boolean;
              canSearchEntities: boolean;
            };
            idCasePermissions: {
              __typename?: 'StaffRoleIdCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
            sendCasePermissions: {
              __typename?: 'StaffRoleSendCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            staffUserPermissions: {
              __typename?: 'StaffRoleStaffUserPermissions';
              canAddOrRemoveTags: boolean;
              canAssignRoles: boolean;
              canBlockAccess: boolean;
              canSearchStaff: boolean;
            };
          };
        } | null;
        search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      } | null;
      requestedChanges?: {
        __typename?: 'IdentityVerificationCaseV1CaseHistoryRevisionRequestRequestedChanges';
        requestScheduleNotaryCam?: boolean | null;
        requestUpdatedPassportDetails?: boolean | null;
        requestUploadExpirationPage?: boolean | null;
        requestUploadNotarizedIdForm?: boolean | null;
        requestUploadPassport?: boolean | null;
        requestUploadPassportTranslation?: boolean | null;
        requestUploadPhoto?: boolean | null;
      } | null;
    } | null;
  } | null> | null;
};

export type CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    submittedAt?: any | null;
    expirationEligibleAt?: any | null;
    lastActivityAt?: any | null;
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  submittedAt?: any | null;
  expirationEligibleAt?: any | null;
  lastActivityAt?: any | null;
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    expirationEligibleAt?: any | null;
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        notaryAffirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'IdentityVerificationCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesIdentityVerificationV1ChangeStatusContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      roleName: string;
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canReopenCases: boolean } };
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      expirationEligibleAt?: any | null;
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
          affirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
          notaryAffirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      activityLog?: Array<{
        __typename?: 'IdentityVerificationCaseV1ActivityLog';
        activityType?: string | null;
        description?: string | null;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  };
};

export type CasesIdentityVerificationV1ChangeStatusContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesIdentityVerificationV1ChangeStatusContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    roleName: string;
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canReopenCases: boolean } };
  } | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  expirationEligibleAt?: any | null;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
        audit?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      notaryAffirmations?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
        audit?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  activityLog?: Array<{
    __typename?: 'IdentityVerificationCaseV1ActivityLog';
    activityType?: string | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1ActivityLog';
  activityType?: string | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    expirationEligibleAt?: any | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        notaryAffirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'IdentityVerificationCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
      audit?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    notaryAffirmations?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
      audit?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
    audit?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  notaryAffirmations?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
    audit?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1QueryQueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffChatPageContainerIdentityVerificationCaseV1QueryQuery = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      requestedChanges?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
        requestUpdatedPassportDetails?: boolean | null;
        requestUploadExpirationPage?: boolean | null;
        requestUploadPassport?: boolean | null;
        requestUploadPassportTranslation?: boolean | null;
        requestUploadPhoto?: boolean | null;
      } | null;
    } | null;
    messages?: Array<{
      __typename?: 'IdentityVerificationCaseV1Message';
      id: any;
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      embedding?: string | null;
      createdAt?: any | null;
      message?: string | null;
    } | null> | null;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
        adhocTransactions?: Array<{
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          id: any;
          createdAt?: any | null;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
        } | null> | null;
      } | null;
      financeConfig?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
        glConfig?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
          additionalCharges?: Array<{ __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge'; type?: string | null } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChatPageContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesIdentityVerificationV1ChatPageContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canIssueRefunds: boolean } };
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChatPageContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canIssueRefunds: boolean } };
  } | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1MessagesFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1Message';
  id: any;
  isHiddenFromApplicant?: boolean | null;
  sentBy?: string | null;
  embedding?: string | null;
  createdAt?: any | null;
  message?: string | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequest';
  requestedAt?: any | null;
  revisionSubmittedAt?: any | null;
  requestedChanges?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
    requestUpdatedPassportDetails?: boolean | null;
    requestUploadExpirationPage?: boolean | null;
    requestUploadPassport?: boolean | null;
    requestUploadPassportTranslation?: boolean | null;
    requestUploadPhoto?: boolean | null;
  } | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
  requestUpdatedPassportDetails?: boolean | null;
  requestUploadExpirationPage?: boolean | null;
  requestUploadPassport?: boolean | null;
  requestUploadPassportTranslation?: boolean | null;
  requestUploadPhoto?: boolean | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
    submission?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
    adhocTransactions?: Array<{
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
      reason?: string | null;
      amount?: number | null;
      id: any;
      createdAt?: any | null;
      transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
    } | null> | null;
  } | null;
  financeConfig?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
    glConfig?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
      additionalCharges?: Array<{ __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge'; type?: string | null } | null> | null;
    } | null;
  } | null;
};

export type ChatPageContainerFinanceConfigFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
  glConfig?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
    additionalCharges?: Array<{ __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge'; type?: string | null } | null> | null;
  } | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
  submission?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
  adhocTransactions?: Array<{
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
    reason?: string | null;
    amount?: number | null;
    id: any;
    createdAt?: any | null;
    transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
  } | null> | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
  amount?: number | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
  reason?: string | null;
  amount?: number | null;
  id: any;
  createdAt?: any | null;
  transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type StaffChatPageContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      id: any;
      applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
      revisionRequest?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequest';
        requestedAt?: any | null;
        revisionSubmittedAt?: any | null;
        requestedChanges?: {
          __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
          requestUpdatedPassportDetails?: boolean | null;
          requestUploadExpirationPage?: boolean | null;
          requestUploadPassport?: boolean | null;
          requestUploadPassportTranslation?: boolean | null;
          requestUploadPhoto?: boolean | null;
        } | null;
      } | null;
      messages?: Array<{
        __typename?: 'IdentityVerificationCaseV1Message';
        id: any;
        isHiddenFromApplicant?: boolean | null;
        sentBy?: string | null;
        embedding?: string | null;
        createdAt?: any | null;
        message?: string | null;
      } | null> | null;
      financeDetails?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetails';
        transactions?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
          submission?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
          adhocTransactions?: Array<{
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
            reason?: string | null;
            amount?: number | null;
            id: any;
            createdAt?: any | null;
            transactionReference?: {
              __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
              referenceId?: string | null;
            } | null;
          } | null> | null;
        } | null;
        financeConfig?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
          glConfig?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
            additionalCharges?: Array<{ __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge'; type?: string | null } | null> | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    revisionRequest?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      requestedChanges?: {
        __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
        requestUpdatedPassportDetails?: boolean | null;
        requestUploadExpirationPage?: boolean | null;
        requestUploadPassport?: boolean | null;
        requestUploadPassportTranslation?: boolean | null;
        requestUploadPhoto?: boolean | null;
      } | null;
    } | null;
    messages?: Array<{
      __typename?: 'IdentityVerificationCaseV1Message';
      id: any;
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      embedding?: string | null;
      createdAt?: any | null;
      message?: string | null;
    } | null> | null;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
        adhocTransactions?: Array<{
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          id: any;
          createdAt?: any | null;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            referenceId?: string | null;
          } | null;
        } | null> | null;
      } | null;
      financeConfig?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
        glConfig?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
          additionalCharges?: Array<{ __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge'; type?: string | null } | null> | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type StaffChatPageContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  revisionRequest?: {
    __typename?: 'IdentityVerificationCaseV1RevisionRequest';
    requestedAt?: any | null;
    revisionSubmittedAt?: any | null;
    requestedChanges?: {
      __typename?: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges';
      requestUpdatedPassportDetails?: boolean | null;
      requestUploadExpirationPage?: boolean | null;
      requestUploadPassport?: boolean | null;
      requestUploadPassportTranslation?: boolean | null;
      requestUploadPhoto?: boolean | null;
    } | null;
  } | null;
  messages?: Array<{
    __typename?: 'IdentityVerificationCaseV1Message';
    id: any;
    isHiddenFromApplicant?: boolean | null;
    sentBy?: string | null;
    embedding?: string | null;
    createdAt?: any | null;
    message?: string | null;
  } | null> | null;
  financeDetails?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetails';
    transactions?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
      submission?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission'; amount?: number | null } | null;
      adhocTransactions?: Array<{
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
        reason?: string | null;
        amount?: number | null;
        id: any;
        createdAt?: any | null;
        transactionReference?: { __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
      } | null> | null;
    } | null;
    financeConfig?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig';
      glConfig?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfig';
        additionalCharges?: Array<{ __typename?: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfigGlConfigAdditionalCharge'; type?: string | null } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
          isIdDocumentAcceptable?: string | null;
          isIdDocumentDetailsAcceptable?: string | null;
          isPhotoAcceptable?: string | null;
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        notaryAffirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
          isNotarizedIdAcceptable?: string | null;
          isNotaryAcceptable?: string | null;
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
          affirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
            isIdDocumentAcceptable?: string | null;
            isIdDocumentDetailsAcceptable?: string | null;
            isPhotoAcceptable?: string | null;
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
          notaryAffirmations?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
            isNotarizedIdAcceptable?: string | null;
            isNotaryAcceptable?: string | null;
            audit?: {
              __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
          isIdDocumentAcceptable?: string | null;
          isIdDocumentDetailsAcceptable?: string | null;
          isPhotoAcceptable?: string | null;
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
        notaryAffirmations?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
          isNotarizedIdAcceptable?: string | null;
          isNotaryAcceptable?: string | null;
          audit?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
        isIdDocumentAcceptable?: string | null;
        isIdDocumentDetailsAcceptable?: string | null;
        isPhotoAcceptable?: string | null;
        audit?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
      notaryAffirmations?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
        isNotarizedIdAcceptable?: string | null;
        isNotaryAcceptable?: string | null;
        audit?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
      isIdDocumentAcceptable?: string | null;
      isIdDocumentDetailsAcceptable?: string | null;
      isPhotoAcceptable?: string | null;
      audit?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
    notaryAffirmations?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
      isNotarizedIdAcceptable?: string | null;
      isNotaryAcceptable?: string | null;
      audit?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmations';
    isIdDocumentAcceptable?: string | null;
    isIdDocumentDetailsAcceptable?: string | null;
    isPhotoAcceptable?: string | null;
    audit?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
  notaryAffirmations?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmations';
    isNotarizedIdAcceptable?: string | null;
    isNotaryAcceptable?: string | null;
    audit?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewNotaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          primaryPhone?: string | null;
          emailAddress?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
        } | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            degreeTitle?: string | null;
            attendanceStartedAt?: any | null;
            attendanceEndedAt?: any | null;
            degreeIssuedAt?: any | null;
            graduationYear?: number | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              zipOrPostalCode?: string | null;
              stateOrProvince?: string | null;
              name?: string | null;
              country?: string | null;
              city?: string | null;
              addressLine1?: string | null;
            } | null;
          } | null> | null;
        } | null;
        applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  applicant?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        primaryPhone?: string | null;
        emailAddress?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
      } | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          attendanceStartedAt?: any | null;
          attendanceEndedAt?: any | null;
          degreeIssuedAt?: any | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            zipOrPostalCode?: string | null;
            stateOrProvince?: string | null;
            name?: string | null;
            country?: string | null;
            city?: string | null;
            addressLine1?: string | null;
          } | null;
        } | null> | null;
      } | null;
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
  } | null;
};

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1FileByFileNameFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
};

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1PdfFileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1ImageFileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobPath?: string | null;
    blobName?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobPath?: string | null;
  blobName?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    } | null;
  };
};

export type StaffCaseFilesContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffCaseFilesContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: { __typename?: 'IdentityVerificationCaseV1'; id: any; isCurrentUserAssigned?: boolean | null; state: string } | null;
};

export type StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type StaffCasesFilesContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    expirationEligibleAt?: any | null;
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          lastName?: string | null;
          restOfName?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type GenerateIdFormContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string };

export type GenerateIdFormContainerApplicantFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      lastName?: string | null;
      restOfName?: string | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
  } | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutationVariables = Exact<{
  input: IdentityVerificationCaseV1UpdateInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1Update: {
    __typename?: 'IdentityVerificationCaseV1MutationResult';
    identityVerificationCaseV1?: {
      __typename?: 'IdentityVerificationCaseV1';
      id: any;
      caseDetails?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetails';
        application?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
          passportAssets?: {
            __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
            passport?: string | null;
            passportExpiration?: string | null;
            passportTranslation?: string | null;
          } | null;
          photoAssets?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets'; photo?: string | null } | null;
        } | null;
      } | null;
      assets?: {
        __typename?: 'IdentityVerificationCaseV1Assets';
        shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; idForm?: string | null; notarizedIdForm?: string | null } | null;
        private?: { __typename?: 'IdentityVerificationCaseV1AssetsPrivate'; redactedNotarizedIdForm?: string | null } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1FileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1PdfFileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables = Exact<{
  input: IdentityVerificationCaseV1BlobFileInput;
}>;

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  identityVerificationCaseV1ImageFileCreateAuthHeader: {
    __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobPath?: string | null;
      blobName?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1MutationResult';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      application?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
        passportAssets?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
          passport?: string | null;
          passportExpiration?: string | null;
          passportTranslation?: string | null;
        } | null;
        photoAssets?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets'; photo?: string | null } | null;
      } | null;
    } | null;
    assets?: {
      __typename?: 'IdentityVerificationCaseV1Assets';
      shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; idForm?: string | null; notarizedIdForm?: string | null } | null;
      private?: { __typename?: 'IdentityVerificationCaseV1AssetsPrivate'; redactedNotarizedIdForm?: string | null } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobPath?: string | null;
    blobName?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobPath?: string | null;
  blobName?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    application?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplication';
      passportAssets?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPassportAssets';
        passport?: string | null;
        passportExpiration?: string | null;
        passportTranslation?: string | null;
      } | null;
      photoAssets?: { __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationPhotoAssets'; photo?: string | null } | null;
    } | null;
  } | null;
  assets?: {
    __typename?: 'IdentityVerificationCaseV1Assets';
    shared?: { __typename?: 'IdentityVerificationCaseV1AssetsShared'; idForm?: string | null; notarizedIdForm?: string | null } | null;
    private?: { __typename?: 'IdentityVerificationCaseV1AssetsPrivate'; redactedNotarizedIdForm?: string | null } | null;
  } | null;
};

export type CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
        decision?: {
          __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationRelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  archivedIdentityVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationRelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    id: any;
    applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
  } | null;
};

export type StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  isCurrentUserAssigned?: boolean | null;
  id: any;
  caseDetails?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
      decision?: {
        __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
        completedAt?: any | null;
        rejectionReason?: string | null;
        result?: string | null;
      } | null;
    } | null;
  } | null;
};

export type StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
    decision?: {
      __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
      completedAt?: any | null;
      rejectionReason?: string | null;
      result?: string | null;
    } | null;
  } | null;
};

export type StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReview';
  decision?: {
    __typename?: 'IdentityVerificationCaseV1CaseDetailsApplicationReviewDecision';
    completedAt?: any | null;
    rejectionReason?: string | null;
    result?: string | null;
  } | null;
};

export type CasesIdentityVerificationV1RelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  id: any;
  applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
};

export type CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    financeDetails?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
          amount?: number | null;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
          } | null;
        } | null;
        adhocTransactions?: Array<{
          __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          status?: string | null;
          requestedAt?: any | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
          approval?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval';
            applicantRespondedAt?: any | null;
            isApplicantApprovalRequired?: boolean | null;
            isApplicantApproved?: boolean | null;
          } | null;
          financeReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference';
            completedAt?: any | null;
            creditGlAccount?: string | null;
            debitGlAccount?: string | null;
          } | null;
          transactionReference?: {
            __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission';
      amount?: number | null;
      transactionReference?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
      } | null;
    } | null;
    adhocTransactions?: Array<{
      __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      status?: string | null;
      requestedAt?: any | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      approval?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionApproval';
        applicantRespondedAt?: any | null;
        isApplicantApprovalRequired?: boolean | null;
        isApplicantApproved?: boolean | null;
      } | null;
      financeReference?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionFinanceReference';
        completedAt?: any | null;
        creditGlAccount?: string | null;
        debitGlAccount?: string | null;
      } | null;
      transactionReference?: {
        __typename?: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesIdentityVerificationV1IndexContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesIdentityVerificationV1IndexContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canViewCaseHistory: boolean } };
    } | null;
  } | null;
};

export type CasesIdentityVerificationV1IndexContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canViewCaseHistory: boolean } };
  } | null;
};

export type CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: { __typename?: 'IdentityVerificationCaseV1'; state: string; caseName: string; id: any } | null;
};

export type CasesIdentityVerificationV1SectionLayoutCaseFieldsFragment = { __typename?: 'IdentityVerificationCaseV1'; state: string; caseName: string; id: any };

export type CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryQueryVariables = Exact<{
  archivedSendReportCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    id: any;
    applicant: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          primaryPhone?: string | null;
          emailAddress?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
        } | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            degreeTitle?: string | null;
            attendanceStartedAt?: any | null;
            attendanceEndedAt?: any | null;
            degreeIssuedAt?: any | null;
            graduationYear?: number | null;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              zipOrPostalCode?: string | null;
              stateOrProvince?: string | null;
              name?: string | null;
              country?: string | null;
              city?: string | null;
              addressLine1?: string | null;
            } | null;
          } | null> | null;
        } | null;
        applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
      } | null;
    };
  } | null;
};

export type CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummary';
  id: any;
  applicant: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        primaryPhone?: string | null;
        emailAddress?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
      } | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          attendanceStartedAt?: any | null;
          attendanceEndedAt?: any | null;
          degreeIssuedAt?: any | null;
          graduationYear?: number | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            zipOrPostalCode?: string | null;
            stateOrProvince?: string | null;
            name?: string | null;
            country?: string | null;
            city?: string | null;
            addressLine1?: string | null;
          } | null;
        } | null> | null;
      } | null;
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    } | null;
  };
};

export type CasesSendReportDecisionDetailContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportDecisionDetailContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        decision?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
    decision?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
    } | null;
  } | null;
};

export type CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryQueryVariables = Exact<{
  archivedSendReportCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    archiveEligibleAt: any;
    archivedAt: any;
    caseName: string;
    caseType: string;
    createdAt: any;
    id: any;
    lastActivityAt: any;
    state: string;
    submittedAt: any;
    activityLog: Array<{
      __typename?: 'ArchivedCaseSummaryActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      activityBy?: {
        __typename?: 'User';
        accessBlocked?: boolean | null;
        createdAt?: any | null;
        displayName?: string | null;
        externalId?: string | null;
        id: any;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        userType?: string | null;
      } | null;
    } | null>;
    applicant: {
      __typename?: 'ApplicantUser';
      accessBlocked?: boolean | null;
      createdAt?: any | null;
      displayName?: string | null;
      externalId?: string | null;
      id: any;
      isProfileSubmitted?: boolean | null;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      userType?: string | null;
      payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        applyingTo?: Array<{
          __typename?: 'Entity';
          createdAt?: any | null;
          disabledAt?: any | null;
          entityLanguage?: string | null;
          entityName?: string | null;
          id: any;
          isClient?: boolean | null;
          isIssuingInstitution?: boolean | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            addressLine2?: string | null;
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
          createdBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
        } | null> | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{
            __typename?: 'ApplicantUserPhone';
            createdAt?: any | null;
            id: any;
            phoneNumber?: string | null;
            phoneType?: string | null;
            updatedAt?: any | null;
          } | null> | null;
        } | null;
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        nameOnDocumentAssets?: Array<{
          __typename?: 'ApplicantUserNameOnDocumentAsset';
          createdAt?: any | null;
          documentName?: string | null;
          id: any;
          isDeleteRequested?: boolean | null;
          updatedAt?: any | null;
          uploadedAt?: any | null;
        } | null> | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            attendanceEndedAt?: any | null;
            attendanceStartedAt?: any | null;
            createdAt?: any | null;
            degreeIssuedAt?: any | null;
            degreeTitle?: string | null;
            graduationYear?: number | null;
            id: any;
            updatedAt?: any | null;
            issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              addressLine1?: string | null;
              city?: string | null;
              country?: string | null;
              name?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
      search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      termsAndConditions?: Array<{
        __typename?: 'ApplicantUserTermsAndCondition';
        acceptanceOf?: string | null;
        attestedAt?: any | null;
        createdAt?: any | null;
        id: any;
        updatedAt?: any | null;
        version?: number | null;
      } | null> | null;
      files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    };
    caseDetails: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
      application: {
        __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication';
        credentialTitle: string;
        destinationEmail: string;
        destinationName: string;
        destinationPhone: string;
      };
      applicationReview: {
        __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: { __typename?: 'ArchivedCaseSummaryAffirmationsAudit'; completedAt?: any | null; result?: string | null } | null;
        } | null;
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
          completedBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
          } | null;
        };
        privateCaseDetails: {
          __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
          institutionContactDetails: {
            __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
            institutionEmail: string;
            institutionPhone: string;
          };
        };
      };
    };
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          approval?: {
            __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
            isApplicantApprovalRequired?: boolean | null;
            isApplicantApproved?: boolean | null;
          } | null;
          transactionReference?: {
            __typename?: 'ArchivedCaseSummaryTransactionReference';
            completedAt?: any | null;
            isSuccess?: boolean | null;
            referenceId?: string | null;
          } | null;
        } | null> | null;
        submission?: { __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission'; amount?: number | null } | null;
      } | null;
    };
  } | null;
};

export type CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummary';
  archiveEligibleAt: any;
  archivedAt: any;
  caseName: string;
  caseType: string;
  createdAt: any;
  id: any;
  lastActivityAt: any;
  state: string;
  submittedAt: any;
  activityLog: Array<{
    __typename?: 'ArchivedCaseSummaryActivityLog';
    activityType?: string | null;
    createdAt?: any | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    activityBy?: {
      __typename?: 'User';
      accessBlocked?: boolean | null;
      createdAt?: any | null;
      displayName?: string | null;
      externalId?: string | null;
      id: any;
      schemaVersion?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      userType?: string | null;
    } | null;
  } | null>;
  applicant: {
    __typename?: 'ApplicantUser';
    accessBlocked?: boolean | null;
    createdAt?: any | null;
    displayName?: string | null;
    externalId?: string | null;
    id: any;
    isProfileSubmitted?: boolean | null;
    schemaVersion?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    userType?: string | null;
    payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{
        __typename?: 'Entity';
        createdAt?: any | null;
        disabledAt?: any | null;
        entityLanguage?: string | null;
        entityName?: string | null;
        id: any;
        isClient?: boolean | null;
        isIssuingInstitution?: boolean | null;
        schemaVersion?: string | null;
        updatedAt?: any | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        client?: { __typename?: 'EntityClient'; email?: string | null; phoneNumber?: string | null } | null;
        createdBy?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          id: any;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            id: any;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        issuingInstitution?: { __typename?: 'EntityIssuingInstitution'; email?: string | null; phoneNumber?: string | null } | null;
      } | null> | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{
          __typename?: 'ApplicantUserPhone';
          createdAt?: any | null;
          id: any;
          phoneNumber?: string | null;
          phoneType?: string | null;
          updatedAt?: any | null;
        } | null> | null;
      } | null;
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        createdAt?: any | null;
        documentName?: string | null;
        id: any;
        isDeleteRequested?: boolean | null;
        updatedAt?: any | null;
        uploadedAt?: any | null;
      } | null> | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          createdAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          updatedAt?: any | null;
          issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
    search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      createdAt?: any | null;
      id: any;
      updatedAt?: any | null;
      version?: number | null;
    } | null> | null;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  };
  caseDetails: {
    __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
    application: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication';
      credentialTitle: string;
      destinationEmail: string;
      destinationName: string;
      destinationPhone: string;
    };
    applicationReview: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'ArchivedCaseSummaryAffirmations';
        audit?: { __typename?: 'ArchivedCaseSummaryAffirmationsAudit'; completedAt?: any | null; result?: string | null } | null;
      } | null;
      decision: {
        __typename?: 'ArchivedCaseSummaryDecision';
        completedAt?: any | null;
        rejectionReason?: string | null;
        result?: string | null;
        completedBy?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          id: any;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
        } | null;
      };
      privateCaseDetails: {
        __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
        institutionContactDetails: {
          __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
          institutionEmail: string;
          institutionPhone: string;
        };
      };
    };
  };
  files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
  financeDetails: {
    __typename?: 'ArchivedCaseSummaryFinanceDetails';
    transactions?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
      adhocTransactions?: Array<{
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
        amount?: number | null;
        reason?: string | null;
        approval?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
          isApplicantApprovalRequired?: boolean | null;
          isApplicantApproved?: boolean | null;
        } | null;
        transactionReference?: {
          __typename?: 'ArchivedCaseSummaryTransactionReference';
          completedAt?: any | null;
          isSuccess?: boolean | null;
          referenceId?: string | null;
        } | null;
      } | null> | null;
      submission?: { __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission'; amount?: number | null } | null;
    } | null;
  };
};

export type CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryQueryVariables = Exact<{
  archivedSendReportCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    submittedAt: any;
    lastActivityAt: any;
    id: any;
    applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
  } | null;
};

export type CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummary';
  submittedAt: any;
  lastActivityAt: any;
  id: any;
  applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
};

export type CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryQueryVariables = Exact<{
  archivedSendReportCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    id: any;
    caseDetails: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
      applicationReview: {
        __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'ArchivedCaseSummaryAffirmations';
          audit?: {
            __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
          } | null;
        } | null;
        decision: {
          __typename?: 'ArchivedCaseSummaryDecision';
          completedAt?: any | null;
          result?: string | null;
          rejectionReason?: string | null;
          completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
        };
        privateCaseDetails: {
          __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
          institutionContactDetails: {
            __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
            institutionEmail: string;
            institutionPhone: string;
          };
        };
      };
      application: {
        __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication';
        credentialTitle: string;
        destinationName: string;
        destinationEmail: string;
        destinationPhone: string;
      };
    };
    financeDetails: {
      __typename?: 'ArchivedCaseSummaryFinanceDetails';
      transactions?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
        adhocTransactions?: Array<{
          __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          approval?: {
            __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
            isApplicantApproved?: boolean | null;
            isApplicantApprovalRequired?: boolean | null;
          } | null;
          transactionReference?: {
            __typename?: 'ArchivedCaseSummaryTransactionReference';
            referenceId?: string | null;
            completedAt?: any | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
        submission?: {
          __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
        } | null;
      } | null;
    };
    activityLog: Array<{
      __typename?: 'ArchivedCaseSummaryActivityLog';
      tags?: Array<string | null> | null;
      description?: string | null;
      activityType?: string | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; id: any; displayName?: string | null } | null;
    } | null>;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetails';
  applicationReview: {
    __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'ArchivedCaseSummaryAffirmations';
      audit?: {
        __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
      } | null;
    } | null;
    decision: {
      __typename?: 'ArchivedCaseSummaryDecision';
      completedAt?: any | null;
      result?: string | null;
      rejectionReason?: string | null;
      completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
    };
    privateCaseDetails: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
      institutionContactDetails: {
        __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
        institutionEmail: string;
        institutionPhone: string;
      };
    };
  };
  application: {
    __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication';
    credentialTitle: string;
    destinationName: string;
    destinationEmail: string;
    destinationPhone: string;
  };
};

export type CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplication';
  credentialTitle: string;
  destinationName: string;
  destinationEmail: string;
  destinationPhone: string;
};

export type CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'ArchivedCaseSummaryAffirmations';
    audit?: {
      __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
    } | null;
  } | null;
  decision: {
    __typename?: 'ArchivedCaseSummaryDecision';
    completedAt?: any | null;
    result?: string | null;
    rejectionReason?: string | null;
    completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
  };
  privateCaseDetails: {
    __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
    institutionContactDetails: {
      __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
      institutionEmail: string;
      institutionPhone: string;
    };
  };
};

export type CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryDecision';
  completedAt?: any | null;
  result?: string | null;
  rejectionReason?: string | null;
  completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
};

export type CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails';
  institutionContactDetails: {
    __typename?: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
    institutionEmail: string;
    institutionPhone: string;
  };
};

export type CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
  amount?: number | null;
  reason?: string | null;
  approval?: {
    __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
    isApplicantApproved?: boolean | null;
    isApplicantApprovalRequired?: boolean | null;
  } | null;
  transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; referenceId?: string | null; completedAt?: any | null; isSuccess?: boolean | null } | null;
};

export type CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryFinanceDetails';
  transactions?: {
    __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactions';
    adhocTransactions?: Array<{
      __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      approval?: {
        __typename?: 'ArchivedCaseSummaryFinanceDetailsAdhocTransactionApproval';
        isApplicantApproved?: boolean | null;
        isApplicantApprovalRequired?: boolean | null;
      } | null;
      transactionReference?: {
        __typename?: 'ArchivedCaseSummaryTransactionReference';
        referenceId?: string | null;
        completedAt?: any | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
    submission?: {
      __typename?: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission';
      amount?: number | null;
      transactionReference?: { __typename?: 'ArchivedCaseSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null } | null;
    } | null;
  } | null;
};

export type CasesSendReportCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryActivityLog';
  tags?: Array<string | null> | null;
  description?: string | null;
  activityType?: string | null;
  updatedAt?: any | null;
  activityBy?: { __typename?: 'User'; id: any; displayName?: string | null } | null;
};

export type CasesSendReportCaseSummaryContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string };

export type CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFieldsFragment = {
  __typename?: 'ArchivedCaseSummaryAffirmations';
  audit?: {
    __typename?: 'ArchivedCaseSummaryAffirmationsAudit';
    completedAt?: any | null;
    result?: string | null;
    completedBy?: { __typename?: 'StaffUser'; id: any; displayName?: string | null } | null;
  } | null;
};

export type CasesSendReportV1ActiveCaseListContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; id: any; displayName?: string | null } | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        credential?: { __typename?: 'CredentialVerificationCaseV1'; caseName?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1ActiveCaseListContainerSendReportCaseV1CurrentQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1ActiveCaseListContainerSendReportCaseV1CurrentQuery = {
  __typename?: 'Query';
  sendReportCaseV1Current?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; id: any; displayName?: string | null } | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        credential?: { __typename?: 'CredentialVerificationCaseV1'; caseName?: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1ActiveCaseListContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; id: any; displayName?: string | null } | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    application?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplication';
      credential?: { __typename?: 'CredentialVerificationCaseV1'; caseName?: string | null } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1ActivityLogContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1ActivityLogContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    isCurrentUserAssigned?: boolean | null;
    id: any;
    state: string;
    activityLog?: Array<{
      __typename?: 'SendReportCaseV1ActivityLog';
      activityType?: string | null;
      createdAt?: any | null;
      description?: string | null;
      id: any;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  isCurrentUserAssigned?: boolean | null;
  id: any;
  state: string;
  activityLog?: Array<{
    __typename?: 'SendReportCaseV1ActivityLog';
    activityType?: string | null;
    createdAt?: any | null;
    description?: string | null;
    id: any;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
};

export type CasesSendReportV1ActivityLogContainerUserFieldsFragment = { __typename?: 'User'; displayName?: string | null; id: any };

export type CasesSendReportV1ActivityLogContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1ActivityLogContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      isCurrentUserAssigned?: boolean | null;
      id: any;
      state: string;
      activityLog?: Array<{
        __typename?: 'SendReportCaseV1ActivityLog';
        activityType?: string | null;
        createdAt?: any | null;
        description?: string | null;
        id: any;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: { __typename?: 'SendReportCaseV1'; id: any; applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null } | null;
};

export type CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    submittedAt?: any | null;
    caseName?: string | null;
    state: string;
    isCurrentUserAssigned?: boolean | null;
    purgeEligibleAt?: any | null;
    archiveEligibleAt?: any | null;
    expirationEligibleAt?: any | null;
    applicant?: { __typename?: 'ApplicantUser'; id: any } | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        credential?: {
          __typename?: 'CredentialVerificationCaseV1';
          id: any;
          caseDetails?: {
            __typename?: 'CredentialVerificationCaseV1CaseDetails';
            application?: {
              __typename?: 'CredentialVerificationCaseV1Application';
              credentialTitle?: string | null;
              issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null } | null;
              otherIssuingInstitution?: { __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution'; institutionName?: string | null } | null;
            } | null;
          } | null;
        } | null;
        destination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
      } | null;
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        decision?: { __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null; completedAt?: any | null } | null;
        privateCaseDetails?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails';
          institutionContactDetails?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
            institutionEmail?: string | null;
            institutionPhone?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SendReportV1CaseDetailsApplicationContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type SendReportV1CaseDetailsApplicationContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; isClient?: boolean | null; id: any } | null> | null;
};

export type SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantQuery = {
  __typename?: 'Query';
  verifiedCredentialVerificationCaseSummariesByApplicant?: Array<{
    __typename?: 'VerifiedCredentialVerificationCaseSummary';
    id: any;
    caseDetails: {
      __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetails';
      application: { __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication'; credentialTitle: string; issuingInstitutionName: string };
    };
  } | null> | null;
};

export type CasesSendReportV1CaseDetailsApplicationContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesSendReportV1CaseDetailsApplicationContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: { __typename?: 'StaffUser'; id: any; role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null } | null;
};

export type CasesSendReportV1CaseDetailsApplicationContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null;
};

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      id: any;
      caseName?: string | null;
      purgeEligibleAt?: any | null;
      archiveEligibleAt?: any | null;
      expirationEligibleAt?: any | null;
      caseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetails';
        application?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplication';
          destination?: { __typename?: 'Entity'; id: any } | null;
          credential?: { __typename?: 'CredentialVerificationCaseV1'; id: any } | null;
        } | null;
        applicationReview?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
          privateCaseDetails?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails';
            institutionContactDetails?: {
              __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
              institutionEmail?: string | null;
              institutionPhone?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantFieldsFragment = {
  __typename?: 'VerifiedCredentialVerificationCaseSummary';
  id: any;
  caseDetails: {
    __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetails';
    application: { __typename?: 'VerifiedCredentialVerificationCaseSummaryCaseDetailsApplication'; credentialTitle: string; issuingInstitutionName: string };
  };
};

export type SendReportV1CaseDetailsApplicationContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
};

export type SendReportV1CaseDetailsApplicationContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  submittedAt?: any | null;
  caseName?: string | null;
  state: string;
  isCurrentUserAssigned?: boolean | null;
  purgeEligibleAt?: any | null;
  archiveEligibleAt?: any | null;
  expirationEligibleAt?: any | null;
  applicant?: { __typename?: 'ApplicantUser'; id: any } | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    application?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplication';
      credential?: {
        __typename?: 'CredentialVerificationCaseV1';
        id: any;
        caseDetails?: {
          __typename?: 'CredentialVerificationCaseV1CaseDetails';
          application?: {
            __typename?: 'CredentialVerificationCaseV1Application';
            credentialTitle?: string | null;
            issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null } | null;
            otherIssuingInstitution?: { __typename?: 'CredentialVerificationCaseV1OtherIssuingInstitution'; institutionName?: string | null } | null;
          } | null;
        } | null;
      } | null;
      destination?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
    } | null;
    applicationReview?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
      decision?: { __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision'; result?: string | null; completedAt?: any | null } | null;
      privateCaseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails';
        institutionContactDetails?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
          institutionEmail?: string | null;
          institutionPhone?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type SendReportCaseV1ApplicationContainerStaffUserCurrentFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null;
};

export type CasesSendReportV1CaseDetailsContainerStaffUsersQueryVariables = Exact<{ [key: string]: never }>;

export type CasesSendReportV1CaseDetailsContainerStaffUsersQuery = {
  __typename?: 'Query';
  staffUsers?: Array<{
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canBeAssignedCases: boolean } };
    } | null;
  } | null> | null;
};

export type CasesSendReportV1CaseDetailsContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesSendReportV1CaseDetailsContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        sendCasePermissions: {
          __typename?: 'StaffRoleSendCasePermissions';
          canAssignSelf: boolean;
          canAssignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canUnassignCaseWorker: boolean;
        };
      };
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        affirmations?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
          audit?: {
            __typename?: 'SendReportCaseV1AuditType';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'SendReportCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      tags?: Array<string | null> | null;
      id: any;
      caseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
          caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          affirmations?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
            audit?: {
              __typename?: 'SendReportCaseV1AuditType';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      activityLog?: Array<{
        __typename?: 'SendReportCaseV1ActivityLog';
        activityType?: string | null;
        description?: string | null;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
      revisionRequest?: {
        __typename?: 'SendReportCaseV1RevisionRequest';
        requestedAt?: any | null;
        revisionSubmittedAt?: any | null;
        requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
      } | null;
    } | null;
  };
};

export type CasesSendReportV1CaseDetailsContainerStaffUsersFieldsFragment = {
  __typename?: 'StaffUser';
  displayName?: string | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canBeAssignedCases: boolean } };
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  displayName?: string | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      sendCasePermissions: {
        __typename?: 'StaffRoleSendCasePermissions';
        canAssignSelf: boolean;
        canAssignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canUnassignCaseWorker: boolean;
      };
    };
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        affirmations?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
          audit?: {
            __typename?: 'SendReportCaseV1AuditType';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'SendReportCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  tags?: Array<string | null> | null;
  id: any;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
      caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      affirmations?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
        audit?: {
          __typename?: 'SendReportCaseV1AuditType';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  activityLog?: Array<{
    __typename?: 'SendReportCaseV1ActivityLog';
    activityType?: string | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
  revisionRequest?: {
    __typename?: 'SendReportCaseV1RevisionRequest';
    requestedAt?: any | null;
    revisionSubmittedAt?: any | null;
    requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
    caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    affirmations?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
      audit?: {
        __typename?: 'SendReportCaseV1AuditType';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
  caseWorkerAssigned?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
  affirmations?: {
    __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
    audit?: {
      __typename?: 'SendReportCaseV1AuditType';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFieldsFragment = {
  __typename?: 'SendReportCaseV1ActivityLog';
  activityType?: string | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'SendReportCaseV1RevisionRequest';
  requestedAt?: any | null;
  revisionSubmittedAt?: any | null;
  requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
};

export type CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFieldsFragment = {
  __typename?: 'SendReportCaseV1RevisionRequestRequestChanges';
  requestUpdatedDestination?: boolean | null;
};

export type CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    caseHistory?: Array<{
      __typename?: 'SendReportCaseV1CaseHistory';
      createdAt?: any | null;
      id: any;
      updatedAt?: any | null;
      caseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetails';
        createdAt?: any | null;
        initiatedByApplicant?: boolean | null;
        application?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplication';
          attestedAt?: any | null;
          isAttestationComplete?: boolean | null;
          credential?: {
            __typename?: 'CredentialVerificationCaseV1';
            archiveEligibleAt?: any | null;
            caseName?: string | null;
            caseType?: string | null;
            createdAt?: any | null;
            expirationEligibleAt?: any | null;
            id: any;
            isCurrentUserAssigned?: boolean | null;
            lastActivityAt?: any | null;
            purgeEligibleAt?: any | null;
            schemaVersion?: string | null;
            state: string;
            submittedAt?: any | null;
            systemTags?: Array<string | null> | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            activityLog?: Array<{
              __typename?: 'CredentialVerificationCaseV1ActivityLog';
              activityType?: string | null;
              createdAt?: any | null;
              description?: string | null;
              id: any;
              metaData?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              activityBy?: {
                __typename?: 'User';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                externalId?: string | null;
                id: any;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
                updatedAt?: any | null;
                userType?: string | null;
              } | null;
            } | null> | null;
            applicant?: {
              __typename?: 'ApplicantUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              externalId?: string | null;
              id: any;
              isProfileSubmitted?: boolean | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
              payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
              personalInformation?: {
                __typename?: 'ApplicantUserPersonalInformation';
                applyingTo?: Array<{
                  __typename?: 'Entity';
                  clientDisabledAt?: any | null;
                  createdAt?: any | null;
                  disabledAt?: any | null;
                  entityLanguage?: string | null;
                  entityName?: string | null;
                  id: any;
                  institutionDisabledAt?: any | null;
                  isClient?: boolean | null;
                  isIssuingInstitution?: boolean | null;
                  schemaVersion?: string | null;
                  updatedAt?: any | null;
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                  client?: {
                    __typename?: 'EntityClient';
                    email?: string | null;
                    phoneNumber?: string | null;
                    address?: {
                      __typename?: 'EntityAddressInfo';
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                  } | null;
                  createdBy?: {
                    __typename?: 'StaffUser';
                    accessBlocked?: boolean | null;
                    createdAt?: any | null;
                    displayName?: string | null;
                    emailAddress?: string | null;
                    externalId?: string | null;
                    firstName?: string | null;
                    id: any;
                    lastName?: string | null;
                    schemaVersion?: string | null;
                    tags?: Array<string | null> | null;
                    updatedAt?: any | null;
                    userType?: string | null;
                    role?: {
                      __typename?: 'StaffRole';
                      createdAt?: any | null;
                      id: any;
                      isDefault: boolean;
                      roleName: string;
                      roleSubtype: string;
                      roleType?: string | null;
                      schemaVersion?: string | null;
                      updatedAt?: any | null;
                      permissions: {
                        __typename?: 'StaffRolePermissions';
                        applicantUserPermissions: {
                          __typename?: 'StaffRoleApplicantUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canBlockAccess: boolean;
                          canSearchApplicants: boolean;
                          canUpdatePersonalInformation: boolean;
                        };
                        credCasePermissions: {
                          __typename?: 'StaffRoleCredCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        entityPermissions: {
                          __typename?: 'StaffRoleEntityPermissions';
                          canAddEntities: boolean;
                          canDeleteEntities: boolean;
                          canEditEntities: boolean;
                          canSearchEntities: boolean;
                        };
                        idCasePermissions: {
                          __typename?: 'StaffRoleIdCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                        sendCasePermissions: {
                          __typename?: 'StaffRoleSendCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        staffUserPermissions: {
                          __typename?: 'StaffRoleStaffUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canAssignRoles: boolean;
                          canBlockAccess: boolean;
                          canSearchStaff: boolean;
                        };
                      };
                    } | null;
                    search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                  } | null;
                  issuingInstitution?: {
                    __typename?: 'EntityIssuingInstitution';
                    email?: string | null;
                    phoneNumber?: string | null;
                    address?: {
                      __typename?: 'EntityAddressInfo';
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                  } | null;
                } | null> | null;
                citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
                contactInformation?: {
                  __typename?: 'ApplicantUserContactInformation';
                  emailAddress?: string | null;
                  primaryPhone?: string | null;
                  address?: {
                    __typename?: 'ApplicantUserAddress';
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    streetAddressLine1?: string | null;
                    streetAddressLine2?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                  phone?: Array<{
                    __typename?: 'ApplicantUserPhone';
                    createdAt?: any | null;
                    id: any;
                    phoneNumber?: string | null;
                    phoneType?: string | null;
                    updatedAt?: any | null;
                  } | null> | null;
                } | null;
                identityDetails?: {
                  __typename?: 'ApplicantUserIdentityDetails';
                  dateOfBirth?: any | null;
                  gender?: string | null;
                  generationalSuffix?: string | null;
                  lastName?: string | null;
                  legalNameConsistsOfOneName?: boolean | null;
                  restOfName?: string | null;
                } | null;
                nameOnDocumentAssets?: Array<{
                  __typename?: 'ApplicantUserNameOnDocumentAsset';
                  createdAt?: any | null;
                  documentName?: string | null;
                  id: any;
                  isDeleteRequested?: boolean | null;
                  updatedAt?: any | null;
                  uploadedAt?: any | null;
                } | null> | null;
                professional?: {
                  __typename?: 'ApplicantUserProfessional';
                  citizenshipAtTimeEnteredMedicalInstitution?: string | null;
                  healthProfession?: string | null;
                  primaryEducationalInformation?: Array<{
                    __typename?: 'ApplicantUserPrimaryEducationalInformation';
                    attendanceEndedAt?: any | null;
                    attendanceStartedAt?: any | null;
                    createdAt?: any | null;
                    degreeIssuedAt?: any | null;
                    degreeTitle?: string | null;
                    graduationYear?: number | null;
                    id: any;
                    updatedAt?: any | null;
                    issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
                    otherIssuingInstitution?: {
                      __typename?: 'ApplicantUserOtherIssuingInstitution';
                      addressLine1?: string | null;
                      city?: string | null;
                      country?: string | null;
                      name?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                  } | null> | null;
                } | null;
              } | null;
              search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
              termsAndConditions?: Array<{
                __typename?: 'ApplicantUserTermsAndCondition';
                acceptanceOf?: string | null;
                attestedAt?: any | null;
                createdAt?: any | null;
                id: any;
                updatedAt?: any | null;
                version?: number | null;
              } | null> | null;
            } | null;
            assets?: {
              __typename?: 'CredentialVerificationCaseV1Assets';
              private?: {
                __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
                verificationComponentPacket?: string | null;
                verificationForm?: string | null;
                verificationPacket?: string | null;
                verificationPacketResponse?: string | null;
                verificationComponentPacketHistory?: Array<{
                  __typename?: 'CredentialVerificationCaseV1AssetHistory';
                  assetVersion?: string | null;
                  createdAt?: any | null;
                  id: any;
                  updatedAt?: any | null;
                  assetUploadedBy?: {
                    __typename?: 'StaffUser';
                    accessBlocked?: boolean | null;
                    createdAt?: any | null;
                    displayName?: string | null;
                    emailAddress?: string | null;
                    externalId?: string | null;
                    firstName?: string | null;
                    id: any;
                    lastName?: string | null;
                    schemaVersion?: string | null;
                    tags?: Array<string | null> | null;
                    role?: {
                      __typename?: 'StaffRole';
                      createdAt?: any | null;
                      id: any;
                      roleName: string;
                      roleSubtype: string;
                      roleType?: string | null;
                      schemaVersion?: string | null;
                      updatedAt?: any | null;
                      permissions: {
                        __typename?: 'StaffRolePermissions';
                        applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canAddOrRemoveTags: boolean };
                      };
                    } | null;
                  } | null;
                } | null> | null;
                verificationFormHistory?: Array<{
                  __typename?: 'CredentialVerificationCaseV1AssetHistory';
                  assetVersion?: string | null;
                  createdAt?: any | null;
                  id: any;
                  updatedAt?: any | null;
                  assetUploadedBy?: { __typename?: 'StaffUser'; accessBlocked?: boolean | null } | null;
                } | null> | null;
              } | null;
            } | null;
            caseDetails?: {
              __typename?: 'CredentialVerificationCaseV1CaseDetails';
              createdAt?: any | null;
              application?: {
                __typename?: 'CredentialVerificationCaseV1Application';
                attestedAt?: any | null;
                credentialTitle?: string | null;
                credentialType?: string | null;
                dateCredentialIssuedAt?: any | null;
                isAttestationComplete?: boolean | null;
                isCredentialInEnglish?: boolean | null;
                isNameOnCredentialMatchPassport?: boolean | null;
                nameOnCredential?: string | null;
                program?: string | null;
                credentialAssets?: {
                  __typename?: 'CredentialVerificationCaseV1CredentialAssets';
                  credential?: string | null;
                  credentialUploadedAt?: any | null;
                  credentialVersion?: string | null;
                  translation?: string | null;
                  translationUploadedAt?: any | null;
                  translationVersion?: string | null;
                } | null;
                issuingInstitution?: {
                  __typename?: 'Entity';
                  clientDisabledAt?: any | null;
                  createdAt?: any | null;
                  disabledAt?: any | null;
                  entityLanguage?: string | null;
                  entityName?: string | null;
                  id: any;
                  institutionDisabledAt?: any | null;
                  isClient?: boolean | null;
                  isIssuingInstitution?: boolean | null;
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                  client?: {
                    __typename?: 'EntityClient';
                    email?: string | null;
                    phoneNumber?: string | null;
                    address?: {
                      __typename?: 'EntityAddressInfo';
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                  } | null;
                  createdBy?: {
                    __typename?: 'StaffUser';
                    accessBlocked?: boolean | null;
                    createdAt?: any | null;
                    displayName?: string | null;
                    emailAddress?: string | null;
                    externalId?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                    id: any;
                    role?: {
                      __typename?: 'StaffRole';
                      createdAt?: any | null;
                      id: any;
                      isDefault: boolean;
                      roleName: string;
                      roleSubtype: string;
                      roleType?: string | null;
                      schemaVersion?: string | null;
                      updatedAt?: any | null;
                      permissions: {
                        __typename?: 'StaffRolePermissions';
                        applicantUserPermissions: {
                          __typename?: 'StaffRoleApplicantUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canBlockAccess: boolean;
                          canSearchApplicants: boolean;
                          canUpdatePersonalInformation: boolean;
                        };
                        credCasePermissions: {
                          __typename?: 'StaffRoleCredCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        entityPermissions: {
                          __typename?: 'StaffRoleEntityPermissions';
                          canAddEntities: boolean;
                          canDeleteEntities: boolean;
                          canEditEntities: boolean;
                          canSearchEntities: boolean;
                        };
                        idCasePermissions: {
                          __typename?: 'StaffRoleIdCasePermissions';
                          canAssignCaseWorker: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        sendCasePermissions: {
                          __typename?: 'StaffRoleSendCasePermissions';
                          canAssignCaseWorker: boolean;
                          canBeAssignedCases: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                        };
                        staffUserPermissions: {
                          __typename?: 'StaffRoleStaffUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canAssignRoles: boolean;
                          canBlockAccess: boolean;
                          canSearchStaff: boolean;
                        };
                      };
                    } | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            caseFlagged?: Array<{
              __typename?: 'CredentialVerificationCaseV1CaseFlagged';
              createdAt?: any | null;
              flagType?: string | null;
              id: any;
              reason?: string | null;
              updatedAt?: any | null;
            } | null> | null;
            caseHistory?: Array<{
              __typename?: 'CredentialVerificationCaseV1CaseHistory';
              createdAt?: any | null;
              id: any;
              updatedAt?: any | null;
              caseDetails?: {
                __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetails';
                createdAt?: any | null;
                application?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication';
                  attestedAt?: any | null;
                  credentialTitle?: string | null;
                  credentialType?: string | null;
                  dateCredentialIssuedAt?: any | null;
                  isAttestationComplete?: boolean | null;
                  isCredentialInEnglish?: boolean | null;
                  isNameOnCredentialMatchPassport?: boolean | null;
                  nameOnCredential?: string | null;
                  program?: string | null;
                  credentialAssets?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets';
                    credential?: string | null;
                    credentialUploadedAt?: any | null;
                    credentialVersion?: string | null;
                    translation?: string | null;
                    translationUploadedAt?: any | null;
                    translationVersion?: string | null;
                  } | null;
                  issuingInstitution?: {
                    __typename?: 'Entity';
                    clientDisabledAt?: any | null;
                    createdAt?: any | null;
                    disabledAt?: any | null;
                    entityLanguage?: string | null;
                    entityName?: string | null;
                    institutionDisabledAt?: any | null;
                    isClient?: boolean | null;
                    isIssuingInstitution?: boolean | null;
                    address?: {
                      __typename?: 'EntityAddressInfo';
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                    client?: {
                      __typename?: 'EntityClient';
                      email?: string | null;
                      phoneNumber?: string | null;
                      address?: {
                        __typename?: 'EntityAddressInfo';
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        country?: string | null;
                        stateOrProvince?: string | null;
                        zipOrPostalCode?: string | null;
                      } | null;
                    } | null;
                  } | null;
                  otherIssuingInstitution?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution';
                    addressLine1?: string | null;
                    city?: string | null;
                    country?: string | null;
                    institutionName?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                  sendDestination?: {
                    __typename?: 'Entity';
                    clientDisabledAt?: any | null;
                    createdAt?: any | null;
                    disabledAt?: any | null;
                    entityName?: string | null;
                    entityLanguage?: string | null;
                    id: any;
                    institutionDisabledAt?: any | null;
                    isClient?: boolean | null;
                    isIssuingInstitution?: boolean | null;
                    address?: {
                      __typename?: 'EntityAddressInfo';
                      addressLine1?: string | null;
                      city?: string | null;
                      addressLine2?: string | null;
                      country?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                    client?: {
                      __typename?: 'EntityClient';
                      email?: string | null;
                      phoneNumber?: string | null;
                      address?: {
                        __typename?: 'EntityAddressInfo';
                        addressLine1?: string | null;
                        addressLine2?: string | null;
                        city?: string | null;
                        country?: string | null;
                        stateOrProvince?: string | null;
                        zipOrPostalCode?: string | null;
                      } | null;
                    } | null;
                  } | null;
                } | null;
                applicationReview?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
                  affirmations?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
                    isCredentialAcceptable?: string | null;
                    isCredentialDetailsAcceptable?: string | null;
                    isCredentialSentForVerification?: string | null;
                    isDateOfBirthAcceptable?: string | null;
                    isEntityAcceptable?: string | null;
                    isNameAcceptable?: string | null;
                    isTranslationAcceptable?: string | null;
                    audit?: {
                      __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
                      completedAt?: any | null;
                      result?: string | null;
                      completedBy?: {
                        __typename?: 'StaffUser';
                        accessBlocked?: boolean | null;
                        createdAt?: any | null;
                        displayName?: string | null;
                        emailAddress?: string | null;
                        externalId?: string | null;
                        firstName?: string | null;
                        id: any;
                        lastName?: string | null;
                        schemaVersion?: string | null;
                        tags?: Array<string | null> | null;
                        updatedAt?: any | null;
                        userType?: string | null;
                        role?: {
                          __typename?: 'StaffRole';
                          createdAt?: any | null;
                          id: any;
                          isDefault: boolean;
                          roleName: string;
                          roleSubtype: string;
                          roleType?: string | null;
                          schemaVersion?: string | null;
                          updatedAt?: any | null;
                          permissions: {
                            __typename?: 'StaffRolePermissions';
                            applicantUserPermissions: {
                              __typename?: 'StaffRoleApplicantUserPermissions';
                              canAddOrRemoveTags: boolean;
                              canBlockAccess: boolean;
                              canSearchApplicants: boolean;
                              canUpdatePersonalInformation: boolean;
                            };
                            credCasePermissions: {
                              __typename?: 'StaffRoleCredCasePermissions';
                              canAssignCaseWorker: boolean;
                              canAssignSelf: boolean;
                              canBeAssignedCases: boolean;
                              canIssueRefunds: boolean;
                              canOverrideCaseState: boolean;
                              canReopenCases: boolean;
                              canSearchCases: boolean;
                              canUnassignCaseWorker: boolean;
                              canUnassignSelf: boolean;
                              canViewCaseHistory: boolean;
                              canViewCasesAssignedToOthers: boolean;
                              canViewUnassignedCases: boolean;
                            };
                            entityPermissions: {
                              __typename?: 'StaffRoleEntityPermissions';
                              canAddEntities: boolean;
                              canDeleteEntities: boolean;
                              canEditEntities: boolean;
                              canSearchEntities: boolean;
                            };
                            idCasePermissions: {
                              __typename?: 'StaffRoleIdCasePermissions';
                              canAssignCaseWorker: boolean;
                              canAssignSelf: boolean;
                              canBeAssignedCases: boolean;
                              canIssueRefunds: boolean;
                              canOverrideCaseState: boolean;
                              canReopenCases: boolean;
                              canSearchCases: boolean;
                              canUnassignCaseWorker: boolean;
                              canUnassignSelf: boolean;
                              canViewCaseHistory: boolean;
                              canViewCasesAssignedToOthers: boolean;
                              canViewUnassignedCases: boolean;
                            };
                            rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                            sendCasePermissions: {
                              __typename?: 'StaffRoleSendCasePermissions';
                              canAssignCaseWorker: boolean;
                              canAssignSelf: boolean;
                              canBeAssignedCases: boolean;
                              canIssueRefunds: boolean;
                              canOverrideCaseState: boolean;
                              canReopenCases: boolean;
                              canSearchCases: boolean;
                              canUnassignCaseWorker: boolean;
                              canUnassignSelf: boolean;
                              canViewCaseHistory: boolean;
                              canViewCasesAssignedToOthers: boolean;
                              canViewUnassignedCases: boolean;
                            };
                            staffUserPermissions: {
                              __typename?: 'StaffRoleStaffUserPermissions';
                              canAddOrRemoveTags: boolean;
                              canAssignRoles: boolean;
                              canBlockAccess: boolean;
                              canSearchStaff: boolean;
                            };
                          };
                        } | null;
                        search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                      } | null;
                    } | null;
                  } | null;
                  caseWorkerAssigned?: {
                    __typename?: 'StaffUser';
                    accessBlocked?: boolean | null;
                    createdAt?: any | null;
                    displayName?: string | null;
                    emailAddress?: string | null;
                    externalId?: string | null;
                    firstName?: string | null;
                    id: any;
                    lastName?: string | null;
                    schemaVersion?: string | null;
                    tags?: Array<string | null> | null;
                    updatedAt?: any | null;
                    userType?: string | null;
                    role?: {
                      __typename?: 'StaffRole';
                      createdAt?: any | null;
                      id: any;
                      isDefault: boolean;
                      roleName: string;
                      roleSubtype: string;
                      roleType?: string | null;
                      schemaVersion?: string | null;
                      updatedAt?: any | null;
                      permissions: {
                        __typename?: 'StaffRolePermissions';
                        applicantUserPermissions: {
                          __typename?: 'StaffRoleApplicantUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canBlockAccess: boolean;
                          canSearchApplicants: boolean;
                          canUpdatePersonalInformation: boolean;
                        };
                        credCasePermissions: {
                          __typename?: 'StaffRoleCredCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        entityPermissions: {
                          __typename?: 'StaffRoleEntityPermissions';
                          canAddEntities: boolean;
                          canDeleteEntities: boolean;
                          canEditEntities: boolean;
                          canSearchEntities: boolean;
                        };
                        idCasePermissions: {
                          __typename?: 'StaffRoleIdCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                        sendCasePermissions: {
                          __typename?: 'StaffRoleSendCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        staffUserPermissions: {
                          __typename?: 'StaffRoleStaffUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canAssignRoles: boolean;
                          canBlockAccess: boolean;
                          canSearchStaff: boolean;
                        };
                      };
                    } | null;
                    search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                  } | null;
                  decision?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
                    completedAt?: any | null;
                    rejectionReason?: string | null;
                    result?: string | null;
                    completedBy?: {
                      __typename?: 'StaffUser';
                      accessBlocked?: boolean | null;
                      createdAt?: any | null;
                      displayName?: string | null;
                      emailAddress?: string | null;
                      externalId?: string | null;
                      firstName?: string | null;
                      id: any;
                      lastName?: string | null;
                      schemaVersion?: string | null;
                      tags?: Array<string | null> | null;
                      updatedAt?: any | null;
                      userType?: string | null;
                      role?: {
                        __typename?: 'StaffRole';
                        createdAt?: any | null;
                        id: any;
                        isDefault: boolean;
                        roleName: string;
                        roleSubtype: string;
                        roleType?: string | null;
                        schemaVersion?: string | null;
                        updatedAt?: any | null;
                        permissions: {
                          __typename?: 'StaffRolePermissions';
                          applicantUserPermissions: {
                            __typename?: 'StaffRoleApplicantUserPermissions';
                            canAddOrRemoveTags: boolean;
                            canBlockAccess: boolean;
                            canSearchApplicants: boolean;
                            canUpdatePersonalInformation: boolean;
                          };
                          credCasePermissions: {
                            __typename?: 'StaffRoleCredCasePermissions';
                            canAssignCaseWorker: boolean;
                            canAssignSelf: boolean;
                            canBeAssignedCases: boolean;
                            canIssueRefunds: boolean;
                            canOverrideCaseState: boolean;
                            canReopenCases: boolean;
                            canSearchCases: boolean;
                            canUnassignCaseWorker: boolean;
                            canUnassignSelf: boolean;
                            canViewCaseHistory: boolean;
                            canViewCasesAssignedToOthers: boolean;
                            canViewUnassignedCases: boolean;
                          };
                          entityPermissions: {
                            __typename?: 'StaffRoleEntityPermissions';
                            canAddEntities: boolean;
                            canDeleteEntities: boolean;
                            canEditEntities: boolean;
                            canSearchEntities: boolean;
                          };
                          idCasePermissions: {
                            __typename?: 'StaffRoleIdCasePermissions';
                            canAssignCaseWorker: boolean;
                            canAssignSelf: boolean;
                            canBeAssignedCases: boolean;
                            canIssueRefunds: boolean;
                            canOverrideCaseState: boolean;
                            canReopenCases: boolean;
                            canSearchCases: boolean;
                            canUnassignCaseWorker: boolean;
                            canUnassignSelf: boolean;
                            canViewCaseHistory: boolean;
                            canViewCasesAssignedToOthers: boolean;
                            canViewUnassignedCases: boolean;
                          };
                          rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                          sendCasePermissions: {
                            __typename?: 'StaffRoleSendCasePermissions';
                            canAssignCaseWorker: boolean;
                            canAssignSelf: boolean;
                            canBeAssignedCases: boolean;
                            canIssueRefunds: boolean;
                            canOverrideCaseState: boolean;
                            canReopenCases: boolean;
                            canSearchCases: boolean;
                            canUnassignCaseWorker: boolean;
                            canUnassignSelf: boolean;
                            canViewCaseHistory: boolean;
                            canViewCasesAssignedToOthers: boolean;
                            canViewUnassignedCases: boolean;
                          };
                          staffUserPermissions: {
                            __typename?: 'StaffRoleStaffUserPermissions';
                            canAddOrRemoveTags: boolean;
                            canAssignRoles: boolean;
                            canBlockAccess: boolean;
                            canSearchStaff: boolean;
                          };
                        };
                      } | null;
                      search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                    } | null;
                  } | null;
                  privateCaseDetails?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails';
                    alternateVerifyingEntity?: {
                      __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity';
                      isVerifiedWithOther?: boolean | null;
                      otherDetails?: string | null;
                    } | null;
                    entitySuppliedCredential?: {
                      __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential';
                      credential?: string | null;
                      credentialUploadedAt?: any | null;
                      credentialVersion?: string | null;
                      translation?: string | null;
                      translationUploadedAt?: any | null;
                      translationVersion?: string | null;
                    } | null;
                    institutionContactDetails?: {
                      __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
                      institutionEmail?: string | null;
                      institutionPhone?: string | null;
                    } | null;
                    verificationStatus?: {
                      __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
                      verificationResponse?: string | null;
                    } | null;
                  } | null;
                  verificationAffirmations?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations';
                    isCredentialReturnedFromEntity?: string | null;
                    isEntityDetailCorrect?: string | null;
                    isReturnedFromCorrectEntity?: string | null;
                    isVerificationComplete?: string | null;
                    isVerificationComponentPacketCompiled?: string | null;
                    isVerificationInEnglishOrWithTranslation?: string | null;
                    isVerificationMethodAcceptable?: string | null;
                    isVerificationStatusComplete?: string | null;
                  } | null;
                } | null;
              } | null;
              revisionRequest?: {
                __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequest';
                requestedAt?: any | null;
                revisionSubmittedAt?: any | null;
                revisionSummary?: string | null;
                requestedBy?: {
                  __typename?: 'StaffUser';
                  accessBlocked?: boolean | null;
                  createdAt?: any | null;
                  displayName?: string | null;
                  emailAddress?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  schemaVersion?: string | null;
                  tags?: Array<string | null> | null;
                } | null;
              } | null;
            } | null> | null;
            files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
            financeDetails?: {
              __typename?: 'CredentialVerificationCaseV1FinanceDetails';
              serviceFee?: number | null;
              financeConfig?: {
                __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
                createdAt?: any | null;
                effectiveAt?: any | null;
                note?: string | null;
                createdBy?: {
                  __typename?: 'StaffUser';
                  accessBlocked?: boolean | null;
                  createdAt?: any | null;
                  displayName?: string | null;
                  emailAddress?: string | null;
                  externalId?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  schemaVersion?: string | null;
                  tags?: Array<string | null> | null;
                } | null;
                glConfig?: {
                  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
                  additionalCharges?: Array<{
                    __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge';
                    createdAt?: any | null;
                    creditGlAccount?: string | null;
                    debitGlAccount?: string | null;
                    id: any;
                    type?: string | null;
                    updatedAt?: any | null;
                  } | null> | null;
                  recognition?: {
                    __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRecognition';
                    creditGlAccount?: string | null;
                    debitGlAccount?: string | null;
                  } | null;
                  refunds?: {
                    __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRefunds';
                    creditGlAccount?: string | null;
                    debitGlAccount?: string | null;
                  } | null;
                  submission?: {
                    __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigSubmission';
                    amount?: number | null;
                    creditGlAccount?: string | null;
                    debitGlAccount?: string | null;
                  } | null;
                } | null;
              } | null;
              revenueRecognition?: {
                __typename?: 'CredentialVerificationCaseV1RevenueRecognition';
                recognition?: {
                  __typename?: 'CredentialVerificationCaseV1RevenueRecognitionRecognition';
                  amount?: number | null;
                  creditGlAccount?: string | null;
                  debitGlAccount?: string | null;
                  recognizedAt?: any | null;
                } | null;
                submission?: {
                  __typename?: 'CredentialVerificationCaseV1RevenueRecognitionSubmission';
                  amount?: number | null;
                  creditGlAccount?: string | null;
                  debitGlAccount?: string | null;
                  recognizedAt?: any | null;
                } | null;
              } | null;
              transactions?: {
                __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
                adhocTransactions?: Array<{
                  __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
                  amount?: number | null;
                  createdAt?: any | null;
                  id: any;
                  reason?: string | null;
                  requestedAt?: any | null;
                  updatedAt?: any | null;
                  requestedBy?: {
                    __typename?: 'StaffUser';
                    accessBlocked?: boolean | null;
                    displayName?: string | null;
                    firstName?: string | null;
                    lastName?: string | null;
                  } | null;
                } | null> | null;
              } | null;
            } | null;
            messages?: Array<{
              __typename?: 'CredentialVerificationCaseV1Message';
              createdAt?: any | null;
              embedding?: string | null;
              id: any;
              initiatedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                emailAddress?: string | null;
                firstName?: string | null;
                lastName?: string | null;
              } | null;
            } | null> | null;
            revisionRequest?: {
              __typename?: 'CredentialVerificationCaseV1RevisionRequest';
              requestedAt?: any | null;
              revisionSubmittedAt?: any | null;
              revisionSummary?: string | null;
              requestedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                displayName?: string | null;
                externalId?: string | null;
                emailAddress?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
              } | null;
            } | null;
            search?: { __typename?: 'CredentialVerificationCaseV1Search'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          destination?: {
            __typename?: 'Entity';
            clientDisabledAt?: any | null;
            createdAt?: any | null;
            disabledAt?: any | null;
            entityName?: string | null;
            entityLanguage?: string | null;
            institutionDisabledAt?: any | null;
            isIssuingInstitution?: boolean | null;
            isClient?: boolean | null;
            client?: {
              __typename?: 'EntityClient';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
              } | null;
            } | null;
          } | null;
        } | null;
        applicationReview?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
          affirmations?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
            isDestinationAcceptable?: string | null;
            isReportCompiled?: string | null;
            isReportSent?: string | null;
            audit?: {
              __typename?: 'SendReportCaseV1AuditType';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                emailAddress?: string | null;
                externalId?: string | null;
                firstName?: string | null;
                id: any;
                lastName?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
                updatedAt?: any | null;
                userType?: string | null;
                role?: {
                  __typename?: 'StaffRole';
                  createdAt?: any | null;
                  id: any;
                  isDefault: boolean;
                  roleName: string;
                  roleSubtype: string;
                  roleType?: string | null;
                  schemaVersion?: string | null;
                  updatedAt?: any | null;
                  permissions: {
                    __typename?: 'StaffRolePermissions';
                    applicantUserPermissions: {
                      __typename?: 'StaffRoleApplicantUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canBlockAccess: boolean;
                      canSearchApplicants: boolean;
                      canUpdatePersonalInformation: boolean;
                    };
                    credCasePermissions: {
                      __typename?: 'StaffRoleCredCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    entityPermissions: {
                      __typename?: 'StaffRoleEntityPermissions';
                      canAddEntities: boolean;
                      canDeleteEntities: boolean;
                      canEditEntities: boolean;
                      canSearchEntities: boolean;
                    };
                    idCasePermissions: {
                      __typename?: 'StaffRoleIdCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                    sendCasePermissions: {
                      __typename?: 'StaffRoleSendCasePermissions';
                      canAssignCaseWorker: boolean;
                      canAssignSelf: boolean;
                      canBeAssignedCases: boolean;
                      canIssueRefunds: boolean;
                      canOverrideCaseState: boolean;
                      canReopenCases: boolean;
                      canSearchCases: boolean;
                      canUnassignCaseWorker: boolean;
                      canUnassignSelf: boolean;
                      canViewCaseHistory: boolean;
                      canViewCasesAssignedToOthers: boolean;
                      canViewUnassignedCases: boolean;
                    };
                    staffUserPermissions: {
                      __typename?: 'StaffRoleStaffUserPermissions';
                      canAddOrRemoveTags: boolean;
                      canAssignRoles: boolean;
                      canBlockAccess: boolean;
                      canSearchStaff: boolean;
                    };
                  };
                } | null;
                search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
              } | null;
            } | null;
          } | null;
          caseWorkerAssigned?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
          decision?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision';
            completedAt?: any | null;
            rejectionReason?: string | null;
            result?: string | null;
            completedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
          } | null;
          privateCaseDetails?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails';
            institutionContactDetails?: {
              __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
              institutionEmail?: string | null;
              institutionPhone?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      revisionRequest?: {
        __typename?: 'SendReportCaseV1RevisionRequest';
        requestedAt?: any | null;
        revisionSubmittedAt?: any | null;
        revisionSummary?: string | null;
        requestedBy?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          id: any;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            id: any;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  caseHistory?: Array<{
    __typename?: 'SendReportCaseV1CaseHistory';
    createdAt?: any | null;
    id: any;
    updatedAt?: any | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      createdAt?: any | null;
      initiatedByApplicant?: boolean | null;
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        attestedAt?: any | null;
        isAttestationComplete?: boolean | null;
        credential?: {
          __typename?: 'CredentialVerificationCaseV1';
          archiveEligibleAt?: any | null;
          caseName?: string | null;
          caseType?: string | null;
          createdAt?: any | null;
          expirationEligibleAt?: any | null;
          id: any;
          isCurrentUserAssigned?: boolean | null;
          lastActivityAt?: any | null;
          purgeEligibleAt?: any | null;
          schemaVersion?: string | null;
          state: string;
          submittedAt?: any | null;
          systemTags?: Array<string | null> | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          activityLog?: Array<{
            __typename?: 'CredentialVerificationCaseV1ActivityLog';
            activityType?: string | null;
            createdAt?: any | null;
            description?: string | null;
            id: any;
            metaData?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            activityBy?: {
              __typename?: 'User';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              externalId?: string | null;
              id: any;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
            } | null;
          } | null> | null;
          applicant?: {
            __typename?: 'ApplicantUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            externalId?: string | null;
            id: any;
            isProfileSubmitted?: boolean | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
            payment?: { __typename?: 'ApplicantUserPayment'; cybersourceCustomerId?: string | null } | null;
            personalInformation?: {
              __typename?: 'ApplicantUserPersonalInformation';
              applyingTo?: Array<{
                __typename?: 'Entity';
                clientDisabledAt?: any | null;
                createdAt?: any | null;
                disabledAt?: any | null;
                entityLanguage?: string | null;
                entityName?: string | null;
                id: any;
                institutionDisabledAt?: any | null;
                isClient?: boolean | null;
                isIssuingInstitution?: boolean | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
                client?: {
                  __typename?: 'EntityClient';
                  email?: string | null;
                  phoneNumber?: string | null;
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                } | null;
                createdBy?: {
                  __typename?: 'StaffUser';
                  accessBlocked?: boolean | null;
                  createdAt?: any | null;
                  displayName?: string | null;
                  emailAddress?: string | null;
                  externalId?: string | null;
                  firstName?: string | null;
                  id: any;
                  lastName?: string | null;
                  schemaVersion?: string | null;
                  tags?: Array<string | null> | null;
                  updatedAt?: any | null;
                  userType?: string | null;
                  role?: {
                    __typename?: 'StaffRole';
                    createdAt?: any | null;
                    id: any;
                    isDefault: boolean;
                    roleName: string;
                    roleSubtype: string;
                    roleType?: string | null;
                    schemaVersion?: string | null;
                    updatedAt?: any | null;
                    permissions: {
                      __typename?: 'StaffRolePermissions';
                      applicantUserPermissions: {
                        __typename?: 'StaffRoleApplicantUserPermissions';
                        canAddOrRemoveTags: boolean;
                        canBlockAccess: boolean;
                        canSearchApplicants: boolean;
                        canUpdatePersonalInformation: boolean;
                      };
                      credCasePermissions: {
                        __typename?: 'StaffRoleCredCasePermissions';
                        canAssignCaseWorker: boolean;
                        canAssignSelf: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canOverrideCaseState: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      entityPermissions: {
                        __typename?: 'StaffRoleEntityPermissions';
                        canAddEntities: boolean;
                        canDeleteEntities: boolean;
                        canEditEntities: boolean;
                        canSearchEntities: boolean;
                      };
                      idCasePermissions: {
                        __typename?: 'StaffRoleIdCasePermissions';
                        canAssignCaseWorker: boolean;
                        canAssignSelf: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canOverrideCaseState: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                      sendCasePermissions: {
                        __typename?: 'StaffRoleSendCasePermissions';
                        canAssignCaseWorker: boolean;
                        canAssignSelf: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canOverrideCaseState: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      staffUserPermissions: {
                        __typename?: 'StaffRoleStaffUserPermissions';
                        canAddOrRemoveTags: boolean;
                        canAssignRoles: boolean;
                        canBlockAccess: boolean;
                        canSearchStaff: boolean;
                      };
                    };
                  } | null;
                  search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                } | null;
                issuingInstitution?: {
                  __typename?: 'EntityIssuingInstitution';
                  email?: string | null;
                  phoneNumber?: string | null;
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                } | null;
              } | null> | null;
              citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
              contactInformation?: {
                __typename?: 'ApplicantUserContactInformation';
                emailAddress?: string | null;
                primaryPhone?: string | null;
                address?: {
                  __typename?: 'ApplicantUserAddress';
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  streetAddressLine1?: string | null;
                  streetAddressLine2?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
                phone?: Array<{
                  __typename?: 'ApplicantUserPhone';
                  createdAt?: any | null;
                  id: any;
                  phoneNumber?: string | null;
                  phoneType?: string | null;
                  updatedAt?: any | null;
                } | null> | null;
              } | null;
              identityDetails?: {
                __typename?: 'ApplicantUserIdentityDetails';
                dateOfBirth?: any | null;
                gender?: string | null;
                generationalSuffix?: string | null;
                lastName?: string | null;
                legalNameConsistsOfOneName?: boolean | null;
                restOfName?: string | null;
              } | null;
              nameOnDocumentAssets?: Array<{
                __typename?: 'ApplicantUserNameOnDocumentAsset';
                createdAt?: any | null;
                documentName?: string | null;
                id: any;
                isDeleteRequested?: boolean | null;
                updatedAt?: any | null;
                uploadedAt?: any | null;
              } | null> | null;
              professional?: {
                __typename?: 'ApplicantUserProfessional';
                citizenshipAtTimeEnteredMedicalInstitution?: string | null;
                healthProfession?: string | null;
                primaryEducationalInformation?: Array<{
                  __typename?: 'ApplicantUserPrimaryEducationalInformation';
                  attendanceEndedAt?: any | null;
                  attendanceStartedAt?: any | null;
                  createdAt?: any | null;
                  degreeIssuedAt?: any | null;
                  degreeTitle?: string | null;
                  graduationYear?: number | null;
                  id: any;
                  updatedAt?: any | null;
                  issuingInstitution?: { __typename?: 'Entity'; entityName?: string | null; id: any } | null;
                  otherIssuingInstitution?: {
                    __typename?: 'ApplicantUserOtherIssuingInstitution';
                    addressLine1?: string | null;
                    city?: string | null;
                    country?: string | null;
                    name?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                } | null> | null;
              } | null;
            } | null;
            search?: { __typename?: 'ApplicantUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            termsAndConditions?: Array<{
              __typename?: 'ApplicantUserTermsAndCondition';
              acceptanceOf?: string | null;
              attestedAt?: any | null;
              createdAt?: any | null;
              id: any;
              updatedAt?: any | null;
              version?: number | null;
            } | null> | null;
          } | null;
          assets?: {
            __typename?: 'CredentialVerificationCaseV1Assets';
            private?: {
              __typename?: 'CredentialVerificationCaseV1AssetsPrivate';
              verificationComponentPacket?: string | null;
              verificationForm?: string | null;
              verificationPacket?: string | null;
              verificationPacketResponse?: string | null;
              verificationComponentPacketHistory?: Array<{
                __typename?: 'CredentialVerificationCaseV1AssetHistory';
                assetVersion?: string | null;
                createdAt?: any | null;
                id: any;
                updatedAt?: any | null;
                assetUploadedBy?: {
                  __typename?: 'StaffUser';
                  accessBlocked?: boolean | null;
                  createdAt?: any | null;
                  displayName?: string | null;
                  emailAddress?: string | null;
                  externalId?: string | null;
                  firstName?: string | null;
                  id: any;
                  lastName?: string | null;
                  schemaVersion?: string | null;
                  tags?: Array<string | null> | null;
                  role?: {
                    __typename?: 'StaffRole';
                    createdAt?: any | null;
                    id: any;
                    roleName: string;
                    roleSubtype: string;
                    roleType?: string | null;
                    schemaVersion?: string | null;
                    updatedAt?: any | null;
                    permissions: {
                      __typename?: 'StaffRolePermissions';
                      applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canAddOrRemoveTags: boolean };
                    };
                  } | null;
                } | null;
              } | null> | null;
              verificationFormHistory?: Array<{
                __typename?: 'CredentialVerificationCaseV1AssetHistory';
                assetVersion?: string | null;
                createdAt?: any | null;
                id: any;
                updatedAt?: any | null;
                assetUploadedBy?: { __typename?: 'StaffUser'; accessBlocked?: boolean | null } | null;
              } | null> | null;
            } | null;
          } | null;
          caseDetails?: {
            __typename?: 'CredentialVerificationCaseV1CaseDetails';
            createdAt?: any | null;
            application?: {
              __typename?: 'CredentialVerificationCaseV1Application';
              attestedAt?: any | null;
              credentialTitle?: string | null;
              credentialType?: string | null;
              dateCredentialIssuedAt?: any | null;
              isAttestationComplete?: boolean | null;
              isCredentialInEnglish?: boolean | null;
              isNameOnCredentialMatchPassport?: boolean | null;
              nameOnCredential?: string | null;
              program?: string | null;
              credentialAssets?: {
                __typename?: 'CredentialVerificationCaseV1CredentialAssets';
                credential?: string | null;
                credentialUploadedAt?: any | null;
                credentialVersion?: string | null;
                translation?: string | null;
                translationUploadedAt?: any | null;
                translationVersion?: string | null;
              } | null;
              issuingInstitution?: {
                __typename?: 'Entity';
                clientDisabledAt?: any | null;
                createdAt?: any | null;
                disabledAt?: any | null;
                entityLanguage?: string | null;
                entityName?: string | null;
                id: any;
                institutionDisabledAt?: any | null;
                isClient?: boolean | null;
                isIssuingInstitution?: boolean | null;
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
                client?: {
                  __typename?: 'EntityClient';
                  email?: string | null;
                  phoneNumber?: string | null;
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                } | null;
                createdBy?: {
                  __typename?: 'StaffUser';
                  accessBlocked?: boolean | null;
                  createdAt?: any | null;
                  displayName?: string | null;
                  emailAddress?: string | null;
                  externalId?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                  id: any;
                  role?: {
                    __typename?: 'StaffRole';
                    createdAt?: any | null;
                    id: any;
                    isDefault: boolean;
                    roleName: string;
                    roleSubtype: string;
                    roleType?: string | null;
                    schemaVersion?: string | null;
                    updatedAt?: any | null;
                    permissions: {
                      __typename?: 'StaffRolePermissions';
                      applicantUserPermissions: {
                        __typename?: 'StaffRoleApplicantUserPermissions';
                        canAddOrRemoveTags: boolean;
                        canBlockAccess: boolean;
                        canSearchApplicants: boolean;
                        canUpdatePersonalInformation: boolean;
                      };
                      credCasePermissions: {
                        __typename?: 'StaffRoleCredCasePermissions';
                        canAssignCaseWorker: boolean;
                        canAssignSelf: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canOverrideCaseState: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      entityPermissions: {
                        __typename?: 'StaffRoleEntityPermissions';
                        canAddEntities: boolean;
                        canDeleteEntities: boolean;
                        canEditEntities: boolean;
                        canSearchEntities: boolean;
                      };
                      idCasePermissions: {
                        __typename?: 'StaffRoleIdCasePermissions';
                        canAssignCaseWorker: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      sendCasePermissions: {
                        __typename?: 'StaffRoleSendCasePermissions';
                        canAssignCaseWorker: boolean;
                        canBeAssignedCases: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                      };
                      staffUserPermissions: {
                        __typename?: 'StaffRoleStaffUserPermissions';
                        canAddOrRemoveTags: boolean;
                        canAssignRoles: boolean;
                        canBlockAccess: boolean;
                        canSearchStaff: boolean;
                      };
                    };
                  } | null;
                } | null;
              } | null;
            } | null;
          } | null;
          caseFlagged?: Array<{
            __typename?: 'CredentialVerificationCaseV1CaseFlagged';
            createdAt?: any | null;
            flagType?: string | null;
            id: any;
            reason?: string | null;
            updatedAt?: any | null;
          } | null> | null;
          caseHistory?: Array<{
            __typename?: 'CredentialVerificationCaseV1CaseHistory';
            createdAt?: any | null;
            id: any;
            updatedAt?: any | null;
            caseDetails?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetails';
              createdAt?: any | null;
              application?: {
                __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplication';
                attestedAt?: any | null;
                credentialTitle?: string | null;
                credentialType?: string | null;
                dateCredentialIssuedAt?: any | null;
                isAttestationComplete?: boolean | null;
                isCredentialInEnglish?: boolean | null;
                isNameOnCredentialMatchPassport?: boolean | null;
                nameOnCredential?: string | null;
                program?: string | null;
                credentialAssets?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationCredentialAssets';
                  credential?: string | null;
                  credentialUploadedAt?: any | null;
                  credentialVersion?: string | null;
                  translation?: string | null;
                  translationUploadedAt?: any | null;
                  translationVersion?: string | null;
                } | null;
                issuingInstitution?: {
                  __typename?: 'Entity';
                  clientDisabledAt?: any | null;
                  createdAt?: any | null;
                  disabledAt?: any | null;
                  entityLanguage?: string | null;
                  entityName?: string | null;
                  institutionDisabledAt?: any | null;
                  isClient?: boolean | null;
                  isIssuingInstitution?: boolean | null;
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                  client?: {
                    __typename?: 'EntityClient';
                    email?: string | null;
                    phoneNumber?: string | null;
                    address?: {
                      __typename?: 'EntityAddressInfo';
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                  } | null;
                } | null;
                otherIssuingInstitution?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationOtherIssuingInstitution';
                  addressLine1?: string | null;
                  city?: string | null;
                  country?: string | null;
                  institutionName?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
                sendDestination?: {
                  __typename?: 'Entity';
                  clientDisabledAt?: any | null;
                  createdAt?: any | null;
                  disabledAt?: any | null;
                  entityName?: string | null;
                  entityLanguage?: string | null;
                  id: any;
                  institutionDisabledAt?: any | null;
                  isClient?: boolean | null;
                  isIssuingInstitution?: boolean | null;
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    city?: string | null;
                    addressLine2?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                  client?: {
                    __typename?: 'EntityClient';
                    email?: string | null;
                    phoneNumber?: string | null;
                    address?: {
                      __typename?: 'EntityAddressInfo';
                      addressLine1?: string | null;
                      addressLine2?: string | null;
                      city?: string | null;
                      country?: string | null;
                      stateOrProvince?: string | null;
                      zipOrPostalCode?: string | null;
                    } | null;
                  } | null;
                } | null;
              } | null;
              applicationReview?: {
                __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReview';
                affirmations?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmations';
                  isCredentialAcceptable?: string | null;
                  isCredentialDetailsAcceptable?: string | null;
                  isCredentialSentForVerification?: string | null;
                  isDateOfBirthAcceptable?: string | null;
                  isEntityAcceptable?: string | null;
                  isNameAcceptable?: string | null;
                  isTranslationAcceptable?: string | null;
                  audit?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewAffirmationsAudit';
                    completedAt?: any | null;
                    result?: string | null;
                    completedBy?: {
                      __typename?: 'StaffUser';
                      accessBlocked?: boolean | null;
                      createdAt?: any | null;
                      displayName?: string | null;
                      emailAddress?: string | null;
                      externalId?: string | null;
                      firstName?: string | null;
                      id: any;
                      lastName?: string | null;
                      schemaVersion?: string | null;
                      tags?: Array<string | null> | null;
                      updatedAt?: any | null;
                      userType?: string | null;
                      role?: {
                        __typename?: 'StaffRole';
                        createdAt?: any | null;
                        id: any;
                        isDefault: boolean;
                        roleName: string;
                        roleSubtype: string;
                        roleType?: string | null;
                        schemaVersion?: string | null;
                        updatedAt?: any | null;
                        permissions: {
                          __typename?: 'StaffRolePermissions';
                          applicantUserPermissions: {
                            __typename?: 'StaffRoleApplicantUserPermissions';
                            canAddOrRemoveTags: boolean;
                            canBlockAccess: boolean;
                            canSearchApplicants: boolean;
                            canUpdatePersonalInformation: boolean;
                          };
                          credCasePermissions: {
                            __typename?: 'StaffRoleCredCasePermissions';
                            canAssignCaseWorker: boolean;
                            canAssignSelf: boolean;
                            canBeAssignedCases: boolean;
                            canIssueRefunds: boolean;
                            canOverrideCaseState: boolean;
                            canReopenCases: boolean;
                            canSearchCases: boolean;
                            canUnassignCaseWorker: boolean;
                            canUnassignSelf: boolean;
                            canViewCaseHistory: boolean;
                            canViewCasesAssignedToOthers: boolean;
                            canViewUnassignedCases: boolean;
                          };
                          entityPermissions: {
                            __typename?: 'StaffRoleEntityPermissions';
                            canAddEntities: boolean;
                            canDeleteEntities: boolean;
                            canEditEntities: boolean;
                            canSearchEntities: boolean;
                          };
                          idCasePermissions: {
                            __typename?: 'StaffRoleIdCasePermissions';
                            canAssignCaseWorker: boolean;
                            canAssignSelf: boolean;
                            canBeAssignedCases: boolean;
                            canIssueRefunds: boolean;
                            canOverrideCaseState: boolean;
                            canReopenCases: boolean;
                            canSearchCases: boolean;
                            canUnassignCaseWorker: boolean;
                            canUnassignSelf: boolean;
                            canViewCaseHistory: boolean;
                            canViewCasesAssignedToOthers: boolean;
                            canViewUnassignedCases: boolean;
                          };
                          rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                          sendCasePermissions: {
                            __typename?: 'StaffRoleSendCasePermissions';
                            canAssignCaseWorker: boolean;
                            canAssignSelf: boolean;
                            canBeAssignedCases: boolean;
                            canIssueRefunds: boolean;
                            canOverrideCaseState: boolean;
                            canReopenCases: boolean;
                            canSearchCases: boolean;
                            canUnassignCaseWorker: boolean;
                            canUnassignSelf: boolean;
                            canViewCaseHistory: boolean;
                            canViewCasesAssignedToOthers: boolean;
                            canViewUnassignedCases: boolean;
                          };
                          staffUserPermissions: {
                            __typename?: 'StaffRoleStaffUserPermissions';
                            canAddOrRemoveTags: boolean;
                            canAssignRoles: boolean;
                            canBlockAccess: boolean;
                            canSearchStaff: boolean;
                          };
                        };
                      } | null;
                      search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                    } | null;
                  } | null;
                } | null;
                caseWorkerAssigned?: {
                  __typename?: 'StaffUser';
                  accessBlocked?: boolean | null;
                  createdAt?: any | null;
                  displayName?: string | null;
                  emailAddress?: string | null;
                  externalId?: string | null;
                  firstName?: string | null;
                  id: any;
                  lastName?: string | null;
                  schemaVersion?: string | null;
                  tags?: Array<string | null> | null;
                  updatedAt?: any | null;
                  userType?: string | null;
                  role?: {
                    __typename?: 'StaffRole';
                    createdAt?: any | null;
                    id: any;
                    isDefault: boolean;
                    roleName: string;
                    roleSubtype: string;
                    roleType?: string | null;
                    schemaVersion?: string | null;
                    updatedAt?: any | null;
                    permissions: {
                      __typename?: 'StaffRolePermissions';
                      applicantUserPermissions: {
                        __typename?: 'StaffRoleApplicantUserPermissions';
                        canAddOrRemoveTags: boolean;
                        canBlockAccess: boolean;
                        canSearchApplicants: boolean;
                        canUpdatePersonalInformation: boolean;
                      };
                      credCasePermissions: {
                        __typename?: 'StaffRoleCredCasePermissions';
                        canAssignCaseWorker: boolean;
                        canAssignSelf: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canOverrideCaseState: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      entityPermissions: {
                        __typename?: 'StaffRoleEntityPermissions';
                        canAddEntities: boolean;
                        canDeleteEntities: boolean;
                        canEditEntities: boolean;
                        canSearchEntities: boolean;
                      };
                      idCasePermissions: {
                        __typename?: 'StaffRoleIdCasePermissions';
                        canAssignCaseWorker: boolean;
                        canAssignSelf: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canOverrideCaseState: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                      sendCasePermissions: {
                        __typename?: 'StaffRoleSendCasePermissions';
                        canAssignCaseWorker: boolean;
                        canAssignSelf: boolean;
                        canBeAssignedCases: boolean;
                        canIssueRefunds: boolean;
                        canOverrideCaseState: boolean;
                        canReopenCases: boolean;
                        canSearchCases: boolean;
                        canUnassignCaseWorker: boolean;
                        canUnassignSelf: boolean;
                        canViewCaseHistory: boolean;
                        canViewCasesAssignedToOthers: boolean;
                        canViewUnassignedCases: boolean;
                      };
                      staffUserPermissions: {
                        __typename?: 'StaffRoleStaffUserPermissions';
                        canAddOrRemoveTags: boolean;
                        canAssignRoles: boolean;
                        canBlockAccess: boolean;
                        canSearchStaff: boolean;
                      };
                    };
                  } | null;
                  search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                } | null;
                decision?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewDecision';
                  completedAt?: any | null;
                  rejectionReason?: string | null;
                  result?: string | null;
                  completedBy?: {
                    __typename?: 'StaffUser';
                    accessBlocked?: boolean | null;
                    createdAt?: any | null;
                    displayName?: string | null;
                    emailAddress?: string | null;
                    externalId?: string | null;
                    firstName?: string | null;
                    id: any;
                    lastName?: string | null;
                    schemaVersion?: string | null;
                    tags?: Array<string | null> | null;
                    updatedAt?: any | null;
                    userType?: string | null;
                    role?: {
                      __typename?: 'StaffRole';
                      createdAt?: any | null;
                      id: any;
                      isDefault: boolean;
                      roleName: string;
                      roleSubtype: string;
                      roleType?: string | null;
                      schemaVersion?: string | null;
                      updatedAt?: any | null;
                      permissions: {
                        __typename?: 'StaffRolePermissions';
                        applicantUserPermissions: {
                          __typename?: 'StaffRoleApplicantUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canBlockAccess: boolean;
                          canSearchApplicants: boolean;
                          canUpdatePersonalInformation: boolean;
                        };
                        credCasePermissions: {
                          __typename?: 'StaffRoleCredCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        entityPermissions: {
                          __typename?: 'StaffRoleEntityPermissions';
                          canAddEntities: boolean;
                          canDeleteEntities: boolean;
                          canEditEntities: boolean;
                          canSearchEntities: boolean;
                        };
                        idCasePermissions: {
                          __typename?: 'StaffRoleIdCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                        sendCasePermissions: {
                          __typename?: 'StaffRoleSendCasePermissions';
                          canAssignCaseWorker: boolean;
                          canAssignSelf: boolean;
                          canBeAssignedCases: boolean;
                          canIssueRefunds: boolean;
                          canOverrideCaseState: boolean;
                          canReopenCases: boolean;
                          canSearchCases: boolean;
                          canUnassignCaseWorker: boolean;
                          canUnassignSelf: boolean;
                          canViewCaseHistory: boolean;
                          canViewCasesAssignedToOthers: boolean;
                          canViewUnassignedCases: boolean;
                        };
                        staffUserPermissions: {
                          __typename?: 'StaffRoleStaffUserPermissions';
                          canAddOrRemoveTags: boolean;
                          canAssignRoles: boolean;
                          canBlockAccess: boolean;
                          canSearchStaff: boolean;
                        };
                      };
                    } | null;
                    search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
                  } | null;
                } | null;
                privateCaseDetails?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetails';
                  alternateVerifyingEntity?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsAlternateVerifyingEntity';
                    isVerifiedWithOther?: boolean | null;
                    otherDetails?: string | null;
                  } | null;
                  entitySuppliedCredential?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsEntitySuppliedCredential';
                    credential?: string | null;
                    credentialUploadedAt?: any | null;
                    credentialVersion?: string | null;
                    translation?: string | null;
                    translationUploadedAt?: any | null;
                    translationVersion?: string | null;
                  } | null;
                  institutionContactDetails?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
                    institutionEmail?: string | null;
                    institutionPhone?: string | null;
                  } | null;
                  verificationStatus?: {
                    __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewPrivateCaseDetailsVerificationStatus';
                    verificationResponse?: string | null;
                  } | null;
                } | null;
                verificationAffirmations?: {
                  __typename?: 'CredentialVerificationCaseV1CaseHistoryCaseDetailsApplicationReviewVerificationAffirmations';
                  isCredentialReturnedFromEntity?: string | null;
                  isEntityDetailCorrect?: string | null;
                  isReturnedFromCorrectEntity?: string | null;
                  isVerificationComplete?: string | null;
                  isVerificationComponentPacketCompiled?: string | null;
                  isVerificationInEnglishOrWithTranslation?: string | null;
                  isVerificationMethodAcceptable?: string | null;
                  isVerificationStatusComplete?: string | null;
                } | null;
              } | null;
            } | null;
            revisionRequest?: {
              __typename?: 'CredentialVerificationCaseV1CaseHistoryRevisionRequest';
              requestedAt?: any | null;
              revisionSubmittedAt?: any | null;
              revisionSummary?: string | null;
              requestedBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                emailAddress?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
              } | null;
            } | null;
          } | null> | null;
          files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
          financeDetails?: {
            __typename?: 'CredentialVerificationCaseV1FinanceDetails';
            serviceFee?: number | null;
            financeConfig?: {
              __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig';
              createdAt?: any | null;
              effectiveAt?: any | null;
              note?: string | null;
              createdBy?: {
                __typename?: 'StaffUser';
                accessBlocked?: boolean | null;
                createdAt?: any | null;
                displayName?: string | null;
                emailAddress?: string | null;
                externalId?: string | null;
                firstName?: string | null;
                lastName?: string | null;
                schemaVersion?: string | null;
                tags?: Array<string | null> | null;
              } | null;
              glConfig?: {
                __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfig';
                additionalCharges?: Array<{
                  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge';
                  createdAt?: any | null;
                  creditGlAccount?: string | null;
                  debitGlAccount?: string | null;
                  id: any;
                  type?: string | null;
                  updatedAt?: any | null;
                } | null> | null;
                recognition?: {
                  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRecognition';
                  creditGlAccount?: string | null;
                  debitGlAccount?: string | null;
                } | null;
                refunds?: {
                  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigRefunds';
                  creditGlAccount?: string | null;
                  debitGlAccount?: string | null;
                } | null;
                submission?: {
                  __typename?: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfigGLConfigSubmission';
                  amount?: number | null;
                  creditGlAccount?: string | null;
                  debitGlAccount?: string | null;
                } | null;
              } | null;
            } | null;
            revenueRecognition?: {
              __typename?: 'CredentialVerificationCaseV1RevenueRecognition';
              recognition?: {
                __typename?: 'CredentialVerificationCaseV1RevenueRecognitionRecognition';
                amount?: number | null;
                creditGlAccount?: string | null;
                debitGlAccount?: string | null;
                recognizedAt?: any | null;
              } | null;
              submission?: {
                __typename?: 'CredentialVerificationCaseV1RevenueRecognitionSubmission';
                amount?: number | null;
                creditGlAccount?: string | null;
                debitGlAccount?: string | null;
                recognizedAt?: any | null;
              } | null;
            } | null;
            transactions?: {
              __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactions';
              adhocTransactions?: Array<{
                __typename?: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions';
                amount?: number | null;
                createdAt?: any | null;
                id: any;
                reason?: string | null;
                requestedAt?: any | null;
                updatedAt?: any | null;
                requestedBy?: {
                  __typename?: 'StaffUser';
                  accessBlocked?: boolean | null;
                  displayName?: string | null;
                  firstName?: string | null;
                  lastName?: string | null;
                } | null;
              } | null> | null;
            } | null;
          } | null;
          messages?: Array<{
            __typename?: 'CredentialVerificationCaseV1Message';
            createdAt?: any | null;
            embedding?: string | null;
            id: any;
            initiatedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              emailAddress?: string | null;
              firstName?: string | null;
              lastName?: string | null;
            } | null;
          } | null> | null;
          revisionRequest?: {
            __typename?: 'CredentialVerificationCaseV1RevisionRequest';
            requestedAt?: any | null;
            revisionSubmittedAt?: any | null;
            revisionSummary?: string | null;
            requestedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              displayName?: string | null;
              externalId?: string | null;
              emailAddress?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
            } | null;
          } | null;
          search?: { __typename?: 'CredentialVerificationCaseV1Search'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        destination?: {
          __typename?: 'Entity';
          clientDisabledAt?: any | null;
          createdAt?: any | null;
          disabledAt?: any | null;
          entityName?: string | null;
          entityLanguage?: string | null;
          institutionDisabledAt?: any | null;
          isIssuingInstitution?: boolean | null;
          isClient?: boolean | null;
          client?: {
            __typename?: 'EntityClient';
            address?: {
              __typename?: 'EntityAddressInfo';
              addressLine1?: string | null;
              addressLine2?: string | null;
              city?: string | null;
              country?: string | null;
              stateOrProvince?: string | null;
            } | null;
          } | null;
        } | null;
      } | null;
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
          isDestinationAcceptable?: string | null;
          isReportCompiled?: string | null;
          isReportSent?: string | null;
          audit?: {
            __typename?: 'SendReportCaseV1AuditType';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: {
              __typename?: 'StaffUser';
              accessBlocked?: boolean | null;
              createdAt?: any | null;
              displayName?: string | null;
              emailAddress?: string | null;
              externalId?: string | null;
              firstName?: string | null;
              id: any;
              lastName?: string | null;
              schemaVersion?: string | null;
              tags?: Array<string | null> | null;
              updatedAt?: any | null;
              userType?: string | null;
              role?: {
                __typename?: 'StaffRole';
                createdAt?: any | null;
                id: any;
                isDefault: boolean;
                roleName: string;
                roleSubtype: string;
                roleType?: string | null;
                schemaVersion?: string | null;
                updatedAt?: any | null;
                permissions: {
                  __typename?: 'StaffRolePermissions';
                  applicantUserPermissions: {
                    __typename?: 'StaffRoleApplicantUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canBlockAccess: boolean;
                    canSearchApplicants: boolean;
                    canUpdatePersonalInformation: boolean;
                  };
                  credCasePermissions: {
                    __typename?: 'StaffRoleCredCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  entityPermissions: {
                    __typename?: 'StaffRoleEntityPermissions';
                    canAddEntities: boolean;
                    canDeleteEntities: boolean;
                    canEditEntities: boolean;
                    canSearchEntities: boolean;
                  };
                  idCasePermissions: {
                    __typename?: 'StaffRoleIdCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                  sendCasePermissions: {
                    __typename?: 'StaffRoleSendCasePermissions';
                    canAssignCaseWorker: boolean;
                    canAssignSelf: boolean;
                    canBeAssignedCases: boolean;
                    canIssueRefunds: boolean;
                    canOverrideCaseState: boolean;
                    canReopenCases: boolean;
                    canSearchCases: boolean;
                    canUnassignCaseWorker: boolean;
                    canUnassignSelf: boolean;
                    canViewCaseHistory: boolean;
                    canViewCasesAssignedToOthers: boolean;
                    canViewUnassignedCases: boolean;
                  };
                  staffUserPermissions: {
                    __typename?: 'StaffRoleStaffUserPermissions';
                    canAddOrRemoveTags: boolean;
                    canAssignRoles: boolean;
                    canBlockAccess: boolean;
                    canSearchStaff: boolean;
                  };
                };
              } | null;
              search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
            } | null;
          } | null;
        } | null;
        caseWorkerAssigned?: {
          __typename?: 'StaffUser';
          accessBlocked?: boolean | null;
          createdAt?: any | null;
          displayName?: string | null;
          emailAddress?: string | null;
          externalId?: string | null;
          firstName?: string | null;
          id: any;
          lastName?: string | null;
          schemaVersion?: string | null;
          tags?: Array<string | null> | null;
          updatedAt?: any | null;
          userType?: string | null;
          role?: {
            __typename?: 'StaffRole';
            createdAt?: any | null;
            id: any;
            isDefault: boolean;
            roleName: string;
            roleSubtype: string;
            roleType?: string | null;
            schemaVersion?: string | null;
            updatedAt?: any | null;
            permissions: {
              __typename?: 'StaffRolePermissions';
              applicantUserPermissions: {
                __typename?: 'StaffRoleApplicantUserPermissions';
                canAddOrRemoveTags: boolean;
                canBlockAccess: boolean;
                canSearchApplicants: boolean;
                canUpdatePersonalInformation: boolean;
              };
              credCasePermissions: {
                __typename?: 'StaffRoleCredCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              entityPermissions: {
                __typename?: 'StaffRoleEntityPermissions';
                canAddEntities: boolean;
                canDeleteEntities: boolean;
                canEditEntities: boolean;
                canSearchEntities: boolean;
              };
              idCasePermissions: {
                __typename?: 'StaffRoleIdCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
              sendCasePermissions: {
                __typename?: 'StaffRoleSendCasePermissions';
                canAssignCaseWorker: boolean;
                canAssignSelf: boolean;
                canBeAssignedCases: boolean;
                canIssueRefunds: boolean;
                canOverrideCaseState: boolean;
                canReopenCases: boolean;
                canSearchCases: boolean;
                canUnassignCaseWorker: boolean;
                canUnassignSelf: boolean;
                canViewCaseHistory: boolean;
                canViewCasesAssignedToOthers: boolean;
                canViewUnassignedCases: boolean;
              };
              staffUserPermissions: {
                __typename?: 'StaffRoleStaffUserPermissions';
                canAddOrRemoveTags: boolean;
                canAssignRoles: boolean;
                canBlockAccess: boolean;
                canSearchStaff: boolean;
              };
            };
          } | null;
          search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
        } | null;
        decision?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewDecision';
          completedAt?: any | null;
          rejectionReason?: string | null;
          result?: string | null;
          completedBy?: {
            __typename?: 'StaffUser';
            accessBlocked?: boolean | null;
            createdAt?: any | null;
            displayName?: string | null;
            emailAddress?: string | null;
            externalId?: string | null;
            firstName?: string | null;
            id: any;
            lastName?: string | null;
            schemaVersion?: string | null;
            tags?: Array<string | null> | null;
            updatedAt?: any | null;
            userType?: string | null;
            role?: {
              __typename?: 'StaffRole';
              createdAt?: any | null;
              id: any;
              isDefault: boolean;
              roleName: string;
              roleSubtype: string;
              roleType?: string | null;
              schemaVersion?: string | null;
              updatedAt?: any | null;
              permissions: {
                __typename?: 'StaffRolePermissions';
                applicantUserPermissions: {
                  __typename?: 'StaffRoleApplicantUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canBlockAccess: boolean;
                  canSearchApplicants: boolean;
                  canUpdatePersonalInformation: boolean;
                };
                credCasePermissions: {
                  __typename?: 'StaffRoleCredCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                entityPermissions: {
                  __typename?: 'StaffRoleEntityPermissions';
                  canAddEntities: boolean;
                  canDeleteEntities: boolean;
                  canEditEntities: boolean;
                  canSearchEntities: boolean;
                };
                idCasePermissions: {
                  __typename?: 'StaffRoleIdCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
                sendCasePermissions: {
                  __typename?: 'StaffRoleSendCasePermissions';
                  canAssignCaseWorker: boolean;
                  canAssignSelf: boolean;
                  canBeAssignedCases: boolean;
                  canIssueRefunds: boolean;
                  canOverrideCaseState: boolean;
                  canReopenCases: boolean;
                  canSearchCases: boolean;
                  canUnassignCaseWorker: boolean;
                  canUnassignSelf: boolean;
                  canViewCaseHistory: boolean;
                  canViewCasesAssignedToOthers: boolean;
                  canViewUnassignedCases: boolean;
                };
                staffUserPermissions: {
                  __typename?: 'StaffRoleStaffUserPermissions';
                  canAddOrRemoveTags: boolean;
                  canAssignRoles: boolean;
                  canBlockAccess: boolean;
                  canSearchStaff: boolean;
                };
              };
            } | null;
            search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
          } | null;
        } | null;
        privateCaseDetails?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetails';
          institutionContactDetails?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewPrivateCaseDetailsInstitutionContactDetails';
            institutionEmail?: string | null;
            institutionPhone?: string | null;
          } | null;
        } | null;
      } | null;
    } | null;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      requestedAt?: any | null;
      revisionSubmittedAt?: any | null;
      revisionSummary?: string | null;
      requestedBy?: {
        __typename?: 'StaffUser';
        accessBlocked?: boolean | null;
        createdAt?: any | null;
        displayName?: string | null;
        emailAddress?: string | null;
        externalId?: string | null;
        firstName?: string | null;
        id: any;
        lastName?: string | null;
        schemaVersion?: string | null;
        tags?: Array<string | null> | null;
        updatedAt?: any | null;
        userType?: string | null;
        role?: {
          __typename?: 'StaffRole';
          createdAt?: any | null;
          id: any;
          isDefault: boolean;
          roleName: string;
          roleSubtype: string;
          roleType?: string | null;
          schemaVersion?: string | null;
          updatedAt?: any | null;
          permissions: {
            __typename?: 'StaffRolePermissions';
            applicantUserPermissions: {
              __typename?: 'StaffRoleApplicantUserPermissions';
              canAddOrRemoveTags: boolean;
              canBlockAccess: boolean;
              canSearchApplicants: boolean;
              canUpdatePersonalInformation: boolean;
            };
            credCasePermissions: {
              __typename?: 'StaffRoleCredCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            entityPermissions: {
              __typename?: 'StaffRoleEntityPermissions';
              canAddEntities: boolean;
              canDeleteEntities: boolean;
              canEditEntities: boolean;
              canSearchEntities: boolean;
            };
            idCasePermissions: {
              __typename?: 'StaffRoleIdCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
            sendCasePermissions: {
              __typename?: 'StaffRoleSendCasePermissions';
              canAssignCaseWorker: boolean;
              canAssignSelf: boolean;
              canBeAssignedCases: boolean;
              canIssueRefunds: boolean;
              canOverrideCaseState: boolean;
              canReopenCases: boolean;
              canSearchCases: boolean;
              canUnassignCaseWorker: boolean;
              canUnassignSelf: boolean;
              canViewCaseHistory: boolean;
              canViewCasesAssignedToOthers: boolean;
              canViewUnassignedCases: boolean;
            };
            staffUserPermissions: {
              __typename?: 'StaffRoleStaffUserPermissions';
              canAddOrRemoveTags: boolean;
              canAssignRoles: boolean;
              canBlockAccess: boolean;
              canSearchStaff: boolean;
            };
          };
        } | null;
        search?: { __typename?: 'StaffUserSearch'; hash?: string | null; indexedAt?: any | null; indexingFailedAt?: any | null } | null;
      } | null;
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
  } | null> | null;
};

export type CasesSendReportCaseInfoHeaderContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    submittedAt?: any | null;
    expirationEligibleAt?: any | null;
    lastActivityAt?: any | null;
    id: any;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesSendReportCaseInfoHeaderContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  submittedAt?: any | null;
  expirationEligibleAt?: any | null;
  lastActivityAt?: any | null;
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
  fileName: Scalars['String']['input'];
}>;

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    expirationEligibleAt?: any | null;
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
          audit?: {
            __typename?: 'SendReportCaseV1AuditType';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'SendReportCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesSendReportV1ChangeStatusContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesSendReportV1ChangeStatusContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      roleName: string;
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canReopenCases: boolean } };
    } | null;
  } | null;
};

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      expirationEligibleAt?: any | null;
      id: any;
      caseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
          affirmations?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
            audit?: {
              __typename?: 'SendReportCaseV1AuditType';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
            } | null;
          } | null;
        } | null;
      } | null;
      activityLog?: Array<{
        __typename?: 'SendReportCaseV1ActivityLog';
        activityType?: string | null;
        description?: string | null;
        metaData?: string | null;
        tags?: Array<string | null> | null;
        id: any;
        createdAt?: any | null;
        updatedAt?: any | null;
        activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
      } | null> | null;
    } | null;
  };
};

export type CasesSendReportV1ChangeStatusContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    roleName: string;
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canReopenCases: boolean } };
  } | null;
};

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  expirationEligibleAt?: any | null;
  id: any;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
        audit?: {
          __typename?: 'SendReportCaseV1AuditType';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
        } | null;
      } | null;
    } | null;
  } | null;
  activityLog?: Array<{
    __typename?: 'SendReportCaseV1ActivityLog';
    activityType?: string | null;
    description?: string | null;
    metaData?: string | null;
    tags?: Array<string | null> | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
  } | null> | null;
};

export type CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFieldsFragment = {
  __typename?: 'SendReportCaseV1ActivityLog';
  activityType?: string | null;
  description?: string | null;
  metaData?: string | null;
  tags?: Array<string | null> | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
};

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    expirationEligibleAt?: any | null;
    id: any;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
          audit?: {
            __typename?: 'SendReportCaseV1AuditType';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
          } | null;
        } | null;
      } | null;
    } | null;
    activityLog?: Array<{
      __typename?: 'SendReportCaseV1ActivityLog';
      activityType?: string | null;
      description?: string | null;
      metaData?: string | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      activityBy?: { __typename?: 'User'; displayName?: string | null; id: any } | null;
    } | null> | null;
  } | null;
};

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
    affirmations?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
      audit?: {
        __typename?: 'SendReportCaseV1AuditType';
        completedAt?: any | null;
        result?: string | null;
        completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1ChangeStatusContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string };

export type CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFieldsFragment = {
  __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
  affirmations?: {
    __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
    audit?: {
      __typename?: 'SendReportCaseV1AuditType';
      completedAt?: any | null;
      result?: string | null;
      completedBy?: { __typename?: 'StaffUser'; displayName?: string | null; id: any } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1ChatPageContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      revisionSubmittedAt?: any | null;
      requestedAt?: any | null;
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
    messages?: Array<{
      __typename?: 'SendReportCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      createdAt?: any | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
    } | null> | null;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      financeConfig?: {
        __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
        glConfig?: {
          __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
          additionalCharges?: Array<{ __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
        } | null;
      } | null;
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        submission?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission'; amount?: number | null } | null;
        adhocTransactions?: Array<{
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          createdAt?: any | null;
          id: any;
          transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
          approval?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval'; isApplicantApproved?: boolean | null } | null;
        } | null> | null;
      } | null;
    } | null;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesSendReportV1ChatPageContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesSendReportV1ChatPageContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canIssueRefunds: boolean } };
    } | null;
  } | null;
};

export type CasesSendReportV1ChatPageContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canIssueRefunds: boolean } };
  } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1ChatPageContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      id: any;
      revisionRequest?: {
        __typename?: 'SendReportCaseV1RevisionRequest';
        revisionSubmittedAt?: any | null;
        requestedAt?: any | null;
        requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
      } | null;
      messages?: Array<{
        __typename?: 'SendReportCaseV1Message';
        isHiddenFromApplicant?: boolean | null;
        sentBy?: string | null;
        createdAt?: any | null;
        embedding?: string | null;
        message?: string | null;
        id: any;
      } | null> | null;
      financeDetails?: {
        __typename?: 'SendReportCaseV1FinanceDetails';
        financeConfig?: {
          __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
          glConfig?: {
            __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
            additionalCharges?: Array<{ __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
          } | null;
        } | null;
        transactions?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
          submission?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission'; amount?: number | null } | null;
          adhocTransactions?: Array<{
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
            reason?: string | null;
            amount?: number | null;
            createdAt?: any | null;
            id: any;
            transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
            approval?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval'; isApplicantApproved?: boolean | null } | null;
          } | null> | null;
        } | null;
      } | null;
      applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
    } | null;
  };
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    revisionRequest?: {
      __typename?: 'SendReportCaseV1RevisionRequest';
      revisionSubmittedAt?: any | null;
      requestedAt?: any | null;
      requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
    } | null;
    messages?: Array<{
      __typename?: 'SendReportCaseV1Message';
      isHiddenFromApplicant?: boolean | null;
      sentBy?: string | null;
      createdAt?: any | null;
      embedding?: string | null;
      message?: string | null;
      id: any;
    } | null> | null;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      financeConfig?: {
        __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
        glConfig?: {
          __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
          additionalCharges?: Array<{ __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
        } | null;
      } | null;
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        submission?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission'; amount?: number | null } | null;
        adhocTransactions?: Array<{
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
          reason?: string | null;
          amount?: number | null;
          createdAt?: any | null;
          id: any;
          transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
          approval?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval'; isApplicantApproved?: boolean | null } | null;
        } | null> | null;
      } | null;
    } | null;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  id: any;
  revisionRequest?: {
    __typename?: 'SendReportCaseV1RevisionRequest';
    revisionSubmittedAt?: any | null;
    requestedAt?: any | null;
    requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
  } | null;
  messages?: Array<{
    __typename?: 'SendReportCaseV1Message';
    isHiddenFromApplicant?: boolean | null;
    sentBy?: string | null;
    createdAt?: any | null;
    embedding?: string | null;
    message?: string | null;
    id: any;
  } | null> | null;
  financeDetails?: {
    __typename?: 'SendReportCaseV1FinanceDetails';
    financeConfig?: {
      __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
      glConfig?: {
        __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
        additionalCharges?: Array<{ __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
      } | null;
    } | null;
    transactions?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
      submission?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission'; amount?: number | null } | null;
      adhocTransactions?: Array<{
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
        reason?: string | null;
        amount?: number | null;
        createdAt?: any | null;
        id: any;
        transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
        approval?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval'; isApplicantApproved?: boolean | null } | null;
      } | null> | null;
    } | null;
  } | null;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFieldsFragment = {
  __typename?: 'SendReportCaseV1RevisionRequest';
  revisionSubmittedAt?: any | null;
  requestedAt?: any | null;
  requestedChanges?: { __typename?: 'SendReportCaseV1RevisionRequestRequestChanges'; requestUpdatedDestination?: boolean | null } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetails';
  financeConfig?: {
    __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
    glConfig?: {
      __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
      additionalCharges?: Array<{ __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
    } | null;
  } | null;
  transactions?: {
    __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
    submission?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission'; amount?: number | null } | null;
    adhocTransactions?: Array<{
      __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
      reason?: string | null;
      amount?: number | null;
      createdAt?: any | null;
      id: any;
      transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
      approval?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval'; isApplicantApproved?: boolean | null } | null;
    } | null> | null;
  } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfig';
  glConfig?: {
    __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfig';
    additionalCharges?: Array<{ __typename?: 'SendReportCaseV1FinanceDetailsFinanceConfigGLConfigAdditionalCharge'; type?: string | null } | null> | null;
  } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
  submission?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission'; amount?: number | null } | null;
  adhocTransactions?: Array<{
    __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
    reason?: string | null;
    amount?: number | null;
    createdAt?: any | null;
    id: any;
    transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
    approval?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval'; isApplicantApproved?: boolean | null } | null;
  } | null> | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
  reason?: string | null;
  amount?: number | null;
  createdAt?: any | null;
  id: any;
  transactionReference?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference'; referenceId?: string | null } | null;
  approval?: { __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval'; isApplicantApproved?: boolean | null } | null;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFieldsFragment = {
  __typename?: 'SendReportCaseV1Message';
  isHiddenFromApplicant?: boolean | null;
  sentBy?: string | null;
  createdAt?: any | null;
  embedding?: string | null;
  message?: string | null;
  id: any;
};

export type CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFieldsFragment = {
  __typename?: 'SendReportCaseV1RevisionRequestRequestChanges';
  requestUpdatedDestination?: boolean | null;
};

export type CasesSendReportV1ChecklistContainerSendReportCaseV1QueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1ChecklistContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
          isDestinationAcceptable?: string | null;
          isReportCompiled?: string | null;
          isReportSent?: string | null;
          audit?: {
            __typename?: 'SendReportCaseV1AuditType';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1ChecklistContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1ChecklistContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      state: string;
      isCurrentUserAssigned?: boolean | null;
      id: any;
      caseDetails?: {
        __typename?: 'SendReportCaseV1CaseDetails';
        applicationReview?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
          affirmations?: {
            __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
            isDestinationAcceptable?: string | null;
            isReportCompiled?: string | null;
            isReportSent?: string | null;
            audit?: {
              __typename?: 'SendReportCaseV1AuditType';
              completedAt?: any | null;
              result?: string | null;
              completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
            } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  };
};

export type CasesSendReportV1ChecklistContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    state: string;
    isCurrentUserAssigned?: boolean | null;
    id: any;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      applicationReview?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
        affirmations?: {
          __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
          isDestinationAcceptable?: string | null;
          isReportCompiled?: string | null;
          isReportSent?: string | null;
          audit?: {
            __typename?: 'SendReportCaseV1AuditType';
            completedAt?: any | null;
            result?: string | null;
            completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
          } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1ChecklistContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  state: string;
  isCurrentUserAssigned?: boolean | null;
  id: any;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    applicationReview?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplicationReview';
      affirmations?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplicationReviewAffirmation';
        isDestinationAcceptable?: string | null;
        isReportCompiled?: string | null;
        isReportSent?: string | null;
        audit?: {
          __typename?: 'SendReportCaseV1AuditType';
          completedAt?: any | null;
          result?: string | null;
          completedBy?: { __typename?: 'StaffUser'; displayName?: string | null } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    applicant?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          generationalSuffix?: string | null;
          lastName?: string | null;
          legalNameConsistsOfOneName?: boolean | null;
          restOfName?: string | null;
        } | null;
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          primaryPhone?: string | null;
          emailAddress?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
        } | null;
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            degreeTitle?: string | null;
            attendanceStartedAt?: any | null;
            attendanceEndedAt?: any | null;
            degreeIssuedAt?: any | null;
            graduationYear?: number | null;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              zipOrPostalCode?: string | null;
              stateOrProvince?: string | null;
              name?: string | null;
              country?: string | null;
              city?: string | null;
              addressLine1?: string | null;
            } | null;
          } | null> | null;
        } | null;
        applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  applicant?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        primaryPhone?: string | null;
        emailAddress?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; updatedAt?: any | null; id: any } | null> | null;
      } | null;
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          degreeTitle?: string | null;
          attendanceStartedAt?: any | null;
          attendanceEndedAt?: any | null;
          degreeIssuedAt?: any | null;
          graduationYear?: number | null;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                addressLine2?: string | null;
                city?: string | null;
                country?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            zipOrPostalCode?: string | null;
            stateOrProvince?: string | null;
            name?: string | null;
            country?: string | null;
            city?: string | null;
            addressLine1?: string | null;
          } | null;
        } | null> | null;
      } | null;
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type CasesSendReportVCoverLetterDocumentPickerContainerSendReportCaseV1MergePdfFilesMutationVariables = Exact<{
  input: SendReportCaseV1MergePdfFilesInput;
}>;

export type CasesSendReportVCoverLetterDocumentPickerContainerSendReportCaseV1MergePdfFilesMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1MergePdfFiles: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
      assets?: { __typename?: 'SendReportCaseV1Asset'; private?: { __typename?: 'SendReportCaseV1AssetPrivate'; statusReportCoverLetter?: string | null } | null } | null;
    } | null;
  };
};

export type CasesSendReportV1CoverLetterDocumentPickerContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1CoverLetterDocumentPickerContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        credential?: {
          __typename?: 'CredentialVerificationCaseV1';
          caseDetails?: {
            __typename?: 'CredentialVerificationCaseV1CaseDetails';
            application?: {
              __typename?: 'CredentialVerificationCaseV1Application';
              nameOnCredential?: string | null;
              credentialTitle?: string | null;
              credentialType?: string | null;
              issuingInstitution?: {
                __typename?: 'Entity';
                entityName?: string | null;
                issuingInstitution?: {
                  __typename?: 'EntityIssuingInstitution';
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                } | null;
              } | null;
              sendDestination?: {
                __typename?: 'Entity';
                entityName?: string | null;
                client?: {
                  __typename?: 'EntityClient';
                  address?: {
                    __typename?: 'EntityAddressInfo';
                    addressLine1?: string | null;
                    addressLine2?: string | null;
                    city?: string | null;
                    country?: string | null;
                    stateOrProvince?: string | null;
                    zipOrPostalCode?: string | null;
                  } | null;
                } | null;
              } | null;
            } | null;
            applicationReview?: {
              __typename?: 'CredentialVerificationCaseV1ApplicationReview';
              privateCaseDetails?: {
                __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
                verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
              } | null;
            } | null;
          } | null;
          files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
        } | null;
      } | null;
    } | null;
    applicant?: {
      __typename?: 'ApplicantUser';
      displayName?: string | null;
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          lastName?: string | null;
          restOfName?: string | null;
          generationalSuffix?: string | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    assets?: { __typename?: 'SendReportCaseV1Asset'; private?: { __typename?: 'SendReportCaseV1AssetPrivate'; statusReportCoverLetter?: string | null } | null } | null;
  } | null;
};

export type CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    application?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplication';
      credential?: {
        __typename?: 'CredentialVerificationCaseV1';
        caseDetails?: {
          __typename?: 'CredentialVerificationCaseV1CaseDetails';
          application?: {
            __typename?: 'CredentialVerificationCaseV1Application';
            nameOnCredential?: string | null;
            credentialTitle?: string | null;
            credentialType?: string | null;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
            sendDestination?: {
              __typename?: 'Entity';
              entityName?: string | null;
              client?: {
                __typename?: 'EntityClient';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  addressLine2?: string | null;
                  city?: string | null;
                  country?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                } | null;
              } | null;
            } | null;
          } | null;
          applicationReview?: {
            __typename?: 'CredentialVerificationCaseV1ApplicationReview';
            privateCaseDetails?: {
              __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
              verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
            } | null;
          } | null;
        } | null;
        files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
      } | null;
    } | null;
  } | null;
  applicant?: {
    __typename?: 'ApplicantUser';
    displayName?: string | null;
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        lastName?: string | null;
        restOfName?: string | null;
        generationalSuffix?: string | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  assets?: { __typename?: 'SendReportCaseV1Asset'; private?: { __typename?: 'SendReportCaseV1AssetPrivate'; statusReportCoverLetter?: string | null } | null } | null;
};

export type CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  displayName?: string | null;
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    identityDetails?: {
      __typename?: 'ApplicantUserIdentityDetails';
      dateOfBirth?: any | null;
      gender?: string | null;
      lastName?: string | null;
      restOfName?: string | null;
      generationalSuffix?: string | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1CaseDetails';
  applicationReview?: {
    __typename?: 'CredentialVerificationCaseV1ApplicationReview';
    privateCaseDetails?: {
      __typename?: 'CredentialVerificationCaseV1PrivateCaseDetails';
      verificationStatus?: { __typename?: 'CredentialVerificationCaseV1VerificationStatus'; verificationResponse?: string | null } | null;
    } | null;
  } | null;
};

export type CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1Application';
  nameOnCredential?: string | null;
  credentialTitle?: string | null;
  credentialType?: string | null;
  issuingInstitution?: {
    __typename?: 'Entity';
    entityName?: string | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
  sendDestination?: {
    __typename?: 'Entity';
    entityName?: string | null;
    client?: {
      __typename?: 'EntityClient';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
};

export type StaffReportCoverLetterContainerEntityAddressInfoFieldsFragment = {
  __typename?: 'EntityAddressInfo';
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQuery = {
  __typename?: 'Query';
  identityVerificationCasesV1ByApplicant?: Array<{
    __typename?: 'IdentityVerificationCaseV1';
    caseName: string;
    caseType?: string | null;
    state: string;
    createdAt?: any | null;
    id: any;
  } | null> | null;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQuery = {
  __typename?: 'Query';
  credentialVerificationCasesV1ByApplicant?: Array<{
    __typename?: 'CredentialVerificationCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    state: string;
    createdAt?: any | null;
    id: any;
  } | null> | null;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicantQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicantQuery = {
  __typename?: 'Query';
  sendReportCasesV1ByApplicant?: Array<{
    __typename?: 'SendReportCaseV1';
    caseName?: string | null;
    caseType?: string | null;
    state: string;
    createdAt?: any | null;
    id: any;
  } | null> | null;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: { __typename?: 'SendReportCaseV1'; id: any; applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null } | null;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCaseV1ByApplicantFieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  caseName?: string | null;
  caseType?: string | null;
  state: string;
  createdAt?: any | null;
  id: any;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCaseV1ByApplicantFieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  caseName: string;
  caseType?: string | null;
  state: string;
  createdAt?: any | null;
  id: any;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1ByApplicantFieldsFragment = {
  __typename?: 'SendReportCaseV1';
  caseName?: string | null;
  caseType?: string | null;
  state: string;
  createdAt?: any | null;
  id: any;
};

export type CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1IdFieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesSendReportFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQuery = {
  __typename?: 'Query';
  archivedCasesByApplicantId?: Array<{ __typename?: 'ArchivedCaseSummary'; archivedAt: any; caseName: string; caseType: string; id: any; state: string } | null> | null;
};

export type CasesSendReportFilePickerArchivedCaseListContainerArchivedCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCaseSummary';
  archivedAt: any;
  caseName: string;
  caseType: string;
  id: any;
  state: string;
};

export type CasesSendReportFilePickerCaseListContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportFilePickerCaseListContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: { __typename?: 'SendReportCaseV1'; id: any; applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null } | null;
};

export type CasesSendReportFilePickerCaseListContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1QueryVariables = Exact<{
  identityVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1Query = {
  __typename?: 'Query';
  identityVerificationCaseV1?: {
    __typename?: 'IdentityVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1QueryVariables = Exact<{
  credentialVerificationCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1Query = {
  __typename?: 'Query';
  credentialVerificationCaseV1?: {
    __typename?: 'CredentialVerificationCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
    applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
  } | null;
};

export type CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryQueryVariables = Exact<{
  archivedCredentialVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedCredentialVerificationCaseSummary?: {
    __typename?: 'ArchivedCredentialVerificationCaseSummary';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryQueryVariables = Exact<{
  archivedIdentityVerificationCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryQuery = {
  __typename?: 'Query';
  archivedIdentityVerificationCaseSummary?: {
    __typename?: 'ArchivedIdentityVerificationCaseSummary';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryQueryVariables = Exact<{
  archivedSendReportCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1FieldsFragment = {
  __typename?: 'IdentityVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1FieldsFragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  applicant?: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any } | null;
};

export type CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCredentialVerificationCaseSummary';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedIdentityVerificationCaseSummary';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummary';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesSendReportDocumentListContainerFileInfoFieldsFragment = { __typename?: 'FileInfo'; name: string; url: string; type?: string | null };

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    } | null;
  };
};

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeaderMutationVariables = Exact<{
  input: SendReportCaseV1BlobFileInput;
}>;

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1PdfFileCreateAuthHeader: {
    __typename?: 'SendReportCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobName?: string | null;
      blobPath?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeaderMutationVariables = Exact<{
  input: SendReportCaseV1BlobFileInput;
}>;

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1ImageFileCreateAuthHeader: {
    __typename?: 'SendReportCaseV1BlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobName?: string | null;
      blobPath?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
  } | null;
};

export type CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileByFileNameFieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
};

export type CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFieldsFragment = {
  __typename?: 'SendReportCaseV1BlobContentAuthHeaderResult';
  authHeader?: {
    __typename?: 'BlobAuthHeader';
    authHeader?: string | null;
    blobName?: string | null;
    blobPath?: string | null;
    requestDate?: string | null;
    indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
    metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFieldsFragment = {
  __typename?: 'BlobAuthHeader';
  authHeader?: string | null;
  blobName?: string | null;
  blobPath?: string | null;
  requestDate?: string | null;
  indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
  metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
};

export type CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationVariables = Exact<{
  input: SendReportCaseV1UpdateInput;
}>;

export type CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1Update: {
    __typename?: 'SendReportCaseV1MutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    sendReportCaseV1?: {
      __typename?: 'SendReportCaseV1';
      id: any;
      files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    } | null;
  };
};

export type CasesSendReportV1FilesContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1FilesContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: { __typename?: 'SendReportCaseV1'; id: any; isCurrentUserAssigned?: boolean | null; state: string } | null;
};

export type CasesSendReportV1FilesContainerSendReportCaseV1MutationResultFieldsFragment = {
  __typename?: 'SendReportCaseV1MutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  } | null;
};

export type CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
};

export type CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: { __typename?: 'SendReportCaseV1'; isCurrentUserAssigned?: boolean | null; id: any } | null;
};

export type CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummaryQueryVariables = Exact<{
  archivedSendReportCaseSummaryId: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummaryQuery = {
  __typename?: 'Query';
  archivedSendReportCaseSummary?: {
    __typename?: 'ArchivedSendReportCaseSummary';
    id: any;
    applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
  } | null;
};

export type CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1FieldsFragment = { __typename?: 'SendReportCaseV1'; isCurrentUserAssigned?: boolean | null; id: any };

export type CasesSendReportV1RelatedCasesTabContainerArchivedSendReportCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedSendReportCaseSummary';
  id: any;
  applicant: { __typename?: 'ApplicantUser'; displayName?: string | null; id: any };
};

export type CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1QueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
  } | null;
};

export type CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; name: string; url: string; type?: string | null } | null> | null;
};

export type CasesSendReportTransactionsContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportTransactionsContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    financeDetails?: {
      __typename?: 'SendReportCaseV1FinanceDetails';
      transactions?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
        submission?: {
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
          amount?: number | null;
          transactionReference?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
          } | null;
        } | null;
        adhocTransactions?: Array<{
          __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
          amount?: number | null;
          reason?: string | null;
          status?: string | null;
          requestedAt?: any | null;
          id: any;
          createdAt?: any | null;
          updatedAt?: any | null;
          approval?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval';
            applicantRespondedAt?: any | null;
            isApplicantApprovalRequired?: boolean | null;
            isApplicantApproved?: boolean | null;
          } | null;
          financeReference?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference';
            recognizedAt?: any | null;
            creditGlAccount?: string | null;
            debitGlAccount?: string | null;
          } | null;
          transactionReference?: {
            __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference';
            completedAt?: any | null;
            referenceId?: string | null;
            vendor?: string | null;
            isSuccess?: boolean | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportTransactionsContainerSendReportCaseV1FinanceDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1FinanceDetails';
  transactions?: {
    __typename?: 'SendReportCaseV1FinanceDetailsTransactions';
    submission?: {
      __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmission';
      amount?: number | null;
      transactionReference?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionSubmissionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
      } | null;
    } | null;
    adhocTransactions?: Array<{
      __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction';
      amount?: number | null;
      reason?: string | null;
      status?: string | null;
      requestedAt?: any | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      approval?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionApproval';
        applicantRespondedAt?: any | null;
        isApplicantApprovalRequired?: boolean | null;
        isApplicantApproved?: boolean | null;
      } | null;
      financeReference?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionFinanceReference';
        recognizedAt?: any | null;
        creditGlAccount?: string | null;
        debitGlAccount?: string | null;
      } | null;
      transactionReference?: {
        __typename?: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransactionTransactionReference';
        completedAt?: any | null;
        referenceId?: string | null;
        vendor?: string | null;
        isSuccess?: boolean | null;
      } | null;
    } | null> | null;
  } | null;
};

export type CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFilesMutationVariables = Exact<{
  input: SendReportCaseV1MergePdfFilesInput;
}>;

export type CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFilesMutation = {
  __typename?: 'Mutation';
  sendReportCaseV1MergePdfFiles: { __typename?: 'SendReportCaseV1MutationResult'; status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean } };
};

export type CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1QueryVariables = Exact<{
  fileName: Scalars['String']['input'];
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: {
    __typename?: 'SendReportCaseV1';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
    caseDetails?: {
      __typename?: 'SendReportCaseV1CaseDetails';
      application?: {
        __typename?: 'SendReportCaseV1CaseDetailsApplication';
        credential?: {
          __typename?: 'CredentialVerificationCaseV1';
          id: any;
          fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
        } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFieldsFragment = {
  __typename?: 'SendReportCaseV1CaseDetails';
  application?: {
    __typename?: 'SendReportCaseV1CaseDetailsApplication';
    credential?: {
      __typename?: 'CredentialVerificationCaseV1';
      id: any;
      fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
    } | null;
  } | null;
};

export type CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1Fragment = {
  __typename?: 'CredentialVerificationCaseV1';
  id: any;
  fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
};

export type CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1FieldsFragment = {
  __typename?: 'SendReportCaseV1';
  id: any;
  files?: Array<{ __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null> | null;
  caseDetails?: {
    __typename?: 'SendReportCaseV1CaseDetails';
    application?: {
      __typename?: 'SendReportCaseV1CaseDetailsApplication';
      credential?: {
        __typename?: 'CredentialVerificationCaseV1';
        id: any;
        fileByFileName?: { __typename?: 'FileInfo'; url: string; type?: string | null; size?: number | null; name: string } | null;
      } | null;
    } | null;
  } | null;
};

export type CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFieldsFragment = {
  __typename?: 'FileInfo';
  url: string;
  type?: string | null;
  size?: number | null;
  name: string;
};

export type CasesSendReportV1IndexContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type CasesSendReportV1IndexContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canViewCaseHistory: boolean } };
    } | null;
  } | null;
};

export type CasesSendReportV1IndexContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canViewCaseHistory: boolean } };
  } | null;
};

export type CasesSendReportV1SectionLayoutContainerSendReportCaseV1QueryVariables = Exact<{
  sendReportCaseV1Id: Scalars['ObjectID']['input'];
}>;

export type CasesSendReportV1SectionLayoutContainerSendReportCaseV1Query = {
  __typename?: 'Query';
  sendReportCaseV1?: { __typename?: 'SendReportCaseV1'; state: string; caseName?: string | null; id: any } | null;
};

export type CasesSendReportV1SectionLayoutContainerSendReportCaseV1FieldsFragment = { __typename?: 'SendReportCaseV1'; state: string; caseName?: string | null; id: any };

export type StaffApplicantProfileApplyToEditContainerApplicantUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfileApplyToEditContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
  } | null;
};

export type StaffApplicantProfileApplyToEditContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffApplicantProfileApplyToEditContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
};

export type StaffApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type StaffApplicantProfileApplyToEditContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
    } | null;
  };
};

export type StaffApplicantProfileApplyToEditContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
};

export type StaffApplicantProfileApplyToEditContainerEntityFieldsFragment = { __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any };

export type StaffApplicantProfileApplyToEditContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
  } | null;
};

export type ApplicantApplyToViewContainerApplicantUserQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type ApplicantApplyToViewContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
    } | null;
  } | null;
};

export type ApplicantApplyToViewContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    applyingTo?: Array<{ __typename?: 'Entity'; entityName?: string | null; id: any } | null> | null;
  } | null;
};

export type StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
      } | null;
    } | null;
  };
};

export type StaffApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    } | null;
  } | null;
};

export type StaffApplicantProfileCitizenshipEditContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  } | null;
};

export type StaffApplicantProfileCitizenshipViewContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfileCitizenshipViewContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
    } | null;
  } | null;
};

export type StaffApplicantProfileCitizenshipViewContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    citizenship?: { __typename?: 'ApplicantUserCitizenship'; currentCitizenOf?: Array<string | null> | null } | null;
  } | null;
};

export type StaffApplicantProfilePersonalInformationContactContainerQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfilePersonalInformationContactContainerQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      contactInformation?: {
        __typename?: 'ApplicantUserContactInformation';
        emailAddress?: string | null;
        primaryPhone?: string | null;
        address?: {
          __typename?: 'ApplicantUserAddress';
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          streetAddressLine1?: string | null;
          streetAddressLine2?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
        phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type StaffApplicantProfileUpdatePersonalInformationContactMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type StaffApplicantProfileUpdatePersonalInformationContactMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        contactInformation?: {
          __typename?: 'ApplicantUserContactInformation';
          emailAddress?: string | null;
          primaryPhone?: string | null;
          address?: {
            __typename?: 'ApplicantUserAddress';
            city?: string | null;
            country?: string | null;
            stateOrProvince?: string | null;
            streetAddressLine1?: string | null;
            streetAddressLine2?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
          phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type StaffApplicantProfileContactInformationFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  contactInformation?: {
    __typename?: 'ApplicantUserContactInformation';
    emailAddress?: string | null;
    primaryPhone?: string | null;
    address?: {
      __typename?: 'ApplicantUserAddress';
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      streetAddressLine1?: string | null;
      streetAddressLine2?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    phone?: Array<{ __typename?: 'ApplicantUserPhone'; phoneNumber?: string | null; phoneType?: string | null; id: any } | null> | null;
  } | null;
};

export type StaffApplicantProfileIdentityApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfileIdentityApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        lastName?: string | null;
        restOfName?: string | null;
      } | null;
      contactInformation?: { __typename?: 'ApplicantUserContactInformation'; emailAddress?: string | null } | null;
    } | null;
  } | null;
};

export type StaffApplicantProfileIdentityUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type StaffApplicantProfileIdentityUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    applicantUser?: {
      __typename?: 'ApplicantUser';
      displayName?: string | null;
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        contactInformation?: { __typename?: 'ApplicantUserContactInformation'; emailAddress?: string | null } | null;
        identityDetails?: {
          __typename?: 'ApplicantUserIdentityDetails';
          dateOfBirth?: any | null;
          gender?: string | null;
          lastName?: string | null;
          restOfName?: string | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
    } | null;
  };
};

export type StaffApplicantProfileIdentityUploadContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: { __typename?: 'ApplicantUserPersonalInformation'; applyingTo?: Array<{ __typename?: 'Entity'; id: any } | null> | null } | null;
};

export type StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  personalInformation?: {
    __typename?: 'ApplicantUserPersonalInformation';
    nameOnDocumentAssets?: Array<{
      __typename?: 'ApplicantUserNameOnDocumentAsset';
      documentName?: string | null;
      isDeleteRequested?: boolean | null;
      uploadedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      id: any;
    } | null> | null;
  } | null;
};

export type StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFilesQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFilesQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    files?: Array<{ __typename?: 'FileInfo'; name: string; size?: number | null; type?: string | null; url: string } | null> | null;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        documentName?: string | null;
        isDeleteRequested?: boolean | null;
        uploadedAt?: any | null;
        createdAt?: any | null;
        updatedAt?: any | null;
        id: any;
      } | null> | null;
    } | null;
  } | null;
};

export type StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutationVariables = Exact<{
  input: ApplicantUserBlobFileInput;
}>;

export type StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutation = {
  __typename?: 'Mutation';
  applicantUserFileCreateAuthHeader: {
    __typename?: 'ApplicantUserBlobContentAuthHeaderResult';
    authHeader?: {
      __typename?: 'BlobAuthHeader';
      authHeader?: string | null;
      blobName?: string | null;
      blobPath?: string | null;
      requestDate?: string | null;
      indexTags?: Array<{ __typename?: 'BlobIndexTag'; name: string; value: string } | null> | null;
      metadataFields?: Array<{ __typename?: 'BlobMetadataField'; name: string; value: string } | null> | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type StaffApplicantProfileIdentityContainerQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfileIdentityContainerQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      contactInformation?: { __typename?: 'ApplicantUserContactInformation'; emailAddress?: string | null } | null;
      identityDetails?: {
        __typename?: 'ApplicantUserIdentityDetails';
        dateOfBirth?: any | null;
        gender?: string | null;
        generationalSuffix?: string | null;
        lastName?: string | null;
        legalNameConsistsOfOneName?: boolean | null;
        restOfName?: string | null;
      } | null;
      nameOnDocumentAssets?: Array<{
        __typename?: 'ApplicantUserNameOnDocumentAsset';
        documentName?: string | null;
        isDeleteRequested?: boolean | null;
        uploadedAt?: any | null;
        createdAt?: any | null;
        updatedAt?: any | null;
        id: any;
      } | null> | null;
    } | null;
    termsAndConditions?: Array<{
      __typename?: 'ApplicantUserTermsAndCondition';
      acceptanceOf?: string | null;
      attestedAt?: any | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      version?: number | null;
      id: any;
    } | null> | null;
  } | null;
};

export type StaffApplicantProfileIdentityDetailsTermsAndConditionsFieldsFragment = {
  __typename?: 'ApplicantUserTermsAndCondition';
  acceptanceOf?: string | null;
  attestedAt?: any | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  version?: number | null;
  id: any;
};

export type StaffApplicantProfileIdentityDetailsContactInformationFieldsFragment = { __typename?: 'ApplicantUserContactInformation'; emailAddress?: string | null };

export type StaffApplicantProfileIdentityDetailsFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  identityDetails?: {
    __typename?: 'ApplicantUserIdentityDetails';
    dateOfBirth?: any | null;
    gender?: string | null;
    generationalSuffix?: string | null;
    lastName?: string | null;
    legalNameConsistsOfOneName?: boolean | null;
    restOfName?: string | null;
  } | null;
};

export type StaffApplicantProfileNameOnDocumentAssetFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  nameOnDocumentAssets?: Array<{
    __typename?: 'ApplicantUserNameOnDocumentAsset';
    documentName?: string | null;
    isDeleteRequested?: boolean | null;
    uploadedAt?: any | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    id: any;
  } | null> | null;
};

export type StaffApplicantProfileProfessionEditContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfileProfessionEditContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                city?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
                country?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type StaffApplicantProfileProfessionEditContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffApplicantProfileProfessionEditContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isIssuingInstitution?: boolean | null; id: any } | null> | null;
};

export type StaffApplicantProfileUpdatePersonalInformationProfessionContainerMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type StaffApplicantProfileUpdatePersonalInformationProfessionContainerMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: {
      __typename?: 'ApplicantUser';
      id: any;
      personalInformation?: {
        __typename?: 'ApplicantUserPersonalInformation';
        professional?: {
          __typename?: 'ApplicantUserProfessional';
          citizenshipAtTimeEnteredMedicalInstitution?: string | null;
          healthProfession?: string | null;
          primaryEducationalInformation?: Array<{
            __typename?: 'ApplicantUserPrimaryEducationalInformation';
            attendanceEndedAt?: any | null;
            attendanceStartedAt?: any | null;
            degreeIssuedAt?: any | null;
            degreeTitle?: string | null;
            graduationYear?: number | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'Entity';
              entityName?: string | null;
              id: any;
              issuingInstitution?: {
                __typename?: 'EntityIssuingInstitution';
                address?: {
                  __typename?: 'EntityAddressInfo';
                  addressLine1?: string | null;
                  city?: string | null;
                  stateOrProvince?: string | null;
                  zipOrPostalCode?: string | null;
                  country?: string | null;
                } | null;
              } | null;
            } | null;
            otherIssuingInstitution?: {
              __typename?: 'ApplicantUserOtherIssuingInstitution';
              addressLine1?: string | null;
              city?: string | null;
              country?: string | null;
              name?: string | null;
              stateOrProvince?: string | null;
              zipOrPostalCode?: string | null;
            } | null;
          } | null> | null;
        } | null;
      } | null;
    } | null;
  };
};

export type StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      attendanceEndedAt?: any | null;
      attendanceStartedAt?: any | null;
      degreeIssuedAt?: any | null;
      degreeTitle?: string | null;
      graduationYear?: number | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            city?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
            country?: string | null;
          } | null;
        } | null;
      } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        name?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFieldsFragment = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: string | null;
  healthProfession?: string | null;
  primaryEducationalInformation?: Array<{
    __typename?: 'ApplicantUserPrimaryEducationalInformation';
    attendanceEndedAt?: any | null;
    attendanceStartedAt?: any | null;
    degreeIssuedAt?: any | null;
    degreeTitle?: string | null;
    graduationYear?: number | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'Entity';
      entityName?: string | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          city?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
          country?: string | null;
        } | null;
      } | null;
    } | null;
    otherIssuingInstitution?: {
      __typename?: 'ApplicantUserOtherIssuingInstitution';
      addressLine1?: string | null;
      city?: string | null;
      country?: string | null;
      name?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null> | null;
};

export type StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPrimaryEducationalInformation';
  attendanceEndedAt?: any | null;
  attendanceStartedAt?: any | null;
  degreeIssuedAt?: any | null;
  degreeTitle?: string | null;
  graduationYear?: number | null;
  id: any;
  issuingInstitution?: {
    __typename?: 'Entity';
    entityName?: string | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        city?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
        country?: string | null;
      } | null;
    } | null;
  } | null;
  otherIssuingInstitution?: {
    __typename?: 'ApplicantUserOtherIssuingInstitution';
    addressLine1?: string | null;
    city?: string | null;
    country?: string | null;
    name?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFieldsFragment = {
  __typename?: 'ApplicantUserOtherIssuingInstitution';
  addressLine1?: string | null;
  city?: string | null;
  country?: string | null;
  name?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type StaffApplicantProfileProfessionEditContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  id: any;
};

export type StaffApplicantProfileProfessionViewContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type StaffApplicantProfileProfessionViewContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: {
    __typename?: 'ApplicantUser';
    id: any;
    personalInformation?: {
      __typename?: 'ApplicantUserPersonalInformation';
      professional?: {
        __typename?: 'ApplicantUserProfessional';
        citizenshipAtTimeEnteredMedicalInstitution?: string | null;
        healthProfession?: string | null;
        primaryEducationalInformation?: Array<{
          __typename?: 'ApplicantUserPrimaryEducationalInformation';
          attendanceEndedAt?: any | null;
          attendanceStartedAt?: any | null;
          degreeIssuedAt?: any | null;
          degreeTitle?: string | null;
          graduationYear?: number | null;
          id: any;
          issuingInstitution?: {
            __typename?: 'Entity';
            entityName?: string | null;
            id: any;
            issuingInstitution?: {
              __typename?: 'EntityIssuingInstitution';
              address?: {
                __typename?: 'EntityAddressInfo';
                addressLine1?: string | null;
                city?: string | null;
                stateOrProvince?: string | null;
                zipOrPostalCode?: string | null;
                country?: string | null;
              } | null;
            } | null;
          } | null;
          otherIssuingInstitution?: {
            __typename?: 'ApplicantUserOtherIssuingInstitution';
            addressLine1?: string | null;
            city?: string | null;
            country?: string | null;
            name?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
          } | null;
        } | null> | null;
      } | null;
    } | null;
  } | null;
};

export type StaffApplicantProfileProfessionViewContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffApplicantProfileProfessionViewContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; id: any; entityName?: string | null; isIssuingInstitution?: boolean | null } | null> | null;
};

export type StaffApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPersonalInformation';
  professional?: {
    __typename?: 'ApplicantUserProfessional';
    citizenshipAtTimeEnteredMedicalInstitution?: string | null;
    healthProfession?: string | null;
    primaryEducationalInformation?: Array<{
      __typename?: 'ApplicantUserPrimaryEducationalInformation';
      attendanceEndedAt?: any | null;
      attendanceStartedAt?: any | null;
      degreeIssuedAt?: any | null;
      degreeTitle?: string | null;
      graduationYear?: number | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'Entity';
        entityName?: string | null;
        id: any;
        issuingInstitution?: {
          __typename?: 'EntityIssuingInstitution';
          address?: {
            __typename?: 'EntityAddressInfo';
            addressLine1?: string | null;
            city?: string | null;
            stateOrProvince?: string | null;
            zipOrPostalCode?: string | null;
            country?: string | null;
          } | null;
        } | null;
      } | null;
      otherIssuingInstitution?: {
        __typename?: 'ApplicantUserOtherIssuingInstitution';
        addressLine1?: string | null;
        city?: string | null;
        country?: string | null;
        name?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null> | null;
  } | null;
};

export type StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFieldsFragment = {
  __typename?: 'ApplicantUserProfessional';
  citizenshipAtTimeEnteredMedicalInstitution?: string | null;
  healthProfession?: string | null;
  primaryEducationalInformation?: Array<{
    __typename?: 'ApplicantUserPrimaryEducationalInformation';
    attendanceEndedAt?: any | null;
    attendanceStartedAt?: any | null;
    degreeIssuedAt?: any | null;
    degreeTitle?: string | null;
    graduationYear?: number | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'Entity';
      entityName?: string | null;
      id: any;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          city?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
          country?: string | null;
        } | null;
      } | null;
    } | null;
    otherIssuingInstitution?: {
      __typename?: 'ApplicantUserOtherIssuingInstitution';
      addressLine1?: string | null;
      city?: string | null;
      country?: string | null;
      name?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null> | null;
};

export type StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFieldsFragment = {
  __typename?: 'ApplicantUserPrimaryEducationalInformation';
  attendanceEndedAt?: any | null;
  attendanceStartedAt?: any | null;
  degreeIssuedAt?: any | null;
  degreeTitle?: string | null;
  graduationYear?: number | null;
  id: any;
  issuingInstitution?: {
    __typename?: 'Entity';
    entityName?: string | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        city?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
        country?: string | null;
      } | null;
    } | null;
  } | null;
  otherIssuingInstitution?: {
    __typename?: 'ApplicantUserOtherIssuingInstitution';
    addressLine1?: string | null;
    city?: string | null;
    country?: string | null;
    name?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFieldsFragment = {
  __typename?: 'ApplicantUserOtherIssuingInstitution';
  addressLine1?: string | null;
  city?: string | null;
  country?: string | null;
  name?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type StaffApplicantProfileProfessionViewContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  id: any;
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
};

export type StaffApplicantSearchFilterContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffApplicantSearchFilterContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
};

export type StaffApplicantSearchFilterContainerEntityFieldsFragment = { __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any };

export type StaffApplicantSearchFilterContainerApplicantUserGetAllTagsQueryVariables = Exact<{ [key: string]: never }>;

export type StaffApplicantSearchFilterContainerApplicantUserGetAllTagsQuery = { __typename?: 'Query'; applicantUserGetAllTags?: Array<string | null> | null };

export type StaffApplicantSearchContainerApplicantUserSearchQueryVariables = Exact<{
  input?: InputMaybe<ApplicantUserSearchInput>;
}>;

export type StaffApplicantSearchContainerApplicantUserSearchQuery = {
  __typename?: 'Query';
  applicantUserSearch?: {
    __typename?: 'ApplicantUserSearchResult';
    count?: number | null;
    applicantUserResults?: Array<{
      __typename?: 'ApplicantUserResult';
      displayName?: string | null;
      createdAt?: any | null;
      accessBlocked?: boolean | null;
      tags?: Array<string | null> | null;
      id?: any | null;
      identityDetails?: { __typename?: 'ApplicantUserIdentityDetailsResult'; lastName?: string | null; restOfName?: string | null } | null;
    } | null> | null;
    facets?: {
      __typename?: 'ApplicantUserSearchFacets';
      accessBlocked?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      applyingTo?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      dateOfBirth?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      gender?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
      generationalSuffix?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
      role?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
      tags?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
      updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    } | null;
  } | null;
};

export type StaffApplicantSearchContainerApplicantApplicantUserResultsFieldsFragment = {
  __typename?: 'ApplicantUserSearchResult';
  count?: number | null;
  applicantUserResults?: Array<{
    __typename?: 'ApplicantUserResult';
    displayName?: string | null;
    createdAt?: any | null;
    accessBlocked?: boolean | null;
    tags?: Array<string | null> | null;
    id?: any | null;
    identityDetails?: { __typename?: 'ApplicantUserIdentityDetailsResult'; lastName?: string | null; restOfName?: string | null } | null;
  } | null> | null;
  facets?: {
    __typename?: 'ApplicantUserSearchFacets';
    accessBlocked?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    applyingTo?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    dateOfBirth?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    gender?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
    generationalSuffix?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
    role?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
    tags?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
    updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  } | null;
};

export type StaffApplicantSearchContainerApplicantUserSearchFieldsFragment = {
  __typename?: 'ApplicantUserResult';
  displayName?: string | null;
  createdAt?: any | null;
  accessBlocked?: boolean | null;
  tags?: Array<string | null> | null;
  id?: any | null;
  identityDetails?: { __typename?: 'ApplicantUserIdentityDetailsResult'; lastName?: string | null; restOfName?: string | null } | null;
};

export type StaffApplicantSearchContainerApplicantUserSearchFacetsFieldsFragment = {
  __typename?: 'ApplicantUserSearchFacets';
  accessBlocked?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  applyingTo?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  dateOfBirth?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  gender?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
  generationalSuffix?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
  role?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
  tags?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
  updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
};

export type StaffCaseSearchFilterContainerStaffUsersQueryVariables = Exact<{ [key: string]: never }>;

export type StaffCaseSearchFilterContainerStaffUsersQuery = {
  __typename?: 'Query';
  staffUsers?: Array<{
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean };
        sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
        credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
      };
    } | null;
  } | null> | null;
};

export type StaffCaseSearchFilterContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffCaseSearchFilterContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    displayName?: string | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean };
        sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
        credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
      };
    } | null;
  } | null;
};

export type StaffCaseSearchFilterContainerStaffUsersFieldsFragment = {
  __typename?: 'StaffUser';
  displayName?: string | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean };
      sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
      credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
    };
  } | null;
};

export type StaffCaseSearchFilterContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffCaseSearchFilterContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{ __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any } | null> | null;
};

export type StaffCaseSearchFilterContainerEntityFieldsFragment = { __typename?: 'Entity'; entityName?: string | null; isClient?: boolean | null; id: any };

export type StaffCaseSearchFilterContainerStaffRoleFieldsFragment = {
  __typename?: 'StaffRole';
  id: any;
  permissions: {
    __typename?: 'StaffRolePermissions';
    idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean };
    sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
    credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
  };
};

export type StaffCaseSearchFilterContainerStaffRolePermissionsFieldsFragment = {
  __typename?: 'StaffRolePermissions';
  idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean };
  sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
  credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canViewUnassignedCases: boolean; canViewCasesAssignedToOthers: boolean; canSearchCases: boolean };
};

export type StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFieldsFragment = {
  __typename?: 'StaffRoleIdCasePermissions';
  canSearchCases: boolean;
  canViewUnassignedCases: boolean;
  canViewCasesAssignedToOthers: boolean;
};

export type StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFieldsFragment = {
  __typename?: 'StaffRoleSendCasePermissions';
  canViewUnassignedCases: boolean;
  canViewCasesAssignedToOthers: boolean;
  canSearchCases: boolean;
};

export type StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFieldsFragment = {
  __typename?: 'StaffRoleCredCasePermissions';
  canViewUnassignedCases: boolean;
  canViewCasesAssignedToOthers: boolean;
  canSearchCases: boolean;
};

export type StaffCaseSearchFilterContainerCaseGetAllTagsQueryVariables = Exact<{ [key: string]: never }>;

export type StaffCaseSearchFilterContainerCaseGetAllTagsQuery = { __typename?: 'Query'; caseGetAllTags?: Array<string | null> | null };

export type StaffCaseSearchContainerCaseSearchQueryVariables = Exact<{
  caseSearchInput2: CaseSearchInput;
}>;

export type StaffCaseSearchContainerCaseSearchQuery = {
  __typename?: 'Query';
  caseSearch?: {
    __typename?: 'CaseSearchResult';
    count?: number | null;
    caseResults?: Array<{
      __typename?: 'CaseResult';
      caseType?: string | null;
      caseName?: string | null;
      state?: string | null;
      submittedAt?: any | null;
      updatedAt?: any | null;
      applicantId?: string | null;
      applicantName?: string | null;
      id?: string | null;
      caseWorkerAssigned?: { __typename?: 'CaseSearchStaffUserResult'; displayName?: string | null; id?: any | null } | null;
      decision?: { __typename?: 'CaseDecisionResult'; result?: string | null } | null;
    } | null> | null;
    facets?: {
      __typename?: 'CaseSearchFacets';
      caseType?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      caseWorkerAssigned?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      clientId?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      credentialType?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      decisionCompletedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      decisionCompletedBy?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      decisionResult?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      expirationEligibleAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      lastActivityCreatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      revisionRequestRequestedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      revisionRequestRequestedBy?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      revisionRequestSubmittedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      state?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      submittedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      systemTags?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      tags?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    } | null;
  } | null;
};

export type StaffCaseSearchContainerCaseSearchResultFieldsFragment = {
  __typename?: 'CaseSearchResult';
  count?: number | null;
  caseResults?: Array<{
    __typename?: 'CaseResult';
    caseType?: string | null;
    caseName?: string | null;
    state?: string | null;
    submittedAt?: any | null;
    updatedAt?: any | null;
    applicantId?: string | null;
    applicantName?: string | null;
    id?: string | null;
    caseWorkerAssigned?: { __typename?: 'CaseSearchStaffUserResult'; displayName?: string | null; id?: any | null } | null;
    decision?: { __typename?: 'CaseDecisionResult'; result?: string | null } | null;
  } | null> | null;
  facets?: {
    __typename?: 'CaseSearchFacets';
    caseType?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    caseWorkerAssigned?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    clientId?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    credentialType?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    decisionCompletedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    decisionCompletedBy?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    decisionResult?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    expirationEligibleAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    lastActivityCreatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    revisionRequestRequestedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    revisionRequestRequestedBy?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    revisionRequestSubmittedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    state?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    submittedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    systemTags?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    tags?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  } | null;
};

export type StaffCaseSearchContainerCaseResultFieldsFragment = {
  __typename?: 'CaseResult';
  caseType?: string | null;
  caseName?: string | null;
  state?: string | null;
  submittedAt?: any | null;
  updatedAt?: any | null;
  applicantId?: string | null;
  applicantName?: string | null;
  id?: string | null;
  caseWorkerAssigned?: { __typename?: 'CaseSearchStaffUserResult'; displayName?: string | null; id?: any | null } | null;
  decision?: { __typename?: 'CaseDecisionResult'; result?: string | null } | null;
};

export type StaffCaseSearchContainerCaseSearchStaffUserResultFieldsFragment = { __typename?: 'CaseSearchStaffUserResult'; displayName?: string | null; id?: any | null };

export type StaffCaseSearchContainerFacetDetailFieldsFragment = { __typename?: 'FacetDetail'; count?: number | null; value?: string | null };

export type StaffCaseSearchContainerCaseSearchFacetsFieldsFragment = {
  __typename?: 'CaseSearchFacets';
  caseType?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  caseWorkerAssigned?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  clientId?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  credentialType?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  decisionCompletedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  decisionCompletedBy?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  decisionResult?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  expirationEligibleAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  lastActivityCreatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  revisionRequestRequestedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  revisionRequestRequestedBy?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  revisionRequestSubmittedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  state?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  submittedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  systemTags?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  tags?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
};

export type StaffStateCountriesEditContainerUpdateBlobCountriesMutationVariables = Exact<{
  input: BlobCountriesInput;
}>;

export type StaffStateCountriesEditContainerUpdateBlobCountriesMutation = {
  __typename?: 'Mutation';
  updateBlobCountries?: {
    __typename?: 'BlobCountriesMutationResult';
    countries: {
      __typename?: 'BlobCountryEvent';
      apiName: string;
      eventPayload?: {
        __typename?: 'BlobCountryEventPayload';
        externalId?: string | null;
        countries: Array<{
          __typename?: 'BlobCountry';
          countryCode?: string | null;
          countryName?: string | null;
          states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
        }>;
      } | null;
    };
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type StaffStateCountriesEditContainerBlobCountriesMutationResultFieldsFragment = {
  __typename?: 'BlobCountriesMutationResult';
  countries: {
    __typename?: 'BlobCountryEvent';
    apiName: string;
    eventPayload?: {
      __typename?: 'BlobCountryEventPayload';
      externalId?: string | null;
      countries: Array<{
        __typename?: 'BlobCountry';
        countryCode?: string | null;
        countryName?: string | null;
        states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
      }>;
    } | null;
  };
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type StaffStateCountriesEditContainerBlobCountryFieldsFragment = {
  __typename?: 'BlobCountryEvent';
  apiName: string;
  eventPayload?: {
    __typename?: 'BlobCountryEventPayload';
    externalId?: string | null;
    countries: Array<{
      __typename?: 'BlobCountry';
      countryCode?: string | null;
      countryName?: string | null;
      states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
    }>;
  } | null;
};

export type StaffStateCountriesEditContainerEventPayloadFieldsFragment = {
  __typename?: 'BlobCountryEventPayload';
  externalId?: string | null;
  countries: Array<{
    __typename?: 'BlobCountry';
    countryCode?: string | null;
    countryName?: string | null;
    states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
  }>;
};

export type StaffStateCountriesEditContainerCountriesFieldsFragment = {
  __typename?: 'BlobCountry';
  countryCode?: string | null;
  countryName?: string | null;
  states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
};

export type StaffStateCountriesEditContainerStateFieldsFragment = { __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null };

export type StaffStateCountriesViewContainerBlobCountriesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffStateCountriesViewContainerBlobCountriesQuery = {
  __typename?: 'Query';
  blobCountries?: {
    __typename?: 'BlobCountryEvent';
    apiName: string;
    eventTimestamp: any;
    eventUuid: string;
    replayId: string;
    eventPayload?: {
      __typename?: 'BlobCountryEventPayload';
      externalId?: string | null;
      countries: Array<{
        __typename?: 'BlobCountry';
        countryCode?: string | null;
        countryName?: string | null;
        states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
      }>;
    } | null;
  } | null;
};

export type StateCountriesViewContainerBlobCountryEventFieldsFragment = {
  __typename?: 'BlobCountryEvent';
  apiName: string;
  eventTimestamp: any;
  eventUuid: string;
  replayId: string;
  eventPayload?: {
    __typename?: 'BlobCountryEventPayload';
    externalId?: string | null;
    countries: Array<{
      __typename?: 'BlobCountry';
      countryCode?: string | null;
      countryName?: string | null;
      states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
    }>;
  } | null;
};

export type StateCountriesViewContainerEventPayloadFieldsFragment = {
  __typename?: 'BlobCountryEventPayload';
  externalId?: string | null;
  countries: Array<{
    __typename?: 'BlobCountry';
    countryCode?: string | null;
    countryName?: string | null;
    states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
  }>;
};

export type StateCountriesViewContainerBlobCountryFieldsFragment = {
  __typename?: 'BlobCountry';
  countryCode?: string | null;
  countryName?: string | null;
  states?: Array<{ __typename?: 'BlobState'; stateCode?: string | null; stateName?: string | null } | null> | null;
};

export type StaffCreateEntityContainerEntityCreateMutationVariables = Exact<{
  input: EntityCreateInput;
}>;

export type StaffCreateEntityContainerEntityCreateMutation = {
  __typename?: 'Mutation';
  entityCreate: {
    __typename?: 'EntityMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    entity?: {
      __typename?: 'Entity';
      entityName?: string | null;
      isClient?: boolean | null;
      isIssuingInstitution?: boolean | null;
      id: any;
      address?: { __typename?: 'EntityAddressInfo'; city?: string | null; country?: string | null } | null;
      client?: {
        __typename?: 'EntityClient';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
  };
};

export type StaffCreateEntityContainerEntityCreateFieldsFragment = {
  __typename?: 'EntityMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  entity?: {
    __typename?: 'Entity';
    entityName?: string | null;
    isClient?: boolean | null;
    isIssuingInstitution?: boolean | null;
    id: any;
    address?: { __typename?: 'EntityAddressInfo'; city?: string | null; country?: string | null } | null;
    client?: {
      __typename?: 'EntityClient';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
};

export type StaffCreateEntityContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isClient?: boolean | null;
  isIssuingInstitution?: boolean | null;
  id: any;
  address?: { __typename?: 'EntityAddressInfo'; city?: string | null; country?: string | null } | null;
  client?: {
    __typename?: 'EntityClient';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
  issuingInstitution?: {
    __typename?: 'EntityIssuingInstitution';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
};

export type StaffEntityDetailsContainerEntityQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type StaffEntityDetailsContainerEntityQuery = {
  __typename?: 'Query';
  entity?: {
    __typename?: 'Entity';
    entityName?: string | null;
    createdAt?: any | null;
    updatedAt?: any | null;
    isClient?: boolean | null;
    isIssuingInstitution?: boolean | null;
    id: any;
    address?: { __typename?: 'EntityAddressInfo'; city?: string | null; country?: string | null } | null;
    client?: {
      __typename?: 'EntityClient';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
};

export type StaffEntityDetailsContainerEntityDeleteMutationVariables = Exact<{
  entityDeleteId: Scalars['ObjectID']['input'];
}>;

export type StaffEntityDetailsContainerEntityDeleteMutation = {
  __typename?: 'Mutation';
  entityDelete: {
    __typename?: 'EntityMutationResult';
    entity?: {
      __typename?: 'Entity';
      entityName?: string | null;
      createdAt?: any | null;
      updatedAt?: any | null;
      isClient?: boolean | null;
      isIssuingInstitution?: boolean | null;
      id: any;
      address?: { __typename?: 'EntityAddressInfo'; city?: string | null; country?: string | null } | null;
      client?: {
        __typename?: 'EntityClient';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type StaffEntityDetailsContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  createdAt?: any | null;
  updatedAt?: any | null;
  isClient?: boolean | null;
  isIssuingInstitution?: boolean | null;
  id: any;
  address?: { __typename?: 'EntityAddressInfo'; city?: string | null; country?: string | null } | null;
  client?: {
    __typename?: 'EntityClient';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
  issuingInstitution?: {
    __typename?: 'EntityIssuingInstitution';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
};

export type StaffEntityDetailsContainerEntityAddressInfoFieldsFragment = {
  __typename?: 'EntityAddressInfo';
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type StaffEntityDetailsContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffEntityDetailsContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        entityPermissions: {
          __typename?: 'StaffRoleEntityPermissions';
          canAddEntities: boolean;
          canDeleteEntities: boolean;
          canEditEntities: boolean;
          canSearchEntities: boolean;
        };
      };
    } | null;
  } | null;
};

export type StaffEntityDetailsContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      entityPermissions: {
        __typename?: 'StaffRoleEntityPermissions';
        canAddEntities: boolean;
        canDeleteEntities: boolean;
        canEditEntities: boolean;
        canSearchEntities: boolean;
      };
    };
  } | null;
};

export type StaffEntityEditContainerEntityUpdateMutationVariables = Exact<{
  input: EntityUpdateInput;
}>;

export type StaffEntityEditContainerEntityUpdateMutation = {
  __typename?: 'Mutation';
  entityUpdate: {
    __typename?: 'EntityMutationResult';
    entity?: {
      __typename?: 'Entity';
      entityName?: string | null;
      isClient?: boolean | null;
      isIssuingInstitution?: boolean | null;
      id: any;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
      client?: {
        __typename?: 'EntityClient';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
      issuingInstitution?: {
        __typename?: 'EntityIssuingInstitution';
        email?: string | null;
        phoneNumber?: string | null;
        address?: {
          __typename?: 'EntityAddressInfo';
          addressLine1?: string | null;
          addressLine2?: string | null;
          city?: string | null;
          country?: string | null;
          stateOrProvince?: string | null;
          zipOrPostalCode?: string | null;
        } | null;
      } | null;
    } | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  };
};

export type StaffEntityEditContainerEntityMutationResultFieldsFragment = {
  __typename?: 'EntityMutationResult';
  entity?: {
    __typename?: 'Entity';
    entityName?: string | null;
    isClient?: boolean | null;
    isIssuingInstitution?: boolean | null;
    id: any;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
    client?: {
      __typename?: 'EntityClient';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      email?: string | null;
      phoneNumber?: string | null;
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type StaffEntityEditContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isClient?: boolean | null;
  isIssuingInstitution?: boolean | null;
  id: any;
  address?: {
    __typename?: 'EntityAddressInfo';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
  client?: {
    __typename?: 'EntityClient';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
  issuingInstitution?: {
    __typename?: 'EntityIssuingInstitution';
    email?: string | null;
    phoneNumber?: string | null;
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
};

export type StaffEntityEditContainerEntityClientFieldsFragment = {
  __typename?: 'EntityClient';
  email?: string | null;
  phoneNumber?: string | null;
  address?: {
    __typename?: 'EntityAddressInfo';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type StaffEntityEditContainerEntityIssuingInstitutionFieldsFragment = {
  __typename?: 'EntityIssuingInstitution';
  email?: string | null;
  phoneNumber?: string | null;
  address?: {
    __typename?: 'EntityAddressInfo';
    addressLine1?: string | null;
    addressLine2?: string | null;
    city?: string | null;
    country?: string | null;
    stateOrProvince?: string | null;
    zipOrPostalCode?: string | null;
  } | null;
};

export type StaffEntityEditContainerEntityAddressInfoFieldsFragment = {
  __typename?: 'EntityAddressInfo';
  addressLine1?: string | null;
  addressLine2?: string | null;
  city?: string | null;
  country?: string | null;
  stateOrProvince?: string | null;
  zipOrPostalCode?: string | null;
};

export type StaffEntityEditContainerMutationStatusFieldsFragment = { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };

export type StaffEntitySearchContainerEntitySearchQueryVariables = Exact<{
  input?: InputMaybe<EntitySearchInput>;
}>;

export type StaffEntitySearchContainerEntitySearchQuery = {
  __typename?: 'Query';
  entitySearch?: {
    __typename?: 'EntitySearchResult';
    count?: number | null;
    entityResults?: Array<{
      __typename?: 'EntityResult';
      entityName?: string | null;
      city?: string | null;
      country?: string | null;
      updatedAt?: any | null;
      id?: string | null;
    } | null> | null;
    facets?: {
      __typename?: 'EntitySearchFacets';
      createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      disabledAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      isClient?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      isIssuingInstitution?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    } | null;
  } | null;
};

export type StaffEntitySearchContainerEntitySearchResultFieldsFragment = {
  __typename?: 'EntitySearchResult';
  count?: number | null;
  entityResults?: Array<{
    __typename?: 'EntityResult';
    entityName?: string | null;
    city?: string | null;
    country?: string | null;
    updatedAt?: any | null;
    id?: string | null;
  } | null> | null;
  facets?: {
    __typename?: 'EntitySearchFacets';
    createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    disabledAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    isClient?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    isIssuingInstitution?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  } | null;
};

export type StaffEntitySearchContainerEntityResultFieldsFragment = {
  __typename?: 'EntityResult';
  entityName?: string | null;
  city?: string | null;
  country?: string | null;
  updatedAt?: any | null;
  id?: string | null;
};

export type StaffEntitySearchContainerEntitySearchFacetsFieldsFragment = {
  __typename?: 'EntitySearchFacets';
  createdAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  disabledAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  isClient?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  isIssuingInstitution?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  updatedAt?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
};

export type StaffEntitySearchContainerFacetDetailFieldsFragment = { __typename?: 'FacetDetail'; count?: number | null; value?: string | null };

export type StaffEntitySearchContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffEntitySearchContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean; canAddEntities: boolean };
      };
    } | null;
  } | null;
};

export type StaffEntitySearchContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean; canAddEntities: boolean };
    };
  } | null;
};

export type StaffFeatureFlagsContainerBlobFeatureFlagsQueryVariables = Exact<{ [key: string]: never }>;

export type StaffFeatureFlagsContainerBlobFeatureFlagsQuery = {
  __typename?: 'Query';
  blobFeatureFlags?: Array<{ __typename?: 'BlobFeatureFlag'; allowedValues: Array<string>; description: string; name: string; retirementDate: any; value: string }> | null;
};

export type StaffFeatureFlagsContainerUpdateBlobFeatureFlagsMutationVariables = Exact<{
  input: BlobFeatureFlagInput;
}>;

export type StaffFeatureFlagsContainerUpdateBlobFeatureFlagsMutation = {
  __typename?: 'Mutation';
  updateBlobFeatureFlags?: {
    __typename?: 'BlobFeatureFlagMutationResult';
    featureFlags?: Array<{ __typename?: 'BlobFeatureFlag'; allowedValues: Array<string>; description: string; name: string; retirementDate: any; value: string }> | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type StaffFeatureFlagsContainerBlobFeatureFlagMutationResultFieldsFragment = {
  __typename?: 'BlobFeatureFlagMutationResult';
  featureFlags?: Array<{ __typename?: 'BlobFeatureFlag'; allowedValues: Array<string>; description: string; name: string; retirementDate: any; value: string }> | null;
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type StaffFeatureFlagsContainerBlobFeatureFlagFieldsFragment = {
  __typename?: 'BlobFeatureFlag';
  allowedValues: Array<string>;
  description: string;
  name: string;
  retirementDate: any;
  value: string;
};

export type StaffFinanceBatchContainerGlPostingSummariesByDateRangeQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
}>;

export type StaffFinanceBatchContainerGlPostingSummariesByDateRangeQuery = {
  __typename?: 'Query';
  glPostingSummariesByDateRange?: Array<{
    __typename?: 'GlPostingSummary';
    glTransactionDate: any;
    schemaVersion?: string | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    glSummary: Array<{
      __typename?: 'GlPostingSummaryGlSummary';
      accountingType: string;
      amount: number;
      glAccountId: string;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
    } | null>;
    postingAttempt?: Array<{
      __typename?: 'GlPostingSummaryPostingAttempt';
      createdUser: string;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      attemptData: { __typename?: 'GlPostingSummaryPostingAttemptAttemptData'; attemptedAt?: any | null; status: string };
      responseData?: {
        __typename?: 'GlPostingSummaryPostingAttemptResponseData';
        errorMessage?: string | null;
        glBatchNumber?: string | null;
        isSuccess: boolean;
        jEntryNumber?: number | null;
        respondedAt: any;
      } | null;
    } | null> | null;
  } | null> | null;
};

export type StaffFinanceBatchContainerGlPostingSummaryFieldsFragment = {
  __typename?: 'GlPostingSummary';
  glTransactionDate: any;
  schemaVersion?: string | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  glSummary: Array<{
    __typename?: 'GlPostingSummaryGlSummary';
    accountingType: string;
    amount: number;
    glAccountId: string;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
  } | null>;
  postingAttempt?: Array<{
    __typename?: 'GlPostingSummaryPostingAttempt';
    createdUser: string;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    attemptData: { __typename?: 'GlPostingSummaryPostingAttemptAttemptData'; attemptedAt?: any | null; status: string };
    responseData?: {
      __typename?: 'GlPostingSummaryPostingAttemptResponseData';
      errorMessage?: string | null;
      glBatchNumber?: string | null;
      isSuccess: boolean;
      jEntryNumber?: number | null;
      respondedAt: any;
    } | null;
  } | null> | null;
};

export type StaffFinanceBatchContainerGlPostingSummaryGlSummaryFieldsFragment = {
  __typename?: 'GlPostingSummaryGlSummary';
  accountingType: string;
  amount: number;
  glAccountId: string;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
};

export type StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFieldsFragment = {
  __typename?: 'GlPostingSummaryPostingAttempt';
  createdUser: string;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  attemptData: { __typename?: 'GlPostingSummaryPostingAttemptAttemptData'; attemptedAt?: any | null; status: string };
  responseData?: {
    __typename?: 'GlPostingSummaryPostingAttemptResponseData';
    errorMessage?: string | null;
    glBatchNumber?: string | null;
    isSuccess: boolean;
    jEntryNumber?: number | null;
    respondedAt: any;
  } | null;
};

export type StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFieldsFragment = {
  __typename?: 'GlPostingSummaryPostingAttemptAttemptData';
  attemptedAt?: any | null;
  status: string;
};

export type StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFieldsFragment = {
  __typename?: 'GlPostingSummaryPostingAttemptResponseData';
  errorMessage?: string | null;
  glBatchNumber?: string | null;
  isSuccess: boolean;
  jEntryNumber?: number | null;
  respondedAt: any;
};

export type StaffFinanceDetailContainerGlTransactionSummariesByDateRangeQueryVariables = Exact<{
  endDate?: InputMaybe<Scalars['Date']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
}>;

export type StaffFinanceDetailContainerGlTransactionSummariesByDateRangeQuery = {
  __typename?: 'Query';
  glTransactionSummariesByDateRange?: Array<{
    __typename?: 'GlTransactionSummary';
    transactionType: string;
    amount: number;
    case: any;
    caseType: string;
    reason?: string | null;
    id: any;
    createdAt?: any | null;
    transactionReference?: { __typename?: 'GlTransactionSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null; vendor?: string | null } | null;
    applicant: { __typename?: 'ApplicantUser'; displayName?: string | null };
    financeReference: { __typename?: 'GlTransactionSummaryFinanceReference'; debitGlAccount: string; creditGlAccount: string };
  } | null> | null;
};

export type StaffFinanceDetailContainerGlTransactionSummaryFieldsFragment = {
  __typename?: 'GlTransactionSummary';
  transactionType: string;
  amount: number;
  case: any;
  caseType: string;
  reason?: string | null;
  id: any;
  createdAt?: any | null;
  transactionReference?: { __typename?: 'GlTransactionSummaryTransactionReference'; completedAt?: any | null; referenceId?: string | null; vendor?: string | null } | null;
  applicant: { __typename?: 'ApplicantUser'; displayName?: string | null };
  financeReference: { __typename?: 'GlTransactionSummaryFinanceReference'; debitGlAccount: string; creditGlAccount: string };
};

export type StaffFinanceSettingsContainerBlobFinancialConfigsQueryVariables = Exact<{ [key: string]: never }>;

export type StaffFinanceSettingsContainerBlobFinancialConfigsQuery = {
  __typename?: 'Query';
  blobFinancialConfigs?: Array<{
    __typename?: 'BlobFinancialConfig';
    caseType?: string | null;
    effectiveAt?: any | null;
    ruleName?: string | null;
    version?: string | null;
    id?: string | null;
  } | null> | null;
};

export type StaffFinanceSettingsContainerBlobFinancialGlConfigQueryVariables = Exact<{
  input: BlobFinanceConfigNameInput;
}>;

export type StaffFinanceSettingsContainerBlobFinancialGlConfigQuery = {
  __typename?: 'Query';
  blobFinancialGlConfig?: {
    __typename?: 'BlobFinanceConfig';
    effectiveAt?: any | null;
    id?: string | null;
    glConfig?: {
      __typename?: 'BlobFinanceGlConfig';
      createdAt?: any | null;
      createdBy?: string | null;
      note?: string | null;
      version?: string | null;
      submission?: { __typename?: 'BlobFinanceSubmission'; amount?: number | null; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
      additionalCharges?: Array<{
        __typename?: 'BlobFinanceAdditionalCharge';
        type?: string | null;
        creditGLAccount?: string | null;
        debitGLAccount?: string | null;
      } | null> | null;
      refunds?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
      recognition?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
    } | null;
  } | null;
};

export type StaffFinanceSettingsContainerStaffUsersQueryVariables = Exact<{ [key: string]: never }>;

export type StaffFinanceSettingsContainerStaffUsersQuery = {
  __typename?: 'Query';
  staffUsers?: Array<{ __typename?: 'StaffUser'; displayName?: string | null; id: any } | null> | null;
};

export type StaffFinanceSettingsContainerUpdateBlobFinanceGlConfigMutationVariables = Exact<{
  input: BlobFinanceConfigInput;
}>;

export type StaffFinanceSettingsContainerUpdateBlobFinanceGlConfigMutation = {
  __typename?: 'Mutation';
  updateBlobFinanceGlConfig?: {
    __typename?: 'BlobFinanceConfigMutationResult';
    financeGlConfig: {
      __typename?: 'BlobFinanceConfig';
      effectiveAt?: any | null;
      id?: string | null;
      glConfig?: {
        __typename?: 'BlobFinanceGlConfig';
        createdAt?: any | null;
        createdBy?: string | null;
        note?: string | null;
        version?: string | null;
        submission?: { __typename?: 'BlobFinanceSubmission'; amount?: number | null; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
        additionalCharges?: Array<{
          __typename?: 'BlobFinanceAdditionalCharge';
          type?: string | null;
          creditGLAccount?: string | null;
          debitGLAccount?: string | null;
        } | null> | null;
        refunds?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
        recognition?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
      } | null;
    };
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type StaffFinanceSettingsContainerBlobFinanceConfigMutationResultFieldsFragment = {
  __typename?: 'BlobFinanceConfigMutationResult';
  financeGlConfig: {
    __typename?: 'BlobFinanceConfig';
    effectiveAt?: any | null;
    id?: string | null;
    glConfig?: {
      __typename?: 'BlobFinanceGlConfig';
      createdAt?: any | null;
      createdBy?: string | null;
      note?: string | null;
      version?: string | null;
      submission?: { __typename?: 'BlobFinanceSubmission'; amount?: number | null; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
      additionalCharges?: Array<{
        __typename?: 'BlobFinanceAdditionalCharge';
        type?: string | null;
        creditGLAccount?: string | null;
        debitGLAccount?: string | null;
      } | null> | null;
      refunds?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
      recognition?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
    } | null;
  };
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type StaffFinanceSettingsContainerBlobFinancialConfigFieldsFragment = {
  __typename?: 'BlobFinancialConfig';
  caseType?: string | null;
  effectiveAt?: any | null;
  ruleName?: string | null;
  version?: string | null;
  id?: string | null;
};

export type StaffFinanceSettingsContainerBlobFinanceConfigFieldsFragment = {
  __typename?: 'BlobFinanceConfig';
  effectiveAt?: any | null;
  id?: string | null;
  glConfig?: {
    __typename?: 'BlobFinanceGlConfig';
    createdAt?: any | null;
    createdBy?: string | null;
    note?: string | null;
    version?: string | null;
    submission?: { __typename?: 'BlobFinanceSubmission'; amount?: number | null; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
    additionalCharges?: Array<{
      __typename?: 'BlobFinanceAdditionalCharge';
      type?: string | null;
      creditGLAccount?: string | null;
      debitGLAccount?: string | null;
    } | null> | null;
    refunds?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
    recognition?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
  } | null;
};

export type StaffFinanceSettingsContainerBlobFinanceGlConfigFieldsFragment = {
  __typename?: 'BlobFinanceGlConfig';
  createdAt?: any | null;
  createdBy?: string | null;
  note?: string | null;
  version?: string | null;
  submission?: { __typename?: 'BlobFinanceSubmission'; amount?: number | null; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
  additionalCharges?: Array<{
    __typename?: 'BlobFinanceAdditionalCharge';
    type?: string | null;
    creditGLAccount?: string | null;
    debitGLAccount?: string | null;
  } | null> | null;
  refunds?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
  recognition?: { __typename?: 'BlobFinanceRefund'; creditGLAccount?: string | null; debitGLAccount?: string | null } | null;
};

export type StaffFinanceSettingsContainerStaffUserFieldsFragment = { __typename?: 'StaffUser'; displayName?: string | null; id: any };

export type StaffHealthProfessionContainerBlobHealthProfessionsQueryVariables = Exact<{ [key: string]: never }>;

export type StaffHealthProfessionContainerBlobHealthProfessionsQuery = {
  __typename?: 'Query';
  blobHealthProfessions?: {
    __typename?: 'BlobHealthProfession';
    createdAt?: any | null;
    updatedAt?: any | null;
    updatedBy?: string | null;
    healthProfessions?: Array<{ __typename?: 'HealthProfessionsData'; professionCode?: string | null; professionName?: string | null } | null> | null;
  } | null;
};

export type HealthProfessionsContainerBlobHealthProfessionsFieldsFragment = {
  __typename?: 'BlobHealthProfession';
  createdAt?: any | null;
  updatedAt?: any | null;
  updatedBy?: string | null;
  healthProfessions?: Array<{ __typename?: 'HealthProfessionsData'; professionCode?: string | null; professionName?: string | null } | null> | null;
};

export type StaffHealthProfessionContainerHealthProfessionsUpdateMutationVariables = Exact<{
  input: HealthProfessionsInput;
}>;

export type StaffHealthProfessionContainerHealthProfessionsUpdateMutation = {
  __typename?: 'Mutation';
  healthProfessionsUpdate?: {
    __typename?: 'BlobHealthProfessionsMutationResult';
    healthProfessions: {
      __typename?: 'BlobHealthProfession';
      createdAt?: any | null;
      updatedAt?: any | null;
      updatedBy?: string | null;
      healthProfessions?: Array<{ __typename?: 'HealthProfessionsData'; professionCode?: string | null; professionName?: string | null } | null> | null;
    };
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type HealthProfessionsContainerHealthProfessionsMutationResultFieldsFragment = {
  __typename?: 'BlobHealthProfessionsMutationResult';
  healthProfessions: {
    __typename?: 'BlobHealthProfession';
    createdAt?: any | null;
    updatedAt?: any | null;
    updatedBy?: string | null;
    healthProfessions?: Array<{ __typename?: 'HealthProfessionsData'; professionCode?: string | null; professionName?: string | null } | null> | null;
  };
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
};

export type HealthProfessionsContainerHealthProfessionsFieldsFragment = {
  __typename?: 'HealthProfessionsData';
  professionCode?: string | null;
  professionName?: string | null;
};

export type StaffProfileHeaderContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffProfileHeaderContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canUpdatePersonalInformation: boolean };
      };
    } | null;
  } | null;
};

export type StaffProfileHeaderContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canUpdatePersonalInformation: boolean };
    };
  } | null;
};

export type StaffReIndexSearchCollectionContainerUserReIndexQueryVariables = Exact<{ [key: string]: never }>;

export type StaffReIndexSearchCollectionContainerUserReIndexQuery = {
  __typename?: 'Query';
  userReIndex?: { __typename?: 'UserReIndexResult'; applicantUserReIndexErrors?: Array<string | null> | null; staffUserReIndexErrors?: Array<string | null> | null } | null;
};

export type StaffReIndexSearchCollectionContainerUserReIndexFieldsFragment = {
  __typename?: 'UserReIndexResult';
  applicantUserReIndexErrors?: Array<string | null> | null;
  staffUserReIndexErrors?: Array<string | null> | null;
};

export type StaffReIndexSearchCollectionContainerCaseReIndexQueryVariables = Exact<{ [key: string]: never }>;

export type StaffReIndexSearchCollectionContainerCaseReIndexQuery = {
  __typename?: 'Query';
  caseReIndex?: {
    __typename?: 'CaseReIndexResult';
    identityCaseReIndexErrors?: Array<string | null> | null;
    credentialCaseReIndexErrors?: Array<string | null> | null;
    sendReportCaseReIndexErrors?: Array<string | null> | null;
  } | null;
};

export type StaffReIndexSearchCollectionContainerCaseReIndexFieldsFragment = {
  __typename?: 'CaseReIndexResult';
  identityCaseReIndexErrors?: Array<string | null> | null;
  credentialCaseReIndexErrors?: Array<string | null> | null;
  sendReportCaseReIndexErrors?: Array<string | null> | null;
};

export type StaffReIndexSearchCollectionContainerEntityReIndexQueryVariables = Exact<{ [key: string]: never }>;

export type StaffReIndexSearchCollectionContainerEntityReIndexQuery = {
  __typename?: 'Query';
  entityReIndex?: { __typename?: 'EntityReIndexResult'; entityReIndexErrors?: Array<string | null> | null } | null;
};

export type StaffReIndexSearchCollectionContainerEntityReIndexFieldsFragment = { __typename?: 'EntityReIndexResult'; entityReIndexErrors?: Array<string | null> | null };

export type StaffReIndexSearchCollectionContainerIdentityCaseReIndexQueryVariables = Exact<{ [key: string]: never }>;

export type StaffReIndexSearchCollectionContainerIdentityCaseReIndexQuery = { __typename?: 'Query'; identityCaseReIndex?: Array<string | null> | null };

export type StaffReIndexSearchCollectionContainerCredentialCaseReIndexQueryVariables = Exact<{ [key: string]: never }>;

export type StaffReIndexSearchCollectionContainerCredentialCaseReIndexQuery = { __typename?: 'Query'; credentialCaseReIndex?: Array<string | null> | null };

export type StaffReIndexSearchCollectionContainerSendReportCaseReIndexQueryVariables = Exact<{ [key: string]: never }>;

export type StaffReIndexSearchCollectionContainerSendReportCaseReIndexQuery = { __typename?: 'Query'; sendReportCaseReIndex?: Array<string | null> | null };

export type StaffReportCoverLetterContainerEntitiesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffReportCoverLetterContainerEntitiesQuery = {
  __typename?: 'Query';
  entities?: Array<{
    __typename?: 'Entity';
    entityName?: string | null;
    isIssuingInstitution?: boolean | null;
    isClient?: boolean | null;
    id: any;
    issuingInstitution?: {
      __typename?: 'EntityIssuingInstitution';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
    client?: {
      __typename?: 'EntityClient';
      address?: {
        __typename?: 'EntityAddressInfo';
        addressLine1?: string | null;
        addressLine2?: string | null;
        city?: string | null;
        country?: string | null;
        stateOrProvince?: string | null;
        zipOrPostalCode?: string | null;
      } | null;
    } | null;
  } | null> | null;
};

export type StaffReportCoverLetterContainerEntityFieldsFragment = {
  __typename?: 'Entity';
  entityName?: string | null;
  isIssuingInstitution?: boolean | null;
  isClient?: boolean | null;
  id: any;
  issuingInstitution?: {
    __typename?: 'EntityIssuingInstitution';
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
  client?: {
    __typename?: 'EntityClient';
    address?: {
      __typename?: 'EntityAddressInfo';
      addressLine1?: string | null;
      addressLine2?: string | null;
      city?: string | null;
      country?: string | null;
      stateOrProvince?: string | null;
      zipOrPostalCode?: string | null;
    } | null;
  } | null;
};

export type RoleCreateContainerStaffRoleCreateMutationVariables = Exact<{
  input: StaffRoleCreateInput;
}>;

export type RoleCreateContainerStaffRoleCreateMutation = {
  __typename?: 'Mutation';
  staffRoleCreate: {
    __typename?: 'StaffRoleMutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    staffRole?: {
      __typename?: 'StaffRole';
      roleName: string;
      roleSubtype: string;
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        applicantUserPermissions: {
          __typename?: 'StaffRoleApplicantUserPermissions';
          canAddOrRemoveTags: boolean;
          canBlockAccess: boolean;
          canSearchApplicants: boolean;
          canUpdatePersonalInformation: boolean;
        };
        credCasePermissions: {
          __typename?: 'StaffRoleCredCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canViewCaseHistory: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        entityPermissions: {
          __typename?: 'StaffRoleEntityPermissions';
          canAddEntities: boolean;
          canDeleteEntities: boolean;
          canEditEntities: boolean;
          canSearchEntities: boolean;
        };
        idCasePermissions: {
          __typename?: 'StaffRoleIdCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canViewCaseHistory: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
        sendCasePermissions: {
          __typename?: 'StaffRoleSendCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canViewCaseHistory: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        staffUserPermissions: {
          __typename?: 'StaffRoleStaffUserPermissions';
          canAddOrRemoveTags: boolean;
          canAssignRoles: boolean;
          canBlockAccess: boolean;
          canSearchStaff: boolean;
        };
      };
    } | null;
  };
};

export type RoleCreateContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type RoleCreateContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: { __typename?: 'StaffUser'; id: any; role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null } | null;
};

export type RoleCreateContainerStaffUserFieldsFragment = { __typename?: 'StaffUser'; id: any; role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null };

export type RoleCreateContainerStaffRoleMutationResultFieldsFragment = {
  __typename?: 'StaffRoleMutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  staffRole?: {
    __typename?: 'StaffRole';
    roleName: string;
    roleSubtype: string;
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: {
        __typename?: 'StaffRoleApplicantUserPermissions';
        canAddOrRemoveTags: boolean;
        canBlockAccess: boolean;
        canSearchApplicants: boolean;
        canUpdatePersonalInformation: boolean;
      };
      credCasePermissions: {
        __typename?: 'StaffRoleCredCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      entityPermissions: {
        __typename?: 'StaffRoleEntityPermissions';
        canAddEntities: boolean;
        canDeleteEntities: boolean;
        canEditEntities: boolean;
        canSearchEntities: boolean;
      };
      idCasePermissions: {
        __typename?: 'StaffRoleIdCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
      sendCasePermissions: {
        __typename?: 'StaffRoleSendCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      staffUserPermissions: {
        __typename?: 'StaffRoleStaffUserPermissions';
        canAddOrRemoveTags: boolean;
        canAssignRoles: boolean;
        canBlockAccess: boolean;
        canSearchStaff: boolean;
      };
    };
  } | null;
};

export type RoleCreateContainerStaffRoleFieldsFragment = {
  __typename?: 'StaffRole';
  roleName: string;
  roleSubtype: string;
  id: any;
  permissions: {
    __typename?: 'StaffRolePermissions';
    applicantUserPermissions: {
      __typename?: 'StaffRoleApplicantUserPermissions';
      canAddOrRemoveTags: boolean;
      canBlockAccess: boolean;
      canSearchApplicants: boolean;
      canUpdatePersonalInformation: boolean;
    };
    credCasePermissions: {
      __typename?: 'StaffRoleCredCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canViewCaseHistory: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    entityPermissions: {
      __typename?: 'StaffRoleEntityPermissions';
      canAddEntities: boolean;
      canDeleteEntities: boolean;
      canEditEntities: boolean;
      canSearchEntities: boolean;
    };
    idCasePermissions: {
      __typename?: 'StaffRoleIdCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canViewCaseHistory: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
    sendCasePermissions: {
      __typename?: 'StaffRoleSendCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canViewCaseHistory: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    staffUserPermissions: {
      __typename?: 'StaffRoleStaffUserPermissions';
      canAddOrRemoveTags: boolean;
      canAssignRoles: boolean;
      canBlockAccess: boolean;
      canSearchStaff: boolean;
    };
  };
};

export type RoleDetailContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type RoleDetailContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      roleSubtype: string;
      id: any;
      permissions: { __typename?: 'StaffRolePermissions'; rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canEditRoles: boolean } };
    } | null;
  } | null;
};

export type RoleDetailContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    roleSubtype: string;
    id: any;
    permissions: { __typename?: 'StaffRolePermissions'; rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canEditRoles: boolean } };
  } | null;
};

export type RoleEditContainerStaffRoleQueryVariables = Exact<{
  staffRoleId: Scalars['ObjectID']['input'];
}>;

export type RoleEditContainerStaffRoleQuery = {
  __typename?: 'Query';
  staffRole?: {
    __typename?: 'StaffRole';
    roleName: string;
    roleSubtype: string;
    isDefault: boolean;
    createdAt?: any | null;
    updatedAt?: any | null;
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: {
        __typename?: 'StaffRoleApplicantUserPermissions';
        canAddOrRemoveTags: boolean;
        canBlockAccess: boolean;
        canSearchApplicants: boolean;
        canUpdatePersonalInformation: boolean;
      };
      credCasePermissions: {
        __typename?: 'StaffRoleCredCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      entityPermissions: {
        __typename?: 'StaffRoleEntityPermissions';
        canAddEntities: boolean;
        canDeleteEntities: boolean;
        canEditEntities: boolean;
        canSearchEntities: boolean;
      };
      idCasePermissions: {
        __typename?: 'StaffRoleIdCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
      sendCasePermissions: {
        __typename?: 'StaffRoleSendCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      staffUserPermissions: {
        __typename?: 'StaffRoleStaffUserPermissions';
        canAddOrRemoveTags: boolean;
        canAssignRoles: boolean;
        canBlockAccess: boolean;
        canSearchStaff: boolean;
      };
    };
  } | null;
};

export type RoleEditContainerStaffRoleUpdateMutationVariables = Exact<{
  input: StaffRoleUpdateInput;
}>;

export type RoleEditContainerStaffRoleUpdateMutation = {
  __typename?: 'Mutation';
  staffRoleUpdate: {
    __typename?: 'StaffRoleMutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    staffRole?: {
      __typename?: 'StaffRole';
      roleName: string;
      roleSubtype: string;
      isDefault: boolean;
      createdAt?: any | null;
      updatedAt?: any | null;
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        applicantUserPermissions: {
          __typename?: 'StaffRoleApplicantUserPermissions';
          canAddOrRemoveTags: boolean;
          canBlockAccess: boolean;
          canSearchApplicants: boolean;
          canUpdatePersonalInformation: boolean;
        };
        credCasePermissions: {
          __typename?: 'StaffRoleCredCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canViewCaseHistory: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        entityPermissions: {
          __typename?: 'StaffRoleEntityPermissions';
          canAddEntities: boolean;
          canDeleteEntities: boolean;
          canEditEntities: boolean;
          canSearchEntities: boolean;
        };
        idCasePermissions: {
          __typename?: 'StaffRoleIdCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canViewCaseHistory: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
        sendCasePermissions: {
          __typename?: 'StaffRoleSendCasePermissions';
          canAssignCaseWorker: boolean;
          canAssignSelf: boolean;
          canBeAssignedCases: boolean;
          canIssueRefunds: boolean;
          canViewCaseHistory: boolean;
          canOverrideCaseState: boolean;
          canReopenCases: boolean;
          canSearchCases: boolean;
          canUnassignCaseWorker: boolean;
          canUnassignSelf: boolean;
          canViewCasesAssignedToOthers: boolean;
          canViewUnassignedCases: boolean;
        };
        staffUserPermissions: {
          __typename?: 'StaffRoleStaffUserPermissions';
          canAddOrRemoveTags: boolean;
          canAssignRoles: boolean;
          canBlockAccess: boolean;
          canSearchStaff: boolean;
        };
      };
    } | null;
  };
};

export type RoleEditContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type RoleEditContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: { __typename?: 'StaffUser'; id: any; role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null } | null;
};

export type RoleEditContainerStaffRoleMutationResultFieldsFragment = {
  __typename?: 'StaffRoleMutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  staffRole?: {
    __typename?: 'StaffRole';
    roleName: string;
    roleSubtype: string;
    isDefault: boolean;
    createdAt?: any | null;
    updatedAt?: any | null;
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: {
        __typename?: 'StaffRoleApplicantUserPermissions';
        canAddOrRemoveTags: boolean;
        canBlockAccess: boolean;
        canSearchApplicants: boolean;
        canUpdatePersonalInformation: boolean;
      };
      credCasePermissions: {
        __typename?: 'StaffRoleCredCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      entityPermissions: {
        __typename?: 'StaffRoleEntityPermissions';
        canAddEntities: boolean;
        canDeleteEntities: boolean;
        canEditEntities: boolean;
        canSearchEntities: boolean;
      };
      idCasePermissions: {
        __typename?: 'StaffRoleIdCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
      sendCasePermissions: {
        __typename?: 'StaffRoleSendCasePermissions';
        canAssignCaseWorker: boolean;
        canAssignSelf: boolean;
        canBeAssignedCases: boolean;
        canIssueRefunds: boolean;
        canViewCaseHistory: boolean;
        canOverrideCaseState: boolean;
        canReopenCases: boolean;
        canSearchCases: boolean;
        canUnassignCaseWorker: boolean;
        canUnassignSelf: boolean;
        canViewCasesAssignedToOthers: boolean;
        canViewUnassignedCases: boolean;
      };
      staffUserPermissions: {
        __typename?: 'StaffRoleStaffUserPermissions';
        canAddOrRemoveTags: boolean;
        canAssignRoles: boolean;
        canBlockAccess: boolean;
        canSearchStaff: boolean;
      };
    };
  } | null;
};

export type RoleEditContainerStaffRoleFieldsFragment = {
  __typename?: 'StaffRole';
  roleName: string;
  roleSubtype: string;
  isDefault: boolean;
  createdAt?: any | null;
  updatedAt?: any | null;
  id: any;
  permissions: {
    __typename?: 'StaffRolePermissions';
    applicantUserPermissions: {
      __typename?: 'StaffRoleApplicantUserPermissions';
      canAddOrRemoveTags: boolean;
      canBlockAccess: boolean;
      canSearchApplicants: boolean;
      canUpdatePersonalInformation: boolean;
    };
    credCasePermissions: {
      __typename?: 'StaffRoleCredCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canViewCaseHistory: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    entityPermissions: {
      __typename?: 'StaffRoleEntityPermissions';
      canAddEntities: boolean;
      canDeleteEntities: boolean;
      canEditEntities: boolean;
      canSearchEntities: boolean;
    };
    idCasePermissions: {
      __typename?: 'StaffRoleIdCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canViewCaseHistory: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean; canSearchRoles: boolean };
    sendCasePermissions: {
      __typename?: 'StaffRoleSendCasePermissions';
      canAssignCaseWorker: boolean;
      canAssignSelf: boolean;
      canBeAssignedCases: boolean;
      canIssueRefunds: boolean;
      canViewCaseHistory: boolean;
      canOverrideCaseState: boolean;
      canReopenCases: boolean;
      canSearchCases: boolean;
      canUnassignCaseWorker: boolean;
      canUnassignSelf: boolean;
      canViewCasesAssignedToOthers: boolean;
      canViewUnassignedCases: boolean;
    };
    staffUserPermissions: {
      __typename?: 'StaffRoleStaffUserPermissions';
      canAddOrRemoveTags: boolean;
      canAssignRoles: boolean;
      canBlockAccess: boolean;
      canSearchStaff: boolean;
    };
  };
};

export type RoleEditContainerStaffUserFieldsFragment = { __typename?: 'StaffUser'; id: any; role?: { __typename?: 'StaffRole'; roleSubtype: string; id: any } | null };

export type RoleListContainerStaffRolesQueryQueryVariables = Exact<{ [key: string]: never }>;

export type RoleListContainerStaffRolesQueryQuery = {
  __typename?: 'Query';
  staffRoles?: Array<{ __typename?: 'StaffRole'; roleName: string; isDefault: boolean; updatedAt?: any | null; createdAt?: any | null; id: any } | null> | null;
};

export type RoleListContainerStaffRoleFieldsFragment = {
  __typename?: 'StaffRole';
  roleName: string;
  isDefault: boolean;
  updatedAt?: any | null;
  createdAt?: any | null;
  id: any;
};

export type RoleListContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type RoleListContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    role?: {
      __typename?: 'StaffRole';
      permissions: { __typename?: 'StaffRolePermissions'; rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canAddRoles: boolean; canEditRoles: boolean } };
    } | null;
  } | null;
};

export type StaffEditContainerStaffUserQueryVariables = Exact<{
  staffUserId: Scalars['ObjectID']['input'];
}>;

export type StaffEditContainerStaffUserQuery = {
  __typename?: 'Query';
  staffUser?: {
    __typename?: 'StaffUser';
    lastName?: string | null;
    firstName?: string | null;
    accessBlocked?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    role?: { __typename?: 'StaffRole'; roleName: string; id: any } | null;
  } | null;
};

export type StaffEditContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  lastName?: string | null;
  firstName?: string | null;
  accessBlocked?: boolean | null;
  tags?: Array<string | null> | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  role?: { __typename?: 'StaffRole'; roleName: string; id: any } | null;
};

export type StaffEditContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffEditContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      roleSubtype: string;
      permissions: {
        __typename?: 'StaffRolePermissions';
        staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canAssignRoles: boolean; canBlockAccess: boolean; canAddOrRemoveTags: boolean };
      };
    } | null;
  } | null;
};

export type StaffEditContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    roleSubtype: string;
    permissions: {
      __typename?: 'StaffRolePermissions';
      staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canAssignRoles: boolean; canBlockAccess: boolean; canAddOrRemoveTags: boolean };
    };
  } | null;
};

export type StaffEditContainerStaffRolesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffEditContainerStaffRolesQuery = { __typename?: 'Query'; staffRoles?: Array<{ __typename?: 'StaffRole'; roleName: string; id: any } | null> | null };

export type StaffEditContainerStaffRoleFieldsFragment = { __typename?: 'StaffRole'; roleName: string; id: any };

export type StaffEditContainerStaffUserUpdateMutationVariables = Exact<{
  input: StaffUserUpdateInput;
}>;

export type StaffEditContainerStaffUserUpdateMutation = {
  __typename?: 'Mutation';
  staffUserUpdate: {
    __typename?: 'StaffUserMutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    staffUser?: {
      __typename?: 'StaffUser';
      lastName?: string | null;
      firstName?: string | null;
      accessBlocked?: boolean | null;
      tags?: Array<string | null> | null;
      id: any;
      createdAt?: any | null;
      updatedAt?: any | null;
      role?: { __typename?: 'StaffRole'; roleName: string; id: any } | null;
    } | null;
  };
};

export type StaffEditContainerStaffUserMutationResultFieldsFragment = {
  __typename?: 'StaffUserMutationResult';
  status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  staffUser?: {
    __typename?: 'StaffUser';
    lastName?: string | null;
    firstName?: string | null;
    accessBlocked?: boolean | null;
    tags?: Array<string | null> | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    role?: { __typename?: 'StaffRole'; roleName: string; id: any } | null;
  } | null;
};

export type StaffStaffSearchFilterContainerStaffRolesQueryVariables = Exact<{ [key: string]: never }>;

export type StaffStaffSearchFilterContainerStaffRolesQuery = {
  __typename?: 'Query';
  staffRoles?: Array<{ __typename?: 'StaffRole'; roleName: string; id: any } | null> | null;
};

export type StaffStaffSearchFilterContainerStaffRolesFieldsFragment = { __typename?: 'StaffRole'; roleName: string; id: any };

export type StaffStaffSearchFilterContainerStaffUserGetAllTagsQueryVariables = Exact<{ [key: string]: never }>;

export type StaffStaffSearchFilterContainerStaffUserGetAllTagsQuery = { __typename?: 'Query'; staffUserGetAllTags?: Array<string | null> | null };

export type StaffStaffSearchContainerStaffUsersQueryVariables = Exact<{
  input?: InputMaybe<StaffUserSearchInput>;
}>;

export type StaffStaffSearchContainerStaffUsersQuery = {
  __typename?: 'Query';
  staffUserSearch?: {
    __typename?: 'StaffUserSearchResult';
    count?: number | null;
    staffUserResults?: Array<{
      __typename?: 'StaffUserResult';
      displayName?: string | null;
      createdAt?: any | null;
      accessBlocked?: boolean | null;
      id?: any | null;
      role?: { __typename?: 'StaffUserSearchRoleResult'; roleName?: string | null; id?: any | null } | null;
    } | null> | null;
    facets?: {
      __typename?: 'StaffUserSearchFacets';
      accessBlocked?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      createdAt?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
      role?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
      tags?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
      updatedAt?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
      schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    } | null;
  } | null;
};

export type StaffStaffSearchContainerStaffUsersSearchFieldsFragment = {
  __typename?: 'StaffUserSearchResult';
  count?: number | null;
  staffUserResults?: Array<{
    __typename?: 'StaffUserResult';
    displayName?: string | null;
    createdAt?: any | null;
    accessBlocked?: boolean | null;
    id?: any | null;
    role?: { __typename?: 'StaffUserSearchRoleResult'; roleName?: string | null; id?: any | null } | null;
  } | null> | null;
  facets?: {
    __typename?: 'StaffUserSearchFacets';
    accessBlocked?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    createdAt?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
    role?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
    tags?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
    updatedAt?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
    schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  } | null;
};

export type StaffStaffSearchContainerStaffUsersResultsFieldsFragment = {
  __typename?: 'StaffUserResult';
  displayName?: string | null;
  createdAt?: any | null;
  accessBlocked?: boolean | null;
  id?: any | null;
  role?: { __typename?: 'StaffUserSearchRoleResult'; roleName?: string | null; id?: any | null } | null;
};

export type StaffStaffSearchContainerStaffUsersResultsRoleFieldsFragment = { __typename?: 'StaffUserSearchRoleResult'; roleName?: string | null; id?: any | null };

export type StaffStaffSearchContainerStaffUsersFacetsFieldsFragment = {
  __typename?: 'StaffUserSearchFacets';
  accessBlocked?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  createdAt?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
  role?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
  tags?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
  updatedAt?: Array<{ __typename?: 'FacetDetail'; value?: string | null; count?: number | null } | null> | null;
  schemaVersion?: Array<{ __typename?: 'FacetDetail'; count?: number | null; value?: string | null } | null> | null;
};

export type StaffViewContainerStaffUserQueryVariables = Exact<{
  staffUserId: Scalars['ObjectID']['input'];
}>;

export type StaffViewContainerStaffUserQuery = {
  __typename?: 'Query';
  staffUser?: {
    __typename?: 'StaffUser';
    lastName?: string | null;
    firstName?: string | null;
    accessBlocked?: boolean | null;
    id: any;
    createdAt?: any | null;
    updatedAt?: any | null;
    tags?: Array<string | null> | null;
    role?: { __typename?: 'StaffRole'; roleName: string; id: any } | null;
  } | null;
};

export type StaffViewContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  lastName?: string | null;
  firstName?: string | null;
  accessBlocked?: boolean | null;
  id: any;
  createdAt?: any | null;
  updatedAt?: any | null;
  tags?: Array<string | null> | null;
  role?: { __typename?: 'StaffRole'; roleName: string; id: any } | null;
};

export type StaffViewContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffViewContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canAssignRoles: boolean; canBlockAccess: boolean; canAddOrRemoveTags: boolean };
      };
    } | null;
  } | null;
};

export type StaffViewContainerStaffUserCurrentFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canAssignRoles: boolean; canBlockAccess: boolean; canAddOrRemoveTags: boolean };
    };
  } | null;
};

export type StaffSystemFlagsContainerApplicantUserQueryQueryVariables = Exact<{
  applicantId: Scalars['ObjectID']['input'];
}>;

export type StaffSystemFlagsContainerApplicantUserQueryQuery = {
  __typename?: 'Query';
  applicantUser?: { __typename?: 'ApplicantUser'; id: any; systemFlags?: Array<string | null> | null } | null;
};

export type StaffSystemFlagsContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type StaffSystemFlagsContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
    applicantUser?: { __typename?: 'ApplicantUser'; id: any; systemFlags?: Array<string | null> | null } | null;
  };
};

export type StaffSystemFlagsContainerApplicantUsereMutationResultFieldsFragment = {
  __typename?: 'ApplicantUserMutationResult';
  status: { __typename?: 'MutationStatus'; success: boolean; errorMessage?: string | null };
  applicantUser?: { __typename?: 'ApplicantUser'; id: any; systemFlags?: Array<string | null> | null } | null;
};

export type StaffSystemFlagsContainerApplicantUserFieldsFragment = { __typename?: 'ApplicantUser'; id: any; systemFlags?: Array<string | null> | null };

export type StaffSectionLayoutContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffSectionLayoutContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    accessBlocked?: boolean | null;
    id: any;
    role?: {
      __typename?: 'StaffRole';
      roleSubtype: string;
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
        credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
        entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
        idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
        sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
        staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
      };
    } | null;
  } | null;
};

export type StaffSectionLayoutContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  accessBlocked?: boolean | null;
  id: any;
  role?: {
    __typename?: 'StaffRole';
    roleSubtype: string;
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
      credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
      entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
      idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
      sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
      staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
    };
  } | null;
};

export type StaffSectionLayoutContainerStaffRoleFieldsFragment = {
  __typename?: 'StaffRole';
  roleSubtype: string;
  id: any;
  permissions: {
    __typename?: 'StaffRolePermissions';
    applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
    credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
    entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
    idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
    sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
    staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
  };
};

export type StaffSectionLayoutContainerStaffRolePermissionsFieldsFragment = {
  __typename?: 'StaffRolePermissions';
  applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
  credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
  entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
  idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
  sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
  staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
};

export type ApplicantDetailsHeaderContainerApplicantUserQueryVariables = Exact<{
  applicantUserId: Scalars['ObjectID']['input'];
}>;

export type ApplicantDetailsHeaderContainerApplicantUserQuery = {
  __typename?: 'Query';
  applicantUser?: { __typename?: 'ApplicantUser'; id: any; accessBlocked?: boolean | null; displayName?: string | null; tags?: Array<string | null> | null } | null;
};

export type ApplicantDetailsHeaderContainerApplicantUserUpdateMutationVariables = Exact<{
  input: ApplicantUserUpdateInput;
}>;

export type ApplicantDetailsHeaderContainerApplicantUserUpdateMutation = {
  __typename?: 'Mutation';
  applicantUserUpdate: {
    __typename?: 'ApplicantUserMutationResult';
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
    applicantUser?: { __typename?: 'ApplicantUser'; id: any; accessBlocked?: boolean | null; displayName?: string | null; tags?: Array<string | null> | null } | null;
  };
};

export type ApplicantDetailsHeaderContainerApplicantUserFieldsFragment = {
  __typename?: 'ApplicantUser';
  id: any;
  accessBlocked?: boolean | null;
  displayName?: string | null;
  tags?: Array<string | null> | null;
};

export type ApplicantDetailsHeaderContainerStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type ApplicantDetailsHeaderContainerStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    id: any;
    role?: {
      __typename?: 'StaffRole';
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canBlockAccess: boolean; canAddOrRemoveTags: boolean };
      };
    } | null;
  } | null;
};

export type ApplicantDetailsHeaderContainerStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  id: any;
  role?: {
    __typename?: 'StaffRole';
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canBlockAccess: boolean; canAddOrRemoveTags: boolean };
    };
  } | null;
};

export type StaffSharedFileUploadProcessMaliciousFileScanMutationVariables = Exact<{
  input: ProcessMaliciousFileScanInput;
}>;

export type StaffSharedFileUploadProcessMaliciousFileScanMutation = {
  __typename?: 'Mutation';
  processMaliciousFileScan?: {
    __typename?: 'ProcessMaliciousFileScanMutationResult';
    scanResult?: string | null;
    isMalicious?: boolean | null;
    isSafe?: boolean | null;
    status: { __typename?: 'MutationStatus'; errorMessage?: string | null; success: boolean };
  } | null;
};

export type StaffLandingPageStaffUserCurrentQueryVariables = Exact<{
  oid?: InputMaybe<Scalars['String']['input']>;
}>;

export type StaffLandingPageStaffUserCurrentQuery = {
  __typename?: 'Query';
  staffUserCurrent?: {
    __typename?: 'StaffUser';
    accessBlocked?: boolean | null;
    displayName?: string | null;
    id: any;
    schemaVersion?: string | null;
    role?: {
      __typename?: 'StaffRole';
      roleSubtype: string;
      id: any;
      permissions: {
        __typename?: 'StaffRolePermissions';
        applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
        credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
        entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
        idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
        rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
        sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
        staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
      };
    } | null;
  } | null;
};

export type StaffLandingPageStaffUserFieldsFragment = {
  __typename?: 'StaffUser';
  accessBlocked?: boolean | null;
  displayName?: string | null;
  id: any;
  schemaVersion?: string | null;
  role?: {
    __typename?: 'StaffRole';
    roleSubtype: string;
    id: any;
    permissions: {
      __typename?: 'StaffRolePermissions';
      applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
      credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
      entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
      idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
      rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
      sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
      staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
    };
  } | null;
};

export type StaffLandingPageStaffRoleFieldsFragment = {
  __typename?: 'StaffRole';
  roleSubtype: string;
  id: any;
  permissions: {
    __typename?: 'StaffRolePermissions';
    applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
    credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
    entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
    idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
    rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
    sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
    staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
  };
};

export type StaffLandingPageStaffRolePermissionsFieldsFragment = {
  __typename?: 'StaffRolePermissions';
  applicantUserPermissions: { __typename?: 'StaffRoleApplicantUserPermissions'; canSearchApplicants: boolean };
  credCasePermissions: { __typename?: 'StaffRoleCredCasePermissions'; canSearchCases: boolean };
  entityPermissions: { __typename?: 'StaffRoleEntityPermissions'; canSearchEntities: boolean };
  idCasePermissions: { __typename?: 'StaffRoleIdCasePermissions'; canSearchCases: boolean };
  rolePermissions: { __typename?: 'StaffRoleRolePermissions'; canSearchRoles: boolean };
  sendCasePermissions: { __typename?: 'StaffRoleSendCasePermissions'; canSearchCases: boolean };
  staffUserPermissions: { __typename?: 'StaffRoleStaffUserPermissions'; canSearchStaff: boolean };
};

export type MaintenanceMessageProviderGetServerDateQueryVariables = Exact<{ [key: string]: never }>;

export type MaintenanceMessageProviderGetServerDateQuery = { __typename?: 'Query'; serverDate?: string | null };

export type ServerDateQueryVariables = Exact<{ [key: string]: never }>;

export type ServerDateQuery = { __typename?: 'Query'; serverDate?: string | null };

export type SharedArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables = Exact<{
  id: Scalars['ObjectID']['input'];
}>;

export type SharedArchivedCaseListContainerArchivedCasesByApplicantIdQuery = {
  __typename?: 'Query';
  archivedCasesByApplicantId?: Array<{ __typename?: 'ArchivedCaseSummary'; archivedAt: any; caseName: string; caseType: string; id: any; state: string } | null> | null;
};

export type SharedArchivedCaseListContainerArchivedCaseSummaryFieldsFragment = {
  __typename?: 'ArchivedCaseSummary';
  archivedAt: any;
  caseName: string;
  caseType: string;
  id: any;
  state: string;
};

export const CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformationFragment, unknown>;
export const CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFieldsFragment, unknown>;
export const CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'permissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applicantUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'credCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entityPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'idCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rolePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sendCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'staffUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'search' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformationFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerFileInfoFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformation' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'permissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applicantUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'credCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entityPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'idCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rolePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sendCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'staffUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'search' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerApplicantUserFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sendDestinationName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment,
  unknown
>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sendDestinationName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'permissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applicantUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'credCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entityPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'idCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rolePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sendCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'staffUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'search' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sendDestinationName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformation' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerEntityFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment,
  unknown
>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment, unknown>;
export const CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerFileInfoFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'program' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const StaffActivityLogContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActivityLogContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActivityLogContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFieldsFragment, unknown>;
export const StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const StaffCasesApplicationContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerApplicantUserFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFieldsFragment, unknown>;
export const StaffCasesApplicationContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerEntityFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1PrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1PrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1PrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1PrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1Fields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1PrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ApplicationContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ApplicationContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ApplicationContainerStaffUserFieldsFragment, unknown>;
export const CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerStaffUsersFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerStaffUsersFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerStaffUserCurrentFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseWorkerAssigned' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseWorkerAssigned' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAffirmations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAffirmations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'application' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'credentialAssets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'client' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'address' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'address' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'otherIssuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'program' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sendDestination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'client' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationReview' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'affirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseWorkerAssigned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'decision' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'privateCaseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'alternateVerifyingEntity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entitySuppliedCredential' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'institutionContactDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'verificationStatus' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'verificationAffirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'revisionRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'permissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'applicantUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'credCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'entityPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'idCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rolePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sendCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'staffUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'search' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedChanges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerFileInfoFieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerStaffUserFieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Affirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1VerificationAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Affirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1VerificationAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Affirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1VerificationAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Affirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1VerificationAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Affirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1VerificationAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerStaffUserFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificationAffirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificationAffirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment, unknown>;
export const StaffCasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credentialAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entitySuppliedCredential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credentialAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entitySuppliedCredential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment, unknown>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment,
  unknown
>;
export const StaffActiveCaseListContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveCaseListContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const StaffActiveCaseListContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveCaseListContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const StaffActiveListContainerCredentialVerificationCaseV1IdFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveListContainerCredentialVerificationCaseV1IdFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveListContainerCredentialVerificationCaseV1IdFieldsFragment, unknown>;
export const CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCaseSummaryFieldsFragment, unknown>;
export const StaffFilePickerCaseListContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFilePickerCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFilePickerCaseListContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const StaffDocumentListContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffDocumentListContainerFileInfoFieldsFragment, unknown>;
export const StaffDocumentListContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffDocumentListContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const StaffDocumentListContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffDocumentListContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesDocumentListContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesDocumentListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesDocumentListContainerSendReportCaseV1FieldsFragment, unknown>;
export const StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesDocumentListContainerArchivedSendReportCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesDocumentListContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesDocumentListContainerArchivedSendReportCaseSummaryFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFieldsFragment, unknown>;
export const CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFieldsFragment,
  unknown
>;
export const StaffCasesFilesContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerFileInfoFieldsFragment, unknown>;
export const StaffCasesFilesContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationResultFieldsFragment, unknown>;
export const StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFieldsFragment, unknown>;
export const StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdCredentialVerificationCaseV1FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdCredentialVerificationCaseV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdCredentialVerificationCaseV1Fragment, unknown>;
export const CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1RelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1RelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1RelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment, unknown>;
export const CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFieldsFragment, unknown>;
export const CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFieldsFragment, unknown>;
export const CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesCredentialVerificationV1IndexContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1IndexContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1IndexContainerStaffUserCurrentFieldsFragment, unknown>;
export const CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformationFragment, unknown>;
export const CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFieldsFragment, unknown>;
export const CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRoleFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffUserFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerEntityFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserNameOnDocumentAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserNameOnDocumentAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserNameOnDocumentAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerApplicantUserFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFieldsFragment,
  unknown
>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserNameOnDocumentAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerApplicantUserSearchFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerApplicantUserSearchFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderDetailContainerStaffRolesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderDetailContainerStaffRolesFieldsFragment, unknown>;
export const CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFieldsFragment,
  unknown
>;
export const CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment, unknown>;
export const CasesIdentityVerificationCaseSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCaseSummaryContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationCaseSummaryContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ActiveCaseListContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ActiveCaseListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ActiveCaseListContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerStaffUsersFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerStaffUsersFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'application' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'notarizationDetails' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'passportAssets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'passportDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoAssets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationReview' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'affirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseWorkerAssigned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'decision' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'notaryAffirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'revisionRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'permissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'applicantUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'credCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'entityPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'idCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rolePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sendCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'staffUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'search' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedChanges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChangeStatusContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChangeStatusContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChangeStatusContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChangeStatusContainerStaffUserFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChatPageContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChatPageContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChatPageContainerStaffUserFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1MessagesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1MessagesFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const ChatPageContainerFinanceConfigFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ChatPageContainerFinanceConfigFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1FileByFileNameFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1FileByFileNameFieldsFragment, unknown>;
export const CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFieldsFragment, unknown>;
export const CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment,
  unknown
>;
export const StaffCasesFilesContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationResultFieldsFragment, unknown>;
export const GenerateIdFormContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GenerateIdFormContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GenerateIdFormContainerFileInfoFieldsFragment, unknown>;
export const GenerateIdFormContainerApplicantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GenerateIdFormContainerApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<GenerateIdFormContainerApplicantFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoAssets' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'photo' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'idForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'redactedNotarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoAssets' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'photo' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'idForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'redactedNotarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFieldsFragment,
  unknown
>;
export const StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFieldsFragment, unknown>;
export const StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationV1RelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1RelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1RelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesIdentityVerificationV1IndexContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IndexContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IndexContainerStaffUserFieldsFragment, unknown>;
export const CasesIdentityVerificationV1SectionLayoutCaseFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1SectionLayoutCaseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1SectionLayoutCaseFieldsFragment, unknown>;
export const CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryFieldsFragment, unknown>;
export const CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'client' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'search' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'termsAndConditions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationPhone' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'institutionContactDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'approval' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFieldsFragment, unknown>;
export const CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationPhone' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationPhone' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerArchivedCaseSummaryActivityLogFieldsFragment, unknown>;
export const CasesSendReportCaseSummaryContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseSummaryContainerFileInfoFieldsFragment, unknown>;
export const CasesSendReportV1ActiveCaseListContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'caseName' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ActiveCaseListContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1ActivityLogContainerUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ActivityLogContainerUserFieldsFragment, unknown>;
export const CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerUserFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ActivityLogContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsApplicationContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsApplicationContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsApplicationContainerStaffUserFieldsFragment, unknown>;
export const SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifiedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantFieldsFragment, unknown>;
export const SendReportV1CaseDetailsApplicationContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerEntityFieldsFragment, unknown>;
export const SendReportV1CaseDetailsApplicationContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'application' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entityName' } }] }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'institutionContactDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerSendReportCaseV1FieldsFragment, unknown>;
export const SendReportCaseV1ApplicationContainerStaffUserCurrentFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportCaseV1ApplicationContainerStaffUserCurrent' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportCaseV1ApplicationContainerStaffUserCurrentFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerStaffUsersFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerStaffUsersFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerStaffUserCurrentFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'application' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'credential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activityLog' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'activityBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applicant' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'files' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'payment' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'personalInformation' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applyingTo' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'address' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'client' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'createdBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'credCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'entityPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'idCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'rolePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'search' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'issuingInstitution' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'citizenship' },
                                                selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contactInformation' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'address' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'phone' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'identityDetails' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'professional' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'primaryEducationalInformation' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'issuingInstitution' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'termsAndConditions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'private' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'verificationComponentPacketHistory' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'assetVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'assetUploadedBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'verificationFormHistory' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'assetUploadedBy' },
                                                      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } }] }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'assetVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'caseDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'application' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credentialAssets' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'program' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'issuingInstitution' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'address' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'client' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'createdBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'credCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'entityPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'idCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'caseFlagged' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'flagType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'caseHistory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'caseDetails' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'application' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credentialAssets' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'issuingInstitution' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'client' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'address' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'program' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendDestination' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'client' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'address' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicationReview' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'affirmations' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'audit' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'completedBy' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'role' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'permissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'credCasePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'entityPermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'idCasePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'rolePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                                      ]
                                                                                    }
                                                                                  }
                                                                                ]
                                                                              }
                                                                            },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'search' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'caseWorkerAssigned' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'credCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'entityPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'idCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'rolePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'search' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'decision' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'completedBy' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'role' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'permissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'credCasePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'entityPermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'idCasePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'rolePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                                ]
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'search' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'privateCaseDetails' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entitySuppliedCredential' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'institutionContactDetails' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'verificationStatus' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'verificationAffirmations' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'caseWorkerAssigned' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'revisionRequest' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'requestedBy' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'files' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'financeDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'financeConfig' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'createdBy' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'glConfig' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'additionalCharges' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'recognition' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'refunds' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'submission' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'note' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'revenueRecognition' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'recognition' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'submission' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'transactions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'adhocTransactions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'requestedBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'initiatedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'revisionRequest' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'requestedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'systemTags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'client' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'address' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationReview' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'affirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDestinationAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReportCompiled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReportSent' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseWorkerAssigned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'decision' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'privateCaseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'institutionContactDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatedByApplicant' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'revisionRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'permissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'applicantUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'credCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'entityPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'idCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rolePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sendCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'staffUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'search' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedChanges' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1FieldsFragment, unknown>;
export const CasesSendReportCaseInfoHeaderContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseInfoHeaderContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1ChangeStatusContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerStaffUserFieldsFragment, unknown>;
export const CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFieldsFragment, unknown>;
export const CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFieldsFragment, unknown>;
export const CasesSendReportV1ChangeStatusContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1ChangeStatusContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const CasesSendReportV1ChangeStatusContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerFileInfoFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerStaffUserFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const CasesSendReportV1ChecklistContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isDestinationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportCompiled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportSent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChecklistContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1ChecklistContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isDestinationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportCompiled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportSent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChecklistContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFieldsFragment, unknown>;
export const CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'statusReportCoverLetter' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFieldsFragment, unknown>;
export const CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'statusReportCoverLetter' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const StaffReportCoverLetterContainerEntityAddressInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffReportCoverLetterContainerEntityAddressInfoFieldsFragment, unknown>;
export const CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFieldsFragment, unknown>;
export const CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'privateCaseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificationStatus' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFieldsFragment, unknown>;
export const CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'application' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFields' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFields' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'files' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'privateCaseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificationStatus' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCaseV1ByApplicantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCaseV1ByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCaseV1ByApplicantFieldsFragment, unknown>;
export const CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCaseV1ByApplicantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCaseV1ByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCaseV1ByApplicantFieldsFragment, unknown>;
export const CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1ByApplicantFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1ByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1ByApplicantFieldsFragment, unknown>;
export const CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1IdFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1IdFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1IdFieldsFragment, unknown>;
export const CasesSendReportFilePickerArchivedCaseListContainerArchivedCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerArchivedCaseListContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportFilePickerArchivedCaseListContainerArchivedCaseSummaryFieldsFragment, unknown>;
export const CasesSendReportFilePickerCaseListContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportFilePickerCaseListContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportDocumentListContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportDocumentListContainerFileInfoFieldsFragment, unknown>;
export const CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryFieldsFragment, unknown>;
export const CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryFieldsFragment, unknown>;
export const CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFieldsFragment, unknown>;
export const CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileByFileNameFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileByFileNameFieldsFragment, unknown>;
export const CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFieldsFragment, unknown>;
export const CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFieldsFragment, unknown>;
export const CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFieldsFragment, unknown>;
export const CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFieldsFragment, unknown>;
export const CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFieldsFragment, unknown>;
export const CasesSendReportV1FilesContainerSendReportCaseV1MutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilesContainerSendReportCaseV1MutationResultFieldsFragment, unknown>;
export const CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1RelatedCasesTabContainerArchivedSendReportCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1RelatedCasesTabContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1RelatedCasesTabContainerArchivedSendReportCaseSummaryFieldsFragment, unknown>;
export const CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportTransactionsContainerSendReportCaseV1FinanceDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportTransactionsContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportTransactionsContainerSendReportCaseV1FinanceDetailsFieldsFragment, unknown>;
export const CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFieldsFragment, unknown>;
export const CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1FragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1Fragment, unknown>;
export const CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credential' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFieldsFragment, unknown>;
export const CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credential' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1FieldsFragment, unknown>;
export const CasesSendReportV1IndexContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1IndexContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1IndexContainerStaffUserFieldsFragment, unknown>;
export const CasesSendReportV1SectionLayoutContainerSendReportCaseV1FieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1SectionLayoutContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1SectionLayoutContainerSendReportCaseV1FieldsFragment, unknown>;
export const StaffApplicantProfileApplyToEditContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileApplyToEditContainerEntityFieldsFragment, unknown>;
export const StaffApplicantProfileApplyToEditContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileApplyToEditContainerApplicantUserFieldsFragment, unknown>;
export const StaffApplicantProfileApplyToEditContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileApplyToEditContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const ApplicantApplyToViewContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantApplyToViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantApplyToViewContainerApplicantUserFieldsFragment, unknown>;
export const StaffApplicantProfileCitizenshipEditContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'citizenship' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileCitizenshipEditContainerApplicantUserFieldsFragment, unknown>;
export const StaffApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'citizenship' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFieldsFragment, unknown>;
export const StaffApplicantProfileCitizenshipViewContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'citizenship' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileCitizenshipViewContainerApplicantUserFieldsFragment, unknown>;
export const StaffApplicantProfileContactInformationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileContactInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileContactInformationFragment, unknown>;
export const StaffApplicantProfileIdentityUploadContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityUploadContainerApplicantUserFieldsFragment, unknown>;
export const StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFieldsFragment, unknown>;
export const StaffApplicantProfileIdentityDetailsTermsAndConditionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsTermsAndConditionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityDetailsTermsAndConditionsFieldsFragment, unknown>;
export const StaffApplicantProfileIdentityDetailsContactInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }] }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityDetailsContactInformationFieldsFragment, unknown>;
export const StaffApplicantProfileIdentityDetailsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityDetailsFieldsFragment, unknown>;
export const StaffApplicantProfileNameOnDocumentAssetFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileNameOnDocumentAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileNameOnDocumentAssetFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionEditContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionEditContainerEntityFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFieldsFragment, unknown>;
export const StaffApplicantProfileProfessionViewContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionViewContainerEntityFieldsFragment, unknown>;
export const StaffApplicantSearchFilterContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchFilterContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantSearchFilterContainerEntityFieldsFragment, unknown>;
export const StaffApplicantSearchContainerApplicantUserSearchFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantSearchContainerApplicantUserSearchFieldsFragment, unknown>;
export const StaffApplicantSearchContainerApplicantUserSearchFacetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessBlocked' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateOfBirth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generationalSuffix' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantSearchContainerApplicantUserSearchFacetsFieldsFragment, unknown>;
export const StaffApplicantSearchContainerApplicantApplicantUserResultsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantApplicantUserResultsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserSearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserResults' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFacetsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessBlocked' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateOfBirth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generationalSuffix' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantSearchContainerApplicantApplicantUserResultsFieldsFragment, unknown>;
export const StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFieldsFragment, unknown>;
export const StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFieldsFragment, unknown>;
export const StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFieldsFragment, unknown>;
export const StaffCaseSearchFilterContainerStaffRolePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffRolePermissionsFieldsFragment, unknown>;
export const StaffCaseSearchFilterContainerStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffRoleFieldsFragment, unknown>;
export const StaffCaseSearchFilterContainerStaffUsersFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffUsersFieldsFragment, unknown>;
export const StaffCaseSearchFilterContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerEntityFieldsFragment, unknown>;
export const StaffCaseSearchContainerCaseSearchStaffUserResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchStaffUserResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchStaffUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchContainerCaseSearchStaffUserResultFieldsFragment, unknown>;
export const StaffCaseSearchContainerCaseResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchStaffUserResultFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicantName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchStaffUserResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchStaffUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchContainerCaseResultFieldsFragment, unknown>;
export const StaffCaseSearchContainerFacetDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchContainerFacetDetailFieldsFragment, unknown>;
export const StaffCaseSearchContainerCaseSearchFacetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientId' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionCompletedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionCompletedBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionResult' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expirationEligibleAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastActivityCreatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestRequestedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestRequestedBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestSubmittedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submittedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemTags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchContainerCaseSearchFacetsFieldsFragment, unknown>;
export const StaffCaseSearchContainerCaseSearchResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseResults' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseResultFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchFacetsFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchStaffUserResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchStaffUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchStaffUserResultFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicantName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientId' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionCompletedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionCompletedBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionResult' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expirationEligibleAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastActivityCreatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestRequestedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestRequestedBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestSubmittedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submittedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemTags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchContainerCaseSearchResultFieldsFragment, unknown>;
export const StaffStateCountriesEditContainerStateFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStateCountriesEditContainerStateFieldsFragment, unknown>;
export const StaffStateCountriesEditContainerCountriesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStateCountriesEditContainerCountriesFieldsFragment, unknown>;
export const StaffStateCountriesEditContainerEventPayloadFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerEventPayloadFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEventPayload' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStateCountriesEditContainerEventPayloadFieldsFragment, unknown>;
export const StaffStateCountriesEditContainerBlobCountryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'apiName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventPayload' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerEventPayloadFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerEventPayloadFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEventPayload' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStateCountriesEditContainerBlobCountryFieldsFragment, unknown>;
export const StaffStateCountriesEditContainerBlobCountriesMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountriesMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountriesMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountryFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerEventPayloadFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEventPayload' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'apiName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventPayload' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerEventPayloadFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStateCountriesEditContainerBlobCountriesMutationResultFieldsFragment, unknown>;
export const StateCountriesViewContainerBlobCountryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StateCountriesViewContainerBlobCountryFieldsFragment, unknown>;
export const StateCountriesViewContainerEventPayloadFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerEventPayloadFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEventPayload' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StateCountriesViewContainerEventPayloadFieldsFragment, unknown>;
export const StateCountriesViewContainerBlobCountryEventFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'apiName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventPayload' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StateCountriesViewContainerEventPayloadFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'eventTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replayId' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerEventPayloadFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEventPayload' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StateCountriesViewContainerBlobCountryEventFieldsFragment, unknown>;
export const StaffCreateEntityContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCreateEntityContainerEntityFieldsFragment, unknown>;
export const StaffCreateEntityContainerEntityCreateFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityCreateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entity' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCreateEntityContainerEntityCreateFieldsFragment, unknown>;
export const StaffEntityDetailsContainerEntityAddressInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityDetailsContainerEntityAddressInfoFieldsFragment, unknown>;
export const StaffEntityDetailsContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityDetailsContainerEntityFieldsFragment, unknown>;
export const StaffEntityDetailsContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityDetailsContainerStaffUserCurrentFieldsFragment, unknown>;
export const StaffEntityEditContainerEntityAddressInfoFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityEditContainerEntityAddressInfoFieldsFragment, unknown>;
export const StaffEntityEditContainerEntityClientFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityEditContainerEntityClientFieldsFragment, unknown>;
export const StaffEntityEditContainerEntityIssuingInstitutionFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityEditContainerEntityIssuingInstitutionFieldsFragment, unknown>;
export const StaffEntityEditContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityClientFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityEditContainerEntityFieldsFragment, unknown>;
export const StaffEntityEditContainerMutationStatusFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerMutationStatusFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MutationStatus' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityEditContainerMutationStatusFieldsFragment, unknown>;
export const StaffEntityEditContainerEntityMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entity' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerMutationStatusFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityClientFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerMutationStatusFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MutationStatus' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityEditContainerEntityMutationResultFieldsFragment, unknown>;
export const StaffEntitySearchContainerEntityResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntityResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntitySearchContainerEntityResultFieldsFragment, unknown>;
export const StaffEntitySearchContainerFacetDetailFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntitySearchContainerFacetDetailFieldsFragment, unknown>;
export const StaffEntitySearchContainerEntitySearchFacetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntitySearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disabledAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isClient' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntitySearchContainerEntitySearchFacetsFieldsFragment, unknown>;
export const StaffEntitySearchContainerEntitySearchResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntitySearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityResults' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerEntityResultFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchFacetsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntityResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntitySearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disabledAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isClient' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntitySearchContainerEntitySearchResultFieldsFragment, unknown>;
export const StaffEntitySearchContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntitySearchContainerStaffUserCurrentFieldsFragment, unknown>;
export const StaffFeatureFlagsContainerBlobFeatureFlagFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFeatureFlag' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'allowedValues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retirementDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFeatureFlagsContainerBlobFeatureFlagFieldsFragment, unknown>;
export const StaffFeatureFlagsContainerBlobFeatureFlagMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFeatureFlagMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFeatureFlag' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'allowedValues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retirementDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFeatureFlagsContainerBlobFeatureFlagMutationResultFieldsFragment, unknown>;
export const StaffFinanceBatchContainerGlPostingSummaryGlSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryGlSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryGlSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accountingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'glAccountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceBatchContainerGlPostingSummaryGlSummaryFieldsFragment, unknown>;
export const StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptAttemptData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attemptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFieldsFragment, unknown>;
export const StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptResponseData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'glBatchNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jEntryNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFieldsFragment, unknown>;
export const StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttempt' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attemptData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responseData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptAttemptData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attemptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptResponseData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'glBatchNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jEntryNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFieldsFragment, unknown>;
export const StaffFinanceBatchContainerGlPostingSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryGlSummaryFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postingAttempt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'glTransactionDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptAttemptData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attemptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptResponseData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'glBatchNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jEntryNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryGlSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryGlSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accountingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'glAccountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttempt' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attemptData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responseData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceBatchContainerGlPostingSummaryFieldsFragment, unknown>;
export const StaffFinanceDetailContainerGlTransactionSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceDetailContainerGlTransactionSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlTransactionSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'transactionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'case' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceDetailContainerGlTransactionSummaryFieldsFragment, unknown>;
export const StaffFinanceSettingsContainerBlobFinanceGlConfigFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceGlConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recognition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerBlobFinanceGlConfigFieldsFragment, unknown>;
export const StaffFinanceSettingsContainerBlobFinanceConfigFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceGlConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recognition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerBlobFinanceConfigFieldsFragment, unknown>;
export const StaffFinanceSettingsContainerBlobFinanceConfigMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfigMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeGlConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceGlConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recognition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerBlobFinanceConfigMutationResultFieldsFragment, unknown>;
export const StaffFinanceSettingsContainerBlobFinancialConfigFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinancialConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinancialConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ruleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerBlobFinancialConfigFieldsFragment, unknown>;
export const StaffFinanceSettingsContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerStaffUserFieldsFragment, unknown>;
export const HealthProfessionsContainerHealthProfessionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HealthProfessionsData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'professionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<HealthProfessionsContainerHealthProfessionsFieldsFragment, unknown>;
export const HealthProfessionsContainerBlobHealthProfessionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerBlobHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobHealthProfession' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'healthProfessions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HealthProfessionsData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'professionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionName' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<HealthProfessionsContainerBlobHealthProfessionsFieldsFragment, unknown>;
export const HealthProfessionsContainerHealthProfessionsMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobHealthProfessionsMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'healthProfessions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerBlobHealthProfessionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HealthProfessionsData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'professionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerBlobHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobHealthProfession' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'healthProfessions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<HealthProfessionsContainerHealthProfessionsMutationResultFieldsFragment, unknown>;
export const StaffProfileHeaderContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffProfileHeaderContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffProfileHeaderContainerStaffUserCurrentFieldsFragment, unknown>;
export const StaffReIndexSearchCollectionContainerUserReIndexFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerUserReIndexFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserReIndexResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'applicantUserReIndexErrors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffUserReIndexErrors' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerUserReIndexFieldsFragment, unknown>;
export const StaffReIndexSearchCollectionContainerCaseReIndexFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerCaseReIndexFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseReIndexResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'identityCaseReIndexErrors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialCaseReIndexErrors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendReportCaseReIndexErrors' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerCaseReIndexFieldsFragment, unknown>;
export const StaffReIndexSearchCollectionContainerEntityReIndexFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerEntityReIndexFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityReIndexResult' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entityReIndexErrors' } }] }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerEntityReIndexFieldsFragment, unknown>;
export const StaffReportCoverLetterContainerEntityFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffReportCoverLetterContainerEntityFieldsFragment, unknown>;
export const RoleCreateContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleCreateContainerStaffUserFieldsFragment, unknown>;
export const RoleCreateContainerStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleCreateContainerStaffRoleFieldsFragment, unknown>;
export const RoleCreateContainerStaffRoleMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRole' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleCreateContainerStaffRoleMutationResultFieldsFragment, unknown>;
export const RoleDetailContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rolePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleDetailContainerStaffUserFieldsFragment, unknown>;
export const RoleEditContainerStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleEditContainerStaffRoleFieldsFragment, unknown>;
export const RoleEditContainerStaffRoleMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRoleMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRole' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleEditContainerStaffRoleFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleEditContainerStaffRoleMutationResultFieldsFragment, unknown>;
export const RoleEditContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleEditContainerStaffUserFieldsFragment, unknown>;
export const RoleListContainerStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleListContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleListContainerStaffRoleFieldsFragment, unknown>;
export const StaffEditContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staffUserPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffUserCurrentFieldsFragment, unknown>;
export const StaffEditContainerStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffRoleFieldsFragment, unknown>;
export const StaffEditContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffUserFieldsFragment, unknown>;
export const StaffEditContainerStaffUserMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUser' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEditContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffUserMutationResultFieldsFragment, unknown>;
export const StaffStaffSearchFilterContainerStaffRolesFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchFilterContainerStaffRolesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchFilterContainerStaffRolesFieldsFragment, unknown>;
export const StaffStaffSearchContainerStaffUsersResultsRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchRoleResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchContainerStaffUsersResultsRoleFieldsFragment, unknown>;
export const StaffStaffSearchContainerStaffUsersResultsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchRoleResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchContainerStaffUsersResultsFieldsFragment, unknown>;
export const StaffStaffSearchContainerStaffUsersFacetsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessBlocked' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchContainerStaffUsersFacetsFieldsFragment, unknown>;
export const StaffStaffSearchContainerStaffUsersSearchFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserResults' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersFacetsFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchRoleResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessBlocked' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchContainerStaffUsersSearchFieldsFragment, unknown>;
export const StaffViewContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffViewContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffViewContainerStaffUserFieldsFragment, unknown>;
export const StaffViewContainerStaffUserCurrentFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffViewContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staffUserPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffViewContainerStaffUserCurrentFieldsFragment, unknown>;
export const StaffSystemFlagsContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'systemFlags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSystemFlagsContainerApplicantUserFieldsFragment, unknown>;
export const StaffSystemFlagsContainerApplicantUsereMutationResultFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUsereMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'systemFlags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSystemFlagsContainerApplicantUsereMutationResultFieldsFragment, unknown>;
export const StaffSectionLayoutContainerStaffRolePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSectionLayoutContainerStaffRolePermissionsFieldsFragment, unknown>;
export const StaffSectionLayoutContainerStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSectionLayoutContainerStaffRoleFieldsFragment, unknown>;
export const StaffSectionLayoutContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRoleFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSectionLayoutContainerStaffUserFieldsFragment, unknown>;
export const ApplicantDetailsHeaderContainerApplicantUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantDetailsHeaderContainerApplicantUserFieldsFragment, unknown>;
export const ApplicantDetailsHeaderContainerStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantDetailsHeaderContainerStaffUserFieldsFragment, unknown>;
export const StaffLandingPageStaffRolePermissionsFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffLandingPageStaffRolePermissionsFieldsFragment, unknown>;
export const StaffLandingPageStaffRoleFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffLandingPageStaffRolePermissionsFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffLandingPageStaffRoleFieldsFragment, unknown>;
export const StaffLandingPageStaffUserFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffLandingPageStaffRoleFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffLandingPageStaffRolePermissionsFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffLandingPageStaffUserFieldsFragment, unknown>;
export const SharedArchivedCaseListContainerArchivedCaseSummaryFieldsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SharedArchivedCaseListContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SharedArchivedCaseListContainerArchivedCaseSummaryFieldsFragment, unknown>;
export const CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryQuery,
  CasesCredentialVerificationCollapsibleApplicantProfileArchivedContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFields' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationDecisionDetailContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'createdBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'role' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'permissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applicantUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'credCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entityPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'idCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'rolePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'sendCasePermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'staffUserPermissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'search' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserPersonalInformation' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'sendDestinationName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerApplicantUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryQuery,
  CasesCredentialVerificationHeaderDetailContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryQuery,
  CasesCredentialVerificationHeaderSummaryContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerEntityFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: {
        kind: 'Name',
        value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
      },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternativeVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields'
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesCredentialVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryCaseDetailsFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseSummaryContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryQuery,
  CasesCredentialVerificationCaseSummaryContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'program' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1CurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Current' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Current' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'program' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1CurrentQuery,
  CasesCredentialVerificationActiveCaseListContainerCredentialVerificationCaseV1CurrentQueryVariables
>;
export const CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1QueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Query' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1QueryQuery,
  CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1QueryQueryVariables
>;
export const CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffActivityLogContainerCredentialVerificationCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActivityLogContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutationMutation,
  CasesCredentialVerificationV1ActivityLogContainerCredentialVerificationCaseV1UpdateMutationMutationVariables
>;
export const CasesCredentialVerificationAdditionalFilesContainerQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationAdditionalFilesContainerQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationAdditionalFilesContainerQueryQuery, CasesCredentialVerificationAdditionalFilesContainerQueryQueryVariables>;
export const CasesCredentialVerificationAdditionalFilesContainerCreateAuthHeaderMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationAdditionalFilesContainerCreateAuthHeaderMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1FileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'authHeader' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'indexTags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadataFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationAdditionalFilesContainerCreateAuthHeaderMutationMutation,
  CasesCredentialVerificationAdditionalFilesContainerCreateAuthHeaderMutationMutationVariables
>;
export const CasesCredentialVerificationAdditionalFilesContainerFileRemoveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationAdditionalFilesContainerFileRemove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FileRemoveInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1FileRemove' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1Fields' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesAdditionalFilesContainerCredentialVerificationCaseV1FileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationAdditionalFilesContainerFileRemoveMutation,
  CasesCredentialVerificationAdditionalFilesContainerFileRemoveMutationVariables
>;
export const StaffCasesApplicationContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1PrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesApplicationContainerCredentialVerificationCaseV1Query, StaffCasesApplicationContainerCredentialVerificationCaseV1QueryVariables>;
export const StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQuery,
  StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerEntitiesQueryVariables
>;
export const StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1OtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1OtherIssuingInstitutionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerEntityFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'program' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReviewDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1PrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationStatus' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewDecisionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1PrivateCaseDetailsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1ApplicationReviewFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerApplicantUserFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesApplicationContainerCredentialVerificationCaseV1Fields' } },
                { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutation,
  StaffCasesCredentialVerificationV1CaseDetailsApplicationContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1ApplicationContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ApplicationContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ApplicationContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ApplicationContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ApplicationContainerStaffUserCurrentQuery,
  CasesCredentialVerificationV1ApplicationContainerStaffUserCurrentQueryVariables
>;
export const CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationArchivedCaseListContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationCaseDetailsContainerStaffUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerStaffUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerStaffUsersFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationCaseDetailsContainerStaffUsersQuery, CasesCredentialVerificationCaseDetailsContainerStaffUsersQueryVariables>;
export const CasesCredentialVerificationV1CaseDetailsContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CaseDetailsContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerStaffUserCurrentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CaseDetailsContainerStaffUserCurrentQuery,
  CasesCredentialVerificationV1CaseDetailsContainerStaffUserCurrentQueryVariables
>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'affirmations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'verificationAffirmations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'audit' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseWorkerAssigned' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerQuery,
  CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerQueryVariables
>;
export const CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseWorkerAssigned' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1CaseWorkerFields' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationCaseDetailsContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'application' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'credentialAssets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'client' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'address' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'address' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'otherIssuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'program' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'sendDestination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'client' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'createdBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationReview' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'affirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseWorkerAssigned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'decision' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'privateCaseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'alternateVerifyingEntity' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'entitySuppliedCredential' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'institutionContactDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'verificationStatus' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'verificationAffirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'revisionRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'permissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'applicantUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'credCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'entityPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'idCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rolePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sendCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'staffUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'search' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedChanges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1Query,
  CasesCredentailVerificationV1CaseHistoryContainerCredentailVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationCaseInfoHeaderContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Fields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileByFileName' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerFileInfoFields' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Affirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1VerificationAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationChangeStatusContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationChangeStatusContainerStaffUserCurrentQuery,
  CasesCredentialVerificationChangeStatusContainerStaffUserCurrentQueryVariables
>;
export const CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Affirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1VerificationAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1AffirmationsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verificationAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1VerificationAffirmationsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationChangeStatusContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1ChatPageContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ChatPageContainerStaffUserCurrentQuery,
  CasesCredentialVerificationV1ChatPageContainerStaffUserCurrentQueryVariables
>;
export const CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedCredentialDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadTranslation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RequestedChangesFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFinanceConfigFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsTransactionsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MessageFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1FinanceDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationV1ChatPageContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificationAffirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificationAffirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationV1ChecklistContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationCollapsibleApplicantProfileContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'StaffCasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credentialAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'entitySuppliedCredential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'translation' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1FileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1PdfFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables
>;
export const CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1ImageFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutation,
  CasesCredentialVerificationV1CredCaseFileUploadButtonWithPreviewContainerCredentialVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables
>;
export const StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1CaseDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQuery,
  StaffActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryVariables
>;
export const StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffActiveCaseListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQuery,
  StaffActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryVariables
>;
export const StaffActiveCaseListContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffActiveListContainerCredentialVerificationCaseV1IdFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffActiveListContainerCredentialVerificationCaseV1IdFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveCaseListContainerCredentialVerificationCaseV1Query, StaffActiveCaseListContainerCredentialVerificationCaseV1QueryVariables>;
export const CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCasesByApplicantId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQuery,
  CasesCredentialVerificationFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables
>;
export const StaffFilePickerCaseListContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffFilePickerCaseListContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFilePickerCaseListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFilePickerCaseListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFilePickerCaseListContainerCredentialVerificationCaseV1Query, StaffFilePickerCaseListContainerCredentialVerificationCaseV1QueryVariables>;
export const StaffDocumentListContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffDocumentListContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffDocumentListContainerIdentityVerificationCaseV1Query, StaffDocumentListContainerIdentityVerificationCaseV1QueryVariables>;
export const StaffDocumentListContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffDocumentListContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffDocumentListContainerCredentialVerificationCaseV1Query, StaffDocumentListContainerCredentialVerificationCaseV1QueryVariables>;
export const CasesDocumentListContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesDocumentListContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesDocumentListContainerSendReportCaseV1Fields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesDocumentListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesDocumentListContainerSendReportCaseV1Query, CasesDocumentListContainerSendReportCaseV1QueryVariables>;
export const StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryQuery,
  StaffDocumentListContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryQuery,
  StaffDocumentListContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const CasesDocumentListContainerArchivedSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesDocumentListContainerArchivedSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesDocumentListContainerArchivedSendReportCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesDocumentListContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffDocumentListContainerFileInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesDocumentListContainerArchivedSendReportCaseSummaryQuery, CasesDocumentListContainerArchivedSendReportCaseSummaryQueryVariables>;
export const CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1MutationFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1FileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation,
  CasesCredCaseFileUploadWithGeneratePdfPacketButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables
>;
export const CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1MutationFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutation,
  CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1UpdateMutationVariables
>;
export const CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1FileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1CreateAuthHeaderMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1BlobAuthHeaderFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutation,
  CasesCredCaseFileUploadWithGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileCreateAuthHeaderMutationVariables
>;
export const StaffCasesFilesContainerCredentialVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutation, StaffCasesFilesContainerCredentialVerificationCaseV1UpdateMutationVariables>;
export const StaffCasesFilesContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerCredentialVerificationCaseV1Query, StaffCasesFilesContainerCredentialVerificationCaseV1QueryVariables>;
export const StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdCredentialVerificationCaseV1' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdCredentialVerificationCaseV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1ApplicantFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdQuery,
  StaffGenerateVerificationFormButtonContainerCredentialVerificationCaseV1FileByIdQueryVariables
>;
export const CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1RelatedCasesTabContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1RelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1RelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryQuery,
  CasesCredentialVerificationRelatedCasesTabContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationReviewDocumentsButtonContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: {
                                kind: 'Name',
                                value: 'CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1FinanceDetailsTransactionAdhocTransactionsFields'
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1TransactionsContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MergePdfFilesInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1MergePdfFiles' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutation,
  CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutationVariables
>;
export const CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Fields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerFileInfoFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1VerificationComponentPacketDocumentPickerContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1MergePdfFilesInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1MergePdfFiles' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutation,
  CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1MergePdfFilesMutationVariables
>;
export const CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Fields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1VerificationPacketDocumentPickerContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesCredentialVerificationV1IndexContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1IndexContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1IndexContainerStaffUserCurrentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1IndexContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesCredentialVerificationV1IndexContainerStaffUserCurrentQuery, CasesCredentialVerificationV1IndexContainerStaffUserCurrentQueryVariables>;
export const CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1Query,
  CasesCredentialVerificationV1SectionLayoutContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'primaryEducationalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'issuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'address' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'otherIssuingInstitution' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerApplicantUserPersonalInformation' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerContainerApplicantUserFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryQuery,
  CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Fields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationDecisionDetailContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleApplicantUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleEntityPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleStaffUserPermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleApplicantUserPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleCredCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleEntityPermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleRolePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleStaffUserPermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearch' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerStaffUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserIdentityDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
          { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserNameOnDocumentAsset' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
          { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'otherIssuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerEntityFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'citizenship' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserIdentityDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserNameOnDocumentAssetFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'payment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserPersonalInformationFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'search' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'termsAndConditions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserTermsAndConditionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerApplicantUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderDetailContainerArchivedCaseSummaryFinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryQuery,
  CasesIdentityVerificationHeaderDetailContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryQuery,
  CasesIdentityVerificationHeaderSummaryContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationCaseSummaryContainerArchivedIdentityVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationPassportDetailsFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationReviewFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryDetailContainerArchivedIdentityVerificationCaseSummaryCaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsTransactionSubmission' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsTransactionSubmissionFields' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCaseSummaryContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedIdentityVerificationCaseSummaryCaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryFinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationSummaryContainerArchivedCaseSummaryActivityLogFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummaryQuery,
  CasesIdentityVerificationV1CaseSummaryContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const StaffActiveCaseListContainerSendReportCasesV1ByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerSendReportCasesV1ByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveCaseListContainerSendReportCasesV1ByApplicantQuery, StaffActiveCaseListContainerSendReportCasesV1ByApplicantQueryVariables>;
export const StaffActiveCaseListContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffActiveCaseListContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveCaseListContainerIdentityVerificationCaseV1Query, StaffActiveCaseListContainerIdentityVerificationCaseV1QueryVariables>;
export const StaffActiveCaseListIdentityVerificationCaseV1CurrentQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffActiveCaseListIdentityVerificationCaseV1CurrentQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Current' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ActiveCaseListContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ActiveCaseListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffActiveCaseListIdentityVerificationCaseV1CurrentQueryQuery, StaffActiveCaseListIdentityVerificationCaseV1CurrentQueryQueryVariables>;
export const StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1QueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Query' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1QueryQuery,
  StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1QueryQueryVariables
>;
export const StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutationMutation,
  StaffCasesIdentityVerificationV1ActivityLogContainerIdentityVerificationCaseV1UpdateMutationMutationVariables
>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'passportDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1ApplicationDetailsContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserCurrentQuery,
  CasesIdentityVerificationV1ApplicationDetailsContainerStaffUserCurrentQueryVariables
>;
export const StaffArchivedCaseListContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffArchivedCaseListContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicant' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffArchivedCaseListContainerIdentityVerificationCaseV1Query, StaffArchivedCaseListContainerIdentityVerificationCaseV1QueryVariables>;
export const CasesIdentityVerificationV1CaseDetailsContainerStaffUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUsersFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1CaseDetailsContainerStaffUsersQuery, CasesIdentityVerificationV1CaseDetailsContainerStaffUsersQueryVariables>;
export const CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentQuery,
  CasesIdentityVerificationV1CaseDetailsContainerStaffUserCurrentQueryVariables
>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestRequestedChangesFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1RevisionRequestFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1CaseDetailsContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'application' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'caseWorkerModifiedPassportDetails' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'notarizationDetails' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isNotarizationComplete' } }] }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'passportAssets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpirationVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportTranslationVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportVersion' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'passportDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPassportExpirationDateVisible' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPassportInLatinCharacters' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportCountry' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportExpiresAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'passportNumber' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'photoAssets' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'photo' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'photoUploadedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'photoVersion' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationReview' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'affirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseWorkerAssigned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'decision' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'notaryAffirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'revisionRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'permissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'applicantUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'credCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'entityPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'idCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rolePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sendCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'staffUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'search' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedChanges' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'requestScheduleNotaryCam' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadNotarizedIdForm' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1CaseHistoryContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationCaseInfoHeaderContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Fields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileByFileName' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerFileInfoFields' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1ChangeStatusContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ChangeStatusContainerStaffUserCurrentQuery,
  CasesIdentityVerificationV1ChangeStatusContainerStaffUserCurrentQueryVariables
>;
export const CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1ActivityLogFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1ChangeStatusContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const StaffChatPageContainerIdentityVerificationCaseV1QueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Query' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1QueryQuery, StaffChatPageContainerIdentityVerificationCaseV1QueryQueryVariables>;
export const CasesIdentityVerificationV1ChatPageContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChatPageContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChatPageContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChatPageContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1ChatPageContainerStaffUserCurrentQuery, CasesIdentityVerificationV1ChatPageContainerStaffUserCurrentQueryVariables>;
export const StaffChatPageContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequestRequestedChanges' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedPassportDetails' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadExpirationPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassport' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPassportTranslation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestUploadPhoto' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RequestedChangesFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsSubmission' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsSubmissionFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsTransactionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ChatPageContainerFinanceConfigFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1MessagesFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1FinanceDetailsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffChatPageContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffChatPageContainerIdentityVerificationCaseV1UpdateMutation, StaffChatPageContainerIdentityVerificationCaseV1UpdateMutationVariables>;
export const CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1MutationResultFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isIdDocumentDetailsAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPhotoAcceptable' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'notaryAffirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotarizedIdAcceptable' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNotaryAcceptable' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1CaseDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1ChecklistContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationCollapsibleApplicantProfileContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1FileByFileNameFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1PdfFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables
>;
export const CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1ImageFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1FileUploadButtonWithGenerateIdFormContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables
>;
export const StaffCasesFilesContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerFileInfoFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesFilesContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutation, StaffCasesFilesContainerIdentityVerificationCaseV1UpdateMutationVariables>;
export const StaffCaseFilesContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCaseFilesContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseFilesContainerIdentityVerificationCaseV1Query, StaffCaseFilesContainerIdentityVerificationCaseV1QueryVariables>;
export const CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GenerateIdFormContainerFileInfoFields' } }] }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicant' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'GenerateIdFormContainerApplicantFields' } }] }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GenerateIdFormContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'GenerateIdFormContainerApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1GenerateIdFormContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'passportAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'passport' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportExpiration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'passportTranslation' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoAssets' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'photo' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shared' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'idForm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'notarizedIdForm' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'redactedNotarizedIdForm' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1Fields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1UpdateMutationVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1FileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1FileCreateAuthHeaderMutationVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1PdfFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1PdfFileCreateAuthHeaderMutationVariables
>;
export const CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1ImageFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: {
                    kind: 'Name',
                    value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields'
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerBlobAuthHeaderFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutation,
  CasesIdentityVerificationV1IdCaseFileUploadButtonWithPreviewContainerIdentityVerificationCaseV1ImageFileCreateAuthHeaderMutationVariables
>;
export const StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsApplicationReviewFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1CaseDetailsFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1Query,
  StaffCasesIdentityVerificationV1RelatedCasesTabContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationRelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationRelatedCasesTabContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1RelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1RelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationRelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryQuery,
  CasesIdentityVerificationRelatedCasesTabContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Fields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationReviewDocumentsButtonContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financeDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1FinanceDetailsFields' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationTransactionsContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesIdentityVerificationV1IndexContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IndexContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1IndexContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1IndexContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'idCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesIdentityVerificationV1IndexContainerStaffUserCurrentQuery, CasesIdentityVerificationV1IndexContainerStaffUserCurrentQueryVariables>;
export const CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesIdentityVerificationV1SectionLayoutCaseFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesIdentityVerificationV1SectionLayoutCaseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1Query,
  CasesIdentityVerificationV1SectionLayoutContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryQuery,
  CasesSendReportArchiveCollapsibleApplicantProfileContainerSendReportCaseSummaryQueryVariables
>;
export const CasesSendReportDecisionDetailContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportDecisionDetailContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDecisionDetailContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'decision' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportDecisionDetailContainerSendReportCaseV1Query, CasesSendReportDecisionDetailContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payment' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'client' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'createdBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'issuingInstitution' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'search' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'termsAndConditions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'version' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationEmail' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'destinationPhone' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'completedBy' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'institutionContactDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'adhocTransactions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'approval' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'transactionReference' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'submission' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryQuery,
  CasesSendReportHeaderDetailContainerArchivedSendReportCaseSummaryQueryVariables
>;
export const CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryQuery,
  CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryQueryVariables
>;
export const CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFields' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financeDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityLog' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryActivityLogFields' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerFileInfoFields' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryAffirmations' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'audit' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'completedBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryDecision' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'result' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'completedBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'institutionContactDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryAffirmationsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryDecisionFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'privateCaseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewPrivateCaseDetailsFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetailsApplication' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationEmail' } },
          { kind: 'Field', name: { kind: 'Name', value: 'destinationPhone' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetailsAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummaryCaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationReviewFields' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryCaseDetailsApplicationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryFinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryFinanceDetailsAdhocTransactionFields' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerArchivedCaseSummaryActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummaryActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseSummaryContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryQuery,
  CasesSendReportCaseSummaryContainerArchivedSendReportCaseSummaryQueryVariables
>;
export const CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ActiveCaseListContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'caseName' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Query, CasesSendReportV1ActiveCaseListContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1ActiveCaseListContainerSendReportCaseV1CurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Current' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Current' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActiveCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'caseName' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1ActiveCaseListContainerSendReportCaseV1CurrentQuery,
  CasesSendReportV1ActiveCaseListContainerSendReportCaseV1CurrentQueryVariables
>;
export const CasesSendReportV1ActivityLogContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerUserFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ActivityLogContainerSendReportCaseV1Query, CasesSendReportV1ActivityLogContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1ActivityLogContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendReportCaseV1' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerSendReportCaseV1Fields' } }]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'User' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activityBy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ActivityLogContainerUserFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1ActivityLogContainerSendReportCaseV1UpdateMutation,
  CasesSendReportV1ActivityLogContainerSendReportCaseV1UpdateMutationVariables
>;
export const CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1Query, CasesSendReportV1ArchivedCaseListContainerSendReportCaseV1QueryVariables>;
export const SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'application' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entityName' } }] }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'institutionName' } }] }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'destination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'decision' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'result' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'privateCaseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'institutionContactDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Query, SendReportV1CaseDetailsApplicationContainerSendReportCaseV1QueryVariables>;
export const SendReportV1CaseDetailsApplicationContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SendReportV1CaseDetailsApplicationContainerEntitiesQuery, SendReportV1CaseDetailsApplicationContainerEntitiesQueryVariables>;
export const SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'verifiedCredentialVerificationCaseSummariesByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VerifiedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'issuingInstitutionName' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantQuery,
  SendReportV1CaseDetailsApplicationContainerVerifiedCredentialVerificationCaseSummariesByApplicantQueryVariables
>;
export const CasesSendReportV1CaseDetailsApplicationContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsApplicationContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsApplicationContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsApplicationContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1CaseDetailsApplicationContainerStaffUserCurrentQuery,
  CasesSendReportV1CaseDetailsApplicationContainerStaffUserCurrentQueryVariables
>;
export const SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendReportV1CaseDetailsApplicationContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendReportCaseV1' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caseDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'application' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'destination' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'credential' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'applicationReview' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'privateCaseDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'institutionContactDetails' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutation,
  SendReportV1CaseDetailsApplicationContainerSendReportCaseV1UpdateMutationVariables
>;
export const CasesSendReportV1CaseDetailsContainerStaffUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUsers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUsersFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerStaffUsersQuery, CasesSendReportV1CaseDetailsContainerStaffUsersQueryVariables>;
export const CasesSendReportV1CaseDetailsContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUserCurrentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerStaffUserCurrentQuery, CasesSendReportV1CaseDetailsContainerStaffUserCurrentQueryVariables>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1CaseDetailsContainerSendReportCaseV1Query, CasesSendReportV1CaseDetailsContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1CaseDetailsContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestRequestChangesFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1ActivityLogFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CaseDetailsContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1CaseDetailsContainerSendReportCaseV1UpdateMutation,
  CasesSendReportV1CaseDetailsContainerSendReportCaseV1UpdateMutationVariables
>;
export const CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseHistory' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'caseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'application' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'credential' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'activityLog' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'activityBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'applicant' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'files' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isProfileSubmitted' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'payment' },
                                          selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'cybersourceCustomerId' } }] }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'personalInformation' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applyingTo' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'address' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'client' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'createdBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'credCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'entityPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'idCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'rolePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'search' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'issuingInstitution' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'citizenship' },
                                                selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'contactInformation' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'address' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'phone' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'identityDetails' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'professional' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'primaryEducationalInformation' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'issuingInstitution' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'termsAndConditions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'version' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'archiveEligibleAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'assets' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'private' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationComponentPacket' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationForm' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationPacket' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'verificationPacketResponse' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'verificationComponentPacketHistory' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'assetVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'assetUploadedBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'verificationFormHistory' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'assetUploadedBy' },
                                                      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } }] }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'assetVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'caseDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'application' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credentialAssets' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'program' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'issuingInstitution' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'address' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'client' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'createdBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'credCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'entityPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'idCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'caseFlagged' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'flagType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'caseHistory' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'caseDetails' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'application' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credentialAssets' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'dateCredentialIssuedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isCredentialInEnglish' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isNameOnCredentialMatchPassport' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'issuingInstitution' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'client' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'address' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'institutionName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'program' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendDestination' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'address' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'client' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'address' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicationReview' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'affirmations' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'audit' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'completedBy' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'role' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'permissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'credCasePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'entityPermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'idCasePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'rolePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                      ]
                                                                                    }
                                                                                  },
                                                                                  {
                                                                                    kind: 'Field',
                                                                                    name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                                    selectionSet: {
                                                                                      kind: 'SelectionSet',
                                                                                      selections: [
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                        { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                                      ]
                                                                                    }
                                                                                  }
                                                                                ]
                                                                              }
                                                                            },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'search' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialDetailsAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialSentForVerification' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isDateOfBirthAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isEntityAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isNameAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isTranslationAcceptable' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'caseWorkerAssigned' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'role' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'permissions' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'credCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'entityPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'idCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'rolePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                          ]
                                                                        }
                                                                      },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                          ]
                                                                        }
                                                                      }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'search' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'decision' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'completedBy' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'role' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                                      {
                                                                        kind: 'Field',
                                                                        name: { kind: 'Name', value: 'permissions' },
                                                                        selectionSet: {
                                                                          kind: 'SelectionSet',
                                                                          selections: [
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'credCasePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'entityPermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'idCasePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'rolePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'sendCasePermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                                                ]
                                                                              }
                                                                            },
                                                                            {
                                                                              kind: 'Field',
                                                                              name: { kind: 'Name', value: 'staffUserPermissions' },
                                                                              selectionSet: {
                                                                                kind: 'SelectionSet',
                                                                                selections: [
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                                  { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                                                ]
                                                                              }
                                                                            }
                                                                          ]
                                                                        }
                                                                      },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                                {
                                                                  kind: 'Field',
                                                                  name: { kind: 'Name', value: 'search' },
                                                                  selectionSet: {
                                                                    kind: 'SelectionSet',
                                                                    selections: [
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                                      { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                                    ]
                                                                  }
                                                                },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                                              ]
                                                            }
                                                          },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'privateCaseDetails' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'alternateVerifyingEntity' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'isVerifiedWithOther' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'otherDetails' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entitySuppliedCredential' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'credential' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'credentialUploadedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'credentialVersion' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'translationUploadedAt' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'translationVersion' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'institutionContactDetails' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'verificationStatus' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'verificationAffirmations' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isCredentialReturnedFromEntity' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isEntityDetailCorrect' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isReturnedFromCorrectEntity' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComplete' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationComponentPacketCompiled' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationInEnglishOrWithTranslation' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationMethodAcceptable' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'isVerificationStatusComplete' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'caseWorkerAssigned' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'revisionRequest' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'requestedBy' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'files' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'financeDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'financeConfig' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'createdBy' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'glConfig' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'additionalCharges' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'recognition' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'refunds' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'submission' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'note' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'revenueRecognition' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'recognition' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'submission' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'serviceFee' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'transactions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'adhocTransactions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'requestedBy' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'messages' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'initiatedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'purgeEligibleAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'revisionRequest' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'requestedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'systemTags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'destination' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'clientDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'disabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'entityLanguage' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'institutionDisabledAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'client' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'address' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'isAttestationComplete' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicationReview' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'affirmations' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'audit' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'completedBy' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'role' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'permissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'credCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'entityPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'idCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'rolePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'sendCasePermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                              ]
                                                            }
                                                          },
                                                          {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'staffUserPermissions' },
                                                            selectionSet: {
                                                              kind: 'SelectionSet',
                                                              selections: [
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                                { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                              ]
                                                            }
                                                          }
                                                        ]
                                                      }
                                                    },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'search' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDestinationAcceptable' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReportCompiled' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isReportSent' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseWorkerAssigned' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'role' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'permissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'credCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'entityPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'idCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'rolePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'sendCasePermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                  ]
                                                }
                                              },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'staffUserPermissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'search' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'decision' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'role' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'permissions' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'applicantUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'credCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'entityPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'idCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'rolePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'sendCasePermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      kind: 'Field',
                                                      name: { kind: 'Name', value: 'staffUserPermissions' },
                                                      selectionSet: {
                                                        kind: 'SelectionSet',
                                                        selections: [
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                                          { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                                        ]
                                                      }
                                                    }
                                                  ]
                                                }
                                              },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'search' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                            ]
                                          }
                                        },
                                        { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'rejectionReason' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'privateCaseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'institutionContactDetails' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionEmail' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'institutionPhone' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'initiatedByApplicant' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'revisionRequest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'role' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'permissions' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'applicantUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'credCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'entityPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'idCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'rolePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'sendCasePermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                                            ]
                                          }
                                        },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'staffUserPermissions' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                                              { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'roleType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'search' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'indexingFailedAt' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userType' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'requestedChanges' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'revisionSummary' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1Query, CasesSendReportCasesV1CaseHistoryContainerSendReportCasesV1QueryVariables>;
export const CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportCaseInfoHeaderContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastActivityAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportCaseInfoHeaderContainerSendReportCaseV1Query, CasesSendReportCaseInfoHeaderContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1ChangeStatusContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Fields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fileByFileName' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerFileInfoFields' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerSendReportCaseV1Query, CasesSendReportV1ChangeStatusContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1ChangeStatusContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChangeStatusContainerStaffUserCurrentQuery, CasesSendReportV1ChangeStatusContainerStaffUserCurrentQueryVariables>;
export const CasesSendReportV1ChangeStatusContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetailsApplicationReview' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'affirmations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'audit' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completedBy' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsApplicationReviewFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1ActivityLog' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityBy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'activityType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'metaData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1CaseDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activityLog' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContaineSendReportCaseV1ActivityLogFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'expirationEligibleAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChangeStatusContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1ChangeStatusContainerSendReportCaseV1UpdateMutation,
  CasesSendReportV1ChangeStatusContainerSendReportCaseV1UpdateMutationVariables
>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1Query, CasesSendReportV1ChatPageContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1ChatPageContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerStaffUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerStaffUserCurrentQuery, CasesSendReportV1ChatPageContainerStaffUserCurrentQueryVariables>;
export const CasesSendReportV1ChatPageContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequestRequestChanges' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'requestUpdatedDestination' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1RevisionRequest' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'requestedChanges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RequestedChangesFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'revisionSubmittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1Message' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isHiddenFromApplicant' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sentBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'embedding' } },
          { kind: 'Field', name: { kind: 'Name', value: 'message' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'additionalCharges' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'type' } }] }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactionAdhocTransaction' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'referenceId' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approval' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetailsTransactions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'amount' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adhocTransactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionAdhocTransactionsFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFinanceConfigFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsTransactionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequest' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1RevisionRequestFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'messages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MessageFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1FinanceDetailsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChatPageContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChatPageContainerSendReportCaseV1UpdateMutation, CasesSendReportV1ChatPageContainerSendReportCaseV1UpdateMutationVariables>;
export const CasesSendReportV1ChecklistContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isDestinationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportCompiled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportSent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChecklistContainerSendReportCaseV1Query, CasesSendReportV1ChecklistContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1ChecklistContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicationReview' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'affirmations' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'isDestinationAcceptable' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportCompiled' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isReportSent' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'audit' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'completedBy' },
                                    selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'result' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1ChecklistContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1ChecklistContainerSendReportCaseV1UpdateMutation, CasesSendReportV1ChecklistContainerSendReportCaseV1UpdateMutationVariables>;
export const CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'address' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'phone' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                                ]
                              }
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'citizenship' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'professional' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'primaryEducationalInformation' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'issuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                        {
                                          kind: 'Field',
                                          name: { kind: 'Name', value: 'issuingInstitution' },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'address' },
                                                selectionSet: {
                                                  kind: 'SelectionSet',
                                                  selections: [
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                                    { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                                                  ]
                                                }
                                              }
                                            ]
                                          }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'otherIssuingInstitution' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } }
                                      ]
                                    }
                                  }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applyingTo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1Query,
  CasesSendReportCollapsibleApplicantProfileContainerSendReportCaseV1QueryVariables
>;
export const CasesSendReportVCoverLetterDocumentPickerContainerSendReportCaseV1MergePdfFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportVCoverLetterDocumentPickerContainerSendReportCaseV1MergePdfFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MergePdfFilesInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1MergePdfFiles' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'private' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'statusReportCoverLetter' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1MutationFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportVCoverLetterDocumentPickerContainerSendReportCaseV1MergePdfFilesMutation,
  CasesSendReportVCoverLetterDocumentPickerContainerSendReportCaseV1MergePdfFilesMutationVariables
>;
export const CasesSendReportV1CoverLetterDocumentPickerContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1Application' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'nameOnCredential' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendDestination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'client' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicationReview' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'privateCaseDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'verificationStatus' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'verificationResponse' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'identityDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportCoverLetterDocumentPickerContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'application' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'credential' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'caseDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'application' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1ApplicationFields' }
                                        }
                                      ]
                                    }
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerCredentialVerificationCaseV1CaseDetailsFields' }
                                  }
                                ]
                              }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'files' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerFileInfoFields' } }]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1CoverLetterDocumentPickerContainerApplicantUserFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1CoverLetterDocumentPickerContainerSendReportCaseV1Query,
  CasesSendReportV1CoverLetterDocumentPickerContainerSendReportCaseV1QueryVariables
>;
export const CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCaseV1ByApplicantFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCaseV1ByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQuery,
  CasesSendReportV1FilePickerActiveCaseListContainerIdentityVerificationCasesV1ByApplicantQueryVariables
>;
export const CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCaseV1ByApplicantFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCaseV1ByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQuery,
  CasesSendReportV1FilePickerActiveCaseListContainerCredentialVerificationCasesV1ByApplicantQueryVariables
>;
export const CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicantDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicant' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCasesV1ByApplicant' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1ByApplicantFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1ByApplicantFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicantQuery,
  CasesSendReportV1FilePickerActiveCaseListContainerSendReportCasesV1ByApplicantQueryVariables
>;
export const CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1IdFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1IdFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1Query,
  CasesSendReportV1FilePickerActiveCaseListContainerSendReportCaseV1QueryVariables
>;
export const CasesSendReportFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerArchivedCaseListContainerArchivedCasesByApplicantId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCasesByApplicantId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportFilePickerArchivedCaseListContainerArchivedCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerArchivedCaseListContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQuery,
  CasesSendReportFilePickerArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables
>;
export const CasesSendReportFilePickerCaseListContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerCaseListContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportFilePickerCaseListContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerCaseListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportFilePickerCaseListContainerSendReportCaseV1Query, CasesSendReportFilePickerCaseListContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityVerificationCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'identityVerificationCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'IdentityVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1Query,
  CasesSendReportV1FilePickerDocumentListContainerIdentityVerificationCaseV1QueryVariables
>;
export const CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialVerificationCaseV1' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'credentialVerificationCaseV1Id' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1Query,
  CasesSendReportV1FilePickerDocumentListContainerCredentialVerificationCaseV1QueryVariables
>;
export const CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1Query,
  CasesSendReportV1FilePickerDocumentListContainerSendReportCaseV1QueryVariables
>;
export const CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedCredentialVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCredentialVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryQuery,
  CasesSendReportFilePickerDocumentListContainerArchivedCredentialVerificationCaseSummaryQueryVariables
>;
export const CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummary' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedIdentityVerificationCaseSummaryId' } }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedIdentityVerificationCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryQuery,
  CasesSendReportFilePickerDocumentListContainerArchivedIdentityVerificationCaseSummaryQueryVariables
>;
export const CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportDocumentListContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryQuery,
  CasesSendReportFilePickerDocumentListContainerArchivedSendReportCaseSummaryQueryVariables
>;
export const CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1MutationFields' }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1UpdateMutation,
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1UpdateMutationVariables
>;
export const CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1PdfFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeaderMutation,
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1PdfFileCreateAuthHeaderMutationVariables
>;
export const CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1BlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1ImageFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobAuthHeader' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'indexTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'metadataFields' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobContentAuthHeaderResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1BlobContentAuthHeaderResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'authHeader' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1BlobAuthHeaderFields' }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeaderMutation,
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1ImageFileCreateAuthHeaderMutationVariables
>;
export const CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileByFileNameFields' }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileByFileNameFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'CasesSendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1FileInfoFields' }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1Query,
  CasesSendReportV1SendCaseFileUploadWithGenerateVerificationStatusReportButtonContainerSendReportCaseV1QueryVariables
>;
export const CasesSendReportV1FilesContainerSendReportCaseV1UpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1Update' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1UpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1Update' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1MutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1MutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutation, CasesSendReportV1FilesContainerSendReportCaseV1UpdateMutationVariables>;
export const CasesSendReportV1FilesContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1FilesContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1FilesContainerSendReportCaseV1Query, CasesSendReportV1FilesContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'isCurrentUserAssigned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1Query, CasesSendReportV1RelatedCasesTabContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummaryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummary' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedSendReportCaseSummary' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'archivedSendReportCaseSummaryId' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1RelatedCasesTabContainerArchivedSendReportCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1RelatedCasesTabContainerArchivedSendReportCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedSendReportCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummaryQuery,
  CasesSendReportRelatedCasesTabContainerArchivedSendReportCaseSummaryQueryVariables
>;
export const CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1Query, CasesSendReportReviewDocumentsButtonContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportTransactionsContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportTransactionsContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'financeDetails' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportTransactionsContainerSendReportCaseV1FinanceDetailsFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportTransactionsContainerSendReportCaseV1FinanceDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1FinanceDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'submission' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'adhocTransactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'approval' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'applicantRespondedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApprovalRequired' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isApplicantApproved' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'financeReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'recognizedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'transactionReference' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'vendor' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportTransactionsContainerSendReportCaseV1Query, CasesSendReportTransactionsContainerSendReportCaseV1QueryVariables>;
export const CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1MergePdfFilesInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1MergePdfFiles' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFilesMutation,
  CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1MergePdfFilesMutationVariables
>;
export const CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FileInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CredentialVerificationCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fileByFileName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'fileName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'fileName' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1CaseDetails' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'application' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credential' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerCredentialVerificationCaseV1' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'files' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerFileInfoFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportVerificationStatusReportDocumentPickerContainerSendReportCaseV1CaseDetailsFields' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1Query,
  CasesSendReportV1VerificationStatusReportDocumentPickerContainerSendReportCaseV1QueryVariables
>;
export const CasesSendReportV1IndexContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1IndexContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1IndexContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1IndexContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'sendCasePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1IndexContainerStaffUserCurrentQuery, CasesSendReportV1IndexContainerStaffUserCurrentQueryVariables>;
export const CasesSendReportV1SectionLayoutContainerSendReportCaseV1Document = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'CasesSendReportV1SectionLayoutContainerSendReportCaseV1' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendReportCaseV1' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'sendReportCaseV1Id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CasesSendReportV1SectionLayoutContainerSendReportCaseV1Fields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CasesSendReportV1SectionLayoutContainerSendReportCaseV1Fields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'SendReportCaseV1' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<CasesSendReportV1SectionLayoutContainerSendReportCaseV1Query, CasesSendReportV1SectionLayoutContainerSendReportCaseV1QueryVariables>;
export const StaffApplicantProfileApplyToEditContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileApplyToEditContainerApplicantUserQuery, StaffApplicantProfileApplyToEditContainerApplicantUserQueryVariables>;
export const StaffApplicantProfileApplyToEditContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileApplyToEditContainerEntitiesQuery, StaffApplicantProfileApplyToEditContainerEntitiesQueryVariables>;
export const StaffApplicantProfileApplyToEditContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileApplyToEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffApplicantProfileApplyToEditContainerApplicantUserUpdateMutation,
  StaffApplicantProfileApplyToEditContainerApplicantUserUpdateMutationVariables
>;
export const ApplicantApplyToViewContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantApplyToViewContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantApplyToViewContainerApplicantUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantApplyToViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantApplyToViewContainerApplicantUserQuery, ApplicantApplyToViewContainerApplicantUserQueryVariables>;
export const StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'citizenship' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipEditContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutation,
  StaffApplicantProfileCitizenshipEditContainerApplicantUserUpdateMutationVariables
>;
export const StaffApplicantProfileCitizenshipViewContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipViewContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipViewContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileCitizenshipViewContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'citizenship' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'currentCitizenOf' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileCitizenshipViewContainerApplicantUserQuery, StaffApplicantProfileCitizenshipViewContainerApplicantUserQueryVariables>;
export const StaffApplicantProfilePersonalInformationContactContainerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfilePersonalInformationContactContainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileContactInformation' } }] }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileContactInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfilePersonalInformationContactContainerQuery, StaffApplicantProfilePersonalInformationContactContainerQueryVariables>;
export const StaffApplicantProfileUpdatePersonalInformationContactDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffApplicantProfileUpdatePersonalInformationContact' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileContactInformation' } }]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileContactInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'contactInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'streetAddressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'phone' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'primaryPhone' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileUpdatePersonalInformationContactMutation, StaffApplicantProfileUpdatePersonalInformationContactMutationVariables>;
export const StaffApplicantProfileIdentityApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'identityDetails' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityApplicantUserQuery, StaffApplicantProfileIdentityApplicantUserQueryVariables>;
export const StaffApplicantProfileIdentityUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'contactInformation' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }] }
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'identityDetails' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
                                ]
                              }
                            }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityUpdateMutation, StaffApplicantProfileIdentityUpdateMutationVariables>;
export const StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileIdentityUploadContainerApplicantUserFields' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applyingTo' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutation,
  StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserUpdateMutationVariables
>;
export const StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFilesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFiles' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'files' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } }
                    ]
                  }
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'personalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'nameOnDocumentAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFilesQuery,
  StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFilesQueryVariables
>;
export const StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeader' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserBlobFileInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserFileCreateAuthHeader' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'authHeader' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'authHeader' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'blobName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'blobPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestDate' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'indexTags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'metadataFields' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'value' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutation,
  StaffApplicantProfileIdentityDocumentUploadContainerApplicantUserFileCreateAuthHeaderMutationVariables
>;
export const StaffApplicantProfileIdentityContainerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityContainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsFields' } },
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileNameOnDocumentAssetFields' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsContactInformationFields' } }]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'termsAndConditions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsTermsAndConditionsFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gender' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generationalSuffix' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'legalNameConsistsOfOneName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileNameOnDocumentAssetFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'nameOnDocumentAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'documentName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isDeleteRequested' } },
                { kind: 'Field', name: { kind: 'Name', value: 'uploadedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsContactInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserContactInformation' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'emailAddress' } }] }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileIdentityDetailsTermsAndConditionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserTermsAndCondition' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'acceptanceOf' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileIdentityContainerQuery, StaffApplicantProfileIdentityContainerQueryVariables>;
export const StaffApplicantProfileProfessionEditContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFields' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionEditContainerApplicantUserQuery, StaffApplicantProfileProfessionEditContainerApplicantUserQueryVariables>;
export const StaffApplicantProfileProfessionEditContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionEditContainerEntitiesQuery, StaffApplicantProfileProfessionEditContainerEntitiesQueryVariables>;
export const StaffApplicantProfileUpdatePersonalInformationProfessionContainerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffApplicantProfileUpdatePersonalInformationProfessionContainer' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'personalInformation' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFields' } }
                          ]
                        }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionEditContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<
  StaffApplicantProfileUpdatePersonalInformationProfessionContainerMutation,
  StaffApplicantProfileUpdatePersonalInformationProfessionContainerMutationVariables
>;
export const StaffApplicantProfileProfessionViewContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalInformation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserOtherIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPrimaryEducationalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceEndedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'attendanceStartedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeIssuedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'degreeTitle' } },
          { kind: 'Field', name: { kind: 'Name', value: 'graduationYear' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'issuingInstitution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } }
                          ]
                        }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'otherIssuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserOtherIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserProfessional' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'citizenshipAtTimeEnteredMedicalInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthProfession' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'primaryEducationalInformation' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPrimaryEducationalInformationFields' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserPersonalInformationFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserPersonalInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'professional' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerApplicantUserProfessionalFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionViewContainerApplicantUserQuery, StaffApplicantProfileProfessionViewContainerApplicantUserQueryVariables>;
export const StaffApplicantProfileProfessionViewContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerEntityFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantProfileProfessionViewContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantProfileProfessionViewContainerEntitiesQuery, StaffApplicantProfileProfessionViewContainerEntitiesQueryVariables>;
export const StaffApplicantSearchFilterContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantSearchFilterContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantSearchFilterContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchFilterContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantSearchFilterContainerEntitiesQuery, StaffApplicantSearchFilterContainerEntitiesQueryVariables>;
export const StaffApplicantSearchFilterContainerApplicantUserGetAllTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantSearchFilterContainerApplicantUserGetAllTags' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'applicantUserGetAllTags' } }] }
    }
  ]
} as unknown as DocumentNode<StaffApplicantSearchFilterContainerApplicantUserGetAllTagsQuery, StaffApplicantSearchFilterContainerApplicantUserGetAllTagsQueryVariables>;
export const StaffApplicantSearchContainerApplicantUserSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserSearchInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserSearch' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantApplicantUserResultsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'identityDetails' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'restOfName' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessBlocked' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applyingTo' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dateOfBirth' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'gender' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'generationalSuffix' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantApplicantUserResultsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserSearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserResults' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffApplicantSearchContainerApplicantUserSearchFacetsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffApplicantSearchContainerApplicantUserSearchQuery, StaffApplicantSearchContainerApplicantUserSearchQueryVariables>;
export const StaffCaseSearchFilterContainerStaffUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUsers' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffUsersFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffUsersQuery, StaffCaseSearchFilterContainerStaffUsersQueryVariables>;
export const StaffCaseSearchFilterContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffUsersFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleIdCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleSendCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCredCasePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleIdCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleSendCasePermissionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleCredCasePermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRolePermissionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffUsersFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerStaffRoleFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerStaffUserCurrentQuery, StaffCaseSearchFilterContainerStaffUserCurrentQueryVariables>;
export const StaffCaseSearchFilterContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerEntitiesQuery, StaffCaseSearchFilterContainerEntitiesQueryVariables>;
export const StaffCaseSearchFilterContainerCaseGetAllTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCaseSearchFilterContainerCaseGetAllTags' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'caseGetAllTags' } }] }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchFilterContainerCaseGetAllTagsQuery, StaffCaseSearchFilterContainerCaseGetAllTagsQueryVariables>;
export const StaffCaseSearchContainerCaseSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'caseSearchInput2' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseSearch' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'caseSearchInput2' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchResultFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchStaffUserResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchStaffUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchStaffUserResultFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicantId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'applicantName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decision' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'result' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseWorkerAssigned' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'clientId' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credentialType' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionCompletedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionCompletedBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'decisionResult' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'expirationEligibleAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastActivityCreatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestRequestedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestRequestedBy' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'revisionRequestSubmittedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'state' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submittedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'systemTags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerFacetDetailFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseSearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseResults' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseResultFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCaseSearchContainerCaseSearchFacetsFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCaseSearchContainerCaseSearchQuery, StaffCaseSearchContainerCaseSearchQueryVariables>;
export const StaffStateCountriesEditContainerUpdateBlobCountriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerUpdateBlobCountries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountriesInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBlobCountries' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountriesMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobState' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerStateFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerEventPayloadFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEventPayload' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerCountriesFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'apiName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventPayload' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerEventPayloadFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountriesMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountriesMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStateCountriesEditContainerBlobCountryFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStateCountriesEditContainerUpdateBlobCountriesMutation, StaffStateCountriesEditContainerUpdateBlobCountriesMutationVariables>;
export const StaffStateCountriesViewContainerBlobCountriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffStateCountriesViewContainerBlobCountries' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blobCountries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryEventFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'states' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stateName' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerEventPayloadFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEventPayload' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'countries' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'externalId' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StateCountriesViewContainerBlobCountryEventFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobCountryEvent' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'apiName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventPayload' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StateCountriesViewContainerEventPayloadFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'eventTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'eventUuid' } },
          { kind: 'Field', name: { kind: 'Name', value: 'replayId' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStateCountriesViewContainerBlobCountriesQuery, StaffStateCountriesViewContainerBlobCountriesQueryVariables>;
export const StaffCreateEntityContainerEntityCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityCreateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityCreate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityCreateFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityCreateFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entity' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffCreateEntityContainerEntityFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffCreateEntityContainerEntityCreateMutation, StaffCreateEntityContainerEntityCreateMutationVariables>;
export const StaffEntityDetailsContainerEntityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entity' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityDetailsContainerEntityQuery, StaffEntityDetailsContainerEntityQueryVariables>;
export const StaffEntityDetailsContainerEntityDeleteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityDelete' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'entityDeleteId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityDelete' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'entityDeleteId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entity' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityFields' } }] }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerEntityAddressInfoFields' } }]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityDetailsContainerEntityDeleteMutation, StaffEntityDetailsContainerEntityDeleteMutationVariables>;
export const StaffEntityDetailsContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityDetailsContainerStaffUserCurrentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityDetailsContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityDetailsContainerStaffUserCurrentQuery, StaffEntityDetailsContainerStaffUserCurrentQueryVariables>;
export const StaffEntityEditContainerEntityUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityClientFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityClient' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityIssuingInstitutionFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityIssuingInstitution' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'address' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityAddressInfoFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityClientFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityIssuingInstitutionFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerMutationStatusFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MutationStatus' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'success' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntityEditContainerEntityMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entity' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerEntityFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntityEditContainerMutationStatusFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntityEditContainerEntityUpdateMutation, StaffEntityEditContainerEntityUpdateMutationVariables>;
export const StaffEntitySearchContainerEntitySearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'EntitySearchInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entitySearch' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntityResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'FacetDetail' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntitySearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disabledAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isClient' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'isIssuingInstitution' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerFacetDetailFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntitySearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityResults' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerEntityResultFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerEntitySearchFacetsFields' } }]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntitySearchContainerEntitySearchQuery, StaffEntitySearchContainerEntitySearchQueryVariables>;
export const StaffEntitySearchContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEntitySearchContainerStaffUserCurrentFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEntitySearchContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entityPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEntitySearchContainerStaffUserCurrentQuery, StaffEntitySearchContainerStaffUserCurrentQueryVariables>;
export const StaffFeatureFlagsContainerBlobFeatureFlagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlags' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blobFeatureFlags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFeatureFlag' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'allowedValues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retirementDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFeatureFlagsContainerBlobFeatureFlagsQuery, StaffFeatureFlagsContainerBlobFeatureFlagsQueryVariables>;
export const StaffFeatureFlagsContainerUpdateBlobFeatureFlagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerUpdateBlobFeatureFlags' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFeatureFlagInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBlobFeatureFlags' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFeatureFlag' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'allowedValues' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'retirementDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'value' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFeatureFlagMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'featureFlags' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFeatureFlagsContainerBlobFeatureFlagFields' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFeatureFlagsContainerUpdateBlobFeatureFlagsMutation, StaffFeatureFlagsContainerUpdateBlobFeatureFlagsMutationVariables>;
export const StaffFinanceBatchContainerGlPostingSummariesByDateRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummariesByDateRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glPostingSummariesByDateRange' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'startDate' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'endDate' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } } }
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryGlSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryGlSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accountingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'glAccountId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptAttemptData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'attemptedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttemptResponseData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'glBatchNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSuccess' } },
          { kind: 'Field', name: { kind: 'Name', value: 'jEntryNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'respondedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummaryPostingAttempt' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attemptData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptAttemptDataFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'responseData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptResponseDataFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdUser' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlPostingSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryGlSummaryFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'postingAttempt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceBatchContainerGlPostingSummaryPostingAttemptFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'glTransactionDate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceBatchContainerGlPostingSummariesByDateRangeQuery, StaffFinanceBatchContainerGlPostingSummariesByDateRangeQueryVariables>;
export const StaffFinanceDetailContainerGlTransactionSummariesByDateRangeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffFinanceDetailContainerGlTransactionSummariesByDateRange' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glTransactionSummariesByDateRange' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'endDate' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'endDate' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'startDate' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'startDate' } } }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceDetailContainerGlTransactionSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceDetailContainerGlTransactionSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'GlTransactionSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'transactionType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transactionReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'completedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'referenceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'vendor' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicant' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'displayName' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'case' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'reason' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeReference' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'debitGlAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGlAccount' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceDetailContainerGlTransactionSummariesByDateRangeQuery, StaffFinanceDetailContainerGlTransactionSummariesByDateRangeQueryVariables>;
export const StaffFinanceSettingsContainerBlobFinancialConfigsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinancialConfigs' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blobFinancialConfigs' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinancialConfigFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinancialConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinancialConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ruleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerBlobFinancialConfigsQuery, StaffFinanceSettingsContainerBlobFinancialConfigsQueryVariables>;
export const StaffFinanceSettingsContainerBlobFinancialGlConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinancialGlConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfigNameInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blobFinancialGlConfig' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceGlConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recognition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerBlobFinancialGlConfigQuery, StaffFinanceSettingsContainerBlobFinancialGlConfigQueryVariables>;
export const StaffFinanceSettingsContainerStaffUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerStaffUsers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUsers' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerStaffUsersQuery, StaffFinanceSettingsContainerStaffUsersQueryVariables>;
export const StaffFinanceSettingsContainerUpdateBlobFinanceGlConfigDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerUpdateBlobFinanceGlConfig' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfigInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateBlobFinanceGlConfig' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceGlConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'submission' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'amount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'additionalCharges' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'refunds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recognition' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'creditGLAccount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'debitGLAccount' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdBy' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'version' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfig' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'effectiveAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'glConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceGlConfigFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobFinanceConfigMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'financeGlConfig' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffFinanceSettingsContainerBlobFinanceConfigFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffFinanceSettingsContainerUpdateBlobFinanceGlConfigMutation, StaffFinanceSettingsContainerUpdateBlobFinanceGlConfigMutationVariables>;
export const StaffHealthProfessionContainerBlobHealthProfessionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffHealthProfessionContainerBlobHealthProfessions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'blobHealthProfessions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerBlobHealthProfessionsFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HealthProfessionsData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'professionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerBlobHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobHealthProfession' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'healthProfessions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffHealthProfessionContainerBlobHealthProfessionsQuery, StaffHealthProfessionContainerBlobHealthProfessionsQueryVariables>;
export const StaffHealthProfessionContainerHealthProfessionsUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffHealthProfessionContainerHealthProfessionsUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'HealthProfessionsInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'healthProfessionsUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'HealthProfessionsData' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'professionCode' } },
          { kind: 'Field', name: { kind: 'Name', value: 'professionName' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerBlobHealthProfessionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobHealthProfession' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'healthProfessions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'HealthProfessionsContainerHealthProfessionsMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BlobHealthProfessionsMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'healthProfessions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'HealthProfessionsContainerBlobHealthProfessionsFields' } }]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffHealthProfessionContainerHealthProfessionsUpdateMutation, StaffHealthProfessionContainerHealthProfessionsUpdateMutationVariables>;
export const StaffProfileHeaderContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffProfileHeaderContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffProfileHeaderContainerStaffUserCurrentFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffProfileHeaderContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }] }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffProfileHeaderContainerStaffUserCurrentQuery, StaffProfileHeaderContainerStaffUserCurrentQueryVariables>;
export const StaffReIndexSearchCollectionContainerUserReIndexDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerUserReIndex' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'userReIndex' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerUserReIndexFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerUserReIndexFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'UserReIndexResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'applicantUserReIndexErrors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'staffUserReIndexErrors' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerUserReIndexQuery, StaffReIndexSearchCollectionContainerUserReIndexQueryVariables>;
export const StaffReIndexSearchCollectionContainerCaseReIndexDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerCaseReIndex' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'caseReIndex' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerCaseReIndexFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerCaseReIndexFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CaseReIndexResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'identityCaseReIndexErrors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'credentialCaseReIndexErrors' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sendReportCaseReIndexErrors' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerCaseReIndexQuery, StaffReIndexSearchCollectionContainerCaseReIndexQueryVariables>;
export const StaffReIndexSearchCollectionContainerEntityReIndexDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerEntityReIndex' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityReIndex' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerEntityReIndexFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerEntityReIndexFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityReIndexResult' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'entityReIndexErrors' } }] }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerEntityReIndexQuery, StaffReIndexSearchCollectionContainerEntityReIndexQueryVariables>;
export const StaffReIndexSearchCollectionContainerIdentityCaseReIndexDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerIdentityCaseReIndex' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'identityCaseReIndex' } }] }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerIdentityCaseReIndexQuery, StaffReIndexSearchCollectionContainerIdentityCaseReIndexQueryVariables>;
export const StaffReIndexSearchCollectionContainerCredentialCaseReIndexDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerCredentialCaseReIndex' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'credentialCaseReIndex' } }] }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerCredentialCaseReIndexQuery, StaffReIndexSearchCollectionContainerCredentialCaseReIndexQueryVariables>;
export const StaffReIndexSearchCollectionContainerSendReportCaseReIndexDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffReIndexSearchCollectionContainerSendReportCaseReIndex' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sendReportCaseReIndex' } }] }
    }
  ]
} as unknown as DocumentNode<StaffReIndexSearchCollectionContainerSendReportCaseReIndexQuery, StaffReIndexSearchCollectionContainerSendReportCaseReIndexQueryVariables>;
export const StaffReportCoverLetterContainerEntitiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntities' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entities' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EntityAddressInfo' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine2' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stateOrProvince' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zipOrPostalCode' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Entity' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'issuingInstitution' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                  }
                }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'client' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'address' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffReportCoverLetterContainerEntityAddressInfoFields' } }]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'entityName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isIssuingInstitution' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isClient' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffReportCoverLetterContainerEntitiesQuery, StaffReportCoverLetterContainerEntitiesQueryVariables>;
export const RoleCreateContainerStaffRoleCreateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleCreate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleCreateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRoleCreate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleMutationResultFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRole' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleCreateContainerStaffRoleFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleCreateContainerStaffRoleCreateMutation, RoleCreateContainerStaffRoleCreateMutationVariables>;
export const RoleCreateContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleCreateContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleCreateContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleCreateContainerStaffUserCurrentQuery, RoleCreateContainerStaffUserCurrentQueryVariables>;
export const RoleDetailContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleDetailContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleDetailContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleDetailContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rolePermissions' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } }] }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleDetailContainerStaffUserCurrentQuery, RoleDetailContainerStaffUserCurrentQueryVariables>;
export const RoleEditContainerStaffRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffRoleId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRole' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'staffRoleId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleEditContainerStaffRoleFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleEditContainerStaffRoleQuery, RoleEditContainerStaffRoleQueryVariables>;
export const RoleEditContainerStaffRoleUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRoleUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRoleUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleEditContainerStaffRoleMutationResultFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUpdatePersonalInformation' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'credCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canDeleteEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditEntities' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rolePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'sendCasePermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBeAssignedCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canIssueRefunds' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCaseHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canOverrideCaseState' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canReopenCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignCaseWorker' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canUnassignSelf' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewCasesAssignedToOthers' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canViewUnassignedCases' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staffUserPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffRoleMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRoleMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRole' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleEditContainerStaffRoleFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleEditContainerStaffRoleUpdateMutation, RoleEditContainerStaffRoleUpdateMutationVariables>;
export const RoleEditContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleEditContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleEditContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleEditContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleEditContainerStaffUserCurrentQuery, RoleEditContainerStaffUserCurrentQueryVariables>;
export const RoleListContainerStaffRolesQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleListContainerStaffRolesQuery' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRoles' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RoleListContainerStaffRoleFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RoleListContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleListContainerStaffRolesQueryQuery, RoleListContainerStaffRolesQueryQueryVariables>;
export const RoleListContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'RoleListContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'role' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'rolePermissions' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'canAddRoles' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'canEditRoles' } }
                                ]
                              }
                            }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<RoleListContainerStaffUserCurrentQuery, RoleListContainerStaffUserCurrentQueryVariables>;
export const StaffEditContainerStaffUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'staffUserId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEditContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffUserQuery, StaffEditContainerStaffUserQueryVariables>;
export const StaffEditContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEditContainerStaffUserCurrentFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staffUserPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffUserCurrentQuery, StaffEditContainerStaffUserCurrentQueryVariables>;
export const StaffEditContainerStaffRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffEditContainerStaffRoles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRoles' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEditContainerStaffRoleFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffRolesQuery, StaffEditContainerStaffRolesQueryVariables>;
export const StaffEditContainerStaffUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEditContainerStaffUserMutationResultFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffEditContainerStaffUserMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'success' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUser' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffEditContainerStaffUserFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffEditContainerStaffUserUpdateMutation, StaffEditContainerStaffUserUpdateMutationVariables>;
export const StaffStaffSearchFilterContainerStaffRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffStaffSearchFilterContainerStaffRoles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffRoles' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchFilterContainerStaffRolesFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchFilterContainerStaffRolesFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchFilterContainerStaffRolesQuery, StaffStaffSearchFilterContainerStaffRolesQueryVariables>;
export const StaffStaffSearchFilterContainerStaffUserGetAllTagsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffStaffSearchFilterContainerStaffUserGetAllTags' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'staffUserGetAllTags' } }] }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchFilterContainerStaffUserGetAllTagsQuery, StaffStaffSearchFilterContainerStaffUserGetAllTagsQueryVariables>;
export const StaffStaffSearchContainerStaffUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchInput' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserSearch' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersSearchFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchRoleResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsRoleFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersFacetsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchFacets' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'accessBlocked' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createdAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatedAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'schemaVersion' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersSearchFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUserSearchResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserResults' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersResultsFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'count' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'facets' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffStaffSearchContainerStaffUsersFacetsFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffStaffSearchContainerStaffUsersQuery, StaffStaffSearchContainerStaffUsersQueryVariables>;
export const StaffViewContainerStaffUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffViewContainerStaffUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'staffUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'staffUserId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffViewContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffViewContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'roleName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffViewContainerStaffUserQuery, StaffViewContainerStaffUserQueryVariables>;
export const StaffViewContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffViewContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffViewContainerStaffUserCurrentFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffViewContainerStaffUserCurrentFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'staffUserPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canAssignRoles' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffViewContainerStaffUserCurrentQuery, StaffViewContainerStaffUserCurrentQueryVariables>;
export const StaffSystemFlagsContainerApplicantUserQueryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserQuery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantId' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'systemFlags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSystemFlagsContainerApplicantUserQueryQuery, StaffSystemFlagsContainerApplicantUserQueryQueryVariables>;
export const StaffSystemFlagsContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUsereMutationResultFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'systemFlags' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUsereMutationResultFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserMutationResult' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'status' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } }
              ]
            }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSystemFlagsContainerApplicantUserFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSystemFlagsContainerApplicantUserUpdateMutation, StaffSystemFlagsContainerApplicantUserUpdateMutationVariables>;
export const StaffSectionLayoutContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRolePermissionsFields' } }]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffSectionLayoutContainerStaffRoleFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSectionLayoutContainerStaffUserCurrentQuery, StaffSectionLayoutContainerStaffUserCurrentQueryVariables>;
export const ApplicantDetailsHeaderContainerApplicantUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerApplicantUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUser' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'id' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'applicantUserId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerApplicantUserFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantDetailsHeaderContainerApplicantUserQuery, ApplicantDetailsHeaderContainerApplicantUserQueryVariables>;
export const ApplicantDetailsHeaderContainerApplicantUserUpdateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerApplicantUserUpdate' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUserUpdateInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserUpdate' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'applicantUser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerApplicantUserFields' } }]
                  }
                }
              ]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerApplicantUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ApplicantUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'tags' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantDetailsHeaderContainerApplicantUserUpdateMutation, ApplicantDetailsHeaderContainerApplicantUserUpdateMutationVariables>;
export const ApplicantDetailsHeaderContainerStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ApplicantDetailsHeaderContainerStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'permissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'applicantUserPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'canBlockAccess' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'canAddOrRemoveTags' } }
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<ApplicantDetailsHeaderContainerStaffUserCurrentQuery, ApplicantDetailsHeaderContainerStaffUserCurrentQueryVariables>;
export const StaffSharedFileUploadProcessMaliciousFileScanDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StaffSharedFileUploadProcessMaliciousFileScan' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProcessMaliciousFileScanInput' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'processMaliciousFileScan' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'status' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'errorMessage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'success' } }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'scanResult' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isMalicious' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSafe' } }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffSharedFileUploadProcessMaliciousFileScanMutation, StaffSharedFileUploadProcessMaliciousFileScanMutationVariables>;
export const StaffLandingPageStaffUserCurrentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'StaffLandingPageStaffUserCurrent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserCurrent' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'oid' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'oid' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffLandingPageStaffUserFields' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffRolePermissionsFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRolePermissions' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'applicantUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchApplicants' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'credCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'entityPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchEntities' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'rolePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchRoles' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendCasePermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchCases' } }] }
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'staffUserPermissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'canSearchStaff' } }] }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffRoleFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffRole' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'roleSubtype' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'permissions' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffLandingPageStaffRolePermissionsFields' } }] }
          },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'StaffLandingPageStaffUserFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'StaffUser' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'accessBlocked' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaVersion' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'role' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'StaffLandingPageStaffRoleFields' } }] }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode<StaffLandingPageStaffUserCurrentQuery, StaffLandingPageStaffUserCurrentQueryVariables>;
export const MaintenanceMessageProviderGetServerDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'MaintenanceMessageProviderGetServerDate' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serverDate' } }] }
    }
  ]
} as unknown as DocumentNode<MaintenanceMessageProviderGetServerDateQuery, MaintenanceMessageProviderGetServerDateQueryVariables>;
export const ServerDateDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ServerDate' },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'serverDate' } }] }
    }
  ]
} as unknown as DocumentNode<ServerDateQuery, ServerDateQueryVariables>;
export const SharedArchivedCaseListContainerArchivedCasesByApplicantIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SharedArchivedCaseListContainerArchivedCasesByApplicantId' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ObjectID' } } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'archivedCasesByApplicantId' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'applicantId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'SharedArchivedCaseListContainerArchivedCaseSummaryFields' } }]
            }
          }
        ]
      }
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'SharedArchivedCaseListContainerArchivedCaseSummaryFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ArchivedCaseSummary' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'archivedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'caseType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } }
        ]
      }
    }
  ]
} as unknown as DocumentNode<SharedArchivedCaseListContainerArchivedCasesByApplicantIdQuery, SharedArchivedCaseListContainerArchivedCasesByApplicantIdQueryVariables>;
